const data_svgs = [
    {
        'id': 1,
        'svg': `<svg width="0" height="0" class="hidden">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1">
            <title>Z1</title>
            <path fill="#d7e8cd" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3">
            <title>Z3</title>
            <path fill="#8de0b8" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2">
            <title>Z2</title>
            <path fill="#92c193" d="M.07-.21h44v44h-44z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="selection-color">
            <path fill="#665c54" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="icon">
            <title>icon</title>
            <path fill="#d7e8cd" d="M0 0h44v44H0z"></path>
            <path d="M12 0h20v12h-5.86L22 7.86 17.86 12H12zm0 32v-5.86L7.86 22 12 17.86V12H0v20zm20 0v-5.86L36.14 22 32 17.86V12h12v20zm0 0h-5.86L22 36.14 17.86 32H12v12h20z" fill="#5bb56f"></path>
            <path d="M22 43.87l-1.2-1.58c-.23-.31-.5-.65-.79-1a12.72 12.72 0 0 0-4.45-3.73 12.71 12.71 0 0 0-5.79-.51c-.46 0-.88.09-1.27.14l-2 .27.27-2c.05-.39.1-.82.14-1.27a12.71 12.71 0 0 0-.51-5.79A12.72 12.72 0 0 0 2.71 24c-.35-.29-.69-.56-1-.79L.13 22l1.58-1.2c.31-.23.65-.5 1-.79a12.72 12.72 0 0 0 3.73-4.45A12.71 12.71 0 0 0 7 9.77c0-.45-.09-.88-.14-1.27l-.27-2 2 .27L9.77 7a12.71 12.71 0 0 0 5.79-.51A12.72 12.72 0 0 0 20 2.71c.29-.35.56-.69.79-1L22 .13l1.2 1.58c.23.31.5.65.79 1a12.72 12.72 0 0 0 4.45 3.73 12.71 12.71 0 0 0 5.79.56l1.27-.14 2-.27-.27 2c0 .39-.1.82-.14 1.27a12.71 12.71 0 0 0 .51 5.79A12.72 12.72 0 0 0 41.29 20c.35.29.69.56 1 .79L43.87 22l-1.58 1.2c-.31.23-.65.5-1 .79a12.72 12.72 0 0 0-3.73 4.45 12.71 12.71 0 0 0-.51 5.79c0 .45.09.88.14 1.27l.27 2-2-.27c-.39 0-.81-.1-1.27-.14a12.71 12.71 0 0 0-5.79.51 12.72 12.72 0 0 0-4.4 3.69c-.29.35-.56.69-.79 1zM11.72 34a13 13 0 0 1 5 .84A14.92 14.92 0 0 1 22 39a14.92 14.92 0 0 1 5.29-4.21A14.88 14.88 0 0 1 34 34a14.88 14.88 0 0 1 .77-6.73A14.92 14.92 0 0 1 39 22a14.92 14.92 0 0 1-4.21-5.29A14.88 14.88 0 0 1 34 10a14.88 14.88 0 0 1-6.73-.77A14.92 14.92 0 0 1 22 5a14.92 14.92 0 0 1-5.29 4.21A14.88 14.88 0 0 1 10 10a14.88 14.88 0 0 1-.77 6.73A14.92 14.92 0 0 1 5 22a14.92 14.92 0 0 1 4.21 5.29A14.88 14.88 0 0 1 10 34h1.72z" fill="#195f28"></path>
            <path d="M18.14 15.57c0-1.42.87-2.57 1.93-2.57S22 14.15 22 15.57c0-1.42.86-2.57 1.93-2.57s1.93.64 1.93 2.57a6.86 6.86 0 0 1-1.36 3.93 6.86 6.86 0 0 1 3.93-1.36c1.42 0 2.57.87 2.57 1.93S29.85 22 28.43 22c1.42 0 2.57.86 2.57 1.93s-.64 1.93-2.57 1.93a6.86 6.86 0 0 1-3.93-1.36 6.86 6.86 0 0 1 1.36 3.93c0 1.42-.87 2.57-1.93 2.57S22 29.85 22 28.43c0 1.42-.86 2.57-1.93 2.57s-1.93-.64-1.93-2.57a6.86 6.86 0 0 1 1.36-3.93 6.86 6.86 0 0 1-3.93 1.36c-1.42 0-2.57-.86-2.57-1.93S14.15 22 15.57 22c-1.42 0-2.57-.86-2.57-1.93s.64-1.93 2.57-1.93a6.86 6.86 0 0 1 3.93 1.36 6.86 6.86 0 0 1-1.36-3.93z" fill="#ef2e7f" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="font-color">
            <path fill="#665c54" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C12">
            <title>C12</title>
            <path d="M18.46 18.46A7.5 7.5 0 0 0 10 10a7.5 7.5 0 0 0 8.48 8.48zM34 34a7.5 7.5 0 0 0-8.48-8.48A7.5 7.5 0 0 0 34 34zm-15.53-8.46A7.5 7.5 0 0 0 10 34a7.51 7.51 0 0 0 8.49-8.48zM34 10a7.5 7.5 0 0 0-8.48 8.48A7.5 7.5 0 0 0 34 10z" fill="#ef2e7f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C11">
            <title>C11</title>
            <path d="M26.75 24h.75a8.08 8.08 0 0 0 5.5-2 8.08 8.08 0 0 0-5.5-2h-.75c.19-.16.38-.33.56-.51a8.07 8.07 0 0 0 2.47-5.3 8.07 8.07 0 0 0-5.3 2.47A8.07 8.07 0 0 0 22 22a8.07 8.07 0 0 0 2.47 5.3 8.07 8.07 0 0 0 5.3 2.47 8.07 8.07 0 0 0-2.47-5.3c-.17-.17-.36-.34-.55-.47zm-7.23-7.31a8.07 8.07 0 0 0-5.3-2.47 8.07 8.07 0 0 0 2.47 5.3c.18.18.37.35.56.51h-.75A8.08 8.08 0 0 0 11 22a8.08 8.08 0 0 0 5.5 2h.75c-.19.16-.38.33-.56.51a8.07 8.07 0 0 0-2.47 5.3 8.07 8.07 0 0 0 5.3-2.47A8.07 8.07 0 0 0 22 22a8.07 8.07 0 0 0-2.48-5.31z" fill="#ef2e7f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C10">
            <title>C10</title>
            <path d="M18.14 15.57c0-1.42.87-2.57 1.93-2.57S22 14.15 22 15.57c0-1.42.86-2.57 1.93-2.57s1.93.64 1.93 2.57a6.86 6.86 0 0 1-1.36 3.93 6.86 6.86 0 0 1 3.93-1.36c1.42 0 2.57.87 2.57 1.93S29.85 22 28.43 22c1.42 0 2.57.86 2.57 1.93s-.64 1.93-2.57 1.93a6.86 6.86 0 0 1-3.93-1.36 6.86 6.86 0 0 1 1.36 3.93c0 1.42-.87 2.57-1.93 2.57S22 29.85 22 28.43c0 1.42-.86 2.57-1.93 2.57s-1.93-.64-1.93-2.57a6.86 6.86 0 0 1 1.36-3.93 6.86 6.86 0 0 1-3.93 1.36c-1.42 0-2.57-.86-2.57-1.93S14.15 22 15.57 22c-1.42 0-2.57-.86-2.57-1.93s.64-1.93 2.57-1.93a6.86 6.86 0 0 1 3.93 1.36 6.86 6.86 0 0 1-1.36-3.93z" fill="#ef2e7f" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C9">
            <title>C9</title>
            <path d="M18.46 18.46A7.5 7.5 0 0 0 10 10a7.5 7.5 0 0 0 8.48 8.48zM34 34a7.5 7.5 0 0 0-8.48-8.48A7.5 7.5 0 0 0 34 34zm-15.53-8.46A7.5 7.5 0 0 0 10 34a7.51 7.51 0 0 0 8.49-8.48zM34 10a7.5 7.5 0 0 0-8.48 8.48A7.5 7.5 0 0 0 34 10z" fill="#5bb56f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C8">
            <title>C8</title>
            <path d="M26.75 24h.75a8.08 8.08 0 0 0 5.5-2 8.08 8.08 0 0 0-5.5-2h-.75c.19-.16.38-.33.56-.51a8.07 8.07 0 0 0 2.47-5.3 8.07 8.07 0 0 0-5.3 2.47A8.07 8.07 0 0 0 22 22a8.07 8.07 0 0 0 2.47 5.3 8.07 8.07 0 0 0 5.3 2.47 8.07 8.07 0 0 0-2.47-5.3c-.17-.17-.36-.34-.55-.47zm-7.23-7.31a8.07 8.07 0 0 0-5.3-2.47 8.07 8.07 0 0 0 2.47 5.3c.18.18.37.35.56.51h-.75A8.08 8.08 0 0 0 11 22a8.08 8.08 0 0 0 5.5 2h.75c-.19.16-.38.33-.56.51a8.07 8.07 0 0 0-2.47 5.3 8.07 8.07 0 0 0 5.3-2.47A8.07 8.07 0 0 0 22 22a8.07 8.07 0 0 0-2.48-5.31z" fill="#5bb56f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C7">
            <title>C7</title>
            <path d="M18.14 15.57c0-1.42.87-2.57 1.93-2.57S22 14.15 22 15.57c0-1.42.86-2.57 1.93-2.57s1.93.64 1.93 2.57a6.86 6.86 0 0 1-1.36 3.93 6.86 6.86 0 0 1 3.93-1.36c1.42 0 2.57.87 2.57 1.93S29.85 22 28.43 22c1.42 0 2.57.86 2.57 1.93s-.64 1.93-2.57 1.93a6.86 6.86 0 0 1-3.93-1.36 6.86 6.86 0 0 1 1.36 3.93c0 1.42-.87 2.57-1.93 2.57S22 29.85 22 28.43c0 1.42-.86 2.57-1.93 2.57s-1.93-.64-1.93-2.57a6.86 6.86 0 0 1 1.36-3.93 6.86 6.86 0 0 1-3.93 1.36c-1.42 0-2.57-.86-2.57-1.93S14.15 22 15.57 22c-1.42 0-2.57-.86-2.57-1.93s.64-1.93 2.57-1.93a6.86 6.86 0 0 1 3.93 1.36 6.86 6.86 0 0 1-1.36-3.93z" fill="#5bb56f" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C6">
            <title>C6</title>
            <path d="M18.46 18.46A7.5 7.5 0 0 0 10 10a7.5 7.5 0 0 0 8.48 8.48zM34 34a7.5 7.5 0 0 0-8.48-8.48A7.5 7.5 0 0 0 34 34zm-15.53-8.46A7.5 7.5 0 0 0 10 34a7.51 7.51 0 0 0 8.49-8.48zM34 10a7.5 7.5 0 0 0-8.48 8.48A7.5 7.5 0 0 0 34 10z" fill="#f3fff4"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C5">
            <title>C5</title>
            <path d="M26.75 24h.75a8.08 8.08 0 0 0 5.5-2 8.08 8.08 0 0 0-5.5-2h-.75c.19-.16.38-.33.56-.51a8.07 8.07 0 0 0 2.47-5.3 8.07 8.07 0 0 0-5.3 2.47A8.07 8.07 0 0 0 22 22a8.07 8.07 0 0 0 2.47 5.3 8.07 8.07 0 0 0 5.3 2.47 8.07 8.07 0 0 0-2.47-5.3c-.17-.17-.36-.34-.55-.47zm-7.23-7.31a8.07 8.07 0 0 0-5.3-2.47 8.07 8.07 0 0 0 2.47 5.3c.18.18.37.35.56.51h-.75A8.08 8.08 0 0 0 11 22a8.08 8.08 0 0 0 5.5 2h.75c-.19.16-.38.33-.56.51a8.07 8.07 0 0 0-2.47 5.3 8.07 8.07 0 0 0 5.3-2.47A8.07 8.07 0 0 0 22 22a8.07 8.07 0 0 0-2.48-5.31z" fill="#f3fff4"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C4">
            <title>C4</title>
            <path d="M18.14 15.57c0-1.42.87-2.57 1.93-2.57S22 14.15 22 15.57c0-1.42.86-2.57 1.93-2.57s1.93.64 1.93 2.57a6.86 6.86 0 0 1-1.36 3.93 6.86 6.86 0 0 1 3.93-1.36c1.42 0 2.57.87 2.57 1.93S29.85 22 28.43 22c1.42 0 2.57.86 2.57 1.93s-.64 1.93-2.57 1.93a6.86 6.86 0 0 1-3.93-1.36 6.86 6.86 0 0 1 1.36 3.93c0 1.42-.87 2.57-1.93 2.57S22 29.85 22 28.43c0 1.42-.86 2.57-1.93 2.57s-1.93-.64-1.93-2.57a6.86 6.86 0 0 1 1.36-3.93 6.86 6.86 0 0 1-3.93 1.36c-1.42 0-2.57-.86-2.57-1.93S14.15 22 15.57 22c-1.42 0-2.57-.86-2.57-1.93s.64-1.93 2.57-1.93a6.86 6.86 0 0 1 3.93 1.36 6.86 6.86 0 0 1-1.36-3.93z" fill="#f3fff4" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C3">
            <title>C3</title>
            <path d="M18.46 18.46A7.5 7.5 0 0 0 10 10a7.5 7.5 0 0 0 8.48 8.48zM34 34a7.5 7.5 0 0 0-8.48-8.48A7.5 7.5 0 0 0 34 34zm-15.53-8.46A7.5 7.5 0 0 0 10 34a7.51 7.51 0 0 0 8.49-8.48zM34 10a7.5 7.5 0 0 0-8.48 8.48A7.5 7.5 0 0 0 34 10z" fill="#195f28"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2">
            <title>C2</title>
            <path d="M26.75 24h.75a8.08 8.08 0 0 0 5.5-2 8.08 8.08 0 0 0-5.5-2h-.75c.19-.16.38-.33.56-.51a8.07 8.07 0 0 0 2.47-5.3 8.07 8.07 0 0 0-5.3 2.47A8.07 8.07 0 0 0 22 22a8.07 8.07 0 0 0 2.47 5.3 8.07 8.07 0 0 0 5.3 2.47 8.07 8.07 0 0 0-2.47-5.3c-.17-.17-.36-.34-.55-.47zm-7.23-7.31a8.07 8.07 0 0 0-5.3-2.47 8.07 8.07 0 0 0 2.47 5.3c.18.18.37.35.56.51h-.75A8.08 8.08 0 0 0 11 22a8.08 8.08 0 0 0 5.5 2h.75c-.19.16-.38.33-.56.51a8.07 8.07 0 0 0-2.47 5.3 8.07 8.07 0 0 0 5.3-2.47A8.07 8.07 0 0 0 22 22a8.07 8.07 0 0 0-2.48-5.31z" fill="#195f28"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1">
            <title>C1</title>
            <path d="M18.14 15.57c0-1.42.87-2.57 1.93-2.57S22 14.15 22 15.57c0-1.42.86-2.57 1.93-2.57s1.93.64 1.93 2.57a6.86 6.86 0 0 1-1.36 3.93 6.86 6.86 0 0 1 3.93-1.36c1.42 0 2.57.87 2.57 1.93S29.85 22 28.43 22c1.42 0 2.57.86 2.57 1.93s-.64 1.93-2.57 1.93a6.86 6.86 0 0 1-3.93-1.36 6.86 6.86 0 0 1 1.36 3.93c0 1.42-.87 2.57-1.93 2.57S22 29.85 22 28.43c0 1.42-.86 2.57-1.93 2.57s-1.93-.64-1.93-2.57a6.86 6.86 0 0 1 1.36-3.93 6.86 6.86 0 0 1-3.93 1.36c-1.42 0-2.57-.86-2.57-1.93S14.15 22 15.57 22c-1.42 0-2.57-.86-2.57-1.93s.64-1.93 2.57-1.93a6.86 6.86 0 0 1 3.93 1.36 6.86 6.86 0 0 1-1.36-3.93z" fill="#195f28" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="bg-color">
            <path fill="#f3b3b3" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12">
            <title>B12</title>
            <path d="M15 7l7-7 7 7-7 7zm0 30l7-7 7 7-7 7zm-8-8l-7-7 7-7 7 7zm30 0l-7-7 7-7 7 7z" fill="#ef2e7f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11">
            <title>B11</title>
            <path d="M22 43.87l-1.2-1.58c-.23-.31-.5-.65-.79-1a12.72 12.72 0 0 0-4.45-3.73 12.71 12.71 0 0 0-5.79-.51c-.46 0-.88.09-1.27.14l-2 .27.27-2c.05-.39.1-.82.14-1.27a12.71 12.71 0 0 0-.51-5.79A12.72 12.72 0 0 0 2.71 24c-.35-.29-.69-.56-1-.79L.13 22l1.58-1.2c.31-.23.65-.5 1-.79a12.72 12.72 0 0 0 3.73-4.45A12.71 12.71 0 0 0 7 9.77c0-.45-.09-.88-.14-1.27l-.27-2 2 .27L9.77 7a12.71 12.71 0 0 0 5.79-.51A12.72 12.72 0 0 0 20 2.71c.29-.35.56-.69.79-1L22 .13l1.2 1.58c.23.31.5.65.79 1a12.72 12.72 0 0 0 4.45 3.73 12.71 12.71 0 0 0 5.79.56l1.27-.14 2-.27-.27 2c0 .39-.1.82-.14 1.27a12.71 12.71 0 0 0 .51 5.79A12.72 12.72 0 0 0 41.29 20c.35.29.69.56 1 .79L43.87 22l-1.58 1.2c-.31.23-.65.5-1 .79a12.72 12.72 0 0 0-3.73 4.45 12.71 12.71 0 0 0-.51 5.79c0 .45.09.88.14 1.27l.27 2-2-.27c-.39 0-.81-.1-1.27-.14a12.71 12.71 0 0 0-5.79.51 12.72 12.72 0 0 0-4.4 3.69c-.29.35-.56.69-.79 1zM11.72 34a13 13 0 0 1 5 .84A14.92 14.92 0 0 1 22 39a14.92 14.92 0 0 1 5.29-4.21A14.88 14.88 0 0 1 34 34a14.88 14.88 0 0 1 .77-6.73A14.92 14.92 0 0 1 39 22a14.92 14.92 0 0 1-4.21-5.29A14.88 14.88 0 0 1 34 10a14.88 14.88 0 0 1-6.73-.77A14.92 14.92 0 0 1 22 5a14.92 14.92 0 0 1-5.29 4.21A14.88 14.88 0 0 1 10 10a14.88 14.88 0 0 1-.77 6.73A14.92 14.92 0 0 1 5 22a14.92 14.92 0 0 1 4.21 5.29A14.88 14.88 0 0 1 10 34h1.72z" fill="#ef2e7f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10">
            <title>B10</title>
            <path d="M18.63 6H6v12.63zM38 18.63V6H25.37zM18.63 38H6V25.37zM38 38V25.37L25.37 38z" fill="#ef2e7f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9">
            <title>B9</title>
            <path d="M15 7l7-7 7 7-7 7zm0 30l7-7 7 7-7 7zm-8-8l-7-7 7-7 7 7zm30 0l-7-7 7-7 7 7z" fill="#5bb56f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8">
            <title>B8</title>
            <path d="M22 43.87l-1.2-1.58c-.23-.31-.5-.65-.79-1a12.72 12.72 0 0 0-4.45-3.73 12.71 12.71 0 0 0-5.79-.51c-.46 0-.88.09-1.27.14l-2 .27.27-2c.05-.39.1-.82.14-1.27a12.71 12.71 0 0 0-.51-5.79A12.72 12.72 0 0 0 2.71 24c-.35-.29-.69-.56-1-.79L.13 22l1.58-1.2c.31-.23.65-.5 1-.79a12.72 12.72 0 0 0 3.73-4.45A12.71 12.71 0 0 0 7 9.77c0-.45-.09-.88-.14-1.27l-.27-2 2 .27L9.77 7a12.71 12.71 0 0 0 5.79-.51A12.72 12.72 0 0 0 20 2.71c.29-.35.56-.69.79-1L22 .13l1.2 1.58c.23.31.5.65.79 1a12.72 12.72 0 0 0 4.45 3.73 12.71 12.71 0 0 0 5.79.56l1.27-.14 2-.27-.27 2c0 .39-.1.82-.14 1.27a12.71 12.71 0 0 0 .51 5.79A12.72 12.72 0 0 0 41.29 20c.35.29.69.56 1 .79L43.87 22l-1.58 1.2c-.31.23-.65.5-1 .79a12.72 12.72 0 0 0-3.73 4.45 12.71 12.71 0 0 0-.51 5.79c0 .45.09.88.14 1.27l.27 2-2-.27c-.39 0-.81-.1-1.27-.14a12.71 12.71 0 0 0-5.79.51 12.72 12.72 0 0 0-4.4 3.69c-.29.35-.56.69-.79 1zM11.72 34a13 13 0 0 1 5 .84A14.92 14.92 0 0 1 22 39a14.92 14.92 0 0 1 5.29-4.21A14.88 14.88 0 0 1 34 34a14.88 14.88 0 0 1 .77-6.73A14.92 14.92 0 0 1 39 22a14.92 14.92 0 0 1-4.21-5.29A14.88 14.88 0 0 1 34 10a14.88 14.88 0 0 1-6.73-.77A14.92 14.92 0 0 1 22 5a14.92 14.92 0 0 1-5.29 4.21A14.88 14.88 0 0 1 10 10a14.88 14.88 0 0 1-.77 6.73A14.92 14.92 0 0 1 5 22a14.92 14.92 0 0 1 4.21 5.29A14.88 14.88 0 0 1 10 34h1.72z" fill="#5bb56f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7">
            <title>B7</title>
            <path d="M18.63 6H6v12.63zM38 18.63V6H25.37zM18.63 38H6V25.37zM38 38V25.37L25.37 38z" fill="#5bb56f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6">
            <title>B6</title>
            <path d="M15 7l7-7 7 7-7 7zm0 30l7-7 7 7-7 7zm-8-8l-7-7 7-7 7 7zm30 0l-7-7 7-7 7 7z" fill="#f3fff4"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5">
            <title>B4</title>
            <path d="M18.63 6H6v12.63zM38 18.63V6H25.37zM18.63 38H6V25.37zM38 38V25.37L25.37 38z" fill="#f3fff4"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4">
            <title>B5</title>
            <path d="M22 43.87l-1.2-1.58c-.23-.31-.5-.65-.79-1a12.72 12.72 0 0 0-4.45-3.73 12.71 12.71 0 0 0-5.79-.51c-.46 0-.88.09-1.27.14l-2 .27.27-2c.05-.39.1-.82.14-1.27a12.71 12.71 0 0 0-.51-5.79A12.72 12.72 0 0 0 2.71 24c-.35-.29-.69-.56-1-.79L.13 22l1.58-1.2c.31-.23.65-.5 1-.79a12.72 12.72 0 0 0 3.73-4.45A12.71 12.71 0 0 0 7 9.77c0-.45-.09-.88-.14-1.27l-.27-2 2 .27L9.77 7a12.71 12.71 0 0 0 5.79-.51A12.72 12.72 0 0 0 20 2.71c.29-.35.56-.69.79-1L22 .13l1.2 1.58c.23.31.5.65.79 1a12.72 12.72 0 0 0 4.45 3.73 12.71 12.71 0 0 0 5.79.56l1.27-.14 2-.27-.27 2c0 .39-.1.82-.14 1.27a12.71 12.71 0 0 0 .51 5.79A12.72 12.72 0 0 0 41.29 20c.35.29.69.56 1 .79L43.87 22l-1.58 1.2c-.31.23-.65.5-1 .79a12.72 12.72 0 0 0-3.73 4.45 12.71 12.71 0 0 0-.51 5.79c0 .45.09.88.14 1.27l.27 2-2-.27c-.39 0-.81-.1-1.27-.14a12.71 12.71 0 0 0-5.79.51 12.72 12.72 0 0 0-4.4 3.69c-.29.35-.56.69-.79 1zM11.72 34a13 13 0 0 1 5 .84A14.92 14.92 0 0 1 22 39a14.92 14.92 0 0 1 5.29-4.21A14.88 14.88 0 0 1 34 34a14.88 14.88 0 0 1 .77-6.73A14.92 14.92 0 0 1 39 22a14.92 14.92 0 0 1-4.21-5.29A14.88 14.88 0 0 1 34 10a14.88 14.88 0 0 1-6.73-.77A14.92 14.92 0 0 1 22 5a14.92 14.92 0 0 1-5.29 4.21A14.88 14.88 0 0 1 10 10a14.88 14.88 0 0 1-.77 6.73A14.92 14.92 0 0 1 5 22a14.92 14.92 0 0 1 4.21 5.29A14.88 14.88 0 0 1 10 34h1.72z" fill="#f3fff4"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3">
            <title>B3</title>
            <path d="M15 7l7-7 7 7-7 7zm0 30l7-7 7 7-7 7zm-8-8l-7-7 7-7 7 7zm30 0l-7-7 7-7 7 7z" fill="#195f28"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2">
            <title>B2</title>
            <path d="M22 43.87l-1.2-1.58c-.23-.31-.5-.65-.79-1a12.72 12.72 0 0 0-4.45-3.73 12.71 12.71 0 0 0-5.79-.51c-.46 0-.88.09-1.27.14l-2 .27.27-2c.05-.39.1-.82.14-1.27a12.71 12.71 0 0 0-.51-5.79A12.72 12.72 0 0 0 2.71 24c-.35-.29-.69-.56-1-.79L.13 22l1.58-1.2c.31-.23.65-.5 1-.79a12.72 12.72 0 0 0 3.73-4.45A12.71 12.71 0 0 0 7 9.77c0-.45-.09-.88-.14-1.27l-.27-2 2 .27L9.77 7a12.71 12.71 0 0 0 5.79-.51A12.72 12.72 0 0 0 20 2.71c.29-.35.56-.69.79-1L22 .13l1.2 1.58c.23.31.5.65.79 1a12.72 12.72 0 0 0 4.45 3.73 12.71 12.71 0 0 0 5.79.56l1.27-.14 2-.27-.27 2c0 .39-.1.82-.14 1.27a12.71 12.71 0 0 0 .51 5.79A12.72 12.72 0 0 0 41.29 20c.35.29.69.56 1 .79L43.87 22l-1.58 1.2c-.31.23-.65.5-1 .79a12.72 12.72 0 0 0-3.73 4.45 12.71 12.71 0 0 0-.51 5.79c0 .45.09.88.14 1.27l.27 2-2-.27c-.39 0-.81-.1-1.27-.14a12.71 12.71 0 0 0-5.79.51 12.72 12.72 0 0 0-4.4 3.69c-.29.35-.56.69-.79 1zM11.72 34a13 13 0 0 1 5 .84A14.92 14.92 0 0 1 22 39a14.92 14.92 0 0 1 5.29-4.21A14.88 14.88 0 0 1 34 34a14.88 14.88 0 0 1 .77-6.73A14.92 14.92 0 0 1 39 22a14.92 14.92 0 0 1-4.21-5.29A14.88 14.88 0 0 1 34 10a14.88 14.88 0 0 1-6.73-.77A14.92 14.92 0 0 1 22 5a14.92 14.92 0 0 1-5.29 4.21A14.88 14.88 0 0 1 10 10a14.88 14.88 0 0 1-.77 6.73A14.92 14.92 0 0 1 5 22a14.92 14.92 0 0 1 4.21 5.29A14.88 14.88 0 0 1 10 34h1.72z" fill="#195f28"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1">
            <title>B1</title>
            <path d="M18.63 6H6v12.63zM38 18.63V6H25.37zM18.63 38H6V25.37zM38 38V25.37L25.37 38z" fill="#195f28"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9">
            <title>A9</title>
            <path d="M11.39 17.61L7 22l4.39 4.39v6.22h6.22L22 37l4.39-4.39h6.22v-6.22L37 22l-4.39-4.39v-6.22h-6.22L22 7l-4.39 4.39h-6.22z" fill="#5bb56f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8">
            <title>A8</title>
            <path d="M37.56 6.44L22 0 6.44 6.44 0 22l6.44 15.56L22 44l15.56-6.44L44 22zm-6.37 6.37L22 9l-9.19 3.81L9 22l3.81 9.19L22 35l9.19-3.81L35 22z" fill="#5bb56f" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7">
            <title>A7</title>
            <path d="M12 0h20v12h-5.86L22 7.86 17.86 12H12zm0 32v-5.86L7.86 22 12 17.86V12H0v20zm20 0v-5.86L36.14 22 32 17.86V12h12v20zm0 0h-5.86L22 36.14 17.86 32H12v12h20z" fill="#5bb56f"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6">
            <title>A6</title>
            <path d="M11.39 17.61L7 22l4.39 4.39v6.22h6.22L22 37l4.39-4.39h6.22v-6.22L37 22l-4.39-4.39v-6.22h-6.22L22 7l-4.39 4.39h-6.22z" fill="#f3fff4"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5">
            <title>A5</title>
            <path d="M37.56 6.44L22 0 6.44 6.44 0 22l6.44 15.56L22 44l15.56-6.44L44 22zm-6.37 6.37L22 9l-9.19 3.81L9 22l3.81 9.19L22 35l9.19-3.81L35 22z" fill="#f3fff4" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4">
            <title>A4</title>
            <path d="M12 0h20v12h-5.86L22 7.86 17.86 12H12zm0 32v-5.86L7.86 22 12 17.86V12H0v20zm20 0v-5.86L36.14 22 32 17.86V12h12v20zm0 0h-5.86L22 36.14 17.86 32H12v12h20z" fill="#f3fff4"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3">
            <title>A3</title>
            <path d="M11.39 17.61L7 22l4.39 4.39v6.22h6.22L22 37l4.39-4.39h6.22v-6.22L37 22l-4.39-4.39v-6.22h-6.22L22 7l-4.39 4.39h-6.22z" fill="#195f28"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2">
            <title>A2</title>
            <path d="M37.56 6.44L22 0 6.44 6.44 0 22l6.44 15.56L22 44l15.56-6.44L44 22zm-6.37 6.37L22 9l-9.19 3.81L9 22l3.81 9.19L22 35l9.19-3.81L35 22z" fill="#195f28" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1">
            <title>A1</title>
            <path d="M12 0h20v12h-5.86L22 7.86 17.86 12H12zm0 32v-5.86L7.86 22 12 17.86V12H0v20zm20 0v-5.86L36.14 22 32 17.86V12h12v20zm0 0h-5.86L22 36.14 17.86 32H12v12h20z" fill="#195f28"></path>
        </symbol>
    </svg>`,

    'symbols': {
        'Z': 3,
        'A': 9,
        'B': 12,
        'C': 12
    },

    },
    {
        'id': 2,
        'svg': `<svg width="0" height="0" class="hidden">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1">
        <title>Z1</title>
        <rect y="0" style="fill:#3fb3b1;" width="44" height="44"/>
      </symbol>

      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2">
      <title>Z2</title>
      <rect y="0" style="fill:#ffcd85;" width="44" height="44"/>
    </symbol>

    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3">
    <title>Z3</title>
    <rect y="0" style="fill:#f26969;" width="44" height="44"/>
  </symbol>



      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1">
      <title>A1</title>
      <polygon  style="fill:#FFFFFF;" points="30.1,2.6 14.3,2.6 2.3,14.6 2.3,30 14.6,41.5 30.3,41.5 41.6,29.9 41.6,15 "/>
      <path style="fill:#F7941C;" d="M6.8,28.5c0,0,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1c0.4,0.4,1.1-0.1,1-0.6C7.6,27.7,6.8,27.8,6.8,28.5z"
      />
  <path style="fill:#F7941C;" d="M7.9,16.3c0.1-0.5-0.6-1-1-0.6c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1C6.8,16.6,7.6,16.7,7.9,16.3z"
      />
  <path style="fill:#F7941C;" d="M16.8,35.1c-2.4-0.2-4.7-0.2-7.1-0.1c1.7,1.6,3.7,3.5,5.5,4.9c2.6,0.1,4.4,0,6.7,0.1
      C20.3,38.3,18.6,36.7,16.8,35.1z M16.1,38.5c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2
      c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1c-0.5-0.6-0.5-1.4,0.1-2c0.4-0.4,1-0.5,1.5-0.4c0.5,0.3,0.8,0.8,0.8,1.3
      C17.4,37.8,16.8,38.4,16.1,38.5z"/>
  <path style="fill:#F7941C;" d="M16.3,36.5c-0.5-0.1-1,0.5-0.6,1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0
      C16.6,37.6,16.7,36.8,16.3,36.5z"/>
  <path style="fill:#F7941C;" d="M3.8,22.6c0.1,2.3-0.1,4.4,0,6.7c1.5,1.8,4,3.6,5.6,5.3c0.1-2.4,0.1-4.7-0.1-7.1
      C7.7,25.8,5.5,24.2,3.8,22.6z M8.3,29.3c-0.5,0.5-1.4,0.5-2,0.1c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1C6.1,29.1,6,29,6,28.9
      c0-0.1-0.1-0.2-0.1-0.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1C6,27.6,6.6,27,7.3,27c0.5,0,1.1,0.3,1.3,0.8C8.8,28.3,8.7,28.9,8.3,29.3z
      "/>
  <path style="fill:#F7941C;" d="M28.2,36.5c-0.4,0.3-0.3,1.1,0.3,1.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1
      C29.1,37.1,28.6,36.4,28.2,36.5z"/>
  <path style="fill:#F7941C;" d="M27.6,9.3c2.4,0.2,4.7,0.2,7.1,0.1c-1.7-1.6-3.5-3.8-5.3-5.3c-3.3,0-4.2,0-6.9,0
      C24,5.9,25.8,7.8,27.6,9.3z M28.4,6c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2
      c0,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0.5,0.6,0.5,1.4-0.1,2c-0.4,0.4-1,0.5-1.5,0.4C27.4,8.5,27,7.9,27,7.4
      C27,6.6,27.6,6,28.4,6z"/>
  <path style="fill:#F7941C;" d="M16.3,7.9c0.4-0.3,0.3-1.1-0.3-1.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1C15.3,7.4,15.8,8,16.3,7.9z"
      />
  <path style="fill:#F7941C;" d="M28.2,7.9c0.5,0.1,1-0.5,0.6-1c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0C27.9,6.8,27.8,7.6,28.2,7.9z"
      />
  <path style="fill:#F7941C;" d="M3.8,22.1c1.8-1.6,3.9-3.4,5.5-5.2c0.2-2.4,0.2-4.7,0.1-7.1c-2,2-3.6,3.4-5.6,5.4
      C3.5,17.5,3.9,19.8,3.8,22.1z M5.9,15.9c0-0.1,0-0.2,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1
      c0.6-0.5,1.4-0.5,2,0.1c0.4,0.4,0.5,1,0.4,1.5c-0.3,0.5-0.8,0.8-1.3,0.8c-0.8,0-1.4-0.6-1.4-1.3c0,0,0-0.1,0-0.1
      C5.9,15.9,5.9,15.9,5.9,15.9z"/>
  <path style="fill:#F7941C;" d="M16.8,9.3c1.8-1.6,3.5-3.4,5.1-5.2c-2.5,0-4.1-0.1-7,0c-1.8,1.5-3.4,3.7-5.1,5.3
      C12.1,9.5,14.5,9.5,16.8,9.3z M15,6.4C15,6.4,15.1,6.3,15,6.4c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.2
      C15.6,6,15.7,6,15.8,6c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.7,0.1,1.3,0.7,1.3,1.4c0,0.5-0.3,1.1-0.8,1.3c-0.5,0.1-1.1,0-1.5-0.4
      C14.5,7.8,14.6,7,15,6.4z"/>
  <path style="fill:#F7941C;" d="M40.1,21.9c0.1-3.6,0.1-3.6,0-6.3c-1.5-1.8-3.5-4.1-5-5.8c-0.1,2.4-0.1,4.7,0.1,7.1
      C36.7,18.7,38.4,20.4,40.1,21.9z M36.1,15.1c0.5-0.5,1.4-0.5,2-0.1c0,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1
      c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c-0.1,0.7-0.7,1.3-1.4,1.3
      c-0.5,0-1.1-0.3-1.3-0.8C35.6,16.1,35.8,15.5,36.1,15.1z"/>
  <path style="fill:#F7941C;" d="M40.1,22.5c-1.8,1.6-3.4,3.3-5,5.1c-0.2,2.4-0.2,4.7-0.1,7.1c1.6-1.7,3.6-3.6,5-5.4
      C40.4,27,40,24.8,40.1,22.5z M38.5,28.6c0,0.1,0,0.2-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1
      c-0.6,0.5-1.4,0.5-2-0.1c-0.4-0.4-0.5-1-0.4-1.5c0.3-0.5,0.8-0.8,1.3-0.8c0.8,0,1.4,0.6,1.4,1.3c0,0,0,0.1,0,0.1
      C38.5,28.5,38.5,28.5,38.5,28.6z"/>
  <path style="fill:#F7941C;" d="M36.6,28.1c-0.1,0.5,0.6,1,1,0.6c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1
      C37.6,27.8,36.8,27.7,36.6,28.1z"/>
  <path style="fill:#F7941C;" d="M27.6,35.1c-1.8,1.6-3.5,3.2-5.1,4.9c3,0,4.4,0,7.2-0.1c1.8-1.5,2.8-2.8,5-5
      C32.3,34.9,29.9,35,27.6,35.1z M29.4,38C29.4,38.1,29.4,38.1,29.4,38c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.2
      c-0.1,0-0.2,0.1-0.4,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0C27.6,38.4,27,37.8,27,37c0-0.5,0.3-1.1,0.8-1.3c0.5-0.1,1.1,0,1.5,0.4
      C29.9,36.6,29.9,37.5,29.4,38z"/>
  <path style="fill:#F7941C;" d="M37.7,16c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1c-0.4-0.4-1.1,0.1-1,0.6C36.8,16.7,37.6,16.6,37.7,16z"
      />
  </symbol>

  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2">
      <title>A2</title>
      <path style="fill:#00366D;" d="M39,15c-1.6-1.1-3.2-2.2-4.8-3.3c-0.4-0.2-0.7-0.5-1.1-0.7c-0.2-0.4-0.5-0.7-0.7-1.1
      c-1.1-1.6-2.3-3.2-3.3-4.8c-1.9,0.4-3.8,0.7-5.8,1c-0.4,0.1-0.8,0.2-1.3,0.3c-0.4-0.1-0.9-0.2-1.3-0.3c-1.9-0.4-3.8-0.7-5.8-1
      c-1.1,1.6-2.2,3.2-3.3,4.8c-0.2,0.4-0.5,0.7-0.7,1.1c-0.4,0.2-0.7,0.5-1.1,0.7C8.2,12.7,6.6,13.9,5,15c0.4,1.9,0.7,3.8,1,5.7
      c0.1,0.4,0.2,0.8,0.3,1.3c-0.1,0.4-0.2,0.8-0.3,1.3c-0.4,1.9-0.7,3.8-1,5.7c1.6,1.1,3.2,2.2,4.8,3.3c0.4,0.2,0.7,0.5,1.1,0.7
      c0.2,0.4,0.5,0.7,0.7,1.1c1.1,1.6,2.3,3.2,3.3,4.8c1.9-0.4,3.8-0.7,5.8-1c0.4-0.1,0.8-0.2,1.3-0.3c0.4,0.1,0.9,0.2,1.3,0.3
      c1.9,0.4,3.8,0.7,5.8,1c1.1-1.6,2.2-3.2,3.3-4.8c0.2-0.4,0.5-0.7,0.7-1.1c0.4-0.2,0.7-0.5,1.1-0.7c1.6-1.1,3.2-2.2,4.8-3.3
      c-0.4-1.9-0.7-3.8-1-5.7c-0.1-0.4-0.2-0.8-0.3-1.3c0.1-0.4,0.2-0.8,0.3-1.3C38.4,18.8,38.7,16.9,39,15z M37.1,28.2
      c-1.7,1.2-3.4,2.4-5.2,3.6c-1.2,1.8-2.4,3.4-3.6,5.2c-2.1-0.4-4.2-0.7-6.2-1.1c-2.1,0.4-4.2,0.7-6.2,1.1
      c-1.2-1.7-2.5-3.4-3.6-5.2c-1.8-1.1-3.5-2.4-5.2-3.6C7.3,26.1,7.6,24,8.1,22c-0.4-2.1-0.8-4.1-1.1-6.2c1.7-1.2,3.4-2.4,5.2-3.6
      c1.2-1.8,2.4-3.4,3.6-5.2C17.9,7.4,20,7.7,22,8.1c2.1-0.4,4.2-0.7,6.2-1.1c1.2,1.7,2.5,3.4,3.6,5.2c1.8,1.1,3.5,2.4,5.2,3.6
      c-0.4,2.1-0.7,4.1-1.1,6.2C36.4,24,36.7,26.1,37.1,28.2z"/>

    </symbol>

    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3">
    <title>A3</title>
    <path  style="fill:#D03F44;" d="M-0.1-0.2v44.2h44.2V-0.2H-0.1z M1.4,3.6c0.4,0.2,1,0.3,1.5,0.1C2.6,4.3,2.5,5,2.8,5.6
    c0.5,1.2,2.1,1.7,3.2,1c0.1,0,0.2-0.1,0.3-0.2C6,6.8,6,7.2,6.1,7.6C6.4,8.1,7,8.4,7.6,8.2c0.5,2.4-0.2,4.9-1.3,7.1
    c-0.8,2.1-1.8,4-3.4,5.4c-0.1-0.2-0.3-0.3-0.5-0.4c-0.3-0.2-0.7-0.2-1-0.2V3.6z M42.6,20.3c-0.7-0.2-1.4-0.1-1.9,0.4
    c-1.6-1.4-2.6-3.3-3.3-5.3c-1.1-2.4-1.8-4.9-1.2-7.4c0.1,0.1,0.3,0.2,0.5,0.2c0.8,0.3,1.7-0.1,2.1-0.9c0.1-0.4,0.1-0.8-0.1-1.2
    c0.1,0.1,0.3,0.1,0.4,0.2c1.1,0.3,2.3-0.2,2.8-1.2c0.2-0.8,0.1-1.6-0.4-2.3c0.1,0,0.2,0.1,0.2,0.1c0.3,0.1,0.6,0.1,0.8,0V20.3z
     M40.3,21.8c-2,1.4-3.2,3.6-4.1,5.9c-1,2.2-1.7,4.7-1.2,7.1c0,0,0,0,0,0c0,0,0,0,0,0c-2.4-0.4-4.8,0.3-7.1,1.3
    c-2.3,0.9-4.5,2.1-5.9,4.1c0,0,0,0,0,0c0,0,0,0,0,0c-1.4-2-3.6-3.3-5.9-4.1c-2.2-1-4.7-1.7-7.1-1.3c0,0,0,0,0,0c0,0,0,0,0,0
    c0.4-2.4-0.3-4.9-1.2-7.1c-0.9-2.3-2.1-4.5-4.1-5.9c0,0,0,0,0,0c0,0,0,0,0,0c2-1.4,3.2-3.6,4.1-5.9c1-2.2,1.7-4.7,1.2-7.1
    c0,0,0,0,0,0c0,0,0,0,0,0c2.4,0.4,4.8-0.3,7.1-1.3c2.3-0.9,4.5-2.1,5.9-4.1c0,0,0,0,0,0c0,0,0,0,0,0c1.4,2,3.6,3.3,5.9,4.1
    c2.2,1,4.7,1.7,7.1,1.3c0,0,0,0,0,0c0,0,0,0,0,0c-0.4,2.4,0.3,4.9,1.2,7.1C37,18.2,38.2,20.4,40.3,21.8
    C40.2,21.8,40.2,21.8,40.3,21.8C40.2,21.8,40.2,21.8,40.3,21.8z M41.1,2.4c-0.1-0.1-0.2-0.1-0.3-0.2c-1.2-0.6-2.7-0.2-3.2,1
    c-0.3,0.6-0.2,1.3,0.1,1.9c-0.8-0.3-1.9,0-2.2,0.9c-0.2,0.5-0.1,1.1,0.2,1.5c-2.5,0.6-5-0.1-7.4-1.2c-2.5-0.9-4.8-2.3-6.1-4.5
    c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0.2c-1.3,2.2-3.6,3.6-6.1,4.5c-2.2,1-4.7,1.7-7,1.3
    c0.1-0.3,0.2-0.6,0.1-1C8.2,6,7.6,5.8,7,5.9C6.9,6,6.8,6,6.7,6c0.5-0.6,0.7-1.5,0.4-2.3c-0.6-1-1.7-1.5-2.8-1.2
    C4.2,2.6,4,2.7,3.9,2.8C4.1,2.4,4.1,1.9,4,1.5c0-0.1-0.1-0.1-0.1-0.2h37.1C40.8,1.7,40.9,2.1,41.1,2.4z M1.4,23.4
    C2,23.5,2.6,23.3,3,22.9c1.6,1.4,2.6,3.3,3.4,5.3c1.1,2.4,1.8,5,1.2,7.5c0,0,0,0.1,0,0.1c0,0,0,0,0,0c-0.6-0.3-1.5-0.1-1.7,0.6
    c-0.2,0.4-0.1,0.8,0.1,1.1c-0.1-0.1-0.2-0.1-0.3-0.2c-1.2-0.6-2.7-0.2-3.2,1c-0.3,0.6-0.2,1.3,0.1,1.9c-0.3-0.1-0.7-0.2-1.1-0.1
    V23.4z M3.5,41.2c0.1,0.1,0.3,0.1,0.4,0.2c1.1,0.3,2.3-0.2,2.8-1.2c0.2-0.8,0.1-1.6-0.4-2.3c0.1,0,0.2,0.1,0.2,0.1
    c0.6,0.2,1.2-0.1,1.5-0.6c0.1-0.4,0-0.9-0.2-1.2c0,0,0,0,0.1,0c2.5-0.6,5.1,0.1,7.5,1.2c2.5,0.9,4.8,2.3,6.1,4.5
    c0.1,0.1,0.2,0.2,0.3,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2,0,0.3-0.2c1.3-2.2,3.6-3.6,6.1-4.5c2.4-1.1,4.9-1.8,7.4-1.2
    c-0.3,0.5-0.4,1-0.2,1.6c0.3,0.9,1.4,1.2,2.3,0.9c-0.3,0.6-0.4,1.3-0.1,1.9c0.5,1.3,2.1,1.7,3.3,1.1c0.1,0,0.2-0.1,0.3-0.2
    c-0.2,0.3-0.3,0.7-0.1,1.1c0,0,0,0,0,0H3.4c0-0.1,0.1-0.1,0.1-0.2C3.7,42,3.7,41.5,3.5,41.2z M42,40.8c-0.1,0-0.2,0.1-0.3,0.1
    c0.5-0.6,0.7-1.5,0.5-2.3c-0.6-1.1-1.8-1.6-2.9-1.2c-0.2,0-0.3,0.1-0.4,0.2c0.2-0.4,0.2-0.8,0.1-1.3c-0.4-0.8-1.3-1.2-2.2-0.9
    c-0.2,0.1-0.4,0.1-0.5,0.2c-0.6-2.5,0.1-5,1.2-7.4c0.8-2.1,1.8-4,3.4-5.4c0.2,0.2,0.5,0.4,0.8,0.5c0.4,0.1,0.7,0.1,1,0v17.5
    C42.4,40.8,42.2,40.8,42,40.8z"/>
  </symbol>

  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4">
  <title>A4</title>
  <path style="fill:#15366C;" d="M5.2,38.4c0,0.3,0,0.7-0.1,1c0.3,0,0.7-0.1,1-0.1c0.2,0.3,0.3,0.6,0.4,0.9C6.8,40,7,39.8,7.3,39.6
  c0.3,0.2,0.6,0.4,0.8,0.6c0.1-0.3,0.3-0.6,0.4-0.9c0.3,0,0.7,0,1,0.1c0-0.3-0.1-0.7-0.1-1c0.3-0.2,0.6-0.3,0.9-0.4
  c-0.3-0.3-0.5-0.5-0.5-0.8c0.2-0.3,0.4-0.6,0.6-0.8c-0.3-0.1-0.6-0.3-0.9-0.4c0-0.3,0-0.7,0.1-1c-0.3,0-0.7,0.1-1,0.1
  c-0.2-0.3-0.3-0.6-0.4-0.9c-0.3,0.2-0.5,0.4-0.8,0.6c-0.3-0.2-0.6-0.4-0.8-0.6c-0.1,0.3-0.3,0.6-0.4,0.9c-0.3,0-0.7,0-1-0.1
  c0,0.3,0.1,0.7,0.1,1c-0.3,0.2-0.6,0.3-0.9,0.4c0.2,0.3,0.4,0.5,0.6,0.8c-0.2,0.3-0.4,0.6-0.6,0.8C4.7,38.1,5,38.2,5.2,38.4z"/>
<path style="fill:#15366C;" d="M5.4,8.2c0,0.3,0,0.7-0.1,1c0.3,0,0.7-0.1,1-0.1C6.5,9.4,6.6,9.7,6.7,10C7,9.8,7.2,9.6,7.5,9.4
  C7.8,9.6,8,9.8,8.3,10c0.1-0.3,0.2-0.6,0.4-0.9c0.3,0,0.6,0.1,0.9,0.1c0-0.3-0.1-0.7-0.1-1c0.3-0.1,0.6-0.2,0.9-0.3
  C10.2,7.6,10,7.4,9.8,7.1c0.2-0.3,0.4-0.6,0.7-0.8C10.2,6.2,9.9,6,9.6,5.9c0-0.3,0-0.7,0.1-1C9.3,5,9,5,8.7,5
  C8.5,4.7,8.4,4.4,8.3,4.1C8,4.4,7.8,4.6,7.5,4.7C7.2,4.6,7,4.4,6.7,4.2C6.6,4.5,6.4,4.8,6.3,5.1C6,5,5.7,5,5.4,4.9
  c0,0.3,0.1,0.7,0.1,1C5.2,6.1,4.9,6.2,4.6,6.3C4.8,6.5,5,6.8,5.2,7.1C5,7.3,4.8,7.6,4.6,7.9C4.9,8,5.2,8.1,5.4,8.2z"/>
<path style="fill:#15366C;" d="M38.5,36c0-0.3,0-0.7,0.1-1c-0.3,0-0.7,0.1-1,0.1c-0.2-0.3-0.3-0.6-0.4-0.9
  c-0.3,0.2-0.5,0.4-0.8,0.6c-0.3-0.2-0.6-0.4-0.8-0.6c-0.1,0.3-0.3,0.6-0.4,0.9c-0.3,0-0.7,0-1-0.1c0,0.3,0.1,0.7,0.1,1
  c-0.3,0.2-0.6,0.3-0.9,0.4c0.2,0.3,0.4,0.5,0.6,0.8c-0.2,0.3-0.4,0.6-0.6,0.8c0.3,0.1,0.6,0.3,0.9,0.4c0,0.3,0,0.7-0.1,1
  c0.3,0,0.7-0.1,1-0.1c0.2,0.3,0.3,0.6,0.4,0.9c0.3-0.2,0.5-0.4,0.8-0.6c0.3,0.2,0.6,0.4,0.8,0.6c0.1-0.3,0.3-0.6,0.4-0.9
  c0.3,0,0.7,0,1,0.1c0-0.3-0.1-0.7-0.1-1c0.3-0.2,0.6-0.3,0.9-0.4c-0.2-0.3-0.5-0.5-0.6-0.8c0.2-0.3,0.4-0.6,0.6-0.8
  C39.1,36.3,38.8,36.1,38.5,36z"/>
<path style="fill:#15366C;" d="M34.3,8.3c0,0.3,0,0.7-0.1,1c0.3,0,0.7-0.1,1-0.1c0.2,0.3,0.3,0.6,0.4,0.9c0.3-0.2,0.5-0.4,0.8-0.6
  c0.3,0.2,0.6,0.4,0.8,0.6c0.1-0.3,0.3-0.6,0.4-0.9c0.3,0,0.7,0,1,0.1c0-0.3-0.1-0.7-0.1-1c0.3-0.2,0.6-0.3,0.9-0.4
  c-0.2-0.3-0.5-0.6-0.6-0.8c0.2-0.3,0.4-0.6,0.6-0.8c-0.3-0.1-0.6-0.3-0.9-0.4c0-0.3,0-0.7,0.1-1c-0.3,0-0.7,0.1-1,0.1
  c-0.2-0.3-0.3-0.6-0.4-0.9c-0.3,0.2-0.5,0.4-0.8,0.6c-0.3-0.2-0.6-0.4-0.8-0.6c-0.1,0.3-0.3,0.6-0.4,0.9c-0.3,0-0.7,0-1-0.1
  c0,0.3,0.1,0.7,0.1,1c-0.3,0.2-0.6,0.3-0.9,0.4c0.2,0.3,0.4,0.5,0.6,0.8c-0.2,0.3-0.4,0.6-0.6,0.8C33.7,8,34,8.2,34.3,8.3z"/>
</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5">
<title>A5</title>
<path style="fill:#FFFFFF;" d="M5.3,31.6c0.7,1.6,1.4,3.3,2.1,4.9c1.6,0.7,3.3,1.4,4.9,2.1c1.4,1.1,2.8,2.2,4.3,3.2
c1.8-0.2,3.5-0.5,5.3-0.7c1.8,0.2,3.6,0.5,5.3,0.7c1.4-1.1,2.8-2.2,4.3-3.2c1.6-0.7,3.3-1.4,4.9-2.1c0.7-1.6,1.4-3.3,2.1-4.9
c1.1-1.4,2.2-2.8,3.2-4.3c-0.2-1.8-0.5-3.5-0.7-5.3c0.2-1.8,0.5-3.6,0.7-5.3c-1.1-1.4-2.2-2.8-3.2-4.3c-0.7-1.6-1.4-3.3-2.1-4.9
c-1.6-0.7-3.3-1.4-4.9-2.1c-1.4-1.1-2.8-2.2-4.3-3.2c-1.8,0.2-3.5,0.5-5.3,0.7c-1.8-0.2-3.6-0.5-5.3-0.7c-1.4,1.1-2.8,2.2-4.3,3.2
C10.7,6.1,9,6.8,7.4,7.5C6.7,9.1,6,10.8,5.3,12.4c-1.1,1.4-2.2,2.8-3.2,4.3c0.2,1.8,0.5,3.5,0.7,5.3c-0.2,1.8-0.5,3.6-0.7,5.3
C3.2,28.7,4.3,30.2,5.3,31.6z"/>
</symbol>



<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6">
<title>A6</title>
<path style="fill:#FFFFFF;" d="M10.3,33.8c1.9,1.9,4.3,2.9,6.8,3.5
l4.8,4.8l4.8-4.8l0.1,0c2.5-0.6,4.9-1.6,6.8-3.5c1.9-1.9,2.9-4.2,3.5-6.8l0-0.1l4.8-4.8l-4.8-4.8l0-0.1c-0.6-2.5-1.6-4.9-3.5-6.8
c-1.9-1.9-4.2-2.9-6.8-3.5l-0.1,0L22,2.1L17.1,7l-0.1,0c-2.5,0.6-4.9,1.6-6.8,3.5c-1.9,1.9-2.9,4.2-3.5,6.8l0,0.1l-3.3,3.3L2,22.1
L6.8,27l0,0.1C7.4,29.6,8.4,31.9,10.3,33.8z"/>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7">
<title>A7</title>
<path  style="fill:#FFFFFF;" d="M6.1,28.2c0.3,0.3,0.3,0.4,0,0.8c-2,2.4-2.7,5.1-1.9,8.2c0.3,1.2,1,2.1,2.1,2.5
		c3.2,1.2,6.2,0.5,8.8-1.7c0.3-0.2,0.4-0.3,0.8,0c3.5,3,8.9,3,12.4,0c0.3-0.2,0.4-0.3,0.6,0c1.7,1.6,3.8,2.2,6.4,2.3
		c0.3,0,0.9-0.1,1.4-0.2c1.9-0.4,3-1.5,3.3-3.3c0.5-2.9-0.1-5.5-2-7.7c-0.3-0.3-0.3-0.5,0-0.8c3-3.3,3-8.9,0-12.3
		c-0.3-0.3-0.3-0.5,0-0.8c2-2.4,2.6-5.1,1.9-8.1c-0.3-1.5-1.3-2.4-2.8-2.8c-3-0.7-5.7-0.1-8.1,1.9c-0.3,0.3-0.4,0.4-0.8,0
		c-3.4-3-8.9-3-12.3,0c-0.3,0.2-0.4,0.3-0.7,0c-2-1.8-4.4-2.4-7-2.2c-2.6,0.2-4,1.6-4.2,4.2c-0.3,2.6,0.4,5,2.2,7
		c0.3,0.3,0.3,0.4,0,0.8C3.1,19.3,3.1,24.8,6.1,28.2z"/>
</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8">
<title>A8</title>
<path  style="fill:#FFFFFF;" d="M10.4,33.5c1.9,1.9,4.2,2.9,6.8,3.5
l4.8,4.8l4.8-4.8l0.1,0c2.5-0.6,4.9-1.6,6.7-3.5c1.9-1.9,2.9-4.2,3.5-6.7l0-0.1l4.8-4.8l-4.8-4.8l0-0.1c-0.6-2.5-1.6-4.9-3.5-6.7
c-1.9-1.9-4.2-2.9-6.7-3.5l-0.1,0L22,2l-4.8,4.8l-0.1,0c-2.5,0.6-4.9,1.6-6.7,3.5c-1.9,1.9-2.9,4.2-3.5,6.7l0,0.1l-3.3,3.3
l-1.5,1.5l4.8,4.8l0,0.1C7.5,29.3,8.6,31.6,10.4,33.5z"/>
</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9">
<title>A9</title>
<path style="fill:#14366B;" d="M3.9,5.6C3.7,5.9,3.7,6.1,3.7,6.4c0,0.2,0.1,0.3,0.3,0.4C4.3,7,4.5,7.1,4.7,7.1
c0.2,0.1,0.5,0.1,0.8,0.2C5.8,7.4,6,7.5,6.2,7.6c-0.4,0-0.8,0-1.2,0C4.7,7.7,4.4,7.8,4.3,7.9C4.1,8,4,8.1,4,8.3
c0,0.2,0.1,0.4,0.4,0.5C4.2,9,4.1,9.2,4,9.4c0,0.2,0,0.5,0,0.7c0.1,0.4,0.3,0.7,0.7,0.9c0.4,0.2,0.8,0.2,1.1,0.1
c0.2,0,0.2-0.2,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4c-0.2,0-0.4-0.1-0.6-0.2C5.1,10.1,5,10,5,9.7C5,9.4,5.2,9.2,5.4,9
c0.3-0.2,0.7-0.3,1.2-0.3c0.5,0,0.8,0.1,1.2,0.2c0.3,0.1,0.6,0.3,0.8,0.4C8.8,9.5,9,9.6,9.2,9.7c0.2,0.1,0.3,0,0.4-0.1
c0.1-0.2,0.2-0.3,0.1-0.5C9.6,9,9.5,8.8,9.4,8.5C9.3,8.3,9.1,8,9,7.7C8.8,7.4,8.8,7,8.7,6.5C8.7,6,8.8,5.7,9,5.4
C9.2,5.1,9.5,5,9.8,5c0.2,0,0.4,0.1,0.5,0.3c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2
c0.1-0.4,0.1-0.8-0.1-1.2c-0.2-0.4-0.5-0.6-0.9-0.7c-0.6-0.1-1,0-1.3,0.3C8.7,4,8.5,3.9,8.3,3.9C8.2,3.9,8,4,7.9,4.2
C7.8,4.4,7.7,4.7,7.6,5c-0.1,0.3-0.1,0.7,0,1.1C7.5,5.9,7.4,5.7,7.4,5.4C7.3,5.1,7.2,4.9,7.1,4.7C7.1,4.4,7,4.2,6.9,4
C6.8,3.9,6.7,3.7,6.5,3.7c-0.3-0.1-0.6,0-0.9,0.1C5.4,4,5.1,4.2,5,4.4C4.8,4.3,4.6,4.1,4.4,4C4.3,3.9,4.2,3.9,4.1,4
C4,4.2,4,4.3,4.1,4.4C4.2,4.6,4.4,4.8,4.5,5C4.3,5.1,4,5.3,3.9,5.6z"/>
<path style="fill:#14366B;" d="M4.7,36.9c-0.2,0.1-0.5,0.2-0.6,0.3c-0.2,0.1-0.3,0.2-0.3,0.4c-0.1,0.3,0,0.6,0.2,0.9
C4,38.7,4.3,38.8,4.5,39c-0.2,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.1,0.3,0,0.4c0.1,0.1,0.3,0.1,0.4,0c0.2-0.1,0.3-0.3,0.5-0.4
c0.2,0.3,0.4,0.5,0.6,0.6c0.3,0.1,0.5,0.2,0.9,0.1c0.2,0,0.3-0.1,0.4-0.3c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.1-0.5,0.2-0.8
c0.1-0.3,0.1-0.5,0.2-0.7c0,0.4,0,0.8,0.1,1.1c0.1,0.3,0.2,0.6,0.3,0.8C8.1,39.9,8.2,40,8.4,40c0.2,0,0.4-0.1,0.5-0.4
c0.2,0.2,0.4,0.3,0.6,0.3c0.2,0,0.5,0,0.8,0c0.4-0.1,0.7-0.3,0.9-0.7c0.2-0.4,0.3-0.8,0.2-1.1c-0.1-0.2-0.2-0.2-0.4-0.2
c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.2,0.3-0.5,0.3c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.3-0.3-0.7-0.3-1.1
c0-0.5,0.1-0.8,0.3-1.2c0.2-0.3,0.3-0.6,0.4-0.8c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.3-0.2-0.4-0.1
c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.5,0.3-0.8,0.4c-0.3,0.2-0.7,0.2-1.2,0.3c-0.5,0-0.9-0.1-1.2-0.3C5.2,34.8,5,34.5,5,34.2
c0-0.2,0.1-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0,0.2-0.2,0.2-0.4c0-0.2-0.1-0.4-0.2-0.4c-0.4-0.1-0.8-0.1-1.1,0.2
c-0.4,0.2-0.6,0.5-0.7,0.9C4,34.1,4,34.3,4,34.5c0,0.2,0.1,0.4,0.3,0.6C4.1,35.3,4,35.5,4,35.7c0,0.2,0.1,0.3,0.3,0.4
c0.2,0.1,0.5,0.2,0.8,0.3c0.3,0.1,0.7,0.1,1.2,0c-0.2,0.1-0.4,0.2-0.7,0.3C5.2,36.7,4.9,36.8,4.7,36.9z"/>
<path style="fill:#14366B;" d="M36.4,5c-0.1-0.3-0.1-0.6-0.3-0.8C36,4,35.8,3.9,35.7,3.9c-0.2,0-0.3,0.1-0.5,0.4
C35,4.1,34.8,4,34.6,4c-0.2,0-0.5,0-0.8,0c-0.4,0.1-0.7,0.3-0.9,0.7c-0.2,0.4-0.2,0.8-0.1,1.1c0,0.2,0.1,0.2,0.4,0.2
c0.2,0,0.3-0.1,0.4-0.2c0-0.2,0.1-0.4,0.2-0.6C33.8,5.1,34,5,34.2,5c0.3,0,0.6,0.1,0.8,0.4c0.2,0.3,0.3,0.7,0.3,1.1
c0,0.5-0.1,0.8-0.3,1.2c-0.2,0.3-0.3,0.6-0.4,0.8c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2,0,0.3,0.1,0.5c0.2,0.1,0.3,0.2,0.5,0.1
c0.2-0.1,0.3-0.2,0.6-0.3c0.2-0.1,0.5-0.3,0.8-0.4c0.3-0.2,0.7-0.2,1.2-0.3c0.5,0,0.9,0.1,1.2,0.3C38.9,9.1,39,9.4,39,9.7
c0,0.2-0.1,0.4-0.3,0.5c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.2,0.1,0.3,0.2,0.4c0.4,0.1,0.8,0.1,1.1-0.2
c0.4-0.2,0.6-0.5,0.7-0.9c0-0.3,0.1-0.5,0-0.7c0-0.2-0.1-0.4-0.3-0.6c0.3-0.2,0.4-0.3,0.4-0.5c0-0.2-0.1-0.3-0.3-0.4
c-0.2-0.1-0.5-0.2-0.8-0.2c-0.4,0-0.7-0.1-1.1,0c0.2-0.1,0.4-0.2,0.7-0.3c0.3-0.1,0.5-0.2,0.8-0.2C39.6,7,39.8,6.9,40,6.8
c0.2-0.1,0.3-0.2,0.3-0.4c0.1-0.3,0-0.6-0.2-0.9C40,5.3,39.8,5,39.5,4.9c0.2-0.2,0.3-0.4,0.4-0.5c0.1-0.2,0.1-0.3,0-0.4
c-0.1-0.1-0.3-0.1-0.4,0c-0.2,0.1-0.3,0.3-0.5,0.4c-0.2-0.3-0.4-0.5-0.6-0.6c-0.3-0.1-0.5-0.2-0.9-0.1c-0.2,0.1-0.3,0.2-0.4,0.3
c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.1,0.5-0.2,0.8c-0.1,0.3-0.1,0.5-0.2,0.7C36.4,5.7,36.4,5.3,36.4,5z"/>
<path style="fill:#14366B;" d="M34.3,38.9c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.1-0.2-0.2-0.4-0.2
c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.4-0.1,0.8,0.1,1.1c0.2,0.4,0.5,0.6,0.9,0.7c0.3,0.1,0.5,0.1,0.8,0c0.2,0,0.4-0.1,0.6-0.3
c0.2,0.3,0.4,0.4,0.5,0.4c0.2,0,0.3-0.1,0.4-0.3c0.1-0.2,0.2-0.5,0.2-0.8c0-0.3,0.1-0.7,0-1.1c0.1,0.2,0.2,0.4,0.2,0.7
c0.1,0.3,0.1,0.5,0.2,0.8c0.1,0.2,0.2,0.5,0.3,0.6c0.1,0.2,0.2,0.3,0.4,0.3c0.3,0.1,0.6,0,0.9-0.1c0.3-0.1,0.5-0.3,0.6-0.6
c0.2,0.2,0.4,0.3,0.5,0.4c0.2,0.1,0.3,0.1,0.4,0c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.2-0.3-0.3-0.4-0.5c0.3-0.2,0.5-0.4,0.6-0.6
c0.2-0.3,0.2-0.5,0.2-0.9c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.5-0.1-0.7-0.2
c0.4,0.1,0.8,0,1.1,0c0.4-0.1,0.6-0.2,0.8-0.3c0.2-0.1,0.3-0.2,0.3-0.4c0-0.2-0.1-0.4-0.4-0.6c0.2-0.2,0.3-0.3,0.3-0.6
c0-0.2,0-0.5,0-0.7c-0.1-0.4-0.3-0.7-0.7-0.9c-0.4-0.2-0.8-0.2-1.1-0.1c-0.2,0.1-0.2,0.2-0.2,0.4c0,0.2,0.1,0.3,0.2,0.4
c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.1,0.3,0.2,0.3,0.5c0,0.3-0.1,0.6-0.4,0.8c-0.3,0.2-0.7,0.3-1.2,0.2c-0.5,0-0.8-0.1-1.2-0.2
c-0.3-0.1-0.6-0.3-0.8-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.3,0-0.4,0.1c-0.1,0.2-0.2,0.3-0.1,0.5c0.1,0.2,0.2,0.4,0.3,0.6
c0.1,0.2,0.3,0.5,0.4,0.8c0.1,0.3,0.2,0.7,0.2,1.2c0.1,0.5,0,0.9-0.2,1.1C34.9,38.8,34.6,38.9,34.3,38.9z"/>
	
</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A10">
<title>A10</title>
<path style="fill:#14366B;" d="M13.2,4.8c-0.4-0.1-0.8-0.1-1-0.1c-0.9,0.1-1.6,0.8-2.1,1.7C9.8,6.2,9.6,5.9,9.4,5.7
C7.7,3.8,5.1,4,4.4,4C4.3,4.7,3.9,7.3,5.6,9.2C5.8,9.4,6,9.6,6.3,9.8c-0.9,0.5-1.6,1.2-1.8,2c-0.1,0.3-0.1,0.6,0,1
c0.8-0.3,2.2-0.6,3.9-0.5c1.3,0.1,2.4,0.3,3.2,0.6c0.3,0.2,0.7,0.1,1-0.1c0.3-0.2,0.4-0.6,0.2-1c-0.2-0.8-0.4-1.9-0.3-3.2
C12.4,6.9,12.8,5.6,13.2,4.8z"/>
<path style="fill:#14366B;" d="M30.9,11.5c-0.2,0.3-0.1,0.7,0.1,1c0.2,0.3,0.6,0.4,1,0.2c0.8-0.2,1.9-0.4,3.2-0.3
c1.7,0.1,3,0.6,3.8,0.9c0.1-0.4,0.1-0.8,0.1-1c-0.1-0.9-0.7-1.6-1.6-2.2c0.2-0.2,0.5-0.3,0.7-0.5c1.9-1.7,1.8-4.3,1.7-5
c-0.7-0.1-3.3-0.5-5.2,1.1c-0.2,0.2-0.4,0.4-0.6,0.7c-0.5-1-1.1-1.6-2-1.9c-0.3-0.1-0.6-0.1-1-0.1c0.3,0.8,0.6,2.2,0.5,3.9
C31.5,9.6,31.2,10.7,30.9,11.5z"/>
<path style="fill:#14366B;" d="M30.6,39.4c0.4,0.1,0.8,0.1,1,0.1c0.9-0.1,1.6-0.7,2.2-1.5c0.1,0.3,0.3,0.5,0.5,0.8
c1.6,1.9,4.2,2,4.9,1.9c0.2-0.7,0.7-3.3-0.9-5.2c-0.2-0.2-0.4-0.5-0.6-0.6c1-0.4,1.7-1.1,2-1.9c0.1-0.3,0.1-0.6,0.1-1
c-0.8,0.2-2.2,0.5-3.9,0.3c-1.3-0.1-2.4-0.5-3.1-0.8c-0.3-0.2-0.7-0.1-1,0.1c-0.3,0.2-0.4,0.6-0.3,0.9c0.2,0.8,0.3,1.9,0.2,3.2
C31.5,37.4,31,38.6,30.6,39.4z"/>
<path style="fill:#14366B;" d="M13.1,31.9c0.2-0.3,0.1-0.7-0.1-1c-0.2-0.3-0.6-0.3-1-0.2c-0.8,0.2-1.9,0.4-3.2,0.4
c-1.7-0.1-3-0.5-3.8-0.8c-0.1,0.4-0.1,0.8,0,1c0.1,0.9,0.8,1.6,1.7,2.1c-0.2,0.2-0.5,0.3-0.7,0.5c-1.8,1.7-1.7,4.3-1.6,5
c0.7,0.1,3.3,0.5,5.1-1.2c0.2-0.2,0.4-0.4,0.6-0.7c0.5,0.9,1.2,1.6,2,1.8c0.3,0.1,0.6,0.1,1,0c-0.3-0.8-0.6-2.2-0.6-3.9
C12.5,33.8,12.8,32.7,13.1,31.9z"/>
</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A11">
<title>A11</title>
<path style="fill:#FFFFFF;" d="M3.6,20.2c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0,0.1c0.2,0.4,0.5,0.8,0.8,1c0.1,0.1,0.3,0.2,0.5,0.3
			c0.1,0,0.1,0.1,0.2,0.1C5.3,22,5.4,22,5.5,22.1c0,0-0.1,0-0.1,0.1c-0.6,0.3-1.1,0.7-1.5,1.3c-0.3,0.6-0.5,1.2-0.4,1.9
			c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.2,0.3,0.3,0.4c0,0.1,0.1,0.1,0.1,0.1
			c0.4,0.3,0.9,0.5,1.5,0.4c0.6-0.1,1.1-0.3,1.4-0.8c0.5-0.7,0.4-1.3,0.1-2C7,24,6.9,23.8,6.8,23.7c-0.2-0.2-0.4-0.3-0.7-0.3
			c-0.5-0.1-1.1,0.3-1.2,0.7c0,0.2-0.1,0.3,0,0.5c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0,0,0.1c0,0-0.1,0-0.1,0c-0.2-0.1-0.3-0.3-0.3-0.6
			c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.3-0.3,0.4-0.4c0.1,0,0.1-0.1,0.2-0.1
			c0.2-0.1,0.4-0.1,0.6-0.1c0,0,0,0,0,0c0.6,0.1,1,0.4,1.3,0.9c0.1,0.2,0.2,0.4,0.3,0.6c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0
			c0,0,0,0,0-0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0.2,0.1,0.3,0.1,0.5c0,0.3,0,0.6-0.1,0.9c0,0,0,0,0.1,0
			c0.1,0,0.2,0,0.3,0.1c0,0,0,0,0.1,0c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.5,0.2,0.8c0,0.2,0,0.5-0.1,0.7C8.1,27.8,8,28,8,28.1
			c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.3,0.6-0.5,1c-0.1,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.2,0.2-0.2,0.4c-0.2,0.3-0.4,0.6-0.6,0.9
			c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.2,0.3c0,0,0,0,0,0
			c-0.7,1.5-0.7,2.9,0.1,4.3c0.1,0.2,0.2,0.3,0.3,0.4c0,0.1,0.1,0.1,0.1,0.2c0.4,0.4,0.8,0.8,1.2,1.2c0.1,0,0.2,0.1,0.2,0.2
			c0.7,0.5,1.4,0.8,2.2,0.9c0.3,0,0.7,0,1,0c0.2,0,0.3-0.1,0.5-0.1c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
			c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.2,0,0.4-0.1,0.5-0.2c0.3-0.1,0.5-0.3,0.8-0.5c0.1-0.1,0.2-0.2,0.4-0.3
			c0.1-0.1,0.2-0.2,0.3-0.2c0.3-0.2,0.6-0.4,0.9-0.6c0.4-0.3,0.8-0.5,1.3-0.7c0,0,0,0,0,0c0.1,0,0.3-0.1,0.4-0.1c0,0,0.1,0,0.1,0
			c0.2,0,0.4-0.1,0.6-0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.5,0.1,0.7,0.3c0.1,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0,0c0,0,0,0,0.1,0
			c0.6-0.2,1.1-0.2,1.6,0.1c0.1,0,0.1,0,0.2,0.1h0c0.1,0.1,0.2,0.2,0.3,0.2c0,0,0,0,0,0c0,0,0,0,0.1,0.1c0,0.1,0.1,0.1,0.2,0.2
			c0.2,0.2,0.3,0.4,0.4,0.7c0,0.1,0.1,0.3,0.1,0.4c0,0.7-0.6,1.4-1.4,1.2c0,0,0,0-0.1,0c-0.2-0.1-0.3-0.2-0.4-0.3c0,0,0-0.1,0-0.1
			c0,0,0,0,0.1,0c0.1,0.2,0.3,0.2,0.5,0.2c0.2,0,0.3,0,0.5-0.1c0.4-0.2,0.6-0.7,0.5-1.1c0-0.2-0.1-0.4-0.2-0.6c0,0,0,0,0-0.1
			c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.4,0-0.5,0.1
			c-0.2,0.1-0.3,0.1-0.4,0.2c-0.2,0.1-0.3,0.3-0.5,0.5c-0.2,0.2-0.3,0.5-0.3,0.7c0,0.1-0.1,0.3-0.1,0.4c0,0.3,0,0.6,0.2,0.9
			c0.1,0.2,0.2,0.4,0.3,0.5c0.2,0.2,0.4,0.4,0.7,0.5c0.4,0.1,0.8,0.2,1.3,0.1c0.3,0,0.7-0.1,1-0.3c0.1,0,0.1,0,0.2-0.1
			c0.2-0.1,0.3-0.2,0.4-0.3c0,0,0,0,0.1,0c0.2-0.2,0.4-0.4,0.6-0.7c0.1-0.2,0.2-0.4,0.3-0.6c0,0,0,0,0.1-0.1c0,0,0,0,0,0
			c0,0.1,0.1,0.2,0.1,0.2c0,0,0,0,0,0.1c0.2,0.4,0.4,0.7,0.7,0.9c0.2,0.1,0.3,0.3,0.5,0.4c0.3,0.2,0.7,0.3,1.1,0.3
			c0.3,0,0.5,0.1,0.8,0c0.2,0,0.4-0.1,0.6-0.2c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.1-0.1,0.2-0.2
			c0.1-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.3-0.8,0.2-1.3c0-0.2-0.1-0.4-0.2-0.6c-0.3-0.6-0.8-0.9-1.4-1c-0.5-0.1-1,0-1.4,0.3
			c-0.3,0.2-0.5,0.5-0.6,0.8c0,0,0,0,0,0.1c-0.1,0.5,0,0.9,0.4,1.2c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3-0.1,0.4-0.2c0,0,0,0,0.1,0
			c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.4-0.1
			c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.2-0.4-0.4-0.4-0.6c-0.1-0.2-0.1-0.4-0.1-0.6c0,0,0,0,0,0c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0
			c0.1-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.3-0.4,0.4-0.5c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2
			c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.4-0.1,0.5-0.1c0,0,0.1,0,0.1,0c0.2,0,0.4,0,0.6,0.1c0,0,0.1,0,0.1,0c-0.1-0.2,0-0.3,0.1-0.3
			c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0.1,0.4,0.1c0.1,0,0.3,0.1,0.4,0.1
			c0.2,0.1,0.4,0.2,0.6,0.3c0,0,0.1,0,0.1,0.1c0.2,0.1,0.5,0.3,0.7,0.4c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3
			c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.3
			c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0.8,0.6,1.8,0.8,2.8,0.8c0.1,0,0.2,0,0.2,0c0.1,0,0.3,0,0.4-0.1c0,0,0,0,0,0
			c0.2,0,0.4-0.1,0.6-0.2c0,0,0,0,0,0h0c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.1,0.4-0.3,0.6-0.4l0,0l0,0
			c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.1,0.2-0.2
			c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0.2-0.2,0.3-0.4,0.4-0.6c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.3,0.2-0.6,0.3-0.9c0-0.1,0-0.3,0-0.4
			c0-0.3,0-0.6,0-0.8c0,0,0,0,0-0.1c-0.1-0.5-0.2-0.9-0.4-1.3c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1
			c0,0,0-0.1-0.1-0.1c-0.1-0.2-0.3-0.4-0.4-0.5c-0.2-0.2-0.3-0.3-0.4-0.5c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.5-0.7-0.7-1.1
			c-0.2-0.3-0.3-0.5-0.4-0.8c0-0.1-0.1-0.2-0.1-0.4c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.2,0-0.2c0-0.1,0-0.3,0.1-0.4c0,0,0-0.1,0-0.1
			c0,0,0-0.1,0-0.1c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.1c-0.2-0.6-0.2-1.2,0-1.7c0,0,0-0.1,0.1-0.1
			c0.1-0.2,0.3-0.5,0.5-0.6c0.4-0.3,1.1-0.6,1.8-0.2c0.1,0.1,0.2,0.2,0.3,0.2c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.6
			c0,0-0.1,0.1-0.1,0c0,0,0-0.1,0-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.3-0.1-0.6-0.4-0.8c-0.1-0.1-0.2-0.1-0.3-0.2
			c-0.2-0.1-0.5-0.1-0.7,0c-0.1,0-0.3,0.1-0.4,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c0,0-0.1,0.1-0.1,0.1c-0.4,0.5-0.4,1.1-0.2,1.7
			c0.2,0.5,0.5,0.8,0.9,1c0.3,0.2,0.7,0.3,1.1,0.2c0.1,0,0.2,0,0.3,0c0.4-0.1,0.7-0.2,0.9-0.5c0.1-0.1,0.1-0.1,0.2-0.2
			c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c-0.1-0.8-0.4-1.5-1.1-2
			c-0.1-0.1-0.3-0.3-0.5-0.3c-0.1-0.1-0.2-0.1-0.4-0.2c0,0-0.1,0-0.1-0.1c0,0,0,0,0.1,0c0.3-0.1,0.6-0.3,0.9-0.5
			c0.4-0.4,0.7-0.8,0.9-1.3c0.1-0.3,0.2-0.6,0.2-1c0-0.3,0-0.6-0.1-0.9c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.3
			c-0.1-0.1-0.2-0.2-0.3-0.2c0,0-0.1-0.1-0.1-0.1c-0.9-0.5-2.1-0.1-2.6,0.7c-0.1,0.2-0.2,0.4-0.2,0.7c0,0.3,0,0.5,0.1,0.8
			c0-0.1,0.1-0.1,0.1-0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0.1,0.2,0.2,0.4,0.4,0.6c0.1,0.1,0.2,0.2,0.3,0.2
			c0.2,0.1,0.4,0.2,0.6,0.3c0.5,0.1,0.9-0.2,1.1-0.5c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2-0.1-0.3-0.2-0.4c0,0,0,0,0,0c0,0,0,0,0-0.1
			c0,0,0,0,0.1,0c0.1,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.4c0,0.1,0,0.2,0,0.3c-0.1,0.4-0.3,0.6-0.6,0.8
			c-0.2,0.1-0.4,0.2-0.7,0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c0,0,0,0-0.1-0.1c-0.1-0.1-0.1-0.3-0.2-0.4c-0.2-0.5-0.2-1,0-1.5c0,0,0,0,0-0.1c-0.2,0.1-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
			c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.4,0-0.8,0.2-1.2c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.1-0.2,0.2-0.3
			c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.1c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.1
			c0,0,0,0,0-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.1,0.3-0.3,0.4-0.5
			c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.2-0.3,0.2-0.4c0,0,0-0.1,0.1-0.1c0.2-0.4,0.3-0.9,0.3-1.3c0-0.3,0-0.6,0-0.9
			c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.1-0.3-0.2-0.4c0-0.1,0-0.1-0.1-0.1
			c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1c-0.1-0.2-0.3-0.4-0.4-0.6c0,0,0,0-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2
			c-0.3-0.3-0.5-0.5-0.8-0.7c-0.3-0.2-0.6-0.4-0.9-0.6c-0.1-0.1-0.2-0.1-0.4-0.2c-0.1-0.1-0.2-0.1-0.3-0.1c-0.4-0.1-0.7-0.2-1.1-0.2
			c0,0-0.1,0-0.1,0c-0.9,0-1.7,0.2-2.4,0.6c-0.2,0.1-0.5,0.3-0.7,0.5c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.2
			c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.2-0.6,0.4-0.9,0.5c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0-0.2,0.1-0.4,0.1
			c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.6-0.2C25.9,8,25.9,8,25.8,7.9c0-0.1-0.1-0.1,0-0.2c0,0,0,0,0-0.1
			c0,0-0.1,0-0.1,0c-0.2,0.1-0.4,0.1-0.6,0.1c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.1-0.1-0.2-0.1
			c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1
			c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.2-0.2-0.4-0.3-0.6c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2
			c0.1-0.2,0.1-0.3,0.2-0.4c0.1-0.2,0.3-0.3,0.5-0.4c0,0,0,0,0.1,0c0.1,0,0.2-0.1,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0
			c0,0,0.1,0,0.1,0.1c0.1,0,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.2-0.2-0.3-0.2-0.6-0.2
			c-0.1,0-0.2,0-0.3,0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.4-0.2,0.7c0,0.2,0.1,0.4,0.2,0.6c0,0,0,0.1,0.1,0.1
			c0.1,0.2,0.3,0.4,0.5,0.5c0,0,0.1,0,0.1,0.1c0.4,0.2,0.8,0.3,1.2,0.2c0.6-0.1,1-0.4,1.3-0.9c0.1-0.2,0.2-0.5,0.2-0.7c0,0,0,0,0,0
			c0.1-0.3,0-0.6-0.1-0.9c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.2-0.2-0.3C26.3,4.2,26.2,4,26,3.9c-0.5-0.3-1-0.4-1.6-0.4
			c-0.1,0-0.1,0-0.2,0c-0.3,0-0.6,0.1-0.9,0.3C23.1,4,23,4.1,22.8,4.2c0,0,0,0-0.1,0c-0.4,0.3-0.6,0.7-0.8,1.2c0,0,0,0.1-0.1,0.1
			c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.2c0,0,0-0.1-0.1-0.1c0,0,0,0,0-0.1c-0.2-0.3-0.4-0.5-0.6-0.7
			c-0.2-0.1-0.3-0.3-0.5-0.3c-0.3-0.2-0.6-0.3-0.9-0.3c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0
			c-0.3,0-0.6,0.1-0.9,0.2C17.4,4,17.1,4.4,17,4.9c-0.1,0.2-0.1,0.4-0.1,0.7c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2
			c0,0.1,0.1,0.3,0.2,0.4c0.3,0.5,0.6,0.8,1.2,1c0.4,0.1,0.7,0.1,1.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1
			c0.1,0,0.2-0.1,0.2-0.2c0.3-0.3,0.5-0.6,0.5-1c0-0.3-0.1-0.6-0.3-0.9C20,5,19.7,4.9,19.4,4.9c-0.1,0-0.2,0.1-0.3,0.1
			c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0C18.9,5.1,19,5,19,5c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0
			c0.1,0,0.2,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.2c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.3,0.3,0.4c0,0.1,0.1,0.2,0.1,0.4
			c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c-0.1,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.1-0.2,0.2
			c-0.1,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.5,0.1-0.9,0.1-1.4,0c0,0,0,0,0,0
			c0,0.2,0,0.2-0.1,0.4c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0c-0.4,0-0.7,0-1.1-0.1
			c-0.1,0-0.2-0.1-0.3-0.1c0,0-0.1,0-0.1,0c-0.1-0.1-0.3-0.1-0.4-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1,0
			c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.4-0.8-0.6c-0.1-0.1-0.3-0.1-0.4-0.3
			c-0.2-0.2-0.4-0.3-0.6-0.5c-0.2-0.1-0.4-0.3-0.6-0.3c0,0,0,0,0,0c-0.3-0.1-0.7-0.3-1.1-0.3c-0.5-0.1-0.9-0.1-1.4-0.1
			c-0.2,0-0.4,0.1-0.6,0.1c0,0,0,0,0,0C8.4,5.7,7.9,6,7.4,6.4c-0.1,0-0.1,0.1-0.2,0.1C7.1,6.6,7,6.8,6.9,6.9C6.8,7,6.7,7,6.6,7.1
			C6.6,7.2,6.5,7.3,6.4,7.4C6.4,7.4,6.3,7.5,6.3,7.5c0,0,0,0,0,0.1C6.2,7.7,6.1,7.7,6,7.8C5.9,8,5.8,8.1,5.7,8.3
			C5.7,8.4,5.6,8.5,5.6,8.6C5.5,8.7,5.4,8.9,5.4,9.1c-0.1,0.4-0.2,0.8-0.2,1.2c0,0,0,0.1,0,0.1c0,0.7,0.1,1.3,0.4,2
			c0.1,0.3,0.3,0.5,0.5,0.8c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.2,0.3,0.3,0.4,0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0.2
			c0.1,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.3,0.5,0.4,0.7c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0
			c0,0,0,0,0,0c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0.1,0,0.1C8,16.1,8,16.3,8.1,16.5c0.1,0.4,0.1,0.7,0,1.1C8.1,17.7,8,17.9,7.9,18
			c-0.1,0.1-0.2,0.2-0.4,0.1c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4-0.1,0.7c0,0,0,0.1-0.1,0.1
			c-0.2,0.5-0.4,0.8-0.9,1.1C6.4,20.9,6.2,21,5.9,21c-0.3,0-0.5-0.1-0.7-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.3-0.4-0.8-0.1-1.1
			c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0-0.1,0.1c-0.1,0.1-0.1,0.1-0.1,0.2
			c-0.1,0.2,0,0.4,0.1,0.6c0,0.1,0.1,0.2,0.2,0.3c0.2,0.2,0.4,0.3,0.7,0.3c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0
			c0.4-0.1,0.6-0.3,0.8-0.6c0.2-0.3,0.3-0.6,0.3-1c0-0.2,0-0.5-0.1-0.7c0-0.1-0.1-0.3-0.2-0.4c0-0.1-0.1-0.2-0.2-0.2
			c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C5.6,17,4.8,17,4.1,17.6c-0.3,0.2-0.4,0.4-0.5,0.8c-0.1,0.4-0.2,0.8-0.1,1.2
			C3.5,19.7,3.6,20,3.6,20.2z"/>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A12">
<title>A12</title>
<path style="fill:#5692B0;" d="M42.5,21.8c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1-0.1c-0.4-0.2-0.7-0.4-1-0.7c-1-0.9-1.7-2-2.2-3.2
c0,0,0-0.1,0-0.1c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.1-0.5-0.1-0.8c-0.1-0.5-0.1-1-0.1-1.5
c0-0.4,0-0.8,0.1-1.3c0-0.2,0-0.3,0.1-0.5c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.1,0-0.2
c0.1-0.4,0.1-0.9,0.2-1.3c0,0,0-0.1,0-0.1c0-0.1,0-0.3,0.1-0.4c0-0.2,0-0.3,0.1-0.4c0-0.1,0-0.3,0.1-0.4c0.1-0.3,0.1-0.7,0.2-1
c0-0.1,0-0.3,0.1-0.4c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.5c0.1-0.7,0-1.4-0.1-2.1c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.1-0.3
c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.3-0.1-0.7-0.1-1.1-0.2c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0
c-0.2,0-0.4,0-0.6,0.1c-0.7,0.1-1.5,0.2-2.2,0.4c-0.1,0-0.2,0-0.2,0c0,0,0,0,0-0.1c0,0,0,0,0,0.1c-0.2,0-0.3,0.1-0.5,0.1
c-0.2,0-0.3,0.1-0.5,0.1c-0.1,0-0.1,0-0.2,0.1c-0.5,0.1-1,0.2-1.6,0.3c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.4,0.1-0.8,0.1-1.2,0.1
c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0l0,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0
c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c-0.5,0-0.9,0-1.3-0.1c-0.2,0-0.4-0.1-0.7-0.1c-0.5-0.1-1-0.3-1.4-0.5c-0.5-0.2-1-0.5-1.4-0.9
c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.1-0.2
c-0.2-0.3-0.4-0.5-0.5-0.8C22.1,1.7,22,1.6,22,1.5c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0,0.1c-0.1,0.4-0.3,0.8-0.6,1.1
c0,0.1-0.1,0.2-0.2,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0,0-0.1,0.1C20.3,3.6,20,3.8,19.8,4
c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0-0.1,0.1-0.2,0.1c-0.3,0.2-0.7,0.3-1.1,0.4
c-0.1,0-0.1,0-0.2,0l0,0c-0.1,0.1-0.2,0.1-0.3,0.1c-0.3,0.1-0.6,0.1-0.8,0.1c-0.3,0-0.6,0.1-0.9,0.1c-0.1,0-0.3,0-0.4,0
c-0.2,0-0.4,0-0.6,0c-0.8,0-1.6-0.1-2.4-0.3c0,0-0.1,0-0.1,0c-0.2,0-0.3,0-0.5-0.1c-0.4-0.1-0.7-0.1-1.1-0.2
c-0.3-0.1-0.6-0.1-1-0.2c-0.2,0-0.4-0.1-0.6-0.1C8,4.4,7.4,4.3,6.9,4.3c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0c-0.2,0-0.3,0-0.5,0
c-0.5,0-0.9,0.1-1.4,0.2c0,0-0.1,0-0.1,0c-0.2,0-0.2,0.1-0.3,0.3C4.2,5.4,4.1,6,4.2,6.6c0,0.2,0,0.4,0,0.6l0,0
c0,0.4,0.1,0.8,0.1,1.2c0,0,0,0,0,0.1c0,0.3,0.1,0.6,0.1,0.9c0,0,0,0,0,0c0.2,1.1,0.5,2.1,0.6,3.2c0,0.1,0,0.1,0,0.2
c0,0.2,0.1,0.3,0.1,0.5l0,0c0.1,0.3,0.1,0.7,0.1,1c0,0.1,0,0.2,0,0.3c0,0.3,0.1,0.6,0,0.9c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0,0.6
c0,0.3,0,0.5-0.1,0.8c-0.1,0.3-0.1,0.6-0.2,0.9c0,0.1-0.1,0.2-0.1,0.4c-0.2,0.7-0.6,1.4-1.1,2c-0.1,0.2-0.3,0.4-0.5,0.5
c0,0.1-0.1,0.1-0.2,0.2C3,21,3,21.1,2.9,21.2c-0.3,0.2-0.6,0.5-0.9,0.6c-0.1,0.1-0.2,0.1-0.2,0.1c-0.1,0.1-0.2,0.1-0.4,0.2
c0,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.3c0.6,0.3,1.1,0.7,1.5,1.2c0.1,0.2,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.3,0.4,0.5
c0.3,0.5,0.6,1,0.7,1.6c0.1,0.2,0.1,0.3,0.1,0.5l0,0c0,0.1,0,0.2,0,0.2c0.1,0.4,0.2,0.9,0.2,1.3c0,0.3,0,0.6,0,0.9
c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0,0.2c0.1,0.1,0,0.1,0,0.2c0,0.9-0.1,1.8-0.3,2.7c-0.1,0.7-0.2,1.3-0.4,2c0,0.2-0.1,0.5-0.1,0.7
c-0.1,0.7-0.2,1.4-0.3,2.2c0,0.7,0,1.4,0.2,2c0,0,0,0,0,0c0,0.2,0.2,0.3,0.4,0.4c0.7,0.1,1.3,0.2,2,0.1c0.1,0,0.2,0,0.3,0
c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.3-0.1,0.4,0c0.4-0.1,0.9-0.1,1.3-0.2c0.9-0.2,1.8-0.4,2.8-0.6
c0.8-0.1,1.5-0.2,2.3-0.3c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0c0.5,0,0.9,0,1.4,0c1,0.1,1.9,0.3,2.9,0.7c0.8,0.3,1.5,0.8,2.1,1.4
c0.4,0.4,0.7,0.8,1,1.3c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0.1,0.1,0.1,0.3,0.2,0.4c0.1-0.2,0.1-0.4,0.2-0.5c0.2-0.4,0.4-0.7,0.7-1
c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1-0.2,0.3-0.3,0.5-0.5c0.2-0.2,0.5-0.4,0.8-0.6c0.4-0.3,0.8-0.5,1.2-0.6
c1.2-0.5,2.5-0.6,3.8-0.6c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0
c0.7,0.1,1.5,0.2,2.2,0.3c0.1,0,0.3,0,0.4,0.1c0.4,0.1,0.8,0.2,1.2,0.2c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0
c0.7,0.1,1.5,0.3,2.2,0.3c0.3,0,0.7,0,1,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6-0.1,0.9-0.1c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.1
c0-0.1,0.1-0.2,0.1-0.3c0-0.3,0.1-0.7,0.1-1c0-0.3,0-0.6,0-0.8c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2
c0-0.3-0.1-0.6-0.1-1c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c-0.1-0.4-0.2-0.7-0.2-1.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1
c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.2-1-0.4-2-0.5-3c0-0.1,0-0.1,0-0.2c-0.1-0.3-0.1-0.6-0.1-1c0-0.6,0-1.3,0.1-1.9
c0-0.1,0-0.1,0-0.2c0.1-0.5,0.2-1,0.3-1.4c0.3-0.9,0.8-1.7,1.4-2.4c0.6-0.7,1.3-1.2,2.1-1.5c0,0,0.1,0,0.1-0.1
C42.6,21.8,42.5,21.8,42.5,21.8z M39.4,22.1c-0.8,0.8-1.5,1.5-2.3,2.3c0,0-0.1,0.1-0.1,0.1c-0.2,0.2-0.4,0.4-0.6,0.6
c-0.2,0.2-0.3,0.3-0.5,0.5c-0.1,0.1-0.1,0.2-0.1,0.3c0,1.7,0,3.4,0,5.1c0,0.4,0,0.8,0,1.2c0,0.3,0,0.7,0,1c0,0.2,0,0.5,0,0.7
c0,0.6,0,1.1,0,1.7c0,0,0,0,0,0c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0c-0.6,0-1.2,0-1.7,0c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3,0-0.5,0
c-0.5,0-1.1,0-1.6,0c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c-1.2,0-2.5,0-3.7,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0
c-0.3,0-0.6,0-0.9,0c-0.1,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c-1.2,1.2-2.3,2.3-3.5,3.5c-0.1,0.1-0.1,0.1-0.3,0
c-1.2-1.2-2.4-2.3-3.5-3.5c-0.1-0.1-0.2-0.1-0.3-0.1c-1.7,0-3.5,0-5.2,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-1.4,0-2.7,0-4.1,0
c-0.2,0-0.2,0-0.2-0.2c0-1.2,0-2.5,0-3.7c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-1.3,0-2.7,0-4c0-0.1,0-0.1,0-0.2
c0-0.4,0-0.8,0-1.3c0-0.1,0-0.2-0.1-0.3c-0.2-0.2-0.4-0.4-0.7-0.7c-0.3-0.3-0.7-0.7-1-1c0,0-0.1-0.1-0.1-0.1
c-0.6-0.6-1.1-1.1-1.7-1.7c0,0,0,0-0.1-0.1c-0.1-0.1-0.1-0.1,0-0.2c0.5-0.5,1-1,1.4-1.5c0,0,0.1-0.1,0.1-0.1
c0.5-0.5,0.9-0.9,1.4-1.4c0.1-0.1,0.3-0.2,0.4-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.1,0.1-0.2c0-0.5,0-1.1,0-1.6
c0-1.8,0-3.6,0-5.4c0-0.2,0-0.3,0-0.5c0,0,0-0.1,0-0.1c0-0.7,0-1.4,0-2.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0
c1.3,0,2.5,0,3.7,0c0,0,0.1,0,0.1,0c0.3,0,0.7,0,1,0c0.1,0,0.1,0,0.2,0c1.5,0,3,0,4.5,0c0.1,0,0.2,0,0.3-0.1
C18.8,7.6,19.4,7,20,6.5c0,0,0.1-0.1,0.1-0.1c0.4-0.4,0.7-0.8,1.1-1.1c0.2-0.2,0.4-0.4,0.6-0.7c0,0,0.1-0.1,0.1,0
c0,0,0.1,0.1,0.1,0.1c1.2,1.2,2.3,2.3,3.5,3.5c0.1,0.1,0.2,0.1,0.3,0.1c0.9,0,1.7,0,2.6,0c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0
c1.6,0,3.1,0,4.7,0c0,0,0.1,0,0.1,0c0.5,0,1,0,1.4,0c0.1,0,0.3-0.1,0.3,0c0.1,0.1,0,0.2,0,0.3c0,1.8,0,3.6,0,5.4
c0,0.2,0,0.5,0,0.7c0,0,0,0.1,0,0.1c0,0.9,0,1.8,0,2.7c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0.1,0.3
c1.2,1.2,2.3,2.3,3.5,3.5C39.6,21.9,39.6,21.9,39.4,22.1z"/>
</symbol>





  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1">
  <title>B1</title>
  <path  style="fill:#3F94B3;" d="M36.6,22c-1.4-1.4-2.8-2.8-4.1-4.3c-0.2-2-0.3-3.9-0.2-5.9c-2,0-4,0-5.9-0.2
c-1.5-1.3-3-2.6-4.3-4c-1.4,1.4-2.8,2.8-4.4,4c-2,0.2-4,0.3-5.9,0.2c0,2,0,3.9-0.2,5.9c-1.3,1.5-2.6,3-4.1,4.3
c1.4,1.4,2.8,2.8,4.1,4.3c0.2,2,0.3,3.9,0.2,5.9c2,0,4,0,5.9,0.2c1.5,1.3,3,2.6,4.4,4c1.4-1.4,2.8-2.8,4.3-4c2-0.2,4-0.3,5.9-0.2
c0-2,0-3.9,0.2-5.9C33.8,24.8,35.1,23.4,36.6,22z M30.8,25.6c-0.2,1.6-0.2,3.3-0.2,4.9c-1.6,0-3.3,0.1-4.9,0.2
c-1.3,1-2.5,2.1-3.6,3.3c-1.2-1.2-2.4-2.2-3.6-3.3c-1.6-0.1-3.3-0.2-4.9-0.2c0-1.6-0.1-3.3-0.2-4.9c-1.1-1.3-2.1-2.5-3.3-3.6
c1.2-1.1,2.3-2.4,3.3-3.6c0.2-1.6,0.2-3.3,0.2-4.9c1.6,0,3.3-0.1,4.9-0.2c1.3-1,2.5-2.1,3.6-3.3c1.2,1.2,2.4,2.2,3.6,3.3
c1.6,0.1,3.3,0.2,4.9,0.2c0,1.6,0.1,3.3,0.2,4.9c1.1,1.3,2.1,2.5,3.3,3.6C32.9,23.1,31.8,24.4,30.8,25.6z"/>
</symbol>


    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2">
    <title>B2</title>
    <path style="fill:#FA9F2C;" d="M22.6,21.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2-0.1-0.4-0.1
    c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0.1,0.2,0.1,0.4c0,0.1-0.1,0.2-0.1,0.4c0.1,0.1,0.2,0.1,0.3,0.2
    c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.2,0.1,0.4,0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.2
    c0-0.1-0.1-0.2-0.1-0.4c0-0.1,0.1-0.2,0.1-0.4C22.8,21.6,22.7,21.5,22.6,21.4z"/>
<path style="fill:#FA9F2C;" d="M36.2,16.2c-1.2-0.8-2.3-1.6-3.5-2.4c-0.5-0.3-1-0.7-1.5-1c-0.3-0.5-0.7-1-1-1.5
    c-0.8-1.1-1.6-2.3-2.4-3.4c-1.4,0.2-2.8,0.5-4.2,0.7C23.2,8.7,22.6,8.8,22,9c-0.6-0.1-1.2-0.2-1.7-0.4c-1.4-0.3-2.8-0.5-4.2-0.7
    c-0.8,1.1-1.6,2.3-2.4,3.4c-0.3,0.5-0.7,1-1,1.5c-0.5,0.3-1,0.6-1.5,1c-1.2,0.8-2.3,1.6-3.5,2.4c0.2,1.4,0.5,2.7,0.7,4.1
    c0.1,0.6,0.2,1.1,0.4,1.7c-0.1,0.6-0.2,1.2-0.4,1.7c-0.3,1.4-0.5,2.7-0.7,4.1c1.2,0.8,2.3,1.6,3.5,2.4c0.5,0.3,1,0.7,1.5,1
    c0.3,0.5,0.7,1,1,1.5c0.8,1.1,1.6,2.3,2.4,3.4c1.4-0.2,2.8-0.5,4.2-0.7c0.6-0.1,1.2-0.2,1.7-0.4c0.6,0.1,1.2,0.2,1.7,0.4
    c1.4,0.3,2.8,0.5,4.2,0.7c0.8-1.1,1.6-2.3,2.4-3.4c0.3-0.5,0.7-1,1-1.5c0.5-0.3,1-0.6,1.5-1c1.2-0.8,2.3-1.6,3.5-2.4
    c-0.2-1.4-0.5-2.7-0.7-4.1c-0.1-0.6-0.2-1.1-0.4-1.7c0.1-0.6,0.2-1.2,0.4-1.7C35.8,18.9,36,17.5,36.2,16.2z M27.4,8.9
    C27.4,8.9,27.4,8.9,27.4,8.9c0.1,0,0.1,0,0.1,0c1,1.4-0.4,2.7-1.6,3.6C25.8,11.1,25.7,9.2,27.4,8.9z M16.5,9
    C16.5,8.9,16.5,8.9,16.5,9c0.1-0.1,0.1-0.1,0.1,0c1.7,0.3,1.6,2.2,1.5,3.6C16.9,11.7,15.5,10.4,16.5,9z M8.8,16.6
    C8.8,16.6,8.8,16.6,8.8,16.6c0-0.1,0-0.1,0-0.1c1.4-1,2.7,0.4,3.6,1.6C11,18.3,9.1,18.3,8.8,16.6z M8.9,27.5
    C8.8,27.4,8.8,27.4,8.9,27.5c-0.1-0.1-0.1-0.1,0-0.1c0.3-1.7,2.2-1.6,3.7-1.4C11.6,27.1,10.3,28.5,8.9,27.5z M16.6,35.1
    C16.6,35.1,16.6,35.1,16.6,35.1c-0.1,0-0.1,0-0.1,0c-1-1.4,0.4-2.7,1.6-3.6C18.2,32.9,18.3,34.8,16.6,35.1z M27.5,35
    C27.5,35.1,27.5,35.1,27.5,35c-0.1,0.1-0.1,0.1-0.1,0c-1.7-0.3-1.6-2.2-1.5-3.6C27.1,32.3,28.5,33.6,27.5,35z M31.7,30
    c-0.5,0.3-0.9,0.3-1.4,0.2c0.1,0.4,0.1,0.9-0.2,1.4c-1,1.5-3,0.4-4.2-0.4c-0.3,1.4-0.9,3.6-2.7,3.2c-0.6-0.1-0.9-0.4-1.1-0.8
    c-0.2,0.4-0.6,0.7-1.1,0.8c-1.8,0.4-2.4-1.8-2.7-3.2c-1.2,0.8-3.2,1.9-4.2,0.4c-0.3-0.5-0.4-0.9-0.2-1.4c-0.4,0.1-0.9,0.1-1.4-0.2
    c-1.5-1-0.4-3,0.4-4.2c-1.4-0.3-3.6-0.9-3.2-2.7c0.1-0.6,0.4-0.9,0.8-1.1c-0.4-0.2-0.7-0.6-0.8-1.1c-0.4-1.8,1.8-2.4,3.2-2.7
    C11.9,17,10.8,15,12.3,14c0.5-0.3,0.9-0.3,1.4-0.2c-0.1-0.4-0.1-0.9,0.2-1.4c1-1.5,3-0.4,4.2,0.4c0.3-1.4,0.9-3.6,2.7-3.2
    c0.6,0.1,0.9,0.4,1.1,0.8c0.2-0.4,0.6-0.7,1.1-0.8c1.8-0.4,2.4,1.8,2.7,3.2c1.2-0.8,3.2-1.9,4.2-0.4c0.3,0.5,0.4,0.9,0.2,1.4
    c0.4-0.1,0.9-0.1,1.4,0.2c1.5,1,0.4,3-0.4,4.2c1.4,0.3,3.6,0.9,3.2,2.7c-0.1,0.6-0.4,0.9-0.8,1.1c0.4,0.2,0.7,0.6,0.8,1.1
    c0.4,1.8-1.8,2.4-3.2,2.7C32.1,27,33.2,29,31.7,30z M35.2,27.4C35.2,27.4,35.2,27.4,35.2,27.4c0,0.1,0,0.1,0,0.1
    c-1.4,1-2.7-0.4-3.6-1.6C33,25.7,34.9,25.7,35.2,27.4z M35.2,16.6c-0.3,1.7-2.2,1.6-3.7,1.4c0.9-1.1,2.2-2.5,3.6-1.6
    C35.2,16.6,35.2,16.6,35.2,16.6C35.2,16.6,35.2,16.6,35.2,16.6z"/>
<path style="fill:#FA9F2C;" d="M30.4,25.4c-0.2-1.1-0.4-2.3-0.7-3.4c0.2-1.1,0.5-2.3,0.7-3.4c-1-0.7-1.9-1.3-2.9-2
    c-0.6-1-1.3-1.9-2-2.9c-1.2,0.2-2.3,0.4-3.5,0.7c-1.1-0.2-2.3-0.5-3.5-0.7c-0.7,1-1.3,1.9-2,2.9c-1,0.6-2,1.3-2.9,2
    c0.2,1.1,0.4,2.3,0.7,3.4c-0.2,1.1-0.5,2.3-0.7,3.4c1,0.7,1.9,1.3,2.9,2c0.6,1,1.3,1.9,2,2.9c1.2-0.2,2.3-0.4,3.5-0.7
    c1.1,0.2,2.3,0.5,3.5,0.7c0.7-1,1.3-1.9,2-2.9C28.4,26.8,29.4,26.1,30.4,25.4z M25.3,27.8c-0.2,0.3-0.3,0.5-0.5,0.7
    c-0.3-0.1-0.6-0.1-0.9-0.2c-0.6-0.1-1.2-0.2-1.9-0.4c-0.6,0.1-1.2,0.3-1.9,0.4c-0.3,0.1-0.6,0.1-0.9,0.2c-0.2-0.2-0.3-0.5-0.5-0.7
    c-0.4-0.5-0.7-1-1-1.6c-0.5-0.3-1.1-0.7-1.6-1c-0.3-0.2-0.5-0.3-0.8-0.5c0.1-0.3,0.1-0.6,0.2-0.9c0.1-0.6,0.2-1.2,0.4-1.8
    c-0.1-0.6-0.3-1.2-0.4-1.8c-0.1-0.3-0.1-0.6-0.2-0.9c0.3-0.2,0.5-0.3,0.8-0.5c0.5-0.4,1.1-0.7,1.6-1c0.3-0.5,0.7-1,1-1.6
    c0.2-0.3,0.3-0.5,0.5-0.7c0.3,0.1,0.6,0.1,0.9,0.2c0.6,0.1,1.2,0.2,1.9,0.4c0.6-0.1,1.2-0.3,1.9-0.4c0.3-0.1,0.6-0.1,0.9-0.2
    c0.2,0.2,0.3,0.5,0.5,0.7c0.4,0.5,0.7,1,1,1.6c0.5,0.3,1.1,0.7,1.6,1c0.3,0.2,0.5,0.3,0.8,0.5c-0.1,0.3-0.1,0.6-0.2,0.9
    c-0.1,0.6-0.2,1.2-0.4,1.8c0.1,0.6,0.3,1.2,0.4,1.8c0.1,0.3,0.1,0.6,0.2,0.9c-0.3,0.2-0.5,0.3-0.8,0.5c-0.5,0.4-1.1,0.7-1.6,1
    C26,26.8,25.6,27.3,25.3,27.8z"/>

    <path style="fill:#D03D41;" d="M28.5,13.4c0.1,0.1,0.1,0.1,0.1,0.2c0.2,0.6-0.9,1-1.4,1.2c0.2,0.3,0.4,0.6,0.6,0.9
    c0.9-0.6,2.2-1.6,1.4-2.6c-0.7-1-2.1-0.2-3,0.4c0.2,0.3,0.4,0.6,0.6,0.9C27.2,13.8,28,12.9,28.5,13.4z"/>
<path style="fill:#D03D41;" d="M16.3,15.6c0.2-0.3,0.4-0.6,0.6-0.9c-0.5-0.2-1.6-0.6-1.4-1.2c0-0.1,0-0.1,0.1-0.2
    c0.5-0.5,1.3,0.4,1.7,0.8c0.2-0.3,0.4-0.6,0.6-0.9c-0.9-0.6-2.2-1.4-3-0.4C14.1,14,15.4,15,16.3,15.6z"/>
<path style="fill:#D03D41;" d="M14.1,17.3c-0.4-0.4-1.3-1.2-0.8-1.7c0.1-0.1,0.1-0.1,0.2-0.1c0.6-0.2,1,0.9,1.2,1.4
    c0.3-0.2,0.6-0.4,0.9-0.6c-0.6-0.9-1.6-2.2-2.6-1.4c-1,0.7-0.2,2.1,0.4,2.9C13.5,17.6,13.8,17.5,14.1,17.3z"/>
<path style="fill:#D03D41;" d="M13.4,21.5c-0.1-0.3-0.1-0.7-0.2-1c-0.5,0.2-1.5,0.7-1.8,0.2c0,0-0.1-0.1-0.1-0.2
    c0-0.7,1.2-0.6,1.8-0.6c-0.1-0.3-0.1-0.7-0.2-1c-1,0.2-2.6,0.6-2.4,1.8C10.7,21.9,12.3,21.7,13.4,21.5z"/>
<path style="fill:#D03D41;" d="M20.4,30.8c0.2,0.5,0.7,1.5,0.2,1.8c0,0-0.1,0.1-0.2,0.1c-0.7,0-0.6-1.2-0.6-1.8
    c-0.3,0.1-0.7,0.1-1,0.2c0.2,1,0.6,2.6,1.8,2.3c1.3-0.2,1-1.8,0.8-2.8C21.1,30.6,20.8,30.7,20.4,30.8z"/>
<path style="fill:#D03D41;" d="M15.5,27.7c-0.3-0.2-0.6-0.4-0.9-0.6c-0.2,0.5-0.6,1.6-1.2,1.4c-0.1,0-0.1,0-0.2-0.1
    c-0.5-0.5,0.4-1.3,0.8-1.7c-0.3-0.2-0.6-0.4-0.9-0.6c-0.6,0.9-1.4,2.2-0.4,2.9C13.9,29.8,14.9,28.5,15.5,27.7z"/>
<path style="fill:#D03D41;" d="M15.5,30.6c-0.1-0.1-0.1-0.1-0.1-0.2c-0.2-0.6,0.9-1,1.4-1.2c-0.2-0.3-0.4-0.6-0.6-0.9
    C15.4,29,14.1,30,14.8,31c0.7,1,2.1,0.2,3-0.4c-0.2-0.3-0.4-0.6-0.6-0.9C16.8,30.2,16,31.1,15.5,30.6z"/>
<path style="fill:#D03D41;" d="M13,24.2c-0.6,0-1.8,0.1-1.8-0.6c0-0.1,0-0.2,0.1-0.2c0.3-0.5,1.4,0,1.8,0.2c0.1-0.3,0.1-0.7,0.2-1
    c-1-0.2-2.6-0.4-2.9,0.8c-0.2,1.2,1.3,1.6,2.4,1.8C12.9,24.9,13,24.5,13,24.2z"/>
<path style="fill:#D03D41;" d="M30.6,22.5c0.1,0.3,0.1,0.7,0.2,1c0.5-0.2,1.5-0.7,1.8-0.2c0,0,0.1,0.1,0.1,0.2
    c0,0.7-1.2,0.6-1.8,0.6c0.1,0.3,0.1,0.7,0.2,1c1-0.2,2.6-0.6,2.4-1.8C33.3,22.1,31.7,22.3,30.6,22.5z"/>
<path style="fill:#D03D41;" d="M20.4,11.3c0.1,0,0.2,0,0.2,0.1c0.5,0.3,0,1.3-0.2,1.8c0.3,0.1,0.7,0.1,1,0.2c0.2-1,0.4-2.6-0.8-2.8
    c-1.2-0.2-1.6,1.3-1.8,2.3c0.3,0.1,0.7,0.1,1,0.2C19.8,12.5,19.7,11.4,20.4,11.3z"/>
<path style="fill:#D03D41;" d="M23.6,13.2c-0.2-0.5-0.7-1.5-0.2-1.8c0,0,0.1-0.1,0.2-0.1c0.7,0,0.6,1.2,0.6,1.8
    c0.3-0.1,0.7-0.1,1-0.2c-0.2-1-0.6-2.6-1.8-2.3c-1.3,0.2-1,1.8-0.8,2.8C22.9,13.4,23.2,13.3,23.6,13.2z"/>
<path style="fill:#D03D41;" d="M31,19.8c0.6,0,1.8-0.1,1.8,0.6c0,0.1,0,0.2-0.1,0.2c-0.3,0.5-1.4,0-1.8-0.2c-0.1,0.3-0.1,0.7-0.2,1
    c1,0.2,2.6,0.4,2.9-0.8c0.2-1.2-1.3-1.6-2.4-1.8C31.1,19.1,31,19.5,31,19.8z"/>
<path style="fill:#D03D41;" d="M28.5,16.3c0.3,0.2,0.6,0.4,0.9,0.6c0.2-0.5,0.6-1.6,1.2-1.4c0.1,0,0.1,0,0.2,0.1
    c0.5,0.5-0.4,1.3-0.8,1.7c0.3,0.2,0.6,0.4,0.9,0.6c0.6-0.9,1.4-2.2,0.4-2.9C30.1,14.2,29.1,15.5,28.5,16.3z"/>
<path style="fill:#D03D41;" d="M23.6,32.7c-0.1,0-0.2,0-0.2-0.1c-0.5-0.3,0-1.3,0.2-1.8c-0.3-0.1-0.7-0.1-1-0.2
    c-0.2,1-0.4,2.6,0.8,2.8c1.2,0.2,1.6-1.3,1.8-2.3c-0.3-0.1-0.7-0.1-1-0.2C24.2,31.5,24.3,32.6,23.6,32.7z"/>
<path style="fill:#D03D41;" d="M27.7,28.4c-0.2,0.3-0.4,0.6-0.6,0.9c0.5,0.2,1.6,0.6,1.4,1.2c0,0.1,0,0.1-0.1,0.2
    c-0.5,0.5-1.3-0.4-1.7-0.8c-0.2,0.3-0.4,0.6-0.6,0.9c0.9,0.6,2.2,1.4,3,0.4C29.9,30,28.6,29,27.7,28.4z"/>
<path style="fill:#D03D41;" d="M29.9,26.7c0.4,0.4,1.3,1.2,0.8,1.7c-0.1,0.1-0.1,0.1-0.2,0.1c-0.6,0.2-1-0.9-1.2-1.4
    c-0.3,0.2-0.6,0.4-0.9,0.6c0.6,0.9,1.6,2.2,2.6,1.4c1-0.7,0.2-2.1-0.4-2.9C30.5,26.4,30.2,26.5,29.9,26.7z"/>

  </symbol>

  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3">
  <title>B3</title>
  <path  style="fill:#00376F;" d="M38.5,21.8C38.5,21.8,38.5,21.8,38.5,21.8c0-0.1,0-0.2-0.2-0.3c-1.8-1.1-3.1-2.9-3.9-4.9
  c-0.8-2-1.2-4.2-0.7-6.3c0-0.1,0-0.3-0.1-0.3c0,0,0,0,0,0c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.3-0.1C31.2,10.4,29,10,27,9.2
  c-2-0.9-3.8-2.1-4.9-3.9C22,5.1,21.9,5,21.8,5c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0.2c-1.1,1.8-2.9,3.1-4.9,3.9
  c-2,0.8-4.2,1.2-6.3,0.7c-0.1,0-0.3,0-0.3,0.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0.1-0.1,0.2-0.1,0.3c0.5,2.1,0.1,4.2-0.7,6.3
  c-0.9,2-2.1,3.8-3.9,4.9C5.1,21.5,5,21.7,5,21.8c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0,0.2,0.2,0.3C7,23.2,8.3,25,9.1,27
  c0.8,2,1.2,4.2,0.7,6.3c0,0.1,0,0.3,0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0.1,0.2,0.1,0.3,0.1c2.1-0.5,4.2-0.1,6.3,0.7
  c2,0.9,3.8,2.1,4.9,3.9c0.1,0.1,0.2,0.2,0.3,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2,0,0.3-0.2c1.1-1.8,2.9-3.1,4.9-3.9
  c2-0.8,4.2-1.2,6.3-0.7c0.1,0,0.3,0,0.3-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.1-0.1,0.1-0.2,0.1-0.3c-0.5-2.1-0.1-4.2,0.7-6.3
  c0.9-2,2.1-3.8,3.9-4.9C38.4,22,38.5,21.9,38.5,21.8C38.5,21.8,38.5,21.8,38.5,21.8z M29.5,11.6c0.3-0.5,0.7-0.6,1.2-0.6
  c0,0,0,0,0,0c0.6,0,1.2,0,1.8-0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1c-0.1,0.6-0.1,1.2-0.1,1.8c0,0,0,0,0,0
  c0,0.5-0.2,1-0.6,1.2c-0.6,0.4-1.5,0.1-2-0.4c0,0,0,0,0,0c0,0,0,0,0,0C29.4,13.1,29.2,12.2,29.5,11.6z M20.5,7.8
  C20.5,7.8,20.5,7.8,20.5,7.8c0.4-0.5,0.9-0.9,1.2-1.4c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1
  c0.3,0.5,0.8,0.9,1.2,1.3c0,0,0,0,0,0c0.3,0.4,0.6,0.8,0.4,1.3c-0.2,0.7-1,1.1-1.7,1.1c0,0,0,0,0,0c0,0,0,0,0,0
  c-0.7,0-1.5-0.4-1.7-1.1C19.9,8.6,20.2,8.2,20.5,7.8z M10.9,10.9C10.9,10.9,10.9,10.9,10.9,10.9c0.7,0.1,1.3,0.1,1.9,0.1
  c0,0,0,0,0,0c0.5,0,1,0.2,1.2,0.6c0.4,0.6,0.1,1.5-0.4,2c0,0,0,0,0,0c0,0,0,0,0,0c-0.5,0.5-1.3,0.8-2,0.4c-0.5-0.3-0.6-0.7-0.6-1.2
  c0,0,0,0,0,0C10.9,12.1,11,11.5,10.9,10.9C10.9,10.9,10.8,10.9,10.9,10.9C10.8,10.9,10.8,10.9,10.9,10.9
  C10.9,10.9,10.9,10.9,10.9,10.9z M7.7,23c-0.5-0.4-0.9-0.8-1.3-1.2c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0
  c0.5-0.3,0.9-0.8,1.3-1.2c0,0,0,0,0,0c0.4-0.3,0.8-0.6,1.3-0.4c0.7,0.2,1.1,1,1.1,1.7c0,0,0,0,0,0c0,0,0,0,0,0
  c0,0.7-0.4,1.5-1.1,1.7C8.6,23.6,8.2,23.4,7.7,23C7.8,23,7.7,23,7.7,23z M14,32c-0.3,0.5-0.7,0.6-1.2,0.6c0,0,0,0,0,0
  c-0.6,0-1.2,0-1.8,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0.1-0.6,0.1-1.2,0.1-1.8c0,0,0,0,0,0
  c0-0.5,0.2-1,0.6-1.2c0.6-0.4,1.5-0.1,2,0.4c0,0,0,0,0,0c0,0,0,0,0,0C14.1,30.5,14.4,31.3,14,32z M23,35.8C23,35.8,23,35.8,23,35.8
  c-0.4,0.5-0.9,0.9-1.2,1.4c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0-0.1c-0.3-0.5-0.8-0.9-1.2-1.3c0,0,0,0,0,0
  c-0.3-0.4-0.6-0.8-0.4-1.3c0.2-0.7,1-1.1,1.7-1.1c0,0,0,0,0,0c0,0,0,0,0,0c0.7,0,1.5,0.4,1.7,1.1C23.6,35,23.3,35.4,23,35.8z
   M32.7,32.7C32.6,32.7,32.6,32.7,32.7,32.7c-0.7-0.1-1.3-0.1-1.9-0.1c0,0,0,0,0,0c-0.5,0-1-0.2-1.2-0.6c-0.4-0.6-0.1-1.5,0.4-2
  c0,0,0,0,0,0c0,0,0,0,0,0c0.5-0.5,1.3-0.8,2-0.4c0.5,0.3,0.6,0.7,0.6,1.2c0,0,0,0,0,0C32.6,31.4,32.6,32,32.7,32.7
  C32.7,32.7,32.7,32.7,32.7,32.7C32.7,32.7,32.7,32.7,32.7,32.7C32.7,32.7,32.7,32.7,32.7,32.7z M33.6,26.7
  c-0.3,0.8-0.6,1.7-0.8,2.6c0,0-0.1-0.1-0.1-0.1c-0.9-1-2.5-0.7-3.4,0.2c0,0,0,0,0,0c0,0,0,0,0,0c-0.9,0.9-1.2,2.5-0.2,3.4
  c0,0,0.1,0.1,0.1,0.1c-0.9,0.2-1.7,0.4-2.6,0.8c-0.8,0.4-1.6,0.8-2.4,1.3c0-0.1,0-0.1,0-0.2c0.1-1.4-1.3-2.3-2.5-2.3c0,0,0,0,0,0
  c0,0,0,0,0,0c-1.2,0-2.6,0.9-2.5,2.3c0,0.1,0,0.1,0,0.2c-0.7-0.5-1.5-0.9-2.4-1.3c-0.8-0.3-1.7-0.6-2.6-0.8c0,0,0.1-0.1,0.1-0.1
  c1-0.9,0.7-2.5-0.2-3.4c0,0,0,0,0,0c0,0,0,0,0,0c-0.9-0.9-2.5-1.2-3.4-0.2c0,0-0.1,0.1-0.1,0.1c-0.2-0.9-0.4-1.7-0.8-2.6
  c-0.4-0.8-0.8-1.6-1.3-2.4c0.1,0,0.1,0,0.2,0c1.4,0.1,2.3-1.3,2.3-2.6c0,0,0,0,0,0c0,0,0,0,0,0c0-1.2-0.9-2.6-2.3-2.6
  c-0.1,0-0.1,0-0.2,0c0.5-0.7,0.9-1.5,1.3-2.4c0.3-0.8,0.6-1.7,0.8-2.6c0,0,0.1,0.1,0.1,0.1c0.9,1,2.5,0.7,3.4-0.2c0,0,0,0,0,0
  c0,0,0,0,0,0c0.9-0.9,1.2-2.5,0.2-3.4c0,0-0.1-0.1-0.1-0.1c0.9-0.2,1.7-0.4,2.6-0.8c0.8-0.4,1.6-0.8,2.4-1.3c0,0.1,0,0.1,0,0.2
  c-0.1,1.4,1.3,2.3,2.5,2.3c0,0,0,0,0,0c0,0,0,0,0,0c1.2,0,2.6-0.9,2.5-2.3c0-0.1,0-0.1,0-0.2c0.7,0.5,1.5,0.9,2.4,1.3
  c0.8,0.3,1.7,0.6,2.6,0.8c0,0-0.1,0.1-0.1,0.1c-1,0.9-0.7,2.5,0.2,3.4c0,0,0,0,0,0c0,0,0,0,0,0c0.9,0.9,2.5,1.2,3.4,0.2
  c0,0,0.1-0.1,0.1-0.1c0.2,0.9,0.4,1.7,0.8,2.6c0.4,0.8,0.8,1.6,1.3,2.4c-0.1,0-0.1,0-0.2,0c-1.4-0.1-2.3,1.3-2.3,2.6c0,0,0,0,0,0
  c0,0,0,0,0,0c0,1.2,0.9,2.6,2.3,2.6c0.1,0,0.1,0,0.2,0C34.4,25.1,34,25.9,33.6,26.7z M37.2,21.8C37.2,21.8,37.2,21.8,37.2,21.8
  c-0.6,0.4-1,0.8-1.4,1.2c0,0,0,0,0,0c-0.4,0.3-0.8,0.6-1.3,0.4c-0.7-0.2-1.1-1-1.1-1.7c0,0,0,0,0,0c0,0,0,0,0,0
  c0-0.7,0.4-1.5,1.1-1.7c0.5-0.1,0.9,0.1,1.3,0.4c0,0,0,0,0,0C36.2,21,36.6,21.4,37.2,21.8C37.2,21.7,37.2,21.8,37.2,21.8
  C37.2,21.8,37.2,21.8,37.2,21.8C37.2,21.8,37.2,21.8,37.2,21.8z"/>

</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4">
<title>B4</title>
<path style="fill:#00366F;" d="M13.5,18.3c-0.5-1.1-0.9-2.2-1.2-3.4c-0.4-1.1-0.7-2.3-1-3.5c-0.6,0.6-1.1,1.3-1.6,2
			c-0.5,0.8-1,1.7-1.4,2.6c-0.7,1.7-1.1,3.6-1.2,5.5c1-0.6,2.1-1.2,3.1-1.7C11.3,19.3,12.4,18.8,13.5,18.3z"/>
		<path style="fill:#00366F;" d="M18.5,30.5c-1.1,0.5-2.2,0.9-3.4,1.2c-1.2,0.4-2.4,0.7-3.6,1.1c0.7,0.7,1.4,1.3,2.1,1.8
			c0.8,0.5,1.7,1,2.6,1.4c1.8,0.8,3.7,1.2,5.6,1.2c-0.7-1.1-1.3-2.3-1.9-3.4C19.5,32.7,19,31.6,18.5,30.5z"/>
		<path style="fill:#00366F;" d="M37.1,22.3c-1,0.6-2.1,1.2-3.2,1.7c-1.1,0.5-2.2,1-3.3,1.5c0.5,1.1,0.9,2.2,1.2,3.4
			c0.4,1.2,0.7,2.4,1.1,3.6c0.6-0.6,1.1-1.3,1.5-1.9c0.5-0.8,1-1.7,1.4-2.6C36.7,26.1,37.1,24.2,37.1,22.3z"/>
		<path style="fill:#00366F;" d="M13.5,25.5c-1.1-0.5-2.2-1-3.3-1.5c-1.1-0.5-2.1-1.1-3.1-1.7c0,2,0.4,3.9,1.2,5.7
			c0.4,0.9,0.8,1.8,1.4,2.6c0.5,0.7,1,1.3,1.5,1.9c0.3-1.2,0.7-2.4,1.1-3.6C12.6,27.7,13,26.6,13.5,25.5z"/>
		<path style="fill:#00366F;" d="M30.7,18.3c1.1,0.5,2.2,1,3.3,1.5c1.1,0.5,2.1,1.1,3.2,1.7c-0.1-1.9-0.4-3.7-1.2-5.5
			c-0.4-0.9-0.8-1.8-1.4-2.6c-0.5-0.7-1-1.4-1.6-2c-0.3,1.2-0.6,2.3-1,3.5C31.6,16.1,31.2,17.2,30.7,18.3z"/>
		<path style="fill:#00366F;" d="M25.7,30.5c-0.5,1.1-1,2.2-1.5,3.3c-0.6,1.2-1.2,2.3-1.9,3.4c2,0,3.9-0.4,5.6-1.2
			c0.9-0.4,1.7-0.9,2.6-1.4c0.8-0.5,1.5-1.1,2.1-1.8c-1.2-0.3-2.4-0.7-3.6-1.1C27.9,31.4,26.8,31,25.7,30.5z"/>
		<path style="fill:#00366F;" d="M25.7,13.3c1.1-0.5,2.2-0.9,3.4-1.2c1.1-0.4,2.3-0.7,3.5-1c-0.6-0.6-1.3-1.1-2-1.6
			c-0.8-0.5-1.7-1-2.6-1.4c-1.8-0.8-3.6-1.2-5.5-1.2c0.6,1.1,1.2,2.1,1.8,3.2C24.7,11.1,25.2,12.2,25.7,13.3z"/>
		<path style="fill:#00366F;" d="M18.5,13.3c0.5-1.1,1-2.2,1.5-3.3c0.6-1.1,1.1-2.2,1.8-3.2c-1.9,0-3.8,0.4-5.5,1.2
			c-0.9,0.4-1.7,0.9-2.6,1.4c-0.7,0.5-1.4,1-2,1.6c1.2,0.3,2.3,0.6,3.5,1C16.3,12.4,17.4,12.9,18.5,13.3z"/>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5">
<title>B5</title>

			<path style="fill:#0070B4;" d="M25.1,20.2c-0.1-0.4-0.1-0.8,0-1.3c-0.4,0-0.8,0-1.3,0c-0.3-0.3-0.5-0.7-0.7-1.1
				c-0.3,0.3-0.7,0.5-1.1,0.6c-0.4-0.1-0.8-0.3-1.1-0.6c-0.2,0.4-0.4,0.8-0.7,1.1c-0.4,0.1-0.8,0.1-1.3,0c0,0.4,0,0.8,0,1.3
				c-0.3,0.3-0.7,0.5-1.1,0.7c0.3,0.3,0.5,0.7,0.6,1.1c-0.1,0.4-0.3,0.8-0.6,1.1c0.4,0.2,0.8,0.4,1.1,0.7c0.1,0.4,0.1,0.8,0,1.3
				c0.4,0,0.8,0,1.3,0c0.3,0.3,0.5,0.7,0.7,1.1c0.3-0.3,0.7-0.5,1.1-0.6c0.4,0.1,0.8,0.3,1.1,0.6c0.2-0.4,0.4-0.8,0.7-1.1
				c0.4-0.1,0.8-0.1,1.3,0c0-0.4,0-0.8,0-1.3c0.3-0.3,0.7-0.5,1.1-0.7c-0.3-0.3-0.5-0.7-0.6-1.1c0.1-0.4,0.3-0.8,0.6-1.1
				C25.8,20.7,25.4,20.5,25.1,20.2z M24.3,22.6c-0.4,0-0.7,0.1-1.1,0.1c0.2,0.3,0.3,0.6,0.4,1c-0.3-0.1-0.7-0.3-1-0.4
				c0,0.4-0.1,0.7-0.1,1.1c-0.2-0.3-0.4-0.6-0.6-0.9c-0.2,0.3-0.4,0.6-0.6,0.9c0-0.4-0.1-0.7-0.1-1.1c-0.3,0.2-0.6,0.3-1,0.4
				c0.1-0.3,0.3-0.7,0.4-1c-0.4,0-0.7-0.1-1.1-0.1c0.3-0.2,0.6-0.4,0.9-0.6c-0.3-0.2-0.6-0.4-0.9-0.6c0.4,0,0.7-0.1,1.1-0.1
				c-0.2-0.3-0.3-0.6-0.4-1c0.3,0.1,0.7,0.3,1,0.4c0-0.4,0.1-0.7,0.1-1.1c0.2,0.3,0.4,0.6,0.6,0.9c0.2-0.3,0.4-0.6,0.6-0.9
				c0,0.4,0.1,0.7,0.1,1.1c0.3-0.2,0.6-0.3,1-0.4c-0.1,0.3-0.3,0.7-0.4,1c0.4,0,0.7,0.1,1.1,0.1c-0.3,0.2-0.6,0.4-0.9,0.6
				C23.7,22.2,24,22.4,24.3,22.6z"/>
		
			<path style="fill:#013571;" d="M34.3,17.3c-0.2,0.5-0.3,1-0.5,1.5c0.4,0.3,0.8,0.7,1.2,1.1c0.7,0.6,1.5,0.3,2.4,0.3
				c0.9,0,1.8,0.2,2.5,0.8c0.1-0.6,0.1-1.2,0.2-1.7c-0.4-0.9-2-0.9-2.9-1.1c-0.2,0-0.4-0.1-0.5-0.1c0.1-0.1,0.3-0.2,0.4-0.4
				c0.6-0.6,2-1.4,1.9-2.4c-0.3-0.5-0.7-0.9-1-1.4c-0.3,0.8-1,1.5-1.8,1.9C35.5,16.3,34.6,16.4,34.3,17.3z"/>
	
				<path style="fill:#013571;" d="M35.8,9.6c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.1-0.4-0.2
					c-0.2-0.1-0.4-0.2-0.6-0.3c0.1,0.5,0.1,1,0,1.5C34.8,9.5,35.4,9.5,35.8,9.6z"/>
			
				<path style="fill:#013571;" d="M30.3,11.7c0.1,0.5,0.2,1,0.3,1.6c0.5,0.1,1,0.2,1.6,0.3c0.9,0.2,1.5-0.5,2.2-0.9
					c0.8-0.4,1.7-0.7,2.5-0.6c-0.2-0.5-0.5-1.1-0.7-1.6c-0.8-0.6-2.2,0.2-3.1,0.5c-0.2,0.1-0.3,0.1-0.5,0.2c0.1-0.2,0.1-0.3,0.2-0.5
					c0.3-0.8,1-2.2,0.5-3.1c-0.5-0.2-1.1-0.5-1.6-0.7c0.2,0.8-0.2,1.8-0.6,2.5C30.8,10.3,30.1,10.8,30.3,11.7z"/>
			
				<path style="fill:#013571;" d="M25.7,40.2c0.2,0,0.4,0.1,0.7,0.1c0.2,0,0.3,0,0.5,0.1c0.1-0.1,0.3-0.2,0.4-0.3
					c0.2-0.1,0.4-0.3,0.5-0.4c-0.5-0.1-0.9-0.4-1.3-0.8C26.3,39.4,26.1,39.9,25.7,40.2z"/>
			
				<path style="fill:#013571;" d="M19.8,35.1c-0.4-0.4-0.7-0.8-1.1-1.2c-0.5,0.2-1,0.3-1.5,0.5c-0.9,0.3-1,1.2-1.5,1.9
					c-0.5,0.7-1.1,1.5-1.9,1.8c0.5,0.3,0.9,0.7,1.4,1c1,0.1,1.8-1.3,2.4-1.9c0.1-0.1,0.2-0.3,0.4-0.4c0,0.2,0.1,0.4,0.1,0.5
					c0.2,0.8,0.2,2.4,1.1,2.9c0.6-0.1,1.1-0.1,1.7-0.2c-0.6-0.6-0.8-1.6-0.8-2.5C20.2,36.6,20.5,35.8,19.8,35.1z"/>
			
				<path style="fill:#013571;" d="M8.1,34.4c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.1,0.4,0.2
					c0.2,0.1,0.4,0.2,0.6,0.3c-0.1-0.5-0.1-1,0-1.5C9.1,34.5,8.5,34.5,8.1,34.4z"/>
			
				<path style="fill:#013571;" d="M13.6,32.3c-0.1-0.5-0.2-1-0.3-1.6c-0.5-0.1-1-0.2-1.6-0.3c-0.9-0.2-1.5,0.5-2.2,0.9
					c-0.8,0.4-1.7,0.7-2.5,0.6c0.2,0.5,0.5,1.1,0.7,1.6c0.8,0.6,2.2-0.2,3.1-0.5c0.2-0.1,0.3-0.1,0.5-0.2c-0.1,0.2-0.1,0.3-0.2,0.5
					c-0.3,0.8-1,2.2-0.5,3.1c0.5,0.2,1.1,0.5,1.6,0.7c-0.2-0.8,0.2-1.8,0.6-2.5C13.1,33.7,13.8,33.2,13.6,32.3z"/>
		
				<path style="fill:#013571;" d="M16.1,39.7c0.2,0.1,0.4,0.3,0.5,0.4c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0,0.3,0,0.5-0.1
					c0.2,0,0.4,0,0.7-0.1c-0.4-0.4-0.6-0.8-0.7-1.3C17,39.2,16.6,39.5,16.1,39.7z"/>
			
				<path style="fill:#013571;" d="M28.1,36.2c-0.4-0.7-0.6-1.6-1.5-1.9c-0.5-0.2-1-0.3-1.5-0.5c-0.3,0.4-0.7,0.8-1.1,1.2
					c-0.6,0.7-0.3,1.5-0.3,2.4c0,0.9-0.2,1.8-0.8,2.5c0.6,0.1,1.2,0.1,1.7,0.2c0.9-0.4,0.9-2,1.1-2.9c0-0.2,0.1-0.4,0.1-0.5
					c0.1,0.1,0.2,0.3,0.4,0.4c0.6,0.6,1.4,2,2.4,1.9c0.5-0.3,0.9-0.7,1.4-1C29.2,37.7,28.6,37,28.1,36.2z"/>
		
				<path style="fill:#013571;" d="M40.2,25.8c-0.4,0.4-0.8,0.6-1.3,0.7c0.4,0.4,0.7,0.8,0.8,1.3c0.1-0.2,0.3-0.4,0.4-0.5
					c0.1-0.1,0.2-0.3,0.3-0.4c0-0.2,0-0.3-0.1-0.5C40.2,26.2,40.2,26,40.2,25.8z"/>
		
				<path style="fill:#013571;" d="M39.6,16.2c-0.1,0.5-0.4,0.9-0.8,1.3c0.5,0.2,1,0.4,1.3,0.7c0-0.2,0.1-0.4,0.1-0.7
					c0-0.2,0-0.3,0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.4C39.9,16.5,39.8,16.3,39.6,16.2z"/>
			
				<path style="fill:#013571;" d="M34.3,34.4c0.1,0.5,0.2,1,0,1.5c0.2-0.1,0.4-0.2,0.6-0.3c0.1-0.1,0.3-0.1,0.4-0.2
					c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.2,0.2-0.4,0.3-0.6C35.4,34.5,34.8,34.5,34.3,34.4z"/>
			
				<path style="fill:#013571;" d="M37,26.3c-0.1-0.1-0.3-0.2-0.4-0.4c0.2,0,0.4-0.1,0.5-0.1c0.8-0.2,2.4-0.2,2.9-1.1
					c-0.1-0.6-0.1-1.1-0.2-1.7c-0.6,0.6-1.6,0.8-2.5,0.8c-0.8,0-1.7-0.3-2.4,0.3c-0.4,0.4-0.8,0.7-1.2,1.1c0.2,0.5,0.3,1,0.5,1.5
					c0.3,0.9,1.2,1,1.9,1.5c0.7,0.5,1.5,1.1,1.8,1.9c0.3-0.5,0.7-0.9,1-1.4C39,27.7,37.7,26.9,37,26.3z"/>
			
				<path style="fill:#013571;" d="M34.4,31.2c-0.7-0.4-1.3-1.1-2.2-0.9c-0.5,0.1-1,0.2-1.6,0.3c-0.1,0.5-0.2,1-0.3,1.6
					c-0.2,0.9,0.5,1.5,0.9,2.2c0.4,0.8,0.7,1.7,0.6,2.5c0.5-0.2,1.1-0.5,1.6-0.7c0.6-0.8-0.2-2.2-0.5-3.1c-0.1-0.2-0.1-0.3-0.2-0.5
					c0.2,0.1,0.3,0.1,0.5,0.2c0.8,0.3,2.2,1,3.1,0.5c0.2-0.5,0.5-1.1,0.7-1.6C36.1,32,35.2,31.7,34.4,31.2z"/>
			
				<path style="fill:#013571;" d="M9.5,12.8c0.7,0.4,1.3,1.1,2.2,0.9c0.5-0.1,1-0.2,1.6-0.3c0.1-0.5,0.2-1,0.3-1.6
					c0.2-0.9-0.5-1.5-0.9-2.2C12.3,8.8,12,7.8,12.1,7c-0.5,0.2-1.1,0.5-1.6,0.7C10,8.5,10.8,9.9,11,10.7c0.1,0.2,0.1,0.3,0.2,0.5
					c-0.2-0.1-0.3-0.1-0.5-0.2c-0.8-0.3-2.2-1-3.1-0.5c-0.2,0.5-0.5,1.1-0.7,1.6C7.8,12,8.7,12.3,9.5,12.8z"/>
			
				<path style="fill:#013571;" d="M9.6,9.6c-0.1-0.5-0.2-1,0-1.5C9.4,8.2,9.1,8.3,8.9,8.4C8.8,8.4,8.7,8.5,8.5,8.6
					C8.5,8.7,8.4,8.9,8.3,9C8.2,9.2,8.1,9.4,8.1,9.6C8.5,9.5,9.1,9.5,9.6,9.6z"/>
			
				<path style="fill:#013571;" d="M18.2,3.8c-0.2,0-0.4-0.1-0.7-0.1c-0.2,0-0.3,0-0.5-0.1c-0.1,0.1-0.3,0.2-0.4,0.3
					c-0.2,0.1-0.4,0.3-0.5,0.4c0.5,0.1,0.9,0.4,1.3,0.8C17.6,4.6,17.8,4.1,18.2,3.8z"/>
		
				<path style="fill:#013571;" d="M27.8,4.3c-0.2-0.1-0.4-0.3-0.5-0.4c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2,0-0.3,0-0.5,0.1
					c-0.2,0-0.4,0-0.7,0.1c0.4,0.4,0.6,0.8,0.7,1.3C26.9,4.8,27.3,4.5,27.8,4.3z"/>
			
				<path style="fill:#013571;" d="M24,8.9c0.4,0.4,0.7,0.8,1.1,1.2c0.5-0.2,1-0.3,1.5-0.5c0.9-0.3,1-1.2,1.5-1.9
					C28.6,7,29.2,6.3,30,6c-0.5-0.3-0.9-0.7-1.4-1c-1-0.1-1.8,1.3-2.4,1.9C26.1,7,26,7.2,25.9,7.3c0-0.2-0.1-0.4-0.1-0.5
					c-0.2-0.8-0.2-2.4-1.1-2.9C24.1,4,23.5,4,22.9,4.1c0.6,0.6,0.8,1.6,0.8,2.5C23.7,7.4,23.4,8.2,24,8.9z"/>
			
				<path style="fill:#013571;" d="M15.8,7.8c0.4,0.7,0.6,1.6,1.5,1.9c0.5,0.2,1,0.3,1.5,0.5c0.3-0.4,0.7-0.8,1.1-1.2
					c0.6-0.7,0.3-1.5,0.3-2.4c0-0.9,0.2-1.8,0.8-2.5C20.4,4,19.8,4,19.2,3.9c-0.9,0.4-0.9,2-1.1,2.9c0,0.2-0.1,0.4-0.1,0.5
					c-0.1-0.1-0.2-0.3-0.4-0.4c-0.6-0.6-1.4-2-2.4-1.9c-0.5,0.3-0.9,0.7-1.4,1C14.7,6.3,15.3,7,15.8,7.8z"/>
			
				<path style="fill:#013571;" d="M9.6,26.7c0.2-0.5,0.3-1,0.5-1.5c-0.4-0.3-0.8-0.7-1.2-1.1c-0.7-0.6-1.5-0.3-2.4-0.3
					c-0.9,0-1.8-0.2-2.5-0.8c-0.1,0.6-0.1,1.2-0.2,1.7c0.4,0.9,2,0.9,2.9,1.1c0.2,0,0.4,0.1,0.5,0.1c-0.1,0.1-0.3,0.2-0.4,0.4
					c-0.6,0.6-2,1.4-1.9,2.4c0.3,0.5,0.7,0.9,1,1.4c0.3-0.8,1-1.5,1.8-1.9C8.4,27.7,9.3,27.6,9.6,26.7z"/>
			
				<path style="fill:#013571;" d="M3.7,25.8c0,0.2-0.1,0.4-0.1,0.7c0,0.2,0,0.3-0.1,0.5c0.1,0.1,0.2,0.3,0.3,0.4
					c0.1,0.2,0.3,0.4,0.4,0.5c0.1-0.5,0.4-0.9,0.8-1.3C4.5,26.4,4.1,26.1,3.7,25.8z"/>
			
				<path style="fill:#013571;" d="M3.7,18.2c0.4-0.4,0.8-0.6,1.3-0.7c-0.4-0.4-0.7-0.8-0.8-1.3c-0.1,0.2-0.3,0.4-0.4,0.5
					c-0.1,0.1-0.2,0.3-0.3,0.4c0,0.2,0,0.3,0.1,0.5C3.7,17.8,3.7,18,3.7,18.2z"/>
			
				<path style="fill:#013571;" d="M6.9,17.7c0.1,0.1,0.3,0.2,0.4,0.4c-0.2,0-0.4,0.1-0.5,0.1c-0.8,0.2-2.4,0.2-2.9,1.1
					C3.9,19.9,4,20.4,4,21c0.6-0.6,1.6-0.8,2.5-0.8c0.8,0,1.7,0.3,2.4-0.3c0.4-0.4,0.8-0.7,1.2-1.1c-0.2-0.5-0.3-1-0.5-1.5
					c-0.3-0.9-1.2-1-1.9-1.5c-0.7-0.5-1.5-1.1-1.8-1.9c-0.3,0.5-0.7,0.9-1,1.4C4.8,16.3,6.2,17.1,6.9,17.7z"/>
	
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6">
<title>B6</title>
			<path style="fill:#D04042;" d="M8.8,22.1c-0.2-0.2-0.5-0.5-0.7-0.7c-0.4-0.4-1-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6l-0.7,0.7
				L5,22.9c0.4,0.4,1,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6C8.3,22.6,8.5,22.4,8.8,22.1z"/>
			<path style="fill:#D04042;" d="M14.5,31.5c0-0.6,0.1-1.3,0.2-1.9l0.1-0.3l-0.3,0.1c-0.6,0.2-1.3,0.2-1.9,0.2
				c-1.1,0-2.2-0.2-3.2-0.7l-0.4-0.2l0.2,0.4c0.5,1.3,1.3,2.5,2.3,3.6c1.2,1.2,2.5,1.9,4,2.5l-0.2-0.4
				C14.7,33.7,14.5,32.6,14.5,31.5z"/>
			<path style="fill:#D04042;" d="M12.6,14.6c0.6,0,1.3,0.1,1.9,0.2l0.3,0.1l-0.1-0.3c-0.2-0.6-0.2-1.3-0.2-1.9
				c0-1.4,0.3-2.4,0.9-3.7L15,9.3c-1.3,0.5-2.5,1.3-3.6,2.3c-1,1-1.8,2.2-2.3,3.6l-0.2,0.4l0.4-0.2C10.4,14.9,11.5,14.6,12.6,14.6z"
				/>
			<path style="fill:#D04042;" d="M29.5,12.7c0,0.6-0.1,1.3-0.2,1.9L29.1,15l0.3-0.1c0.6-0.2,1.3-0.2,1.9-0.2c1.1,0,2.2,0.2,3.2,0.7
				l0.4,0.2l-0.2-0.4c-0.5-1.3-1.3-2.5-2.3-3.6c-1-1-2.2-1.8-3.6-2.3l-0.4-0.2l0.2,0.4C29.2,10.5,29.5,11.6,29.5,12.7z"/>
			<path style="fill:#D04042;" d="M21.8,8.8L22,8.9l0.1-0.1c0.2-0.2,0.4-0.4,0.6-0.6c0.4-0.4,0.6-1,0.6-1.5c0-0.6-0.2-1.1-0.6-1.5
				L22,4.4l-0.7,0.7c-0.4,0.4-0.6,1-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5C21.4,8.4,21.6,8.6,21.8,8.8z"/>
			<path style="fill:#D04042;" d="M35.3,22l-0.1,0.1l0.1,0.1c0.2,0.2,0.4,0.4,0.6,0.6c0.4,0.4,1,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6
				l0.7-0.7L39,21.4c-0.4-0.4-1-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6C35.7,21.6,35.5,21.8,35.3,22z"/>
			<path style="fill:#D04042;" d="M31.4,29.6c-0.6,0-1.3-0.1-1.9-0.2l-0.3-0.1l0.1,0.3c0.2,0.6,0.2,1.3,0.2,1.9
				c0,1.1-0.2,2.2-0.7,3.2l-0.2,0.4L29,35c1.3-0.5,2.5-1.3,3.6-2.3c1.2-1.2,1.9-2.5,2.5-4l-0.4,0.2C33.6,29.4,32.5,29.6,31.4,29.6z"
				/>
			<path style="fill:#D04042;" d="M22,35.3c-0.2,0.2-0.5,0.5-0.7,0.7c-0.4,0.4-0.6,1-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5l0.7,0.7l0.7-0.7
				c0.4-0.4,0.6-1,0.6-1.5c0-0.6-0.2-1.1-0.6-1.5C22.5,35.8,22.2,35.6,22,35.3z"/>
			<path style="fill:#FCB040;" d="M9.2,20.3c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.2,0.4-0.4,0.6-0.6c2-2,3.3-2.8,6-2.7L16,17.3
				c-1-0.7-2.2-1.1-3.4-1.1c-1.6,0-3.1,0.6-4.2,1.7l-1.2,1.2l0.3,0.1C8.1,19.5,8.7,19.8,9.2,20.3z"/>
			<path style="fill:#FCB040;" d="M17.5,16.6l0-0.6c-0.1-2.2,1.2-3.9,2.7-5.4c0.2-0.2,0.4-0.4,0.6-0.6l-0.1-0.1
				c-0.2-0.2-0.4-0.3-0.5-0.5c-0.5-0.5-0.8-1.1-1-1.7L19,7.3l-1.2,1.2c-1.1,1.1-1.7,2.6-1.7,4.2c0,1.2,0.4,2.4,1.1,3.4L17.5,16.6z"
				/>
			<path style="fill:#FCB040;" d="M28.1,17.6c2.2-0.1,3.9,1.2,5.4,2.7c0.2,0.2,0.4,0.4,0.6,0.6l0.1-0.1c0.2-0.2,0.3-0.4,0.5-0.5
				c0.5-0.5,1.1-0.8,1.7-1l0.3-0.1L35.5,18c-1.1-1.1-2.6-1.7-4.2-1.7c-1.2,0-2.4,0.4-3.4,1.1l-0.5,0.4L28.1,17.6z"/>
			<path style="fill:#FCB040;" d="M23.3,10.1c0.2,0.2,0.3,0.3,0.5,0.5c1.5,1.5,2.8,3.2,2.7,5.4l0,0.6l0.4-0.5c0.7-1,1.1-2.2,1.1-3.4
				c0-1.6-0.6-3.1-1.7-4.2l-1.2-1.2l-0.1,0.3c-0.2,0.7-0.5,1.2-1,1.7c-0.2,0.2-0.4,0.4-0.7,0.6L23.3,10.1z"/>
			<path style="fill:#FCB040;" d="M34.7,24c-0.2-0.2-0.3-0.4-0.5-0.5l-0.1-0.1L34,23.5c-0.2,0.2-0.3,0.3-0.5,0.5
				c-1.5,1.5-3.2,2.8-5.4,2.7l-0.6,0L28,27c1,0.7,2.2,1.1,3.4,1.1c1.6,0,3.1-0.6,4.2-1.7l1.2-1.2L36.5,25
				C35.8,24.8,35.2,24.5,34.7,24z"/>
			<path style="fill:#FCB040;" d="M20.8,34.3l-0.1-0.1c-0.2-0.2-0.3-0.3-0.5-0.5c-1.5-1.5-2.8-3.2-2.7-5.4l0-0.6l-0.4,0.5
				c-0.7,1-1.1,2.2-1.1,3.4c0,1.6,0.6,3.1,1.7,4.2l1.2,1.2l0.1-0.3c0.2-0.7,0.5-1.2,1-1.7c0.2-0.2,0.4-0.3,0.5-0.5L20.8,34.3z"/>
			<path style="fill:#FCB040;" d="M26.4,27.6l0,0.6c0.1,2.2-1.2,3.9-2.7,5.4c-0.2,0.2-0.4,0.4-0.6,0.6l0.1,0.1
				c0.2,0.2,0.4,0.3,0.5,0.5c0.5,0.5,0.8,1.1,1,1.7l0.1,0.3l1.2-1.2c1.1-1.1,1.7-2.6,1.7-4.2c0-1.2-0.4-2.4-1.1-3.4L26.4,27.6z"/>
			<path style="fill:#FCB040;" d="M15.9,26.6c-2.2,0.1-3.9-1.2-5.4-2.7c-0.2-0.2-0.3-0.3-0.5-0.5l-0.1-0.1l-0.1,0.1
				c-0.2,0.2-0.3,0.4-0.5,0.5c-0.5,0.5-1.1,0.8-1.7,1l-0.3,0.1l1.2,1.2C9.5,27.4,11,28,12.6,28c1.2,0,2.4-0.4,3.4-1.1l0.5-0.4
				L15.9,26.6z"/>
</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7">
<title>B7</title>

<path style="fill:#3F94B3;" d="M28.6,11.5c-0.1,0.1-0.2,0.2-0.3,0.3c-1.2,1.2-2.3,2.3-3.5,3.5c-0.3,0.3-0.2,0.4,0,0.6
    c1.1,1.1,2.3,2.3,3.4,3.4c0.3,0.3,0.4,0.2,0.6,0c1.1-1.1,2.2-2.3,3.4-3.4c0.3-0.3,0.3-0.4,0-0.7c-1.1-1.1-2.3-2.2-3.4-3.4
    C28.8,11.7,28.7,11.6,28.6,11.5z"/>

<path style="fill:#3F94B3;" d="M35.1,7.5c-1.5,0.1-2.6,0.5-3.7,1.2c-0.3,0.2-0.4,0.3-0.1,0.6c1.1,1.1,2.3,2.2,3.4,3.4
    c0.3,0.3,0.5,0.2,0.7-0.1c0.7-1,1.1-2.1,1.2-3.4C36.6,8,36.1,7.4,35.1,7.5z"/>

<path style="fill:#3F94B3;" d="M15.1,11.7c-1.1,1.2-2.3,2.3-3.5,3.5c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.2
    c1.2,1.2,2.4,2.4,3.6,3.6c0.2,0.2,0.3,0.1,0.5-0.1c1.2-1.2,2.3-2.3,3.5-3.5c0.2-0.2,0.3-0.3,0-0.6c-1.2-1.1-2.3-2.3-3.5-3.5
    C15.5,11.5,15.4,11.5,15.1,11.7z"/>

<path style="fill:#3F94B3;" d="M18.4,8.7C18,8.9,18,9,18.3,9.3c1.1,1.1,2.3,2.2,3.4,3.4c0.2,0.3,0.4,0.3,0.6,0
    c1.1-1.1,2.2-2.3,3.4-3.4C26,9,26,8.9,25.6,8.7c-1.1-0.7-2.3-1.2-3.7-1.2C20.6,7.5,19.5,7.9,18.4,8.7z"/>

<path style="fill:#3F94B3;" d="M8.6,12.6c0.2,0.3,0.3,0.4,0.6,0.1c1.1-1.1,2.2-2.3,3.4-3.4c0.3-0.3,0.2-0.5-0.1-0.7
    c-1-0.7-2.1-1.1-3.4-1.2C7.9,7.4,7.4,8,7.4,8.9C7.5,10.4,7.9,11.6,8.6,12.6z"/>

<path style="fill:#3F94B3;" d="M8.6,18.4c-0.7,1.1-1.2,2.3-1.2,3.7c0,1.3,0.5,2.5,1.2,3.6c0.2,0.3,0.3,0.4,0.7,0.1
    c1.1-1.1,2.2-2.3,3.4-3.4c0.2-0.2,0.3-0.4,0-0.6c-1.2-1.1-2.3-2.3-3.4-3.4C8.9,18,8.8,18.1,8.6,18.4z"/>

<path style="fill:#3F94B3;" d="M35.4,25.7c0.7-1.1,1.2-2.3,1.2-3.7c0-1.3-0.5-2.5-1.2-3.6c-0.2-0.3-0.3-0.4-0.7-0.1
    c-1.1,1.1-2.2,2.3-3.4,3.4c-0.3,0.3-0.2,0.4,0,0.7c1.1,1.1,2.3,2.2,3.4,3.4C35.1,26.1,35.2,26,35.4,25.7z"/>

<path style="fill:#3F94B3;" d="M28.9,32.3c1.1-1.1,2.2-2.2,3.3-3.3c0.3-0.3,0.3-0.4,0-0.8c-1.1-1.1-2.2-2.2-3.3-3.3
    c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-1.2,1.2-2.3,2.3-3.5,3.5c-0.3,0.3-0.2,0.4,0,0.6c1.1,1.1,2.3,2.2,3.4,3.4
    C28.5,32.6,28.6,32.6,28.9,32.3z"/>

<path style="fill:#3F94B3;" d="M36.6,35.2c-0.1-1.5-0.5-2.7-1.2-3.7c-0.2-0.2-0.3-0.4-0.6-0.1c-1.1,1.2-2.3,2.3-3.4,3.4
    c-0.3,0.3-0.2,0.4,0,0.6c1.1,0.7,2.2,1.2,3.5,1.2C36.1,36.7,36.6,36.1,36.6,35.2z"/>

<path style="fill:#3F94B3;" d="M15.4,32.6c0.2,0,0.3-0.1,0.4-0.2c1.1-1.1,2.2-2.3,3.4-3.4c0.3-0.3,0.3-0.4,0-0.7
    c-1.1-1.1-2.3-2.2-3.4-3.4c-0.3-0.3-0.4-0.3-0.7,0c-1.1,1.1-2.2,2.2-3.3,3.3c-0.3,0.3-0.3,0.4,0,0.8c1.1,1.1,2.2,2.2,3.3,3.3
    C15.2,32.4,15.3,32.5,15.4,32.6z"/>

<path style="fill:#3F94B3;" d="M9.1,36.6c1.2-0.1,2.4-0.5,3.4-1.2c0.3-0.2,0.4-0.3,0.1-0.7c-1.1-1.1-2.3-2.2-3.4-3.4
    c-0.3-0.3-0.4-0.2-0.6,0.1c-0.7,1-1.2,2.2-1.2,3.7C7.4,36.1,7.9,36.7,9.1,36.6z"/>

<path style="fill:#3F94B3;" d="M25.6,35.5c0.3-0.2,0.4-0.3,0.1-0.7c-1.1-1.1-2.3-2.2-3.4-3.4c-0.2-0.2-0.4-0.3-0.6,0
    c-1.1,1.2-2.3,2.3-3.4,3.4c-0.3,0.3-0.2,0.4,0.1,0.6c1.1,0.7,2.3,1.2,3.7,1.2C23.3,36.6,24.5,36.2,25.6,35.5z"/>

</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8">
<title>B8</title>

					<path style="fill:#5692B0;" d="M8.9,21.9c-0.2-0.2-0.5-0.5-0.7-0.7c-0.4-0.4-1-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6l-0.7,0.7
						l0.7,0.7c0.4,0.4,1,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6C8.4,22.4,8.7,22.1,8.9,21.9z"/>
				
					<path style="fill:#5692B0;" d="M14.6,31.2c0-0.6,0.1-1.3,0.2-1.9l0.1-0.3l-0.3,0.1c-0.6,0.2-1.3,0.2-1.9,0.2
						c-1.1,0-2.2-0.2-3.2-0.7L9,28.4l0.2,0.4c0.5,1.3,1.3,2.5,2.3,3.5c1.2,1.2,2.5,1.9,4,2.5l-0.2-0.4
						C14.8,33.4,14.6,32.3,14.6,31.2z"/>
				
					<path style="fill:#5692B0;" d="M12.7,14.4c0.6,0,1.3,0.1,1.9,0.2l0.3,0.1l-0.1-0.3c-0.2-0.6-0.2-1.3-0.2-1.9
						c0-1.4,0.3-2.4,0.9-3.6L15,9.1c-1.3,0.5-2.5,1.3-3.5,2.3c-1,1-1.8,2.2-2.3,3.5L9,15.4l0.4-0.2C10.5,14.7,11.6,14.4,12.7,14.4z"
						/>
			
					<path style="fill:#5692B0;" d="M29.4,12.6c0,0.6-0.1,1.3-0.2,1.9l-0.1,0.3l0.3-0.1c0.6-0.2,1.3-0.2,1.9-0.2
						c1.1,0,2.2,0.2,3.2,0.7l0.4,0.2l-0.2-0.4c-0.5-1.3-1.3-2.5-2.3-3.5c-1-1-2.2-1.8-3.5-2.3l-0.4-0.2l0.2,0.4
						C29.2,10.3,29.4,11.5,29.4,12.6z"/>
				
					<path style="fill:#5692B0;" d="M21.9,8.7L22,8.8l0.1-0.1c0.2-0.2,0.4-0.4,0.6-0.6c0.4-0.4,0.6-1,0.6-1.5c0-0.6-0.2-1.1-0.6-1.5
						L22,4.3L21.3,5c-0.4,0.4-0.6,1-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5C21.5,8.3,21.7,8.5,21.9,8.7z"/>
				
					<path style="fill:#5692B0;" d="M35.2,21.8l-0.1,0.1l0.1,0.1c0.2,0.2,0.4,0.4,0.6,0.6c0.4,0.4,1,0.6,1.5,0.6
						c0.6,0,1.1-0.2,1.5-0.6l0.7-0.7l-0.7-0.7c-0.4-0.4-1-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6C35.6,21.4,35.4,21.6,35.2,21.8z"/>
				
					<path style="fill:#5692B0;" d="M31.3,29.3c-0.6,0-1.3-0.1-1.9-0.2L29.1,29l0.1,0.3c0.2,0.6,0.2,1.3,0.2,1.9
						c0,1.1-0.2,2.2-0.7,3.2l-0.2,0.4l0.4-0.2c1.3-0.5,2.5-1.3,3.5-2.3c1.2-1.2,1.9-2.5,2.5-4l-0.4,0.2
						C33.5,29.1,32.4,29.3,31.3,29.3z"/>
				
					<path style="fill:#5692B0;" d="M22,35c-0.2,0.2-0.5,0.5-0.7,0.7c-0.4,0.4-0.6,1-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5l0.7,0.7l0.7-0.7
						c0.4-0.4,0.6-1,0.6-1.5c0-0.6-0.2-1.1-0.6-1.5C22.5,35.5,22.2,35.2,22,35z"/>
			
					<path style="fill:#5692B0;" d="M9.3,20c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.2,0.4-0.4,0.6-0.6c1.9-1.9,3.3-2.8,6-2.6L16,17.1
						c-1-0.7-2.2-1.1-3.4-1.1c-1.6,0-3,0.6-4.1,1.7L7.3,19l0.3,0.1C8.3,19.2,8.8,19.6,9.3,20z"/>
				
					<path style="fill:#5692B0;" d="M17.6,16.4l0-0.6c-0.1-2.2,1.2-3.9,2.7-5.4c0.2-0.2,0.4-0.4,0.6-0.6l-0.1-0.1
						c-0.2-0.2-0.4-0.3-0.5-0.5c-0.5-0.5-0.8-1.1-1-1.7l-0.1-0.3l-1.2,1.2c-1.1,1.1-1.7,2.6-1.7,4.1c0,1.2,0.4,2.4,1.1,3.4
						L17.6,16.4z"/>
				
					<path style="fill:#5692B0;" d="M28.1,17.4c2.2-0.1,3.9,1.2,5.4,2.7c0.2,0.2,0.4,0.4,0.6,0.6l0.1-0.1c0.2-0.2,0.3-0.4,0.5-0.5
						c0.5-0.5,1.1-0.8,1.7-1l0.3-0.1l-1.2-1.2c-1.1-1.1-2.6-1.7-4.1-1.7c-1.2,0-2.4,0.4-3.4,1.1l-0.5,0.4L28.1,17.4z"/>
			
					<path style="fill:#5692B0;" d="M23.3,10c0.2,0.2,0.3,0.3,0.5,0.5c1.5,1.5,2.8,3.2,2.7,5.4l0,0.6l0.4-0.5c0.7-1,1.1-2.2,1.1-3.4
						c0-1.6-0.6-3-1.7-4.1l-1.2-1.2l-0.1,0.3c-0.2,0.7-0.5,1.2-1,1.7c-0.2,0.2-0.4,0.4-0.7,0.6L23.3,10z"/>
				
					<path style="fill:#5692B0;" d="M34.7,23.7c-0.2-0.2-0.3-0.4-0.5-0.5L34,23.1l-0.1,0.1c-0.2,0.2-0.3,0.3-0.5,0.5
						c-1.5,1.5-3.2,2.8-5.4,2.7l-0.6,0l0.5,0.4c1,0.7,2.2,1.1,3.4,1.1c1.6,0,3-0.6,4.1-1.7l1.2-1.2l-0.3-0.1
						C35.7,24.6,35.2,24.2,34.7,23.7z"/>
			
					<path style="fill:#5692B0;" d="M20.8,33.9l-0.1-0.1c-0.2-0.2-0.3-0.3-0.5-0.5c-1.5-1.5-2.8-3.2-2.7-5.4l0-0.6l-0.4,0.5
						c-0.7,1-1.1,2.2-1.1,3.4c0,1.6,0.6,3,1.7,4.1l1.2,1.2l0.1-0.3c0.2-0.7,0.5-1.2,1-1.7c0.2-0.2,0.4-0.3,0.5-0.5L20.8,33.9z"/>
			
				<path style="fill:#5692B0;" d="M26.4,27.3l0,0.6c0.1,2.2-1.2,3.9-2.7,5.4c-0.2,0.2-0.4,0.4-0.6,0.6l0.1,0.1
					c0.2,0.2,0.4,0.3,0.5,0.5c0.5,0.5,0.8,1.1,1,1.7l0.1,0.3l1.2-1.2c1.1-1.1,1.7-2.6,1.7-4.1c0-1.2-0.4-2.4-1.1-3.4L26.4,27.3z"/>
				
					<path style="fill:#5692B0;" d="M15.9,26.4c-2.2,0.1-3.9-1.2-5.4-2.7c-0.2-0.2-0.3-0.3-0.5-0.5L10,23.1l-0.1,0.1
						c-0.2,0.2-0.3,0.4-0.5,0.5c-0.5,0.5-1.1,0.8-1.7,1l-0.3,0.1L8.5,26c1.1,1.1,2.6,1.7,4.1,1.7c1.2,0,2.4-0.4,3.4-1.1l0.5-0.4
						L15.9,26.4z"/>

</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9">
<title>B9</title>
<path id="b" style="fill:#FFFFFF;" d="M24.7,37.3c0-1-0.2-1.8-0.6-2.5c0.3,0.1,0.6,0.2,0.9,0.2c0.4,0,0.8-0.1,1.1-0.4
		c0.3-0.3,0.5-0.6,0.5-0.9c0-0.3,0-0.4-0.1-0.6c-0.1-0.1-0.1-0.3-0.2-0.5c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0
		c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0.1-0.1,0.2c0.1,0.4,0.1,0.8,0,1c-0.1,0.2-0.4,0.3-0.7,0.4c-0.2,0-0.3,0-0.4-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.2,0-0.3,0.1-0.5c0.3,0.1,0.5,0.1,0.6-0.1c0.2-0.2,0.3-0.4,0.3-0.7
		c0.1-0.3,0.1-0.5,0.2-0.8c0-0.3,0-0.5,0-0.5c0.2,0.2,0.4,0.3,0.6,0.3c0.2,0,0.4-0.1,0.5-0.2c0.1-0.2,0.2-0.4,0.3-0.6
		c0.1-0.3,0-0.6,0-1c0.8,0.7,1.5,1.3,2.3,1.9c0.8,0.6,1.7,1,2.8,1.4c0.1,0.4,0.2,0.9,0.2,1.4c0,0.5-0.1,1-0.3,1.5
		c-0.3-0.2-0.7-0.3-1.2-0.4c-0.5-0.1-0.8,0-1.1,0.2c-0.3,0.2-0.4,0.4-0.5,0.7c-0.1,0.3-0.2,0.6-0.2,1c-0.1,0.3,0,0.5,0.2,0.7
		c0.2,0.2,0.5,0.3,0.9,0.4c0,0.2,0,0.4-0.1,0.7c-0.1,0.2-0.1,0.5-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.1-0.4,0.2-0.6,0.2
		c-0.4,0-0.7-0.1-1-0.4c-0.3-0.3-0.4-0.5-0.4-0.8c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.2-0.3
		c0.1-0.1,0.1-0.2,0-0.3C27.4,37,27.2,37,27,37c-0.2,0-0.4,0.1-0.6,0.3c-0.2,0.2-0.4,0.3-0.5,0.6c-0.2,0.2-0.2,0.5-0.2,0.7
		c0,0.7,0.2,1.2,0.7,1.6c0.5,0.4,1,0.6,1.6,0.6c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,0.9-0.5,1.3-0.9c0.4-0.4,0.6-0.7,0.9-1.2
		c0.2-0.4,0.4-0.8,0.5-1.2c0.2-0.9,0.3-1.8,0.3-2.6c0-0.8,0-1.6-0.2-2.4c1.5,0.3,3.2,0.3,4.9-0.2c0.4-0.1,0.8-0.2,1.2-0.4
		c0.4-0.2,0.8-0.5,1.2-0.9c0.3-0.4,0.6-0.8,0.8-1.3c0.2-0.5,0.3-1.1,0.3-1.7c0-0.6-0.2-1.1-0.6-1.6c-0.4-0.5-1-0.7-1.6-0.8
		c-0.3,0-0.5,0.1-0.8,0.2c-0.2,0.2-0.4,0.3-0.5,0.5c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.2,0,0.4,0.2,0.5c0.1,0.1,0.2,0.1,0.3,0
		c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.2,0.4-0.2c0.3,0,0.5,0.1,0.8,0.4c0.3,0.3,0.4,0.6,0.4,1
		c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.4,0.2-0.7,0.3c-0.2,0.1-0.5,0.1-0.7,0.1c-0.1-0.4-0.2-0.6-0.4-0.8
		c-0.2-0.2-0.5-0.3-0.8-0.2c-0.8,0.1-1.3,0.3-1.7,0.7c-0.3,0.3-0.3,0.6-0.2,1.1c0.1,0.5,0.2,0.8,0.4,1.1c-0.5,0.2-1,0.3-1.5,0.3
		c-0.5,0-1-0.1-1.4-0.2c-0.4-1-0.8-1.9-1.4-2.7c-0.6-0.8-1.2-1.6-1.9-2.3c0.4,0.1,0.7,0.1,1,0c0.3-0.1,0.5-0.1,0.6-0.3
		c0.2-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.6c0.1,0,0.3,0,0.5,0c0.3,0,0.5-0.1,0.8-0.2c0.3-0.1,0.5-0.2,0.7-0.4
		c0.2-0.2,0.2-0.4,0.1-0.6c0.3-0.2,0.6-0.2,0.9,0c0.3,0.2,0.4,0.5,0.4,0.8c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.1-0.5,0.1-1,0
		c-0.1,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.2c0.2,0.1,0.4,0.2,0.5,0.2
		c0.1,0.1,0.3,0.1,0.6,0.1c0.3,0,0.6-0.2,0.9-0.5c0.3-0.3,0.4-0.7,0.4-1.1c0-0.4-0.1-0.7-0.3-1c0.7,0.4,1.6,0.6,2.6,0.6
		c2,0,3.7-1,4-2.2v-0.7c-0.3-1.3-1.9-2.2-4-2.2c-1,0-1.9,0.2-2.6,0.6c0.2-0.3,0.3-0.6,0.3-1c0-0.4-0.1-0.8-0.4-1.1
		c-0.3-0.3-0.6-0.5-0.9-0.5c-0.3,0-0.4,0-0.6,0.1c-0.1,0.1-0.3,0.1-0.5,0.2c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0,0.4
		c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.1c0.4-0.1,0.7-0.1,1,0c0.2,0.1,0.3,0.4,0.3,0.7c0,0.3-0.1,0.6-0.4,0.8
		c-0.3,0.2-0.6,0.2-0.9,0c0.1-0.3,0.1-0.5-0.1-0.6c-0.2-0.2-0.4-0.3-0.7-0.4c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3,0-0.5,0-0.5,0
		c0.2-0.2,0.3-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.5c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3,0-0.6,0-1,0c0.7-0.7,1.4-1.5,1.9-2.3
		c0.6-0.8,1-1.7,1.4-2.8c0.4-0.1,0.8-0.2,1.4-0.2c0.5,0,1,0.1,1.5,0.3c-0.2,0.4-0.3,0.8-0.4,1.2c-0.1,0.5,0,0.8,0.2,1.1
		c0.4,0.4,0.9,0.7,1.7,0.7c0.3,0,0.5-0.1,0.8-0.3c0.2-0.2,0.4-0.5,0.4-0.8c0.2,0,0.4,0,0.7,0.1c0.2,0.1,0.5,0.2,0.7,0.3
		c0.2,0.1,0.4,0.3,0.5,0.4c0.1,0.2,0.2,0.4,0.2,0.6c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.5,0.4-0.8,0.4c-0.2,0-0.3-0.1-0.4-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.2,0-0.3,0c-0.2,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.6
		c0.1,0.2,0.3,0.4,0.5,0.5c0.2,0.2,0.5,0.2,0.8,0.2c0.7,0,1.2-0.2,1.6-0.7c0.4-0.5,0.6-1,0.6-1.6c0-0.6-0.1-1.2-0.3-1.7
		c-0.2-0.5-0.5-0.9-0.8-1.3c-0.3-0.4-0.7-0.6-1.2-0.9c-0.4-0.2-0.8-0.4-1.2-0.5c-1.8-0.4-3.4-0.4-5-0.2c0.3-1.5,0.3-3.2-0.1-4.9
		c-0.1-0.4-0.2-0.8-0.5-1.2c-0.2-0.4-0.5-0.8-0.9-1.2c-0.4-0.4-0.8-0.6-1.2-0.9C29.2,3.2,28.7,3,28,3c-0.6,0-1.2,0.2-1.6,0.6
		c-0.5,0.4-0.7,1-0.7,1.6c0,0.3,0.1,0.5,0.2,0.8c0.2,0.2,0.3,0.4,0.5,0.6c0.2,0.2,0.4,0.2,0.6,0.3c0.2,0,0.4,0,0.4-0.2
		c0.1-0.1,0.1-0.2,0-0.3c-0.1-0.1-0.1-0.2-0.2-0.3C27.2,6,27.1,5.9,27,5.7c-0.1-0.1-0.2-0.3-0.2-0.4c0-0.3,0.1-0.5,0.4-0.8
		c0.3-0.3,0.6-0.4,1-0.4c0.2,0,0.4,0.1,0.6,0.2c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.3,0.7c0.1,0.2,0.1,0.5,0.1,0.7
		c-0.4,0.1-0.6,0.2-0.8,0.4c-0.2,0.2-0.3,0.5-0.3,0.7c0,0.8,0.3,1.4,0.7,1.7c0.3,0.2,0.6,0.3,1.1,0.2c0.5-0.1,0.8-0.2,1.2-0.4
		c0.2,0.5,0.3,0.9,0.3,1.5c0,0.5-0.1,1-0.2,1.4c-1.1,0.4-2,0.8-2.8,1.4c-0.8,0.6-1.5,1.2-2.3,1.9c0.1-0.4,0.1-0.7,0-1
		c-0.1-0.3-0.1-0.5-0.3-0.6c-0.1-0.2-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.6,0.3c0-0.1,0-0.3,0-0.5c0-0.3-0.1-0.5-0.2-0.8
		c-0.1-0.3-0.2-0.5-0.4-0.7c-0.2-0.2-0.4-0.2-0.6-0.1c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.3
		c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0,0.5,0.1,0.6,0.4c0.1,0.2,0.1,0.5,0,1c0,0.1,0,0.1,0.1,0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0
		c0.1,0,0.2-0.1,0.2-0.1c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.1,0.1-0.3,0.1-0.6c0-0.4-0.2-0.7-0.5-0.9C25.8,9,25.4,8.9,25,8.9
		c-0.3,0-0.6,0.1-0.9,0.2c0.3-0.7,0.5-1.5,0.5-2.4c0-2.2-1.2-4-2.6-4s-2.6,1.8-2.6,4c0,0.9,0.2,1.8,0.5,2.5c-0.3-0.2-0.6-0.2-1-0.2
		c-0.5,0-0.8,0.1-1.2,0.4c-0.3,0.3-0.5,0.6-0.5,0.9c0,0.3,0,0.4,0.1,0.6c0.1,0.1,0.1,0.3,0.2,0.5c0,0.1,0.1,0.1,0.2,0.1
		c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.1-0.2c-0.1-0.4-0.1-0.8,0-1c0.1-0.2,0.4-0.3,0.7-0.4c0.3,0,0.5,0.1,0.7,0.4
		c0.2,0.3,0.2,0.6,0,0.9c-0.3-0.1-0.5-0.1-0.6,0.1c-0.2,0.2-0.3,0.4-0.3,0.7c-0.1,0.3-0.1,0.5-0.2,0.8c0,0.3,0,0.5,0,0.5
		c-0.2-0.2-0.4-0.3-0.6-0.3c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.3,0,0.6,0,1c-0.8-0.7-1.5-1.3-2.3-1.9
		c-0.8-0.6-1.7-1-2.8-1.4c-0.1-0.4-0.2-0.9-0.2-1.4c0-0.5,0.1-1,0.3-1.5c0.3,0.2,0.7,0.3,1.2,0.4c0.5,0.1,0.8,0,1.1-0.2
		c0.3-0.2,0.4-0.4,0.5-0.7c0.1-0.3,0.2-0.6,0.2-1c0.1-0.3,0-0.5-0.2-0.7c-0.2-0.2-0.5-0.3-0.9-0.4c0-0.2,0-0.4,0.1-0.7
		c0.1-0.2,0.1-0.5,0.3-0.7c0.1-0.2,0.3-0.4,0.4-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.4,0,0.7,0.1,1,0.4c0.3,0.3,0.4,0.5,0.4,0.8
		c0,0.2-0.1,0.3-0.2,0.4C17,5.9,16.9,6,16.8,6.1c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2,0,0.3c0.1,0.2,0.3,0.2,0.5,0.2
		c0.2,0,0.4-0.1,0.6-0.3c0.2-0.2,0.4-0.3,0.5-0.6c0.2-0.2,0.2-0.5,0.2-0.8c0-0.7-0.2-1.2-0.7-1.6C17.2,3.3,16.6,3,16,3
		c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-0.9,0.5-1.3,0.9c-0.4,0.4-0.6,0.7-0.9,1.2c-0.2,0.4-0.4,0.8-0.5,1.2c-0.2,0.9-0.3,1.7-0.3,2.6
		c0,0.8,0,1.6,0.2,2.4c-1.5-0.3-3.2-0.3-4.9,0.2c-0.4,0.1-0.8,0.2-1.2,0.4C5,12.4,4.6,12.7,4.3,13c-0.3,0.4-0.6,0.8-0.8,1.3
		c-0.2,0.5-0.3,1.1-0.3,1.7c0,0.6,0.2,1.1,0.6,1.6c0.4,0.5,1,0.7,1.6,0.8c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.4-0.3,0.6-0.5
		C6.9,17.4,6.9,17.2,7,17c0-0.2,0-0.4-0.2-0.5c-0.1-0.1-0.2-0.1-0.3,0c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		c-0.1,0.1-0.3,0.2-0.4,0.2c-0.3,0-0.5-0.1-0.8-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.3-0.3,0.5-0.4
		c0.2-0.1,0.4-0.2,0.7-0.3c0.2-0.1,0.5-0.1,0.7-0.1c0.1,0.4,0.2,0.6,0.4,0.8c0.2,0.2,0.5,0.3,0.8,0.2c0.4,0,0.7-0.1,1-0.2
		c0.3-0.1,0.6-0.3,0.8-0.5c0.2-0.3,0.3-0.6,0.2-1.1c-0.1-0.5-0.2-0.8-0.4-1.1c0.5-0.2,1-0.3,1.5-0.3c0.5,0,1,0.1,1.4,0.2
		c0.4,1,0.8,1.9,1.4,2.7c0.6,0.8,1.2,1.6,1.9,2.3c-0.4-0.1-0.7-0.1-1,0c-0.3,0.1-0.5,0.1-0.6,0.3c-0.2,0.1-0.2,0.3-0.2,0.5
		c0,0.2,0.1,0.4,0.2,0.6c-0.1,0-0.3,0-0.5,0c-0.3,0-0.5,0.1-0.8,0.2c-0.3,0.1-0.5,0.2-0.7,0.4c-0.2,0.2-0.2,0.4-0.1,0.6
		c-0.3,0.2-0.6,0.2-0.9,0c-0.3-0.2-0.4-0.5-0.4-0.8c0-0.3,0.1-0.5,0.3-0.7s0.5-0.1,1,0c0.1,0,0.1,0,0.2-0.1c0-0.1,0.1-0.2,0.1-0.3
		c0-0.1,0-0.2,0-0.4c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0-0.6,0.2-0.9,0.5
		C9.1,18.2,9,18.6,9,19c0,0.3,0.1,0.7,0.3,1c-0.7-0.4-1.6-0.6-2.6-0.6c-2.2,0-4,1.2-4,2.6c0,1.4,1.8,2.6,4,2.6c1,0,1.9-0.2,2.6-0.6
		c-0.2,0.3-0.3,0.7-0.3,1c0,0.4,0.1,0.8,0.4,1.1c0.3,0.3,0.6,0.5,0.9,0.5c0.3,0,0.5,0,0.6-0.1c0.2-0.1,0.3-0.1,0.5-0.2
		c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.1c-0.4,0.1-0.8,0.1-1,0c-0.2-0.1-0.3-0.4-0.3-0.7
		c0-0.3,0.1-0.6,0.4-0.8c0.3-0.2,0.6-0.2,0.9,0c-0.1,0.3-0.1,0.5,0.1,0.6c0.2,0.2,0.4,0.3,0.7,0.4c0.3,0.1,0.5,0.1,0.8,0.2
		c0.3,0,0.5,0,0.5,0c-0.2,0.2-0.3,0.4-0.2,0.6c0,0.2,0.1,0.4,0.2,0.5c0.2,0.1,0.4,0.2,0.6,0.3c0.3,0.1,0.6,0,1,0
		c-0.7,0.7-1.4,1.5-1.9,2.3c-0.6,0.8-1,1.7-1.4,2.8c-0.4,0.1-0.8,0.2-1.4,0.2c-0.5,0-1-0.1-1.5-0.3c0.2-0.3,0.3-0.7,0.4-1.2
		c0.1-0.5,0-0.8-0.2-1.1c-0.2-0.3-0.5-0.4-0.8-0.5c-0.3-0.1-0.6-0.2-1-0.2c-0.3,0-0.5,0.1-0.8,0.3c-0.2,0.2-0.4,0.5-0.4,0.8
		c-0.2,0-0.4,0-0.7-0.1c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.4-0.3-0.5-0.4c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.4,0.1-0.7,0.4-1
		c0.3-0.3,0.5-0.4,0.8-0.4c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.2,0,0.3,0
		C6.9,27.3,7,27.2,7,26.9c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.3-0.4-0.6-0.5c-0.2-0.2-0.5-0.2-0.7-0.2c-0.7,0-1.2,0.2-1.6,0.7
		c-0.4,0.5-0.6,1-0.6,1.6c0,0.6,0.1,1.2,0.3,1.7c0.2,0.5,0.5,0.9,0.8,1.3c0.3,0.4,0.7,0.6,1.2,0.9c0.4,0.2,0.8,0.4,1.2,0.5
		c1.8,0.4,3.4,0.4,5,0.2c-0.3,1.5-0.3,3.2,0.1,4.9c0.1,0.4,0.2,0.8,0.5,1.2c0.2,0.4,0.5,0.8,0.9,1.2c0.4,0.4,0.8,0.6,1.2,0.9
		c0.5,0.2,1,0.3,1.7,0.3c0.6,0,1.2-0.2,1.7-0.6c0.5-0.4,0.8-1,0.8-1.6c0-0.3-0.1-0.5-0.2-0.7c-0.2-0.2-0.3-0.4-0.5-0.6
		C17.5,37.1,17.3,37,17,37c-0.2,0-0.4,0-0.4,0.2c-0.1,0.1-0.1,0.2,0,0.3c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.3
		c0.1,0.1,0.2,0.3,0.2,0.4c0,0.3-0.1,0.5-0.4,0.8c-0.3,0.3-0.6,0.4-1,0.4c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.3-0.3-0.4-0.5
		c-0.1-0.2-0.2-0.4-0.3-0.7c-0.1-0.2-0.1-0.5-0.1-0.7c0.4-0.1,0.6-0.2,0.8-0.4c0.2-0.2,0.3-0.5,0.3-0.7c-0.1-0.8-0.3-1.4-0.7-1.7
		c-0.3-0.2-0.6-0.3-1.1-0.2c-0.5,0.1-0.8,0.2-1.2,0.4c-0.2-0.5-0.3-0.9-0.3-1.5c0-0.5,0.1-1,0.2-1.4c1.1-0.4,2-0.8,2.8-1.4
		c0.8-0.6,1.6-1.2,2.3-1.9c-0.1,0.4-0.1,0.7,0,1c0,0.3,0.1,0.5,0.3,0.6c0.1,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.6-0.3
		c0,0.1,0,0.3,0,0.5c0,0.3,0.1,0.5,0.2,0.8c0.1,0.3,0.2,0.5,0.4,0.7c0.2,0.2,0.4,0.2,0.6,0.1c0.2,0.3,0.2,0.6,0,0.9
		c-0.2,0.3-0.4,0.5-0.8,0.4c-0.3,0-0.5-0.1-0.6-0.4c-0.1-0.2-0.1-0.5,0-1c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.2,0-0.3,0
		c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.1,0.3-0.1,0.6c0,0.4,0.2,0.7,0.5,0.9
		c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.7-0.1,1.1-0.3c-0.4,0.7-0.6,1.6-0.6,2.6c0,2.2,1.1,3.9,2.5,4h0.2C23.6,41.2,24.7,39.5,24.7,37.3z
		"/>

</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10">
  <title>B10</title>
  <path style="fill:#C04947;" d="M14.6,33.7c0.3,0.5,0.6,0.7,0.9,0.9c0.9,0.6,2.1,0.7,3.4,0.3c-0.1,0.4-0.1,0.7-0.1,1.1
  c0,3.1,2.5,5.2,3.2,5.8c0.7-0.6,3.2-2.7,3.2-5.8c0-0.4,0-0.8-0.1-1.1c1.3,0.4,2.5,0.3,3.4-0.3c0.3-0.2,0.6-0.5,0.9-0.9
  c-1-0.4-2.5-1.3-4-2.8c-1.2-1.2-1.9-2.3-2.4-3.3c-0.2-0.4-0.6-0.7-1-0.7c-0.5,0-0.9,0.3-1,0.7c-0.5,0.9-1.2,2.1-2.4,3.3
  C17.1,32.4,15.6,33.3,14.6,33.7z"/>
<path style="fill:#C04947;" d="M2.2,22c0.6,0.7,2.7,3.2,5.8,3.2c0.4,0,0.8,0,1.1-0.1c-0.4,1.3-0.3,2.5,0.3,3.4
  c0.2,0.3,0.5,0.6,0.9,0.9c0.4-1,1.3-2.5,2.8-4c1.2-1.2,2.3-1.9,3.3-2.4c0.4-0.2,0.7-0.6,0.7-1c0-0.5-0.3-0.9-0.7-1
  c-0.9-0.5-2.1-1.2-3.3-2.4c-1.5-1.5-2.3-3-2.8-4c-0.5,0.3-0.7,0.6-0.9,0.9c-0.6,0.9-0.7,2.1-0.3,3.4c-0.4-0.1-0.7-0.1-1.1-0.1
  C4.8,18.8,2.8,21.3,2.2,22z"/>
<path style="fill:#C04947;" d="M18.8,8c0,0.4,0,0.8,0.1,1.1c-1.3-0.4-2.5-0.3-3.4,0.3c-0.3,0.2-0.6,0.5-0.9,0.9
  c1,0.4,2.5,1.3,4,2.8c1.2,1.2,1.9,2.3,2.4,3.3c0.2,0.4,0.6,0.7,1,0.7s0.9-0.3,1-0.7c0.5-0.9,1.2-2.1,2.4-3.3c1.5-1.5,3-2.3,4-2.8
  c-0.3-0.5-0.6-0.7-0.9-0.9c-0.9-0.6-2.1-0.7-3.4-0.3c0.1-0.4,0.1-0.7,0.1-1.1c0-3.1-2.5-5.2-3.2-5.8h0C21.3,2.8,18.8,4.8,18.8,8z
  "/>
<path style="fill:#C04947;" d="M36,18.8c-0.4,0-0.8,0-1.1,0.1c0.4-1.3,0.3-2.5-0.3-3.4c-0.2-0.3-0.5-0.6-0.9-0.9
  c-0.4,1-1.3,2.5-2.8,4c-1.2,1.2-2.3,1.9-3.3,2.4c-0.4,0.2-0.7,0.6-0.7,1c0,0.5,0.3,0.9,0.7,1c0.9,0.5,2.1,1.2,3.3,2.4
  c1.5,1.5,2.3,3,2.8,4c0.5-0.3,0.7-0.6,0.9-0.9c0.6-0.9,0.7-2.1,0.3-3.4c0.4,0.1,0.7,0.1,1.1,0.1c2.8,0,4.8-2.1,5.6-3v-0.5
  C40.9,20.8,38.9,18.8,36,18.8z"/>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11">
  <title>B11</title>
  <path style="fill:#FCB040;" d="M36.1,21.8C36,21.8,36,21.8,36.1,21.8c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.1-0.5-0.3-0.7-0.5
      c-0.7-0.6-1.2-1.4-1.5-2.2c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.1,0-0.2c-0.1-0.2-0.1-0.4-0.1-0.5
      c0-0.4-0.1-0.7-0.1-1.1c0-0.3,0-0.6,0-0.9c0-0.1,0-0.2,0-0.3c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.1,0-0.2,0-0.3
      c0-0.1,0-0.1,0-0.1c0-0.3,0.1-0.6,0.2-0.9c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3
      c0-0.2,0.1-0.5,0.1-0.7c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0-0.1,0-0.3,0-0.4c0-0.5,0-1,0-1.5c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2
      c0,0,0-0.1,0-0.1c0-0.1-0.1-0.1-0.1-0.1c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0
      c-0.1,0-0.3,0-0.4,0c-0.5,0-1,0.1-1.5,0.2c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0,0,0,0,0C30.2,10,30.1,10,30,10
      c-0.1,0-0.2,0.1-0.4,0.1c0,0-0.1,0-0.1,0c-0.4,0.1-0.7,0.1-1.1,0.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.3,0-0.6,0.1-0.8,0.1
      c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0
      c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c-0.3,0-0.6,0-0.9-0.1c-0.2,0-0.3,0-0.5-0.1c-0.3-0.1-0.7-0.2-1-0.3c-0.4-0.2-0.7-0.4-1-0.6
      c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.1-0.2-0.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1
      C22.2,8.4,22.1,8.2,22,8c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c-0.1,0.3-0.2,0.5-0.4,0.8c0,0.1-0.1,0.1-0.1,0.2
      c0,0.1-0.1,0.1-0.1,0.2C21.1,8.9,21,9,20.9,9c0,0,0,0,0,0c-0.2,0.2-0.4,0.3-0.6,0.5c-0.1,0.1-0.2,0.1-0.2,0.1
      c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0,0-0.1,0.1-0.1,0.1c-0.2,0.1-0.5,0.2-0.7,0.3c0,0-0.1,0-0.1,0c0,0,0,0,0,0
      c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.4,0.1-0.7,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0
      c-0.6,0-1.1-0.1-1.7-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c-0.3,0-0.5-0.1-0.8-0.1c-0.2,0-0.4-0.1-0.7-0.1
      c-0.1,0-0.3,0-0.4-0.1c-0.4-0.1-0.8-0.1-1.2-0.1c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0.1-1,0.1
      c0,0,0,0-0.1,0c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.4-0.1,0.8-0.1,1.3c0,0.1,0,0.3,0,0.4c0,0,0,0,0,0c0,0.3,0.1,0.6,0.1,0.8
      c0,0,0,0,0,0c0,0.2,0.1,0.4,0.1,0.6c0,0,0,0,0,0c0.2,0.7,0.3,1.5,0.4,2.2c0,0,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.4l0,0
      c0,0.2,0.1,0.5,0.1,0.7c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0,0.6c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4c0,0.2,0,0.3-0.1,0.5
      c0,0.2-0.1,0.4-0.2,0.7c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.4,0.9-0.7,1.4C9.2,20.9,9.1,21,9,21.1c0,0.1-0.1,0.1-0.1,0.1
      c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.4,0.3-0.7,0.4c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c0,0,0.1,0,0.1,0.1
      c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0.2,0.7,0.5,1,0.8c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.1,0.2,0.2,0.2,0.4c0.2,0.3,0.4,0.7,0.5,1.1
      c0,0.1,0.1,0.2,0.1,0.4c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0.1,0.3,0.1,0.6,0.1,0.9c0,0.2,0,0.4,0,0.6c0,0.1,0,0.1,0,0.2
      c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.6-0.1,1.2-0.2,1.9c-0.1,0.5-0.2,0.9-0.3,1.4c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.5-0.2,1-0.2,1.5
      c0,0.5,0,0.9,0.1,1.4c0,0,0,0,0,0c0,0.2,0.1,0.2,0.3,0.2c0.5,0.1,0.9,0.1,1.4,0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0
      c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.3-0.1,0.6-0.1,0.9-0.2c0.6-0.1,1.3-0.3,1.9-0.4c0.5-0.1,1.1-0.2,1.6-0.2c0,0,0,0,0.1,0
      c0.1,0,0.1,0,0.2,0c0.3,0,0.6,0,0.9,0c0.7,0,1.3,0.2,2,0.5c0.5,0.2,1,0.6,1.4,1c0.3,0.3,0.5,0.6,0.7,0.9c0,0,0,0,0,0.1
      c0,0,0,0.1,0,0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.3,0.3-0.5,0.5-0.7c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1
      c0.1-0.1,0.2-0.2,0.4-0.4c0.2-0.1,0.3-0.3,0.5-0.4c0.3-0.2,0.5-0.3,0.8-0.4c0.8-0.3,1.7-0.4,2.6-0.4c0.1,0,0.2,0,0.3,0
      c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.5,0.1,1,0.1,1.5,0.2c0.1,0,0.2,0,0.3,0
      c0.3,0.1,0.5,0.1,0.8,0.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.5,0.1,1,0.2,1.5,0.2c0.2,0,0.5,0,0.7,0c0.1,0,0.1,0,0.2,0
      c0.2,0,0.4-0.1,0.6-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1-0.1c0-0.1,0-0.2,0.1-0.2c0-0.2,0.1-0.5,0.1-0.7c0-0.2,0-0.4,0-0.6
      c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1
      C34.1,31,34,30.8,34,30.5c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2-0.1-0.2c-0.1-0.7-0.3-1.4-0.4-2.1
      c0,0,0-0.1,0-0.1c0-0.2,0-0.4,0-0.7c0-0.4,0-0.9,0.1-1.3c0,0,0-0.1,0-0.1c0-0.3,0.1-0.7,0.2-1c0.2-0.6,0.5-1.2,1-1.7
      c0.4-0.5,0.9-0.8,1.5-1.1c0,0,0.1,0,0-0.1C36.2,21.9,36.1,21.9,36.1,21.8z M33.9,22.1c-0.5,0.5-1.1,1.1-1.6,1.6
      c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.3-0.4,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.1-0.1,0.2c0,1.2,0,2.3,0,3.5
      c0,0.3,0,0.6,0,0.8c0,0.2,0,0.5,0,0.7c0,0.2,0,0.3,0,0.5c0,0.4,0,0.8,0,1.2c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0
      c-0.4,0-0.8,0-1.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8,0-1.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0
      c-0.9,0-1.7,0-2.6,0c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0c-0.2,0-0.4,0-0.6,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0.1
      c-0.8,0.8-1.6,1.6-2.4,2.4c-0.1,0.1-0.1,0.1-0.2,0c-0.8-0.8-1.6-1.6-2.5-2.4c-0.1-0.1-0.1-0.1-0.2-0.1c-1.2,0-2.4,0-3.6,0
      c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.9,0-1.9,0-2.8,0c-0.1,0-0.1,0-0.1-0.1c0-0.8,0-1.7,0-2.5c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2
      c0-0.9,0-1.9,0-2.8c0,0,0-0.1,0-0.1c0-0.3,0-0.6,0-0.9c0-0.1,0-0.1-0.1-0.2c-0.2-0.1-0.3-0.3-0.5-0.5c-0.2-0.2-0.5-0.5-0.7-0.7
      c0,0-0.1,0-0.1-0.1c-0.4-0.4-0.8-0.8-1.2-1.2c0,0,0,0-0.1-0.1c-0.1-0.1-0.1-0.1,0-0.2c0.3-0.3,0.7-0.7,1-1c0,0,0,0,0.1-0.1
      c0.3-0.3,0.6-0.6,1-1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.2c0-0.4,0-0.7,0-1.1c0-1.2,0-2.5,0-3.7
      c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1c0-0.5,0-1,0-1.4c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1c0,0,0,0,0.1,0c0.9,0,1.7,0,2.6,0
      c0,0,0.1,0,0.1,0c0.2,0,0.5,0,0.7,0c0,0,0.1,0,0.1,0c1,0,2.1,0,3.1,0c0.1,0,0.1,0,0.2-0.1c0.4-0.4,0.8-0.8,1.2-1.2
      c0,0,0.1-0.1,0.1-0.1c0.3-0.3,0.5-0.5,0.8-0.8c0.1-0.2,0.3-0.3,0.4-0.5c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0.1c0.8,0.8,1.6,1.6,2.4,2.4
      c0.1,0.1,0.1,0.1,0.2,0.1c0.6,0,1.2,0,1.8,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c1.1,0,2.2,0,3.2,0c0,0,0.1,0,0.1,0
      c0.3,0,0.7,0,1,0c0.1,0,0.2,0,0.2,0c0.1,0.1,0,0.2,0,0.2c0,1.2,0,2.5,0,3.7c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0.1c0,0.6,0,1.3,0,1.9
      c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0.1,0.2c0.8,0.8,1.6,1.6,2.4,2.4C34.1,22,34.1,21.9,33.9,22.1z"/>
  <path style="fill:#3F94B5;" d="M30.7,21.9c-0.2-0.2-0.4-0.4-0.6-0.6c-0.4-0.4-0.7-0.7-1.1-1.1c0,0-0.1-0.1-0.1-0.1
      c0-0.3,0-0.5,0-0.8c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0-1.2,0-2.5,0-3.7c0,0,0-0.1,0-0.1
      c0,0-0.1,0-0.1,0c-1.1,0-2.2,0-3.3,0c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.4,0-0.7,0-1.1,0c-0.1,0-0.2,0-0.3-0.1
      c-0.6-0.6-1.1-1.1-1.7-1.7c-0.1-0.1-0.1-0.1-0.2,0c0,0,0,0,0,0c-0.6,0.6-1.1,1.1-1.7,1.7C20,15,19.9,15,19.8,15c-1.3,0-2.7,0-4,0
      c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.2,0c-0.2,0-0.4,0-0.6,0c0,0.1,0,0.1,0,0.1c0,1.3,0,2.7,0,4c0,0.2,0,0.3,0,0.5
      c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1-0.1,0.1c-0.1,0.1-0.3,0.3-0.4,0.4c-0.4,0.4-0.9,0.9-1.3,1.3
      c-0.1,0.1-0.1,0.1,0,0.2c0.2,0.2,0.3,0.3,0.5,0.5c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.3,0.6,0.6,0.9,0.9C15,23.9,15,23.9,15,24
      c0,0.5,0,0.9,0,1.4c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0
      c0,0,0,0.1,0,0.1c0,0.7,0,1.5,0,2.2c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.8,0,1.7,0,2.5,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
      c0.1,0,0.2,0,0.3,0c0.6,0,1.3,0,1.9,0c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.2,0.2,0.4,0.4,0.6,0.6c0,0,0,0-0.1,0.1
      c0,0,0,0,0.1-0.1c0,0,0.1,0.1,0.1,0.1c0.3,0.3,0.5,0.5,0.8,0.8c0.1,0.1,0.1,0.1,0.1,0c0,0,0,0,0.1-0.1c0.6-0.6,1.1-1.1,1.7-1.7
      c0,0,0.1-0.1,0.2-0.1c0.3,0,0.6,0,1,0c0.5,0,1.1,0,1.6,0c0.7,0,1.5,0,2.2,0c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0-0.9,0-1.8,0-2.7
      c0-0.1,0-0.2,0-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0-0.6,0-1.2,0-1.8c0-0.1,0-0.1,0.1-0.2c0.6-0.6,1.2-1.2,1.7-1.7
      C30.7,21.9,30.7,21.9,30.7,21.9z M26,23.6C25.9,23.7,25.9,23.7,26,23.6C25.9,23.7,25.9,23.7,26,23.6c-0.2,0.6-0.6,1-1,1.4
      c-0.4,0.4-0.9,0.7-1.4,1c0,0,0,0,0,0c0,0,0,0,0,0c-0.5,0.2-1.1,0.3-1.7,0.3c-0.6,0-1.1-0.1-1.7-0.3c0,0,0,0,0,0c0,0,0,0,0,0
      c-0.5-0.2-1-0.6-1.4-1c-0.4-0.4-0.7-0.9-1-1.4c0,0,0,0,0,0c0,0,0,0,0,0c-0.2-0.5-0.3-1.1-0.3-1.7c0-0.6,0.1-1.1,0.3-1.7
      c0,0,0,0,0,0c0,0,0,0,0,0c0.2-0.5,0.6-1,1-1.4c0.4-0.4,0.9-0.7,1.4-1c0,0,0,0,0,0c0,0,0,0,0,0c0.5-0.2,1.1-0.3,1.7-0.3
      c0.6,0,1.1,0.1,1.7,0.3c0,0,0,0,0,0c0,0,0,0,0,0c0.5,0.2,1,0.6,1.4,1c0.4,0.4,0.7,0.9,1,1.4c0,0,0,0,0,0c0,0,0,0,0,0
      c0.2,0.5,0.3,1.1,0.3,1.7C26.3,22.5,26.2,23.1,26,23.6z"/>
  <path style="fill:#CF3C40;" d="M32.9,21.8c-0.7-0.7-1.5-1.5-2.2-2.2c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.4,0-0.8,0-1.2c0,0,0-0.1,0-0.1
      c0-0.2,0-0.4,0-0.6c0-0.1,0-0.3,0-0.4c0-1.3,0-2.6,0-3.8c0,0,0-0.1,0-0.1c-0.1-0.1-0.2,0-0.3,0c-1.2,0-2.5,0-3.7,0
      c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c-0.6,0-1.2,0-1.9,0c-0.1,0-0.1,0-0.2-0.1c-0.5-0.5-1.1-1.1-1.6-1.6
      c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1-0.1-0.1-0.1-0.1,0c-0.1,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0c-0.7,0.7-1.3,1.3-2,2
      c0,0-0.1,0.1-0.2,0.1c-1.3,0-2.5,0-3.8,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0
      c0,0-0.1,0-0.1,0c-0.4,0-0.9,0-1.3,0c-0.1,0-0.1,0-0.1,0.1c0,0.1,0,0.2,0,0.4c0,0.1,0,0.2,0,0.2c0,0.2,0,0.3,0,0.5
      c0,1.4,0,2.9,0,4.3c0,0.2,0,0.4,0,0.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2-0.1,0.3c-0.7,0.7-1.4,1.4-2.2,2.2c-0.1,0.1-0.1,0.1,0,0.2
      c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0c0.2,0.2,0.4,0.4,0.6,0.6c0,0,0.1,0.1,0.1,0.1c0.4,0.4,0.8,0.8,1.2,1.1
      c0.1,0.1,0.1,0.1,0.1,0.2c0,1.2,0,2.5,0,3.7c0,0.2,0,0.3,0,0.5h0c0,0.2,0,0.4,0,0.6c0,0,0,0,0,0c0,0,0,0.1,0,0.1
      c0,0.4,0,0.8,0,1.2c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0c0.7,0,1.3,0,2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c1.2,0,2.4,0,3.6,0
      c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0.1c0.4,0.4,0.8,0.8,1.1,1.1c0.1,0.1,0.3,0.3,0.4,0.4
      c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0,0,0c0.2,0.2,0.3,0.3,0.5,0.5c0.1,0.1,0.1,0.1,0.2,0c0.7-0.7,1.4-1.4,2.1-2.1
      c0.1-0.1,0.3-0.2,0.4-0.2c0.3,0,0.6,0,0.9,0c0,0,0.1,0,0.1,0c1.4,0,2.9,0,4.3,0c0,0,0.1,0,0.1,0c0.2,0,0.4,0,0.7,0
      c0,0,0-0.1,0-0.1c0-1.4,0-2.8,0-4.3c0-0.6,0-1.2,0-1.9c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.2-0.3,0.4-0.4c0.3-0.3,0.6-0.5,0.8-0.8
      c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0.3-0.3,0.6-0.6,0.9-0.9C33,21.9,33,21.9,32.9,21.8z M31.3,22
      C31.3,22,31.3,22,31.3,22c-0.7,0.7-1.3,1.3-1.9,1.9c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.6,0,1.2,0,1.8c0,0.1,0,0.1,0,0.2
      c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0.9,0,1.9,0,2.8c0,0.1,0,0.1-0.1,0.1c-0.9,0-1.8,0-2.7,0c-0.4,0-0.9,0-1.3,0
      c-0.4,0-0.7,0-1.1,0c-0.1,0-0.2,0-0.2,0.1c-0.6,0.6-1.2,1.2-1.8,1.8c-0.1,0.1-0.1,0.1-0.2,0c-0.3-0.3-0.6-0.6-0.9-0.9
      c0,0-0.1-0.1-0.1-0.1c-0.2-0.2-0.3-0.3-0.5-0.5c-0.1-0.1-0.2-0.2-0.4-0.4c0-0.1-0.1-0.1-0.2-0.1c-0.7,0-1.3,0-2,0
      c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c-0.9,0-1.8,0-2.8,0c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c0-0.8,0-1.6,0-2.4c0,0,0-0.1,0-0.1
      c0-0.1,0-0.3,0-0.4c0-0.2,0-0.4,0-0.5c0-0.3,0-0.7,0-1c0-0.2,0-0.5,0-0.7c0-0.1,0-0.1-0.1-0.2c-0.3-0.3-0.5-0.5-0.8-0.8
      c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c-0.3-0.3-0.6-0.6-0.9-0.9c0,0,0,0-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0.1-0.1
      c0.6-0.6,1.2-1.2,1.8-1.9c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.4c0-1.5,0-3,0-4.5c0,0,0-0.1,0-0.1
      c0.3,0,0.5,0,0.7,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c1.4,0,2.7,0,4.1,0c0.1,0,0.1,0,0.2-0.1c0.6-0.6,1.2-1.2,1.8-1.8
      c0,0,0,0,0.1-0.1c0.1-0.1,0.1-0.1,0.2,0c0.6,0.6,1.2,1.2,1.9,1.8c0.1,0.1,0.1,0.1,0.2,0.1c0.4,0,0.7,0,1.1,0c0,0,0.1,0,0.1,0
      c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2,0,0.2,0c1.2,0,2.5,0,3.7,0c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,1.4,0,2.7,0,4.1c0,0,0,0,0,0.1
      c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0c0,0.2,0,0.4,0,0.7c0,0.1,0,0.2,0.1,0.3c0.6,0.6,1.2,1.2,1.8,1.8C31.3,21.9,31.3,21.9,31.3,22
      C31.3,21.9,31.3,22,31.3,22z"/>
</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12">
  <title>B12</title>
  <path style="fill:#FFFFFF;" d="M34.7,21.8c-0.3-0.3-0.6-0.6-0.9-0.9c-0.5-0.5-1.1-1.1-1.6-1.6c0,0-0.1-0.1-0.1-0.2
  c0-0.4,0-0.8,0-1.2c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-1.8,0-3.6,0-5.4c0-0.1,0-0.1,0-0.2
  c-0.1,0-0.1,0-0.2,0c-1.6,0-3.2,0-4.8,0c-0.1,0-0.3,0-0.4,0l0,0c0,0-0.1,0-0.1,0c-0.5,0-1,0-1.5,0c-0.2,0-0.3,0-0.4-0.2
  c-0.8-0.8-1.7-1.6-2.5-2.5c-0.1-0.1-0.1-0.1-0.2,0c0,0,0,0-0.1,0.1c-0.8,0.8-1.6,1.6-2.4,2.4C19.3,11.9,19.2,12,19,12
  c-1.9,0-3.9,0-5.8,0c-0.1,0-0.1,0-0.2,0l0,0c-0.1,0-0.2,0-0.3,0c-0.3,0-0.5,0-0.8,0c0,0.1,0,0.1,0,0.2c0,1.9,0,3.9,0,5.8
  c0,0.2,0,0.5,0,0.7c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1-0.1,0.2c-0.2,0.2-0.4,0.4-0.6,0.6
  c-0.6,0.6-1.3,1.3-1.9,1.9c-0.1,0.1-0.1,0.1,0,0.3c0.2,0.2,0.5,0.5,0.7,0.7c0.2,0.2,0.3,0.3,0.5,0.5c0.4,0.4,0.9,0.9,1.3,1.3
  c0.1,0.1,0.1,0.1,0.1,0.2c0,0.7,0,1.3,0,2c0,0.1,0,0.2,0,0.4l0,0c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4c0,0.2,0,0.5,0,0.7l0,0
  c0,0.1,0,0.1,0,0.2c0,1,0,2.1,0,3.1c0,0.1,0,0.1,0,0.2c0.1,0,0.1,0,0.2,0c1.2,0,2.4,0,3.6,0c0.1,0,0.1,0,0.2,0l0,0
  c0.1,0,0.3,0,0.4,0c0.9,0,1.8,0,2.7,0c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.2,0.4,0.3c0.3,0.3,0.6,0.6,0.9,0.9
  c0,0-0.1,0.1-0.1,0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0.1,0.1,0.1c0.4,0.4,0.8,0.8,1.2,1.2c0.1,0.1,0.1,0.1,0.2,0
  c0,0,0.1-0.1,0.1-0.1c0.8-0.8,1.6-1.7,2.5-2.5c0.1-0.1,0.1-0.1,0.2-0.1c0.5,0,0.9,0,1.4,0c0.8,0,1.6,0,2.4,0c1.1,0,2.1,0,3.2,0
  c0.1,0,0.1,0,0.2,0c0,0,0-0.1,0-0.1c0-1.3,0-2.6,0-3.9c0-0.1,0-0.2,0-0.3l0,0c0-0.1,0-0.1,0-0.2c0-0.8,0-1.7,0-2.5
  c0-0.1,0-0.2,0.1-0.3c0.8-0.8,1.7-1.7,2.5-2.5C34.8,21.9,34.8,21.9,34.7,21.8z M27.9,24.4C27.9,24.4,27.9,24.4,27.9,24.4
  C27.9,24.4,27.9,24.4,27.9,24.4c-0.3,0.8-0.8,1.5-1.4,2.1c-0.6,0.6-1.3,1.1-2,1.4c0,0,0,0,0,0c0,0,0,0,0,0
  c-0.8,0.3-1.6,0.5-2.4,0.5c-0.8,0-1.6-0.1-2.4-0.5c0,0,0,0,0,0c0,0,0,0,0,0c-0.8-0.3-1.5-0.8-2-1.4c-0.6-0.6-1.1-1.3-1.4-2
  c0,0,0,0,0,0c0,0,0,0,0,0c-0.3-0.8-0.5-1.6-0.5-2.4c0-0.8,0.1-1.6,0.5-2.4c0,0,0,0,0,0c0,0,0,0,0,0c0.3-0.8,0.8-1.5,1.4-2
  c0.6-0.6,1.3-1.1,2-1.4c0,0,0,0,0,0c0,0,0,0,0,0c0.8-0.3,1.6-0.5,2.4-0.5c0.8,0,1.6,0.1,2.4,0.5c0,0,0,0,0,0c0,0,0,0,0,0
  c0.8,0.3,1.5,0.8,2,1.4c0.6,0.6,1.1,1.3,1.4,2c0,0,0,0,0,0c0,0,0,0,0,0c0.3,0.8,0.5,1.6,0.5,2.4C28.3,22.8,28.2,23.6,27.9,24.4z
  "/>

<path style="fill:#13356B;" d="M37.9,21.8c-1.1-1-2.1-2.1-3.2-3.1c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.6,0-1.1,0-1.7
  c0-0.1,0-0.1,0-0.2c0-0.3,0-0.6,0-0.9c0-0.2,0-0.4,0-0.6c0-1.9,0-3.7,0-5.6c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.3,0-0.4,0
  c-1.8,0-3.6,0-5.4,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.4,0c0,0,0,0-0.1,0c-0.9,0-1.8,0-2.7,0c-0.1,0-0.2,0-0.2-0.1
  C24.5,8.5,23.7,7.7,23,7c-0.3-0.3-0.6-0.6-0.9-0.9c-0.1-0.1-0.1-0.1-0.2,0c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0,0-0.1,0.1
  c-0.9,1-1.9,1.9-2.9,2.9c-0.1,0.1-0.1,0.1-0.2,0.1c-1.8,0-3.7,0-5.5,0c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.6,0
  c-0.2,0-0.3,0-0.5,0l0,0c-0.1,0-0.1,0-0.2,0c-0.6,0-1.2,0-1.9,0c-0.1,0-0.1,0-0.1,0.1c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.4
  c0,0.2,0,0.4,0,0.7c0,2.1,0.1,4.1,0,6.2c0,0.3,0,0.5,0,0.8c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3-0.1,0.4c-1,1-2.1,2.1-3.1,3.1
  c-0.2,0.2-0.2,0.1,0,0.3c0.1,0.1,0.3,0.3,0.4,0.4l0,0c0.3,0.3,0.6,0.6,0.9,0.9c0,0,0.1,0.1,0.1,0.1c0.6,0.6,1.1,1.1,1.7,1.7
  c0.1,0.1,0.1,0.2,0.1,0.3c0,1.8,0,3.6,0,5.3c0,0.2,0,0.5,0,0.7l0,0c0,0.3,0,0.6,0,0.9l0,0c0,0.1,0,0.1,0,0.2c0,0.6,0,1.1,0,1.7
  c0,0.2,0,0.2,0.2,0.2c0,0,0,0,0,0c1,0,1.9,0,2.9,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c1.7,0,3.5,0,5.2,0c0,0,0.1,0,0.1,0l0,0
  c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.3,0.1c0.6,0.6,1.1,1.1,1.7,1.6c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.1,0.2,0.2,0.3,0.3l0,0
  c0.2,0.2,0.4,0.4,0.7,0.7c0.2,0.2,0.1,0.2,0.3,0c1-1,2-2,3-3c0.2-0.2,0.4-0.3,0.6-0.3c0.4,0,0.9,0,1.3,0c0,0,0.1,0,0.1,0
  c2.1,0,4.2,0,6.3,0c0,0,0.1,0,0.1,0c0.3,0,0.6,0,1,0c0-0.1,0-0.1,0-0.2c0-2,0-4.1,0-6.1c0-0.9,0-1.8,0-2.7c0-0.1,0-0.2,0.1-0.3
  c0.2-0.2,0.4-0.4,0.5-0.5c0.4-0.4,0.8-0.8,1.2-1.2c0,0,0,0,0.1,0c0,0,0,0-0.1,0c0-0.1,0.1-0.1,0.1-0.1c0.4-0.4,0.9-0.9,1.3-1.3
  C38.1,21.9,38.1,21.9,37.9,21.8z M35.6,22C35.6,22,35.5,22.1,35.6,22c-1,1-1.8,1.9-2.7,2.7c-0.1,0.1-0.2,0.2-0.2,0.4
  c0,0.8,0,1.7,0,2.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0,1.4,0,2.7,0,4.1c0,0.2,0,0.2-0.2,0.2
  c-1.3,0-2.6,0-3.9,0c-0.6,0-1.3,0-1.9,0c-0.5,0-1,0-1.5,0c-0.1,0-0.2,0-0.3,0.1c-0.9,0.9-1.8,1.8-2.6,2.7
  c-0.2,0.2-0.1,0.2-0.3,0c-0.4-0.4-0.9-0.9-1.3-1.3c0,0-0.1-0.1-0.1-0.1c-0.3-0.2-0.5-0.5-0.7-0.7c-0.2-0.2-0.4-0.3-0.5-0.5
  c-0.1-0.1-0.1-0.1-0.2-0.1c-0.9,0-1.9,0-2.8,0c-0.1,0-0.3,0-0.4,0c0,0-0.1,0-0.1,0c-1.3,0-2.7,0-4,0c-0.1,0-0.1,0-0.2,0
  c0-0.1,0-0.1,0-0.2c0-1.2,0-2.3,0-3.5c0,0,0-0.1,0-0.1c0-0.2,0-0.4,0-0.6c0-0.3,0-0.5,0-0.8c0-0.5,0-1,0-1.4c0-0.3,0-0.7,0-1
  c0-0.1,0-0.2-0.1-0.2c-0.4-0.4-0.8-0.8-1.2-1.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1-0.1-0.1-0.1c-0.4-0.4-0.8-0.8-1.2-1.2
  c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1c0.9-0.9,1.8-1.8,2.7-2.7c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.3
  c0-0.2,0-0.4,0-0.6c0-2.2,0-4.3,0-6.5c0-0.1,0-0.1,0-0.2c0.4,0,0.7,0,1,0c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0c2,0,4,0,6,0
  c0.1,0,0.2,0,0.3-0.1c0.9-0.9,1.7-1.8,2.6-2.6c0,0,0,0,0.1-0.1c0.1-0.1,0.1-0.1,0.2,0c0.9,0.9,1.8,1.8,2.7,2.7
  c0.1,0.1,0.2,0.1,0.3,0.1c0.5,0,1,0,1.6,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0,0-0.1c0.1,0,0.2,0,0.3,0c1.8,0,3.6,0,5.3,0
  c0.1,0,0.1,0,0.2,0c0,0,0,0.1,0,0.1c0,2,0,4,0,5.9c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3l0,0c0,0.3,0,0.6,0,1
  c0,0.2,0.1,0.3,0.2,0.5c0.9,0.9,1.8,1.7,2.6,2.6c0,0,0,0,0.1,0.1C35.6,21.9,35.6,22,35.6,22z"/>
</symbol>






<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1">
  <title>C1</title>
  <path style="fill:#D03D41;" d="M27.4,20.9c0.7-0.3,1.4-0.3,1.9-0.2c-0.4-0.4-0.8-0.9-1.2-1.3c0-0.6-0.1-1.2-0.1-1.7
  c-0.3,0.5-0.8,1-1.5,1.3c-0.6,0.3-1.2,0.3-1.8,0.3c-0.1-0.6,0-1.2,0.3-1.8c0.3-0.7,0.7-1.2,1.3-1.5c-0.6,0-1.2-0.1-1.7-0.1
  c-0.4-0.4-0.9-0.8-1.3-1.2c0.2,0.6,0.1,1.2-0.2,1.9c-0.3,0.6-0.6,1.1-1.1,1.5c-0.5-0.4-0.8-0.9-1.1-1.5c-0.3-0.7-0.3-1.4-0.2-1.9
  c-0.4,0.4-0.9,0.8-1.3,1.2c-0.6,0-1.2,0.1-1.7,0.1c0.5,0.3,1,0.8,1.3,1.5c0.3,0.6,0.3,1.2,0.3,1.8c-0.6,0.1-1.2,0-1.8-0.3
  c-0.7-0.3-1.2-0.7-1.5-1.3c0,0.6-0.1,1.2-0.1,1.7c-0.4,0.4-0.8,0.9-1.2,1.3c0.6-0.2,1.2-0.1,1.9,0.2c0.6,0.3,1.1,0.6,1.5,1.1
  c-0.4,0.5-0.9,0.8-1.5,1.1c-0.7,0.3-1.4,0.3-1.9,0.2c0.4,0.4,0.8,0.9,1.2,1.3c0,0.6,0.1,1.2,0.1,1.7c0.3-0.5,0.8-1,1.5-1.3
  c0.6-0.3,1.2-0.3,1.8-0.3c0.1,0.6,0,1.2-0.3,1.8c-0.3,0.7-0.7,1.2-1.3,1.5c0.6,0,1.2,0.1,1.7,0.1c0.4,0.4,0.9,0.8,1.3,1.2
  c-0.2-0.6-0.1-1.2,0.2-1.9c0.3-0.6,0.6-1.1,1.1-1.5c0.5,0.4,0.8,0.9,1.1,1.5c0.3,0.7,0.3,1.4,0.2,1.9c0.4-0.4,0.9-0.8,1.3-1.2
  c0.6,0,1.2-0.1,1.7-0.1c-0.5-0.3-1-0.8-1.3-1.5c-0.3-0.6-0.3-1.2-0.3-1.8c0.6-0.1,1.2,0,1.8,0.3c0.7,0.3,1.2,0.7,1.5,1.3
  c0-0.6,0.1-1.2,0.1-1.7c0.4-0.4,0.8-0.9,1.2-1.3c-0.6,0.2-1.2,0.1-1.9-0.2c-0.6-0.3-1.1-0.6-1.5-1.1C26.3,21.5,26.8,21.2,27.4,20.9z
   M22.9,22.4c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.1,0.3-0.1,0.4c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0.1-0.3,0.1-0.4,0.2
  c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.1-0.3-0.1-0.4-0.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.1-0.1-0.1-0.3-0.2-0.4c0.1,0,0.3-0.1,0.4-0.1
  c0.1-0.1,0.1-0.3,0.1-0.4c0.1,0.1,0.3,0.1,0.4,0.2c0.1-0.1,0.3-0.1,0.4-0.2c0,0.1,0.1,0.3,0.1,0.4c0.1,0.1,0.3,0.1,0.4,0.1
  c-0.1,0.1-0.1,0.3-0.2,0.4C22.8,22.1,22.9,22.3,22.9,22.4z"/>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2">
<title>C2</title>
<path  style="fill:#00366D;" d="M25.5,18.5c-0.4-0.6-0.8-1.3-1.3-1.9c-0.7,0.1-1.5,0.3-2.2,0.5c-0.7-0.2-1.5-0.3-2.2-0.5
c-0.4,0.6-0.8,1.3-1.3,1.9c-0.6,0.4-1.3,0.8-1.9,1.2c0.1,0.7,0.3,1.5,0.5,2.2c-0.2,0.7-0.3,1.5-0.5,2.2c0.6,0.4,1.3,0.8,1.9,1.2
c0.4,0.6,0.8,1.3,1.3,1.9c0.7-0.1,1.5-0.3,2.2-0.5c0.7,0.2,1.5,0.3,2.2,0.5c0.4-0.6,0.8-1.3,1.3-1.9c0.6-0.4,1.3-0.8,1.9-1.2
c-0.1-0.7-0.3-1.5-0.5-2.2c0.2-0.7,0.3-1.5,0.5-2.2C26.8,19.4,26.1,18.9,25.5,18.5z M18.5,23.8c-0.3,0.3-0.9,0.4-1.2,0.1
c0.1-0.4,0.5-0.8,1-0.8c0.2,0,0.4,0.1,0.5,0.2C18.8,23.5,18.7,23.7,18.5,23.8z M18.3,20.8c-0.5,0-0.9-0.3-1-0.8
c0.4-0.2,0.9-0.2,1.2,0.1c0.1,0.1,0.2,0.3,0.3,0.5C18.6,20.8,18.5,20.8,18.3,20.8z M20.1,17.3c0.4,0.1,0.8,0.5,0.8,1
c0,0.2-0.1,0.4-0.2,0.5c-0.2,0-0.4-0.1-0.5-0.3C19.8,18.2,19.8,17.7,20.1,17.3z M20.1,26.7c-0.2-0.4-0.2-0.9,0.1-1.2
c0.1-0.1,0.3-0.2,0.5-0.3c0.1,0.2,0.2,0.3,0.2,0.5C20.8,26.2,20.5,26.5,20.1,26.7z M22.7,23.7c-0.2-0.1-0.5-0.1-0.7-0.2
c-0.2,0.1-0.5,0.1-0.7,0.2c-0.1-0.2-0.3-0.4-0.4-0.6c-0.2-0.1-0.4-0.3-0.6-0.4c0.1-0.2,0.1-0.5,0.2-0.7c-0.1-0.2-0.1-0.5-0.2-0.7
c0.2-0.1,0.4-0.3,0.6-0.4c0.1-0.2,0.3-0.4,0.4-0.6c0.2,0.1,0.5,0.1,0.7,0.2c0.2-0.1,0.5-0.1,0.7-0.2c0.1,0.2,0.3,0.4,0.4,0.6
c0.2,0.1,0.4,0.3,0.6,0.4c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0.2,0.1,0.5,0.2,0.7c-0.2,0.1-0.4,0.3-0.6,0.4C23,23.3,22.9,23.5,22.7,23.7z
 M23.9,26.7c-0.4-0.1-0.8-0.5-0.8-1c0-0.2,0.1-0.4,0.2-0.5c0.2,0,0.4,0.1,0.5,0.3C24.2,25.8,24.2,26.3,23.9,26.7z M23.8,18.6
c-0.1,0.1-0.3,0.2-0.5,0.3c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.5,0.3-0.9,0.8-1C24.2,17.7,24.2,18.2,23.8,18.6z M25.5,23.8
c-0.1-0.1-0.2-0.3-0.3-0.5c0.2-0.1,0.3-0.2,0.5-0.2c0.5,0,0.9,0.3,1,0.8C26.3,24.2,25.8,24.1,25.5,23.8z M25.7,20.8
c-0.2,0-0.4-0.1-0.5-0.2c0-0.2,0.1-0.4,0.3-0.5c0.3-0.3,0.9-0.4,1.2-0.1C26.6,20.5,26.2,20.9,25.7,20.8z"/>

</symbol>

  


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C3">
<title>C3</title>
<path style="fill:#00376F;" d="M27.2,20c1.1-1.2,2.1-2.8,0.8-4.1c0,0,0,0,0,0c0,0,0,0,0,0c-1.3-1.3-2.9-0.3-4.1,0.8
c-0.1-1.6-0.5-3.5-2.3-3.5c0,0,0,0,0,0c0,0,0,0,0,0c-1.8,0-2.2,1.9-2.3,3.5c-1.2-1.1-2.8-2.1-4.1-0.8c0,0,0,0,0,0c0,0,0,0,0,0
c-1.3,1.3-0.3,2.9,0.8,4.1c-1.6,0.1-3.5,0.5-3.5,2.3c0,0,0,0,0,0c0,0,0,0,0,0c0,1.8,1.9,2.2,3.5,2.3c-1.1,1.2-2.1,2.8-0.8,4.1
c0,0,0,0,0,0c0,0,0,0,0,0c1.3,1.3,2.9,0.3,4.1-0.8c0.1,1.6,0.5,3.5,2.3,3.5c0,0,0,0,0,0c0,0,0,0,0,0c1.8,0,2.2-1.9,2.3-3.5
c1.2,1.1,2.8,2.1,4.1,0.8c0,0,0,0,0,0c0,0,0,0,0,0c1.3-1.3,0.3-2.9-0.8-4.1c1.6-0.1,3.5-0.5,3.5-2.3c0,0,0,0,0,0c0,0,0,0,0,0
C30.7,20.6,28.8,20.1,27.2,20z M25.2,23.9c-0.4,0.4-0.7,0.7-1.1,1.1c-0.4,0.4-0.7,0.7-1.1,1.1c-0.5,0-1,0-1.5,0c-0.5,0-1,0-1.5,0
c-0.4-0.4-0.7-0.7-1.1-1.1c-0.4-0.4-0.7-0.7-1.1-1.1c0-0.5,0-1,0-1.5c0-0.5,0-1,0-1.5c0.4-0.4,0.7-0.7,1.1-1.1
c0.4-0.4,0.7-0.7,1.1-1.1c0.5,0,1,0,1.5,0c0.5,0,1,0,1.5,0c0.4,0.4,0.7,0.7,1.1,1.1c0.4,0.4,0.7,0.7,1.1,1.1c0,0.5,0,1,0,1.5
C25.2,22.9,25.2,23.4,25.2,23.9z"/>
</symbol>
        
        
<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C4">
  <title>C4</title>
  <path style="fill:#D03C40;" d="M32.4,23.9c-0.2-0.7-0.4-1.4-0.8-2c0.4-0.6,0.6-1.3,0.8-2c-0.3-0.1-0.6-0.3-0.8-0.4
  c-0.1,0.7-0.2,1.4-0.7,1.9c-0.5,0.4-1.2,0.6-1.8,0.3c-0.5-0.2-0.9-0.7-1-1.3c-0.1-0.4,0-0.8,0.2-1.1c-0.4-0.1-0.7-0.3-1-0.6
  c-0.4-0.5-0.4-1.1-0.2-1.6c0.2-0.6,0.8-1,1.5-1c0.7,0,1.3,0.4,1.8,0.8c0.1-0.3,0.2-0.6,0.3-0.9c-0.6-0.3-1.3-0.7-2-0.8
  c-0.1-0.7-0.5-1.3-0.8-2c-0.3,0.1-0.6,0.2-0.9,0.3c0.4,0.5,0.9,1.1,0.8,1.8c0,0.6-0.4,1.2-1,1.5c-0.5,0.2-1.2,0.1-1.6-0.2
  c-0.3-0.3-0.5-0.6-0.6-1c-0.3,0.2-0.7,0.3-1.1,0.2c-0.6-0.1-1.1-0.5-1.3-1c-0.2-0.6-0.1-1.3,0.3-1.8c0.5-0.5,1.2-0.6,1.9-0.7
  c-0.1-0.3-0.3-0.6-0.4-0.8c-0.7,0.2-1.4,0.4-2,0.8c-0.6-0.4-1.3-0.6-2-0.8c-0.1,0.3-0.3,0.6-0.4,0.8c0.7,0.1,1.4,0.2,1.9,0.7
  c0.4,0.5,0.6,1.2,0.3,1.8c-0.2,0.5-0.7,0.9-1.3,1c-0.4,0.1-0.8,0-1.1-0.2c-0.1,0.4-0.3,0.7-0.6,1c-0.5,0.4-1.1,0.4-1.6,0.2
  c-0.6-0.2-1-0.8-1-1.5c0-0.7,0.4-1.3,0.8-1.8c-0.3-0.1-0.6-0.2-0.9-0.3c-0.3,0.6-0.7,1.3-0.8,2c-0.7,0.1-1.3,0.5-2,0.8
  c0.1,0.3,0.2,0.6,0.3,0.9c0.5-0.4,1.1-0.9,1.8-0.8c0.6,0,1.2,0.4,1.5,1c0.2,0.5,0.1,1.2-0.2,1.6c-0.3,0.3-0.6,0.5-1,0.6
  c0.2,0.3,0.3,0.7,0.2,1.1c-0.1,0.6-0.5,1.1-1,1.3c-0.6,0.2-1.3,0.1-1.8-0.3c-0.5-0.5-0.6-1.2-0.7-1.9c-0.3,0.1-0.6,0.3-0.8,0.4
  c0.2,0.7,0.4,1.4,0.8,2c-0.4,0.6-0.6,1.3-0.8,2c0.3,0.1,0.6,0.3,0.8,0.4c0.1-0.7,0.2-1.4,0.7-1.9c0.5-0.4,1.2-0.6,1.8-0.3
  c0.5,0.2,0.9,0.7,1,1.3c0.1,0.4,0,0.8-0.2,1.1c0.4,0.1,0.7,0.3,1,0.6c0.4,0.5,0.4,1.1,0.2,1.6c-0.2,0.6-0.8,1-1.5,1
  c-0.7,0-1.3-0.4-1.8-0.8c-0.1,0.3-0.2,0.6-0.3,0.9c0.6,0.3,1.3,0.7,2,0.8c0.1,0.7,0.5,1.3,0.8,2c0.3-0.1,0.6-0.2,0.9-0.3
  c-0.4-0.5-0.9-1.1-0.8-1.8c0-0.6,0.4-1.2,1-1.5c0.5-0.2,1.2-0.1,1.6,0.2c0.3,0.3,0.5,0.6,0.6,1c0.3-0.2,0.7-0.3,1.1-0.2
  c0.6,0.1,1.1,0.5,1.3,1c0.2,0.6,0.1,1.3-0.3,1.8c-0.5,0.5-1.2,0.6-1.9,0.7c0.1,0.3,0.3,0.6,0.4,0.8c0.7-0.2,1.4-0.4,2-0.8
  c0.6,0.4,1.3,0.6,2,0.8c0.1-0.3,0.3-0.6,0.4-0.8c-0.7-0.1-1.4-0.2-1.9-0.7c-0.4-0.5-0.6-1.2-0.3-1.8c0.2-0.5,0.7-0.9,1.3-1
  c0.4-0.1,0.8,0,1.1,0.2c0.1-0.4,0.3-0.7,0.6-1c0.5-0.4,1.1-0.4,1.6-0.2c0.6,0.2,1,0.8,1,1.5c0,0.7-0.4,1.3-0.8,1.8
  c0.3,0.1,0.6,0.2,0.9,0.3c0.3-0.6,0.7-1.3,0.8-2c0.7-0.1,1.3-0.5,2-0.8c-0.1-0.3-0.2-0.6-0.3-0.9c-0.5,0.4-1.1,0.9-1.8,0.8
  c-0.6,0-1.2-0.4-1.5-1c-0.2-0.5-0.1-1.2,0.2-1.6c0.3-0.3,0.6-0.5,1-0.6c-0.2-0.3-0.3-0.7-0.2-1.1c0.1-0.6,0.5-1.1,1-1.3
  c0.6-0.2,1.3-0.1,1.8,0.3c0.5,0.5,0.6,1.2,0.7,1.9C31.8,24.1,32.1,24,32.4,23.9z M27.2,23.3c0,0.3,0,0.5,0.1,0.7
  c-0.2,0.1-0.4,0.3-0.6,0.5c-0.4,0.4-0.6,0.9-0.6,1.4c-0.5,0-1,0.2-1.4,0.6c-0.2,0.2-0.3,0.4-0.5,0.6C24,27,23.8,27,23.5,27
  c-0.6,0-1,0.2-1.4,0.6c-0.4-0.4-0.8-0.6-1.4-0.6c-0.3,0-0.5,0-0.7,0.1c-0.1-0.2-0.3-0.4-0.5-0.6c-0.4-0.4-0.9-0.6-1.4-0.6
  c0-0.5-0.2-1-0.6-1.4c-0.2-0.2-0.4-0.3-0.6-0.5c0.1-0.2,0.1-0.5,0.1-0.7c0-0.6-0.2-1-0.6-1.4c0.4-0.4,0.6-0.8,0.6-1.4
  c0-0.3,0-0.5-0.1-0.7c0.2-0.1,0.4-0.3,0.6-0.5c0.4-0.4,0.6-0.9,0.6-1.4c0.5,0,1-0.2,1.4-0.6c0.2-0.2,0.3-0.4,0.5-0.6
  c0.2,0.1,0.5,0.1,0.7,0.1c0.6,0,1-0.2,1.4-0.6c0.4,0.4,0.8,0.6,1.4,0.6c0.3,0,0.5,0,0.7-0.1c0.1,0.2,0.3,0.4,0.5,0.6
  c0.4,0.4,0.9,0.6,1.4,0.6c0,0.5,0.2,1,0.6,1.4c0.2,0.2,0.4,0.3,0.6,0.5c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.6,0.2,1,0.6,1.4
  C27.4,22.3,27.2,22.7,27.2,23.3z"/>
  <path style="fill:#D03C40;" d="M12.2,12c0.3,1.2,0.7,2.3,1.1,3.4c0.4-0.3,1-0.6,1.6-0.8c0.1-0.6,0.4-1.2,0.8-1.6
      C14.5,12.7,13.3,12.3,12.2,12z M14.3,14.1c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0-0.1c0,0,0,0,0-0.1
      c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0.4,0,0.7,0.3,0.7,0.7
      C14.5,13.8,14.5,14,14.3,14.1z"/>
  <path style="fill:#D03C40;" d="M13.8,13.4c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.2c0,0.3,0.3,0.3,0.5,0.2
      C14.2,13.7,14.1,13.4,13.8,13.4z"/>
  <path style="fill:#D03C40;" d="M31,15.4c0.4-1.1,0.7-2.3,1.1-3.4c-1.2,0.3-2.3,0.7-3.4,1.1c0.3,0.4,0.6,1,0.8,1.6
      C29.9,14.8,30.5,15.1,31,15.4z M30.3,12.9C30.3,12.9,30.4,12.9,30.3,12.9c0.1,0,0.1,0,0.1,0c0.2,0,0.3,0.1,0.4,0.2
      c0.1,0.1,0.2,0.3,0.2,0.4c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0.4-0.3,0.7-0.7,0.7c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5
      C29.7,13.3,30,13,30.3,12.9z"/>
  <path style="fill:#D03C40;" d="M30.7,13.6c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.3,0-0.3,0.3-0.2,0.5
      C30.3,14,30.6,13.9,30.7,13.6z"/>
  <path style="fill:#D03C40;" d="M13.5,30.2c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.1c0.3,0,0.3-0.3,0.2-0.5
      C13.9,29.9,13.5,29.9,13.5,30.2z"/>
  <path style="fill:#D03C40;" d="M32,31.8c-0.3-1.2-0.7-2.3-1.1-3.4c-0.4,0.3-1,0.6-1.6,0.8c-0.1,0.6-0.4,1.2-0.8,1.6
      C29.7,31.2,30.9,31.5,32,31.8z M29.9,29.7c0.1-0.1,0.3-0.2,0.5-0.2c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0.1c0,0,0,0,0,0.1
      c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0.2-0.4,0.2c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-0.4,0-0.7-0.3-0.7-0.7
      C29.7,30,29.7,29.8,29.9,29.7z"/>
  <path style="fill:#D03C40;" d="M13.2,28.4c-0.4,1.1-0.7,2.3-1.1,3.4c1.2-0.3,2.3-0.7,3.4-1.1c-0.3-0.4-0.6-1-0.8-1.6
      C14.3,29,13.7,28.8,13.2,28.4z M13.9,30.9C13.9,30.9,13.8,30.9,13.9,30.9c-0.1,0-0.1,0-0.1,0c-0.2,0-0.3-0.1-0.4-0.2
      c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0-0.4,0.3-0.7,0.7-0.7c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5
      C14.5,30.6,14.2,30.9,13.9,30.9z"/>
  <path style="fill:#D03C40;" d="M34,22.1c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1-0.1-0.2c-0.2-0.2-0.5,0-0.5,0.2
      C33.5,22.1,33.8,22.3,34,22.1z"/>
  <path style="fill:#D03C40;" d="M30.4,30.5c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.2c0-0.3-0.3-0.3-0.5-0.2
      C30,30.1,30.1,30.5,30.4,30.5z"/>
  <path style="fill:#D03C40;" d="M8.1,21.9c1,0.6,2.1,1.2,3.2,1.7c0.1-0.5,0.3-1.1,0.6-1.7c-0.3-0.5-0.5-1.1-0.6-1.7
      C10.2,20.8,9.1,21.3,8.1,21.9z M10.9,22.4c-0.3,0.3-0.7,0.3-1,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1-0.1-0.2-0.3-0.2-0.5
      c0-0.2,0.1-0.3,0.2-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0.3-0.2,0.7-0.2,1,0c0.1,0.1,0.2,0.3,0.2,0.5C11.1,22.1,11,22.3,10.9,22.4z"/>
  <path style="fill:#D03C40;" d="M10.2,21.7c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0.1,0.2c0.2,0.2,0.5,0,0.5-0.2
      C10.7,21.7,10.4,21.5,10.2,21.7z"/>
  <path style="fill:#D03C40;" d="M22.1,32.2c-0.5,0.3-1.1,0.5-1.7,0.6c0.5,1.1,1.1,2.1,1.7,3.2c0.6-1,1.2-2.1,1.7-3.2
      C23.2,32.7,22.6,32.5,22.1,32.2z M22.6,34.1C22.6,34.1,22.6,34.1,22.6,34.1c-0.2,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.5-0.2
      c0,0,0,0,0,0c0,0,0,0,0,0c-0.2-0.3-0.2-0.7,0-1c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2C22.9,33.4,22.9,33.8,22.6,34.1
      C22.6,34.1,22.6,34.1,22.6,34.1z"/>
  <path style="fill:#D03C40;" d="M22.1,33.3c-0.2,0-0.4,0.3-0.2,0.5c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1
      C22.5,33.6,22.3,33.3,22.1,33.3z"/>
  <path style="fill:#D03C40;" d="M36.1,21.9c-1-0.6-2.1-1.2-3.2-1.7c-0.1,0.5-0.3,1.1-0.6,1.7c0.3,0.5,0.5,1.1,0.6,1.7
      C34,23.1,35.1,22.5,36.1,21.9z M33.3,21.4c0.3-0.3,0.7-0.3,1,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0.1,0.2,0.3,0.2,0.5
      c0,0.2-0.1,0.3-0.2,0.5c0,0,0,0,0,0c0,0,0,0,0,0c-0.3,0.2-0.7,0.2-1,0c-0.1-0.1-0.2-0.3-0.2-0.5C33.1,21.7,33.2,21.5,33.3,21.4z
      "/>
  <path style="fill:#D03C40;" d="M22.1,10.5c0.2,0,0.4-0.3,0.2-0.5c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.2,0.1
      C21.7,10.2,21.9,10.5,22.1,10.5z"/>
  <path style="fill:#D03C40;" d="M22.1,11.7c0.5-0.3,1.1-0.5,1.7-0.6c-0.5-1.1-1.1-2.1-1.7-3.2c-0.6,1-1.2,2.1-1.7,3.2
      C21,11.1,21.6,11.3,22.1,11.7z M21.6,9.7C21.6,9.7,21.6,9.7,21.6,9.7c0.2-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2
      c0,0,0,0,0,0c0,0,0,0,0,0c0.2,0.3,0.2,0.7,0,1c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2C21.3,10.4,21.3,10,21.6,9.7
      C21.6,9.7,21.6,9.7,21.6,9.7z"/>
<path style="fill:#00366F;" d="M26.5,20.7c-0.3-0.1-0.6-0.2-0.9-0.3c0.1-0.3,0.3-0.6,0.4-0.8c0-0.1-0.1-0.1-0.1-0.2
c-0.2-0.3-0.4-0.6-0.4-0.9c-0.3-0.1-0.6-0.2-0.9-0.4c-0.1,0-0.1-0.1-0.2-0.1c-0.3,0.1-0.6,0.3-0.8,0.4c-0.1-0.3-0.2-0.6-0.3-0.9
c-0.1,0-0.1,0-0.2,0c-0.4,0-0.7-0.2-1-0.4c-0.3,0.2-0.6,0.3-1,0.4c-0.1,0-0.1,0-0.2,0c-0.1,0.3-0.2,0.6-0.3,0.9
c-0.3-0.1-0.6-0.3-0.8-0.4c-0.1,0-0.1,0.1-0.2,0.1c-0.3,0.2-0.6,0.4-0.9,0.4c-0.1,0.3-0.2,0.6-0.4,0.9c0,0.1-0.1,0.1-0.1,0.2
c0.1,0.3,0.3,0.6,0.4,0.8c-0.3,0.1-0.6,0.2-0.9,0.3c0,0.1,0,0.1,0,0.2c0,0.4-0.2,0.7-0.4,1c0.2,0.3,0.3,0.6,0.4,1
c0,0.1,0,0.1,0,0.2c0.3,0.1,0.6,0.2,0.9,0.3c-0.1,0.3-0.3,0.6-0.4,0.8c0,0.1,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.4,0.9
c0.3,0.1,0.6,0.2,0.9,0.4c0.1,0,0.1,0.1,0.2,0.1c0.3-0.1,0.6-0.3,0.8-0.4c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0,0.1,0,0.2,0
c0.4,0,0.7,0.2,1,0.4c0.3-0.2,0.6-0.3,1-0.4c0.1,0,0.1,0,0.2,0c0.1-0.3,0.2-0.6,0.3-0.9c0.3,0.1,0.6,0.3,0.8,0.4
c0.1,0,0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.9-0.4c0.1-0.3,0.2-0.6,0.4-0.9c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.3-0.3-0.6-0.4-0.8
c0.3-0.1,0.6-0.2,0.9-0.3c0-0.1,0-0.1,0-0.2c0-0.4,0.2-0.7,0.4-1c-0.2-0.3-0.3-0.6-0.4-1C26.5,20.9,26.5,20.8,26.5,20.7z
M22.8,22.2c0,0.2,0,0.3,0,0.5c-0.2,0-0.3,0-0.5,0c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1-0.1-0.2-0.2-0.3-0.4c-0.2,0-0.3,0-0.5,0
c0-0.2,0-0.3,0-0.5c-0.1-0.1-0.2-0.2-0.4-0.3c0.1-0.1,0.2-0.2,0.4-0.3c0-0.2,0-0.3,0-0.5c0.2,0,0.3,0,0.5,0
c0.1-0.1,0.2-0.2,0.3-0.4c0.1,0.1,0.2,0.2,0.3,0.4c0.2,0,0.3,0,0.5,0c0,0.2,0,0.3,0,0.5c0.1,0.1,0.2,0.2,0.4,0.3
C23.1,22,23,22.1,22.8,22.2z"/>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C5">
<title>C5</title>
			<path style="fill:#F7941C;" d="M34.4,23.1c-0.4-0.2-0.8-0.3-1.2-0.5c-0.4,0.8-1,1.4-1.9,1.4c-1,0.1-1.7-0.5-2.4-1.1
				c-0.3-0.3-0.5-0.6-0.7-0.9c0.2-0.3,0.5-0.6,0.7-0.9c0.7-0.7,1.4-1.2,2.4-1.1c1,0.1,1.5,0.7,1.9,1.4c0.4-0.2,0.8-0.4,1.2-0.5
				C34,20.2,33.6,19.5,33,19c0.3-0.7,0.3-1.5,0.3-2.3c-0.4,0.1-0.9,0.1-1.3,0.1c0,0.9-0.2,1.7-1,2.2c-0.8,0.6-1.7,0.5-2.6,0.2
				c-0.4-0.1-0.7-0.2-1.1-0.4c0-0.4,0.1-0.7,0.2-1.1c0.3-0.9,0.6-1.7,1.5-2.2c0.9-0.4,1.6-0.2,2.4,0.3c0.2-0.4,0.5-0.7,0.8-1.1
				c-0.7-0.4-1.4-0.8-2.1-0.9c-0.1-0.7-0.5-1.4-0.9-2.1c-0.3,0.3-0.7,0.5-1.1,0.8c0.5,0.8,0.7,1.5,0.3,2.4c-0.4,0.9-1.3,1.3-2.2,1.5
				c-0.4,0.1-0.8,0.2-1.1,0.2c-0.2-0.3-0.3-0.7-0.4-1.1c-0.2-0.9-0.4-1.8,0.2-2.6c0.5-0.8,1.3-1,2.2-1c0-0.4,0.1-0.9,0.1-1.3
				c-0.8,0-1.6,0-2.3,0.3c-0.5-0.6-1.1-1-1.9-1.4c-0.2,0.4-0.3,0.8-0.5,1.2c0.8,0.4,1.4,1,1.4,1.9c0.1,1-0.5,1.7-1.1,2.4
				c-0.3,0.3-0.6,0.5-0.9,0.7c-0.3-0.2-0.6-0.5-0.9-0.7c-0.7-0.7-1.2-1.4-1.1-2.4c0.1-1,0.7-1.5,1.4-1.9c-0.2-0.4-0.4-0.8-0.5-1.2
				c-0.7,0.4-1.4,0.8-1.9,1.4c-0.7-0.3-1.5-0.3-2.3-0.3c0.1,0.4,0.1,0.9,0.1,1.3c0.9,0,1.7,0.2,2.2,1c0.6,0.8,0.5,1.7,0.2,2.6
				c-0.1,0.4-0.2,0.7-0.4,1.1c-0.4,0-0.7-0.1-1.1-0.2c-0.9-0.3-1.7-0.6-2.2-1.5c-0.4-0.9-0.2-1.6,0.3-2.4c-0.4-0.2-0.7-0.5-1.1-0.8
				c-0.4,0.7-0.8,1.4-0.9,2.1c-0.7,0.1-1.4,0.5-2.1,0.9c0.3,0.3,0.5,0.7,0.8,1.1c0.8-0.5,1.5-0.7,2.4-0.3c0.9,0.4,1.3,1.3,1.5,2.2
				c0.1,0.4,0.2,0.8,0.2,1.1c-0.3,0.2-0.7,0.3-1.1,0.4c-0.9,0.2-1.8,0.4-2.6-0.2c-0.8-0.5-1-1.3-1-2.2c-0.4,0-0.9-0.1-1.3-0.1
				c0,0.8,0,1.6,0.3,2.3c-0.6,0.5-1,1.1-1.4,1.9c0.4,0.2,0.8,0.3,1.2,0.5c0.4-0.8,1-1.4,1.9-1.4c1-0.1,1.7,0.5,2.4,1.1
				c0.3,0.3,0.5,0.6,0.7,0.9c-0.2,0.3-0.5,0.6-0.7,0.9c-0.7,0.7-1.4,1.2-2.4,1.1c-1-0.1-1.5-0.7-1.9-1.4c-0.4,0.2-0.8,0.4-1.2,0.5
				c0.4,0.7,0.8,1.4,1.4,1.9c-0.3,0.7-0.3,1.5-0.3,2.3c0.4-0.1,0.9-0.1,1.3-0.1c0-0.9,0.2-1.7,1-2.2c0.8-0.6,1.7-0.5,2.6-0.2
				c0.4,0.1,0.7,0.2,1.1,0.4c0,0.4-0.1,0.7-0.2,1.1c-0.3,0.9-0.6,1.7-1.5,2.2c-0.9,0.4-1.6,0.2-2.4-0.3c-0.2,0.4-0.5,0.7-0.8,1.1
				c0.7,0.4,1.4,0.8,2.1,0.9c0.1,0.7,0.5,1.4,0.9,2.1c0.3-0.3,0.7-0.5,1.1-0.8c-0.5-0.8-0.7-1.5-0.3-2.4c0.4-0.9,1.3-1.3,2.2-1.5
				c0.4-0.1,0.8-0.2,1.1-0.2c0.2,0.3,0.3,0.7,0.4,1.1c0.2,0.9,0.4,1.8-0.2,2.6c-0.5,0.8-1.3,1-2.2,1c0,0.4-0.1,0.9-0.1,1.3
				c0.8,0,1.6,0,2.3-0.3c0.5,0.6,1.1,1,1.9,1.4c0.2-0.4,0.3-0.8,0.5-1.2c-0.8-0.4-1.4-1-1.4-1.9c-0.1-1,0.5-1.7,1.1-2.4
				c0.3-0.3,0.6-0.5,0.9-0.7c0.3,0.2,0.6,0.5,0.9,0.7c0.7,0.7,1.2,1.4,1.1,2.4c-0.1,1-0.7,1.5-1.4,1.9c0.2,0.4,0.4,0.8,0.5,1.2
				c0.7-0.4,1.4-0.8,1.9-1.4c0.7,0.3,1.5,0.3,2.3,0.3c-0.1-0.4-0.1-0.9-0.1-1.3c-0.9,0-1.7-0.2-2.2-1c-0.6-0.8-0.5-1.7-0.2-2.6
				c0.1-0.4,0.2-0.7,0.4-1.1c0.4,0,0.7,0.1,1.1,0.2c0.9,0.3,1.7,0.6,2.2,1.5c0.4,0.9,0.2,1.6-0.3,2.4c0.4,0.2,0.7,0.5,1.1,0.8
				c0.4-0.7,0.8-1.4,0.9-2.1c0.7-0.1,1.4-0.5,2.1-0.9c-0.3-0.3-0.5-0.7-0.8-1.1c-0.8,0.5-1.5,0.7-2.4,0.3c-0.9-0.4-1.3-1.3-1.5-2.2
				c-0.1-0.4-0.2-0.8-0.2-1.1c0.3-0.2,0.7-0.3,1.1-0.4c0.9-0.2,1.8-0.4,2.6,0.2c0.8,0.5,1,1.3,1,2.2c0.4,0,0.9,0.1,1.3,0.1
				c0-0.8,0-1.6-0.3-2.3C33.6,24.5,34,23.8,34.4,23.1z M27.2,23.4c-0.6,0.2-1.1,0.4-1.5,0.8c-0.1,0.6,0,1.1,0.1,1.7
				c-0.6-0.1-1.1-0.2-1.7-0.1c-0.3,0.4-0.6,1-0.8,1.5c-0.4-0.4-0.9-0.7-1.4-0.9c-0.5,0.2-1,0.5-1.4,0.9c-0.2-0.6-0.4-1.1-0.8-1.5
				c-0.6-0.1-1.1,0-1.7,0.1c0.1-0.6,0.2-1.1,0.1-1.7c-0.4-0.3-1-0.6-1.5-0.8c0.4-0.4,0.7-0.9,0.9-1.4c-0.2-0.5-0.5-1-0.9-1.4
				c0.6-0.2,1.1-0.4,1.5-0.8c0.1-0.6,0-1.1-0.1-1.7c0.6,0.1,1.1,0.2,1.7,0.1c0.3-0.4,0.6-1,0.8-1.5c0.4,0.4,0.9,0.7,1.4,0.9
				c0.5-0.2,1-0.5,1.4-0.9c0.2,0.6,0.4,1.1,0.8,1.5c0.6,0.1,1.1,0,1.7-0.1c-0.1,0.6-0.2,1.1-0.1,1.7c0.4,0.3,1,0.6,1.5,0.8
				c-0.4,0.4-0.7,0.9-0.9,1.4C26.5,22.5,26.8,23,27.2,23.4z"/>
		
				<path style="fill:#CF4040;" d="M20.6,13c0,0.7,0.5,1.2,1,1.7c0.1,0.1,0.3,0.3,0.4,0.4c0.1-0.1,0.3-0.3,0.4-0.4
					c0.5-0.5,0.9-0.9,1-1.7c0-0.8-0.5-1.3-1.1-1.7c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1-0.1-0.2-0.3-0.2-0.4C21,11.7,20.5,12.1,20.6,13z"
					/>
			
				<path style="fill:#CF4040;" d="M16.2,14.9c0.4,0.6,1,0.8,1.7,1c0.2,0.1,0.4,0.1,0.6,0.1c0.1-0.2,0.1-0.4,0.2-0.6
					c0.2-0.6,0.3-1.3,0-1.9c-0.4-0.7-1.1-0.9-1.8-0.9c0,0.2,0,0.3,0,0.5c-0.1-0.1-0.3-0.1-0.4-0.2C16,13.5,15.8,14.2,16.2,14.9z"/>
			
				<path style="fill:#CF4040;" d="M27.1,12.6c-0.7,0-1.4,0.1-1.8,0.9c-0.3,0.6-0.2,1.3,0,1.9c0.1,0.2,0.1,0.4,0.2,0.6
					c0.2,0,0.4-0.1,0.6-0.1c0.7-0.2,1.3-0.4,1.7-1c0.4-0.7,0.2-1.4-0.2-2c-0.1,0.1-0.3,0.1-0.4,0.2C27.1,12.9,27.1,12.8,27.1,12.6z"
					/>
		
				<path style="fill:#CF4040;" d="M13.4,18.7c0.6,0.3,1.3,0.2,1.9,0c0.2-0.1,0.4-0.1,0.6-0.2c0-0.2-0.1-0.4-0.1-0.6
					c-0.2-0.7-0.4-1.3-1-1.7c-0.7-0.4-1.4-0.2-2,0.2c0.1,0.1,0.1,0.3,0.2,0.4c-0.2,0-0.3,0-0.5,0C12.6,17.6,12.7,18.3,13.4,18.7z"/>
		
				<path style="fill:#CF4040;" d="M12.9,23.4c0.7,0,1.2-0.5,1.7-1c0.1-0.1,0.3-0.3,0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4
					c-0.5-0.5-0.9-0.9-1.7-1c-0.8,0-1.3,0.5-1.7,1.1c0.1,0.1,0.3,0.2,0.4,0.2c-0.1,0.1-0.3,0.2-0.4,0.2
					C11.6,22.9,12.1,23.4,12.9,23.4z"/>
			
				<path style="fill:#CF4040;" d="M33.1,14.7c-0.4,0.4-0.8,0.9-1.2,1.5c0.6,0,1.3-0.1,1.9-0.3c1.4-0.3,3.2-1.3,3.3-2.7
					C35.8,12.6,34.1,13.7,33.1,14.7z"/>
			
				<path style="fill:#CF4040;" d="M31,20.6c-0.7,0-1.2,0.5-1.7,1c-0.1,0.1-0.3,0.3-0.4,0.4c0.1,0.1,0.3,0.3,0.4,0.4
					c0.5,0.5,0.9,0.9,1.7,1c0.8,0,1.3-0.5,1.7-1.1c-0.1-0.1-0.3-0.2-0.4-0.2c0.1-0.1,0.3-0.2,0.4-0.2C32.3,21.1,31.8,20.6,31,20.6z"
					/>
		
				<path style="fill:#CF4040;" d="M29.1,16.3c-0.6,0.4-0.8,1-1,1.7c-0.1,0.2-0.1,0.4-0.1,0.6c0.2,0.1,0.4,0.1,0.6,0.2
					c0.6,0.2,1.3,0.3,1.9,0c0.7-0.4,0.9-1.1,0.9-1.8c-0.2,0-0.3,0-0.5,0c0.1-0.1,0.1-0.3,0.2-0.4C30.4,16.1,29.8,15.8,29.1,16.3z"/>
			
				<path style="fill:#CF4040;" d="M23.3,31c0-0.7-0.5-1.2-1-1.7c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1,0.1-0.3,0.3-0.4,0.4
					c-0.5,0.5-0.9,0.9-1,1.7c0,0.8,0.5,1.3,1.1,1.7c0.1-0.1,0.2-0.3,0.2-0.4c0.1,0.1,0.2,0.3,0.2,0.4C22.8,32.3,23.4,31.9,23.3,31z"
					/>
			
				<path style="fill:#CF4040;" d="M30.4,25.3c-0.6-0.3-1.3-0.2-1.9,0c-0.2,0.1-0.4,0.1-0.6,0.2c0,0.2,0.1,0.4,0.1,0.6
					c0.2,0.7,0.4,1.3,1,1.7c0.7,0.4,1.4,0.2,2-0.2c-0.1-0.1-0.1-0.3-0.2-0.4c0.2,0,0.3,0,0.5,0C31.3,26.4,31.2,25.7,30.4,25.3z"/>
			
				<path style="fill:#CF4040;" d="M39.4,22c-0.8-1.2-2.8-1.1-4.2-0.7c-0.6,0.2-1.2,0.4-1.8,0.7c0.6,0.3,1.2,0.5,1.8,0.7
					C36.6,23.1,38.7,23.2,39.4,22z"/>
			
				<path style="fill:#CF4040;" d="M16.8,31.4c0.7,0,1.4-0.1,1.8-0.9c0.3-0.6,0.2-1.3,0-1.9c-0.1-0.2-0.1-0.4-0.2-0.6
					c-0.2,0-0.4,0.1-0.6,0.1c-0.7,0.2-1.3,0.4-1.7,1c-0.4,0.7-0.2,1.4,0.2,2c0.1-0.1,0.3-0.1,0.4-0.2C16.8,31.1,16.8,31.2,16.8,31.4
					z"/>
			
				<path style="fill:#CF4040;" d="M14.8,27.7c0.6-0.4,0.8-1,1-1.7c0.1-0.2,0.1-0.4,0.1-0.6c-0.2-0.1-0.4-0.1-0.6-0.2
					c-0.6-0.2-1.3-0.3-1.9,0c-0.7,0.4-0.9,1.1-0.9,1.8c0.2,0,0.3,0,0.5,0c-0.1,0.1-0.1,0.3-0.2,0.4C13.5,27.9,14.1,28.2,14.8,27.7z"
					/>
		
				<path style="fill:#CF4040;" d="M8.6,21.3c-1.4-0.4-3.4-0.5-4.2,0.7c0.8,1.2,2.8,1.1,4.2,0.7c0.6-0.2,1.2-0.4,1.8-0.7
					C9.8,21.7,9.2,21.5,8.6,21.3z"/>
			
				<path style="fill:#CF4040;" d="M33.8,28.1c-0.6-0.1-1.2-0.2-1.9-0.3c0.3,0.5,0.7,1,1.2,1.5c1,1,2.7,2.1,4,1.5
					C37,29.3,35.2,28.4,33.8,28.1z"/>
			
				<path style="fill:#CF4040;" d="M29.2,33.2c-0.4-0.4-0.9-0.8-1.5-1.2c0,0.6,0.1,1.3,0.3,1.9c0.3,1.4,1.3,3.2,2.7,3.3
					C31.3,35.9,30.2,34.2,29.2,33.2z"/>
			
				<path style="fill:#CF4040;" d="M21.9,33.6c-0.3,0.6-0.5,1.2-0.7,1.8c-0.4,1.4-0.5,3.4,0.7,4.2c1.2-0.8,1.1-2.8,0.7-4.2
					C22.5,34.7,22.2,34.1,21.9,33.6z"/>
			
				<path style="fill:#CF4040;" d="M15.9,33.9c0.1-0.6,0.2-1.2,0.3-1.9c-0.5,0.3-1,0.7-1.5,1.2c-1,1-2.1,2.7-1.5,4
					C14.6,37.1,15.5,35.3,15.9,33.9z"/>
			
				<path style="fill:#CF4040;" d="M28,10.1c-0.1,0.6-0.2,1.2-0.3,1.9c0.5-0.3,1-0.7,1.5-1.2c1-1,2.1-2.7,1.5-4
					C29.3,6.9,28.3,8.7,28,10.1z"/>
			
				<path style="fill:#CF4040;" d="M10.8,29.3c0.4-0.4,0.8-0.9,1.2-1.5c-0.6,0-1.3,0.1-1.9,0.3c-1.4,0.3-3.2,1.3-3.3,2.7
					C8.1,31.4,9.8,30.3,10.8,29.3z"/>
			
				<path style="fill:#CF4040;" d="M14.7,10.8c0.4,0.4,0.9,0.8,1.5,1.2c0-0.6-0.1-1.3-0.3-1.9c-0.3-1.4-1.3-3.2-2.7-3.3
					C12.5,8.1,13.7,9.8,14.7,10.8z"/>
			
				<path style="fill:#CF4040;" d="M21.9,10.4c0.3-0.6,0.5-1.2,0.7-1.8c0.4-1.4,0.5-3.4-0.7-4.2c-1.2,0.8-1.1,2.8-0.7,4.2
					C21.4,9.3,21.7,9.9,21.9,10.4z"/>
			
				<path style="fill:#CF4040;" d="M10.1,15.9c0.6,0.1,1.2,0.2,1.9,0.3c-0.3-0.5-0.7-1-1.2-1.5c-1-1-2.7-2.1-4-1.5
					C6.9,14.7,8.7,15.6,10.1,15.9z"/>
			
				<path style="fill:#CF4040;" d="M27.6,29.1c-0.4-0.6-1-0.8-1.7-1c-0.2-0.1-0.4-0.1-0.6-0.1c-0.1,0.2-0.1,0.4-0.2,0.6
					c-0.2,0.6-0.3,1.3,0,1.9c0.4,0.7,1.1,0.9,1.8,0.9c0-0.2,0-0.3,0-0.5c0.1,0.1,0.3,0.1,0.4,0.2C27.9,30.5,28.1,29.8,27.6,29.1z"/>
		
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C6">
<title>C6</title>
<path  style="fill:#D04042;" d="M13.9,19.8c-0.9,0.4-1.7,1-2.3,1.7
c-0.2,0.2-0.4,0.4-0.6,0.7c0.2,0.2,0.4,0.5,0.6,0.7c0.7,0.7,1.4,1.3,2.3,1.7c2,0.9,4,0.1,5.6-1.2l1.3,1.3c-1.2,1.7-2.1,3.6-1.2,5.6
c0.4,0.9,1,1.7,1.7,2.3c0.2,0.2,0.4,0.4,0.5,0.5l0.1,0.1l0.1-0.1c0.2-0.2,0.4-0.4,0.5-0.5c0.7-0.7,1.3-1.4,1.7-2.3
c0.9-2,0.1-4-1.2-5.6l1.3-1.3c1.7,1.2,3.6,2.1,5.6,1.2c0.9-0.4,1.7-1,2.3-1.7c0.2-0.2,0.4-0.4,0.5-0.5l0.1-0.1L32.9,22
c-0.2-0.2-0.4-0.4-0.5-0.5c-0.7-0.7-1.4-1.3-2.3-1.7c-2-0.9-4-0.1-5.6,1.2l-1.3-1.3c1.2-1.7,2.1-3.6,1.2-5.6
c-0.4-0.9-1-1.7-1.7-2.3c-0.2-0.2-0.4-0.4-0.5-0.5L22,11.1l-0.1,0.1c-0.2,0.2-0.4,0.4-0.5,0.5c-0.7,0.7-1.3,1.4-1.7,2.3
c-0.9,2-0.1,4,1.2,5.6l-1.3,1.3C17.9,19.7,15.9,18.9,13.9,19.8z"/>
</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C7">
<title>C7</title>
<path style="fill:#FA9F2C;" d="M22,18c-0.1,0.1-0.2,0.2-0.3,0.3c-1.2,1.2-2.3,2.3-3.5,3.5c-0.3,0.3-0.2,0.4,0.1,0.6
c1.1,1.1,2.3,2.2,3.4,3.4c0.2,0.2,0.4,0.3,0.6,0c1.1-1.2,2.3-2.3,3.4-3.4c0.3-0.2,0.3-0.4,0-0.6c-1.2-1.1-2.3-2.3-3.4-3.4
C22.2,18.2,22.1,18.1,22,18z"/>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C8">
<title>C8</title>
<path  style="fill:#14366B;" d="M14,19.5c-0.9,0.4-1.6,1-2.3,1.7
c-0.2,0.2-0.4,0.4-0.6,0.7c0.2,0.2,0.4,0.4,0.6,0.7c0.7,0.7,1.4,1.3,2.3,1.7c2,0.9,3.9,0.1,5.6-1.2l1.2,1.2
c-1.2,1.6-2.1,3.6-1.2,5.6c0.4,0.9,1,1.6,1.7,2.3c0.2,0.2,0.4,0.4,0.5,0.5l0.1,0.1l0.1-0.1c0.2-0.2,0.4-0.3,0.5-0.5
c0.7-0.7,1.3-1.4,1.7-2.3c0.9-2,0.1-3.9-1.2-5.6l1.2-1.2c1.6,1.2,3.6,2.1,5.6,1.2c0.9-0.4,1.6-1,2.3-1.7c0.2-0.2,0.4-0.4,0.5-0.5
l0.1-0.1l-0.1-0.1c-0.2-0.2-0.3-0.4-0.5-0.5c-0.7-0.7-1.4-1.3-2.3-1.7c-2-0.9-3.9-0.1-5.6,1.2l-1.2-1.2c1.2-1.6,2.1-3.6,1.2-5.6
c-0.4-0.9-1-1.6-1.7-2.3c-0.2-0.2-0.4-0.4-0.5-0.5L22,10.9L21.9,11c-0.2,0.2-0.4,0.3-0.5,0.5c-0.7,0.7-1.3,1.4-1.7,2.3
c-0.9,2-0.1,3.9,1.2,5.6l-1.2,1.2C17.9,19.5,16,18.7,14,19.5z"/>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C9">
<title>C9</title>
<path style="fill:#14366B;" d="M23.5,24.8c-0.2-0.4-0.4-0.8-0.5-1.2c-0.1-0.2-0.1-0.4-0.1-0.6c-0.3,0.2-0.6,0.2-0.9,0.2
c-0.3,0-0.6-0.1-0.8-0.2c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.4-0.3,0.8-0.5,1.2c-0.2,0.4-0.4,0.8-0.7,1.2c-0.3,0.4-0.6,0.7-0.8,1
c0.5,0,0.9,0,1.2,0.2c0.4,0.2,0.6,0.4,0.8,0.6c0.2,0.2,0.2,0.5,0.1,0.8c-0.1,0.3-0.4,0.5-0.8,0.7c0.1,0.1,0.2,0.3,0.4,0.5
c0.2,0.3,0.4,0.6,0.5,0.9c0.2,0.3,0.3,0.6,0.3,1c0,0.3-0.1,0.5-0.4,0.7c0,0.5,0,0.9-0.1,1.2c0.3-0.2,0.7-0.3,1.1-0.3
c0.3,0,0.6,0.1,0.9,0.3c-0.1-0.3-0.1-0.7-0.1-1.1c-0.3-0.2-0.4-0.4-0.4-0.7c0-0.3,0.1-0.6,0.3-1c0.2-0.3,0.3-0.6,0.5-0.9
c0.2-0.3,0.3-0.5,0.4-0.5c-0.5-0.2-0.7-0.4-0.8-0.7c-0.1-0.3-0.1-0.5,0.1-0.8c0.2-0.2,0.4-0.4,0.8-0.6c0.4-0.2,0.8-0.2,1.2-0.2
c-0.3-0.3-0.6-0.6-0.8-1C23.9,25.7,23.7,25.3,23.5,24.8z"/>
<path style="fill:#14366B;" d="M20.6,19.1c0.2,0.4,0.3,0.7,0.4,1c0.3-0.2,0.6-0.3,1-0.3c0.4,0,0.7,0.1,1,0.3
c0.1-0.3,0.3-0.7,0.5-1.1c0.2-0.4,0.5-0.8,0.7-1.2c0.3-0.4,0.5-0.8,0.9-1c-0.5,0.1-0.9,0-1.2-0.2c-0.4-0.2-0.7-0.3-0.8-0.6
c-0.2-0.2-0.2-0.5-0.1-0.8c0.1-0.3,0.4-0.5,0.8-0.7c-0.1-0.1-0.2-0.3-0.4-0.5c-0.2-0.3-0.4-0.6-0.5-0.9c-0.2-0.3-0.3-0.6-0.3-1
c0-0.3,0.1-0.5,0.4-0.7c0-0.4,0-0.7,0.1-1c-0.3,0.2-0.6,0.3-0.9,0.3c-0.3,0-0.7-0.1-1-0.3c0.1,0.3,0.1,0.7,0.1,1.1
c0.3,0.2,0.4,0.4,0.4,0.7c0,0.3-0.1,0.6-0.3,1c-0.2,0.3-0.3,0.6-0.5,0.9c-0.2,0.3-0.3,0.5-0.4,0.5c0.5,0.2,0.7,0.4,0.8,0.7
c0.1,0.3,0,0.5-0.1,0.8c-0.2,0.2-0.4,0.4-0.8,0.6c-0.4,0.2-0.8,0.2-1.2,0.2c0.3,0.3,0.6,0.6,0.8,1C20.1,18.2,20.4,18.6,20.6,19.1z
"/>
<path style="fill:#14366B;" d="M16.1,22.9c0.3,0.2,0.5,0.4,0.6,0.8c0.2,0.4,0.2,0.8,0.2,1.2c0.3-0.3,0.6-0.6,1-0.9
c0.4-0.3,0.8-0.5,1.2-0.7c0.4-0.2,0.8-0.4,1.2-0.5c0.2-0.1,0.3-0.1,0.4-0.1c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.2,0-0.4,0.1-0.6
c-0.4-0.1-0.8-0.3-1.2-0.5c-0.4-0.2-0.8-0.4-1.2-0.7c-0.4-0.3-0.8-0.6-1-0.8c0.1,0.5,0,0.9-0.2,1.2c-0.2,0.4-0.4,0.6-0.6,0.8
c-0.3,0.2-0.5,0.2-0.8,0.1c-0.3-0.1-0.5-0.3-0.7-0.8c-0.1,0.1-0.3,0.2-0.5,0.4c-0.3,0.2-0.6,0.4-0.9,0.5c-0.3,0.2-0.6,0.2-1,0.3
c-0.3,0-0.5-0.1-0.7-0.4c-0.5,0.1-0.9,0-1.2-0.1c0.2,0.3,0.3,0.6,0.3,1c0,0.4-0.1,0.7-0.3,1c0.4-0.2,0.8-0.2,1.3-0.2
c0.2-0.3,0.4-0.4,0.7-0.4c0.3,0,0.6,0.1,1,0.3c0.3,0.2,0.6,0.3,0.9,0.5c0.3,0.2,0.5,0.3,0.5,0.4c0.2-0.5,0.4-0.7,0.7-0.8
C15.6,22.7,15.9,22.8,16.1,22.9z"/>
<path style="fill:#14366B;" d="M33.4,21.9c0-0.3,0.1-0.7,0.3-1c-0.4,0.1-0.8,0.2-1.2,0.1c-0.2,0.3-0.4,0.4-0.7,0.4
c-0.3,0-0.6-0.1-1-0.3c-0.3-0.2-0.6-0.3-0.9-0.5c-0.3-0.2-0.5-0.3-0.5-0.4c-0.2,0.5-0.4,0.7-0.7,0.8c-0.3,0.1-0.5,0-0.8-0.1
c-0.3-0.2-0.5-0.4-0.6-0.8c-0.2-0.4-0.2-0.8-0.2-1.2c-0.3,0.3-0.6,0.6-1,0.8c-0.4,0.3-0.8,0.5-1.2,0.7c-0.4,0.2-0.8,0.4-1.2,0.5
c0,0,0,0-0.1,0c0.1,0.2,0.1,0.4,0.1,0.6c0,0.5-0.2,0.9-0.5,1.3c0.1,0,0.3,0.1,0.5,0.1c0.4,0.1,0.8,0.3,1.2,0.5
c0.4,0.2,0.8,0.4,1.2,0.7c0.4,0.3,0.8,0.6,1,0.8c-0.1-0.5,0-0.9,0.2-1.2c0.2-0.4,0.4-0.6,0.6-0.8c0.3-0.2,0.5-0.2,0.8-0.1
c0.3,0.1,0.5,0.3,0.7,0.8c0.1,0,0.3-0.1,0.5-0.3c0.3-0.2,0.6-0.4,0.9-0.5c0.3-0.2,0.6-0.2,1-0.3c0.3,0,0.5,0.1,0.7,0.4
c0.5-0.1,0.9,0,1.2,0.1C33.5,22.6,33.4,22.3,33.4,21.9z"/>
</symbol>
        
        
<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C10">
<title>C10</title>
<path style="fill:#14366B;" d="M24.5,22c0-1.4-1.1-2.5-2.5-2.5
c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5C23.4,24.5,24.5,23.4,24.5,22z"/>

</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C11">
<title>C11</title>
c-0.3,0.1-0.9,0.2-0.9,0.7c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0-0.4,0.1-0.3c0.2,0,0.1,0.3,0.1,0.4c0.2,0,0.3,0,0.5,0
c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0.1-0.2c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0.1,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2,0,0.3
c0.2,0,0.3,0,0.5,0c0-0.1-0.1-0.4,0.1-0.4c0.2,0,0.1,0.2,0.1,0.3c0.2,0,0.4-0.1,0.6-0.2C23.2,25.3,22.7,25.3,22.4,25.1z"/>
<path style="display:inline;fill:#CF3C40;" d="M19.9,24c-0.2,0-0.4,0-0.6-0.1c-0.3-0.2-0.8-0.5-1.1-0.2c0.1,0.2,0.2,0.4,0.3,0.6
c0.1-0.1,0.2-0.3,0.3-0.2c0.1,0.1-0.1,0.3-0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.2-0.1
c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.2,0.4,0.3c0.1-0.1,0.2-0.3,0.3-0.2
c0.1,0.1-0.1,0.3-0.2,0.3c0.2,0.1,0.4,0.2,0.6,0.3c0.3-0.3,0-0.8-0.2-1.1C19.9,24.4,19.9,24.2,19.9,24z"/>
<path style="display:inline;fill:#CF3C40;" d="M23.8,20c0.2,0,0.4,0,0.6,0.1c0.3,0.2,0.8,0.5,1.1,0.2c-0.1-0.2-0.2-0.4-0.3-0.6
c-0.1,0.1-0.2,0.3-0.3,0.2c-0.1-0.1,0.1-0.3,0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.1-0.2,0.1
c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1,0.1-0.2,0.3-0.3,0.2
c-0.1-0.1,0.1-0.3,0.2-0.3c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3,0.3,0,0.8,0.2,1.1C23.8,19.6,23.8,19.8,23.8,20z"/>
<path style="display:inline;fill:#CF3C40;" d="M18.7,22.5c0.1-0.2,0.2-0.4,0.3-0.5c-0.2-0.1-0.3-0.3-0.3-0.5
c-0.1-0.3-0.2-0.9-0.7-0.9c-0.1,0.2-0.1,0.4-0.2,0.6c0.1,0,0.4,0,0.3,0.1c0,0.2-0.3,0.1-0.4,0.1c0,0.2,0,0.3,0,0.5
c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.2,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1c-0.1,0.1-0.2,0.1-0.2,0.1c-0.1,0-0.2,0-0.3,0
c0,0.2,0,0.3,0,0.5c0.1,0,0.4-0.1,0.4,0.1c0,0.2-0.2,0.1-0.3,0.1c0,0.2,0.1,0.4,0.2,0.6C18.5,23.4,18.6,22.9,18.7,22.5z"/>
<path style="display:inline;fill:#CF3C40;" d="M21.3,18.9c0.2,0.1,0.4,0.2,0.5,0.3c0.1-0.2,0.3-0.3,0.5-0.3
c0.3-0.1,0.9-0.2,0.9-0.7c-0.2-0.1-0.4-0.1-0.6-0.2c0,0.1,0,0.4-0.1,0.3c-0.2,0-0.1-0.3-0.1-0.4c-0.2,0-0.3,0-0.5,0
c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2-0.1,0.2c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-0.1-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.2,0-0.3
c-0.2,0-0.3,0-0.5,0c0,0.1,0.1,0.4-0.1,0.4c-0.2,0-0.1-0.2-0.1-0.3c-0.2,0-0.4,0.1-0.6,0.2C20.4,18.7,21,18.8,21.3,18.9z"/>
<path style="display:inline;fill:#CF3C40;" d="M19.3,20.2c0.2-0.1,0.4-0.1,0.6-0.1c0-0.2,0-0.4,0.1-0.6c0.2-0.3,0.5-0.8,0.2-1.1
c-0.2,0.1-0.4,0.2-0.6,0.3c0.1,0.1,0.3,0.2,0.2,0.3c-0.1,0.1-0.3-0.1-0.3-0.2c-0.1,0.1-0.2,0.2-0.4,0.3c0.1,0.1,0.2,0.1,0.3,0.2
c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0.1c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1,0.1-0.2,0.2-0.3,0.4
c0.1,0.1,0.3,0.2,0.2,0.3c-0.1,0.1-0.3-0.1-0.3-0.2c-0.1,0.2-0.2,0.4-0.3,0.6C18.5,20.6,18.9,20.3,19.3,20.2z"/>
<path style="display:inline;fill:#CF3C40;" d="M25.8,21.2c0-0.2-0.1-0.4-0.2-0.6c-0.5,0-0.5,0.5-0.7,0.9c-0.1,0.2-0.2,0.4-0.3,0.5
c0.2,0.1,0.3,0.3,0.3,0.5c0.1,0.3,0.2,0.9,0.7,0.9c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.4,0-0.3-0.1c0-0.2,0.3-0.1,0.4-0.1
c0-0.2,0-0.3,0-0.5c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.2-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0.1-0.1,0.2-0.1,0.2-0.1
c0.1,0,0.2,0,0.3,0c0-0.2,0-0.3,0-0.5c-0.1,0-0.4,0.1-0.4-0.1C25.4,21.2,25.7,21.2,25.8,21.2z"/>
<path style="display:inline;fill:#CF3C40;" d="M24.4,23.8C24.2,23.9,24,24,23.8,24c0,0.2,0,0.4-0.1,0.6c-0.2,0.3-0.5,0.8-0.2,1.1
c0.2-0.1,0.4-0.2,0.6-0.3c-0.1-0.1-0.3-0.2-0.2-0.3c0.1-0.1,0.3,0.1,0.3,0.2c0.1-0.1,0.2-0.2,0.4-0.3c-0.1-0.1-0.2-0.1-0.3-0.2
c-0.1-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.2-0.2,0.3-0.4
c-0.1-0.1-0.3-0.2-0.2-0.3c0.1-0.1,0.3,0.1,0.3,0.2c0.1-0.2,0.2-0.4,0.3-0.6C25.2,23.4,24.7,23.7,24.4,23.8z"/>
<path style="display:inline;fill:#CF3C40;" d="M25,23.2c-0.1-0.1-0.1-0.2-0.1-0.3c-0.2,0.1-0.5,0.1-0.7,0c0,0-0.1,0-0.1,0
c-0.4-0.2-0.4-0.6-0.8-0.8c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0.4-0.2,0.5-0.6,0.8-0.8c0,0,0.1,0,0.1,0
c0.2-0.1,0.5-0.1,0.7,0c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2-0.1-0.3-0.1
c-0.1,0.2-0.2,0.5-0.5,0.6c0,0-0.1,0-0.1,0c-0.4,0.1-0.8-0.1-1.2,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0,0,0
c0.2-0.4-0.1-0.8,0-1.2c0,0,0-0.1,0-0.1c0.1-0.2,0.3-0.4,0.6-0.5c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2
c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c0.1,0.2,0.1,0.5,0,0.7c0,0,0,0.1,0,0.1c-0.2,0.4-0.6,0.4-0.8,0.8c0,0,0,0,0,0
c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.2-0.4-0.6-0.5-0.8-0.8c0,0,0-0.1,0-0.1c-0.1-0.2-0.1-0.5,0-0.7
c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1-0.1-0.2-0.2c0,0.1,0,0.2,0,0.2c0,0.1-0.1,0.2-0.1,0.3c0.2,0.1,0.5,0.2,0.6,0.5
c0,0,0,0.1,0,0.1c0.1,0.4-0.1,0.8,0,1.2c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.4-0.2-0.8,0.1-1.2,0
c0,0-0.1,0-0.1,0c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2,0c0.1,0.1,0.1,0.1,0.2,0.2
c0.1,0.1,0.1,0.2,0.1,0.3c0.2-0.1,0.5-0.1,0.7,0c0,0,0.1,0,0.1,0c0.4,0.2,0.4,0.6,0.8,0.8c0,0,0,0,0,0c0,0,0,0,0,0.1
c0,0,0,0,0,0.1c0,0,0,0,0,0c-0.4,0.2-0.5,0.6-0.8,0.8c0,0-0.1,0-0.1,0c-0.2,0.1-0.5,0.1-0.7,0c0,0.1-0.1,0.2-0.1,0.3
c0,0.1-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0.2-0.5,0.5-0.6c0,0,0.1,0,0.1,0c0.4-0.1,0.8,0.1,1.2,0
c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0,0,0c-0.2,0.4,0.1,0.8,0,1.2c0,0,0,0.1,0,0.1c-0.1,0.2-0.3,0.4-0.6,0.5
c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c-0.1-0.2-0.1-0.5,0-0.7
c0,0,0-0.1,0-0.1c0.2-0.4,0.6-0.4,0.8-0.8c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0.2,0.4,0.6,0.5,0.8,0.8
c0,0,0,0.1,0,0.1c0.1,0.2,0.1,0.5,0,0.7c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.2,0.2c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.2,0.1-0.3
c-0.2-0.1-0.5-0.2-0.6-0.5c0,0,0-0.1,0-0.1c-0.1-0.4,0.1-0.8,0-1.2c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0,0,0,0,0,0
c0.4,0.2,0.8-0.1,1.2,0c0,0,0.1,0,0.1,0c0.2,0.1,0.4,0.3,0.5,0.6c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0
C25.1,23.3,25.1,23.3,25,23.2z M22.7,22C22.7,22,22.7,22,22.7,22C22.7,22,22.7,22,22.7,22l0,0.1c0,0,0,0,0,0
c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1-0.2,0.1-0.2,0.1c0,0,0,0,0,0l0,0.1c0,0,0,0,0,0c0,0,0,0,0,0l-0.1,0c0,0,0,0,0,0
c0,0.1,0,0.2-0.1,0.2c-0.1,0-0.2,0-0.3-0.1c0,0,0,0,0,0l-0.1,0c0,0,0,0,0,0s0,0,0,0l-0.1,0c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.3,0.1
c-0.1,0-0.1-0.2-0.1-0.2c0,0,0,0,0,0l-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0-0.1c0,0,0,0,0,0c-0.1,0-0.2,0-0.2-0.1c0-0.1,0-0.2,0.1-0.3
c0,0,0,0,0,0l0-0.1c0,0,0,0,0,0c0,0,0,0,0,0l0-0.1c0,0,0,0,0,0c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0.2-0.1,0.2-0.1c0,0,0,0,0,0l0-0.1
c0,0,0,0,0,0c0,0,0,0,0,0l0.1,0c0,0,0,0,0,0c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.3,0.1c0,0,0,0,0,0l0.1,0c0,0,0,0,0,0s0,0,0,0
l0.1,0c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0.2,0.1,0.2c0,0,0,0,0,0l0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0.1c0,0,0,0,0,0
c0.1,0,0.2,0,0.2,0.1C22.8,21.7,22.8,21.8,22.7,22C22.7,21.9,22.7,21.9,22.7,22L22.7,22z"/>

</symbol>


<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C12">
<title>C12</title>
<path style="fill:#C04947;" d="M22.7,26.5c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2,0.2-0.4,0.4-0.7,0.5c-0.5,0.2-1.3,0.3-1.3,1
c0.3,0.1,0.6,0.2,0.9,0.2c0-0.2-0.1-0.5,0.2-0.5c0.2,0,0.2,0.4,0.1,0.6c0.2,0,0.4,0,0.7,0.1c0-0.2,0-0.3-0.1-0.5
c0-0.1,0-0.3,0.1-0.4c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.1,0.2,0.1,0.4c0,0.2,0,0.3-0.1,0.5c0.2,0,0.4,0,0.7-0.1
c0-0.2-0.1-0.5,0.1-0.6c0.2,0,0.2,0.3,0.2,0.5c0.3-0.1,0.6-0.1,0.9-0.2C23.9,26.8,23.2,26.7,22.7,26.5z"/>
<path style="fill:#C04947;" d="M19.1,24.9c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.2-1.1-0.7-1.6-0.2c0.1,0.3,0.3,0.6,0.5,0.8
c0.1-0.1,0.3-0.4,0.5-0.2c0.2,0.2-0.1,0.4-0.3,0.5c0.1,0.2,0.3,0.3,0.4,0.5c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.2,0.3-0.2
c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1c0,0.1-0.1,0.3-0.2,0.3c-0.1,0.1-0.2,0.2-0.4,0.3c0.2,0.2,0.3,0.3,0.5,0.4
c0.1-0.2,0.3-0.5,0.5-0.3c0.2,0.2-0.1,0.4-0.2,0.5c0.3,0.2,0.5,0.3,0.8,0.5c0.4-0.5,0-1.1-0.2-1.6C19.1,25.4,19.1,25.2,19.1,24.9
z"/>
<path style="fill:#C04947;" d="M24.8,19.2c0.3,0,0.6,0.1,0.9,0.2c0.5,0.2,1.1,0.7,1.6,0.2c-0.1-0.3-0.3-0.6-0.5-0.8
c-0.1,0.1-0.3,0.4-0.5,0.2c-0.2-0.2,0.1-0.4,0.3-0.5c-0.1-0.2-0.3-0.3-0.4-0.5c-0.1,0.1-0.2,0.3-0.3,0.4
c-0.1,0.1-0.2,0.2-0.3,0.2c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1c0-0.1,0.1-0.3,0.2-0.3c0.1-0.1,0.2-0.2,0.4-0.3
c-0.2-0.2-0.3-0.3-0.5-0.4c-0.1,0.2-0.3,0.5-0.5,0.3c-0.2-0.2,0.1-0.4,0.2-0.5c-0.3-0.2-0.5-0.3-0.8-0.5c-0.4,0.5,0,1.1,0.2,1.6
C24.7,18.6,24.8,18.9,24.8,19.2z"/>
<path style="fill:#C04947;" d="M17.4,22.8c0.1-0.3,0.3-0.5,0.5-0.7c-0.2-0.2-0.4-0.4-0.5-0.7c-0.2-0.5-0.3-1.3-1-1.3
c-0.1,0.3-0.2,0.6-0.2,0.9c0.2,0,0.5-0.1,0.5,0.2c0,0.2-0.4,0.2-0.6,0.1c0,0.2,0,0.4-0.1,0.7c0.2,0,0.3,0,0.5-0.1
c0.1,0,0.3,0,0.4,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.5-0.1c0,0.2,0,0.4,0.1,0.7
c0.2,0,0.5-0.1,0.6,0.1c0,0.2-0.3,0.2-0.5,0.2c0.1,0.3,0.1,0.6,0.2,0.9C17.1,24,17.2,23.3,17.4,22.8z"/>
<path style="fill:#C04947;" d="M21.2,17.5c0.3,0.1,0.5,0.3,0.7,0.5c0.2-0.2,0.4-0.4,0.7-0.5c0.5-0.2,1.3-0.3,1.3-1
c-0.3-0.1-0.6-0.2-0.9-0.2c0,0.2,0.1,0.5-0.2,0.5c-0.2,0-0.2-0.4-0.1-0.6c-0.2,0-0.4,0-0.7-0.1c0,0.2,0,0.3,0.1,0.5
c0,0.1,0,0.3-0.1,0.4c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.2,0-0.3,0.1-0.5c-0.2,0-0.4,0-0.7,0.1
c0,0.2,0.1,0.5-0.1,0.6c-0.2,0-0.2-0.3-0.2-0.5c-0.3,0.1-0.6,0.1-0.9,0.2C19.9,17.2,20.7,17.3,21.2,17.5z"/>
<path style="fill:#C04947;" d="M18.2,19.4c0.3-0.1,0.6-0.2,0.9-0.2c0-0.3,0.1-0.6,0.2-0.9c0.2-0.5,0.7-1.1,0.2-1.6
c-0.3,0.1-0.6,0.3-0.8,0.5c0.1,0.1,0.4,0.3,0.2,0.5c-0.2,0.2-0.4-0.1-0.5-0.3c-0.2,0.1-0.3,0.3-0.5,0.4c0.1,0.1,0.3,0.2,0.4,0.3
c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0c-0.1,0-0.3-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.4
c-0.2,0.2-0.3,0.3-0.4,0.5c0.2,0.1,0.5,0.3,0.3,0.5c-0.2,0.2-0.4-0.1-0.5-0.2c-0.2,0.3-0.3,0.5-0.5,0.8
C17.1,20,17.7,19.6,18.2,19.4z"/>
<path style="fill:#C04947;" d="M27.6,20.9c-0.1-0.3-0.1-0.6-0.2-0.9c-0.7,0-0.8,0.8-1,1.3c-0.1,0.3-0.3,0.5-0.5,0.7
c0.2,0.2,0.4,0.4,0.5,0.7c0.2,0.5,0.3,1.3,1,1.3c0.1-0.3,0.2-0.6,0.2-0.9c-0.2,0-0.5,0.1-0.5-0.2c0-0.2,0.4-0.2,0.6-0.1
c0-0.2,0-0.4,0.1-0.7c-0.2,0-0.3,0-0.5,0.1c-0.1,0-0.3,0-0.4-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0.1-0.1,0.2-0.1,0.4-0.1
c0.2,0,0.3,0,0.5,0.1c0-0.2,0-0.4-0.1-0.7c-0.2,0-0.5,0.1-0.6-0.1C27.1,20.8,27.5,20.9,27.6,20.9z"/>
<path style="fill:#C04947;" d="M25.6,24.7c-0.3,0.1-0.6,0.2-0.9,0.2c0,0.3-0.1,0.6-0.2,0.9c-0.2,0.5-0.7,1.1-0.2,1.6
c0.3-0.1,0.6-0.3,0.8-0.5c-0.1-0.1-0.4-0.3-0.2-0.5c0.2-0.2,0.4,0.1,0.5,0.3c0.2-0.1,0.3-0.3,0.5-0.4c-0.1-0.1-0.3-0.2-0.4-0.3
c-0.1-0.1-0.2-0.2-0.2-0.3c0,0,0-0.1,0-0.1c0,0,0,0,0.1,0c0.1,0,0.3,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.3,0.4
c0.2-0.2,0.3-0.3,0.4-0.5c-0.2-0.1-0.5-0.3-0.3-0.5c0.2-0.2,0.4,0.1,0.5,0.2c0.2-0.3,0.3-0.5,0.5-0.8
C26.8,24,26.1,24.5,25.6,24.7z"/>
<path style="fill:#C04947;" d="M26.5,23.7c-0.1-0.1-0.1-0.3-0.2-0.5c-0.3,0.2-0.7,0.2-1.1,0.1c0,0-0.1,0-0.1-0.1
c-0.5-0.3-0.6-0.9-1.2-1.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0.6-0.2,0.7-0.9,1.2-1.2c0,0,0.1,0,0.1-0.1
c0.3-0.1,0.7-0.1,1.1,0.1c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0-0.4,0c-0.2,0-0.3-0.1-0.5-0.2
c-0.1,0.4-0.3,0.7-0.7,0.8c0,0-0.1,0-0.1,0c-0.6,0.2-1.1-0.2-1.7,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0
c0.2-0.6-0.1-1.1,0-1.7c0,0,0-0.1,0-0.1c0.1-0.3,0.4-0.6,0.8-0.7c-0.1-0.1-0.1-0.3-0.2-0.5c0-0.1,0-0.2,0-0.4
c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.5,0.2c0.2,0.3,0.2,0.7,0.1,1.1c0,0,0,0.1-0.1,0.1c-0.3,0.5-0.9,0.6-1.2,1.2
c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.2-0.6-0.9-0.7-1.2-1.2c0,0,0-0.1-0.1-0.1c-0.1-0.3-0.1-0.7,0.1-1.1
c-0.2-0.1-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c0,0.1,0,0.2,0,0.4c0,0.2-0.1,0.3-0.2,0.5c0.4,0.1,0.7,0.3,0.8,0.7
c0,0,0,0.1,0,0.1c0.2,0.6-0.2,1.1,0,1.7c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.6-0.2-1.1,0.1-1.7,0
c0,0-0.1,0-0.1,0c-0.3-0.1-0.6-0.4-0.7-0.8c-0.1,0.1-0.3,0.1-0.5,0.2c-0.1,0-0.2,0-0.4,0c0.1,0.1,0.2,0.2,0.2,0.3
c0.1,0.1,0.1,0.3,0.2,0.5c0.3-0.2,0.7-0.2,1.1-0.1c0,0,0.1,0,0.1,0.1c0.5,0.3,0.6,0.9,1.2,1.2c0,0,0,0,0,0c0,0,0,0.1,0,0.1
s0,0.1,0,0.1c0,0,0,0,0,0c-0.6,0.2-0.7,0.9-1.2,1.2c0,0-0.1,0-0.1,0.1c-0.3,0.1-0.7,0.1-1.1-0.1c-0.1,0.2-0.1,0.3-0.2,0.5
c-0.1,0.1-0.1,0.2-0.2,0.3c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0.1,0.5,0.2c0.1-0.4,0.3-0.7,0.7-0.8c0,0,0.1,0,0.1,0
c0.6-0.2,1.1,0.2,1.7,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c-0.2,0.6,0.1,1.1,0,1.7c0,0,0,0.1,0,0.1
c-0.1,0.3-0.4,0.6-0.8,0.7c0.1,0.1,0.1,0.3,0.2,0.5c0,0.1,0,0.2,0,0.4c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.3-0.1,0.5-0.2
c-0.2-0.3-0.2-0.7-0.1-1.1c0,0,0-0.1,0.1-0.1c0.3-0.5,0.9-0.6,1.2-1.2c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
c0.2,0.6,0.9,0.7,1.2,1.2c0,0,0,0.1,0.1,0.1c0.1,0.3,0.1,0.7-0.1,1.1c0.2,0.1,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.1,0.3,0.2
c0-0.1,0-0.2,0-0.4c0-0.2,0.1-0.3,0.2-0.5c-0.4-0.1-0.7-0.3-0.8-0.7c0,0,0-0.1,0-0.1c-0.2-0.6,0.2-1.1,0-1.7c0,0,0,0,0,0
c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.6,0.2,1.1-0.1,1.7,0c0,0,0.1,0,0.1,0c0.3,0.1,0.6,0.4,0.7,0.8
c0.1-0.1,0.3-0.1,0.5-0.2c0.1,0,0.2,0,0.4,0C26.7,23.9,26.6,23.9,26.5,23.7z M23.2,22C23.2,22,23.2,22,23.2,22
C23.2,22,23.2,22.1,23.2,22l0,0.2c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.1,0.4c-0.1,0.1-0.2,0.2-0.4,0.2c0,0,0,0,0,0l-0.1,0.1
c0,0,0,0,0,0c0,0,0,0,0,0l-0.1,0.1c0,0,0,0,0,0c0,0.1,0,0.3-0.2,0.4c-0.1,0.1-0.3,0-0.4-0.1c0,0,0,0,0,0l-0.1,0c0,0,0,0,0,0
s0,0,0,0l-0.1,0c0,0,0,0,0,0c-0.1,0.1-0.2,0.2-0.4,0.1c-0.1-0.1-0.2-0.2-0.2-0.4c0,0,0,0,0,0l-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0
l-0.1-0.1c0,0,0,0,0,0c-0.1,0-0.3,0-0.4-0.2c-0.1-0.1,0-0.3,0.1-0.4c0,0,0,0,0,0l0-0.1c0,0,0,0,0,0c0,0,0,0,0,0l0-0.1
c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.1-0.4c0.1-0.1,0.2-0.2,0.4-0.2c0,0,0,0,0,0l0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0l0.1-0.1
c0,0,0,0,0,0c0-0.1,0-0.3,0.2-0.4c0.1-0.1,0.3,0,0.4,0.1c0,0,0,0,0,0l0.1,0c0,0,0,0,0,0s0,0,0,0l0.1,0c0,0,0,0,0,0
c0.1-0.1,0.2-0.2,0.4-0.1c0.1,0.1,0.2,0.2,0.2,0.4c0,0,0,0,0,0l0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0l0.1,0.1c0,0,0,0,0,0
c0.1,0,0.3,0,0.4,0.2c0.1,0.1,0,0.3-0.1,0.4C23.2,21.9,23.2,21.9,23.2,22L23.2,22z"/>

</symbol>

        

        
        
        
        </svg> `,



        'symbols': {
            'Z': 3,
            'A': 12,
            'B': 12,
            'C': 12
        },
    
    },


    {
        'id': 3,
        'svg': `<svg width="0" height="0" class="hidden">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1">
            <title>Z1</title>
            <path fill="#d7e8cd" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3">
            <title>Z3</title>
            <path fill="#8de0b8" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2">
            <title>Z2</title>
            <path fill="#92c193" d="M.07-.21h44v44h-44z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2">
        <title>Z2</title>
        <path fill="#FFFFFF" d="M.07-.21h44v44h-44z"></path>
    </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="selection-color">
            <path fill="#665c54" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="icon">
            <title>icon</title>
            <path fill="#d7e8cd" d="M0 0h44v44H0z"></path>
            <path d="M12 0h20v12h-5.86L22 7.86 17.86 12H12zm0 32v-5.86L7.86 22 12 17.86V12H0v20zm20 0v-5.86L36.14 22 32 17.86V12h12v20zm0 0h-5.86L22 36.14 17.86 32H12v12h20z" fill="#5bb56f"></path>
            <path d="M22 43.87l-1.2-1.58c-.23-.31-.5-.65-.79-1a12.72 12.72 0 0 0-4.45-3.73 12.71 12.71 0 0 0-5.79-.51c-.46 0-.88.09-1.27.14l-2 .27.27-2c.05-.39.1-.82.14-1.27a12.71 12.71 0 0 0-.51-5.79A12.72 12.72 0 0 0 2.71 24c-.35-.29-.69-.56-1-.79L.13 22l1.58-1.2c.31-.23.65-.5 1-.79a12.72 12.72 0 0 0 3.73-4.45A12.71 12.71 0 0 0 7 9.77c0-.45-.09-.88-.14-1.27l-.27-2 2 .27L9.77 7a12.71 12.71 0 0 0 5.79-.51A12.72 12.72 0 0 0 20 2.71c.29-.35.56-.69.79-1L22 .13l1.2 1.58c.23.31.5.65.79 1a12.72 12.72 0 0 0 4.45 3.73 12.71 12.71 0 0 0 5.79.56l1.27-.14 2-.27-.27 2c0 .39-.1.82-.14 1.27a12.71 12.71 0 0 0 .51 5.79A12.72 12.72 0 0 0 41.29 20c.35.29.69.56 1 .79L43.87 22l-1.58 1.2c-.31.23-.65.5-1 .79a12.72 12.72 0 0 0-3.73 4.45 12.71 12.71 0 0 0-.51 5.79c0 .45.09.88.14 1.27l.27 2-2-.27c-.39 0-.81-.1-1.27-.14a12.71 12.71 0 0 0-5.79.51 12.72 12.72 0 0 0-4.4 3.69c-.29.35-.56.69-.79 1zM11.72 34a13 13 0 0 1 5 .84A14.92 14.92 0 0 1 22 39a14.92 14.92 0 0 1 5.29-4.21A14.88 14.88 0 0 1 34 34a14.88 14.88 0 0 1 .77-6.73A14.92 14.92 0 0 1 39 22a14.92 14.92 0 0 1-4.21-5.29A14.88 14.88 0 0 1 34 10a14.88 14.88 0 0 1-6.73-.77A14.92 14.92 0 0 1 22 5a14.92 14.92 0 0 1-5.29 4.21A14.88 14.88 0 0 1 10 10a14.88 14.88 0 0 1-.77 6.73A14.92 14.92 0 0 1 5 22a14.92 14.92 0 0 1 4.21 5.29A14.88 14.88 0 0 1 10 34h1.72z" fill="#195f28"></path>
            <path d="M18.14 15.57c0-1.42.87-2.57 1.93-2.57S22 14.15 22 15.57c0-1.42.86-2.57 1.93-2.57s1.93.64 1.93 2.57a6.86 6.86 0 0 1-1.36 3.93 6.86 6.86 0 0 1 3.93-1.36c1.42 0 2.57.87 2.57 1.93S29.85 22 28.43 22c1.42 0 2.57.86 2.57 1.93s-.64 1.93-2.57 1.93a6.86 6.86 0 0 1-3.93-1.36 6.86 6.86 0 0 1 1.36 3.93c0 1.42-.87 2.57-1.93 2.57S22 29.85 22 28.43c0 1.42-.86 2.57-1.93 2.57s-1.93-.64-1.93-2.57a6.86 6.86 0 0 1 1.36-3.93 6.86 6.86 0 0 1-3.93 1.36c-1.42 0-2.57-.86-2.57-1.93S14.15 22 15.57 22c-1.42 0-2.57-.86-2.57-1.93s.64-1.93 2.57-1.93a6.86 6.86 0 0 1 3.93 1.36 6.86 6.86 0 0 1-1.36-3.93z" fill="#ef2e7f" fill-rule="evenodd"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="font-color">
            <path fill="#665c54" d="M0 0h44v44H0z"></path>
        </symbol>






        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C12">
        <title>C12</title>
        <path  style="display:inline;fill:#293FC5;" d="M26.1,22.2l4.5-1
		L26,20.5l3.8-2.7l-4.5,1.1l2.5-3.9L24,17.8l0.8-4.6l-2.4,4l-1-4.5l-0.7,4.6l-2.7-4l1.1,4.5l-3.9-2.5l2.8,3.8l-4.6-0.8l4,2.4l-4.5,1
		l4.6,0.7l-3.8,2.7l4.5-1.1l-2.5,3.9l3.8-2.8l-0.8,4.6l2.4-4l1,4.5l0.7-4.6l2.7,3.8l-1.1-4.5l3.9,2.5l-2.8-3.8l4.6,0.8L26.1,22.2z
		 M21.7,24.3c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8s2.8,1.2,2.8,2.8C24.5,23,23.2,24.3,21.7,24.3z"/>
        </symbol>

        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C11">
        <title>C11</title>
        <path  style="display:inline;fill:#293FC5;" d="M26.8,18.1l-3.1-2.3
		h-3.9l-3.1,2.3l-1.2,3.7l1.2,3.7l3.1,2.3h3.9l3.1-2.3l1.2-3.7L26.8,18.1z M25.5,23.9l-2.2-0.6l0.6,2.2l-1.6-1.7l-0.6,2.3l-0.6-2.3
		l-1.6,1.7l0.6-2.2l-2.2,0.6l1.7-1.6l-2.3-0.6l2.3-0.6l-1.7-1.6l2.2,0.6L19.5,18l1.6,1.7l0.6-2.3l0.6,2.3l1.6-1.7l-0.6,2.2l2.2-0.6
		l-1.7,1.6l2.3,0.6l-2.3,0.6L25.5,23.9z"/>
        </symbol>

        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C10">
        <title>C10</title>
        <g  style="display:inline;">
		<path style="fill:#293FC5;" d="M21.7,18.8c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S22.9,18.8,21.7,18.8z"/>
		<path style="fill:#293FC5;" d="M32.8,20.9c0,0-1.1-4.8-7.6-3.6V17c0,0,1.1-4.9-3.5-7.3l0,0l0,0l0,0l0,0c-0.1,0-4.8,1.2-3.6,7.6
			h-0.3c0,0-4.9-1.1-7.3,3.5l0,0l0,0l0,0l0,0c0,0.1,1.2,4.8,7.6,3.6v0.3c0,0-1.1,4.9,3.5,7.3v-0.1V32c0,0,4.8-1.1,3.6-7.6h0.3
			C25.5,24.4,30.4,25.5,32.8,20.9L32.8,20.9L32.8,20.9z M27.3,21.3h-2.9c-0.1,1.3-1.1,2.3-2.4,2.5v2.8h-0.5v-2.8
			c-1.3-0.1-2.3-1.2-2.4-2.5h-3v-0.5h3c0.1-1.3,1.2-2.3,2.5-2.4v-3.3H22v3.3l0,0c1.3,0.1,2.3,1.2,2.4,2.4h2.9V21.3z"/>
	</g>
        </symbol>

        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C9">
        <title>C9</title>
        <g  style="display:inline;">
		<path style="fill:#293FC5;" d="M30.3,16v2.8h-5.7v-5.5h3.1v-2.5H16.1v2.5h2.8v5.5h-6.1V16h-2.5v11.6h2.5v-2.9h6.1V31h-2.8v2.5
			h11.6V31h-3.1v-6.2h5.7v2.9h2.5V16H30.3z M25.9,23.8h-2.7v2.7h-3.4v-2.7h-2.7v-3.4h2.7v-2.7h3.4v2.7h2.7V23.8z"/>
		<polygon style="fill:#293FC5;" points="24.6,21.5 22.3,21.5 22.3,18.9 20.7,18.9 20.7,21.5 18.3,21.5 18.3,22.9 20.7,22.9 
			20.7,25.4 22.3,25.4 22.3,22.9 24.6,22.9 		"/>
	</g>
        </symbol>


        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C8">
        <title>C8</title>
        <g style="display:inline;">
		<path style="fill:#293FC5;" d="M21.9,10.3c-6.2,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
			C33,15.3,28,10.3,21.9,10.3z M21.9,30.9c-5.2,0-9.5-4.2-9.5-9.5c0-5.2,4.2-9.5,9.5-9.5s9.5,4.2,9.5,9.5
			C31.4,26.6,27.1,30.9,21.9,30.9z"/>
		<path style="fill:#293FC5;" d="M21.9,13c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5S26.6,13,21.9,13z
			 M22.1,25.4c-2.3,0-4.1-1.9-4.1-4.1s1.9-4.1,4.1-4.1c2.3,0,4.1,1.9,4.1,4.1S24.4,25.4,22.1,25.4z"/>
	</g>
        </symbol>



        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C7">
        <title>C7</title>
    	<g style="display:inline;">
		<path  style="fill:#293FC5;" d="M21.8,10.5c-6.2,0-11.1,5-11.1,11.1
			s5,11.1,11.1,11.1s11.1-5,11.1-11.1S27.9,10.5,21.8,10.5z M27.5,27.3l-3.4-0.1l-2.3,2.5l-2.3-2.5l-3.4,0.1l0.1-3.4l-2.5-2.3
			l2.5-2.3L16,15.9l3.4,0.1l2.3-2.5L24,16l3.4-0.1l-0.1,3.4l2.5,2.3l-2.4,2.3L27.5,27.3z"/>
		<polygon  style="fill:#293FC5;" points="21.8,14.8 23.7,16.9 
			26.5,16.8 26.5,19.7 28.5,21.6 26.5,23.6 26.5,26.4 23.7,26.3 21.8,28.4 19.8,26.3 17,26.4 17.1,23.6 15,21.6 17.1,19.7 17,16.8 
			19.8,16.9 		"/>
	</g>
        </symbol>


        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C6">
        <title>C6</title>
        <g  style="display:inline;">
		<path style="fill:#293FC5;" d="M28.7,17.3l-1.4-2l-2-1.4L23,13.2h-2.4l-2.3,0.8l-2,1.4l-1.4,2l-0.8,2.3v2.4l0.8,2.3l1.4,2l2,1.4
			l2.3,0.8H23l2.3-0.8l2-1.4l1.4-2l0.8-2.3v-2.4L28.7,17.3z M28.5,22l-0.7,2l-1.3,1.7l-1.7,1.2l-2,0.6l-2.2,0l-2-0.7L17,25.6
			l-1.2-1.7l-0.6-2l0-2.1l0.7-2l1.3-1.7l1.7-1.2l2-0.6l2.1,0l2,0.7l1.7,1.3l1.2,1.7l0.6,2L28.5,22z"/>
		<path style="fill:#293FC5;" d="M27.3,18l-1.1-1.6l-1.6-1.1l-1.8-0.6h-1.9L19,15.3l-1.6,1.1L16.3,18l-0.6,1.8v1.9l0.6,1.8l1.1,1.6
			l1.6,1.1l1.8,0.6h1.9l1.8-0.6l1.6-1.1l1.1-1.6l0.6-1.8v-1.9L27.3,18z M25.2,22l-1.8-0.3l1.3,1.3l-1.6-0.8l0.8,1.6l-1.3-1.3
			l0.3,1.8l-0.8-1.6l-0.3,1.8l-0.3-1.8l-0.8,1.6l0.3-1.8l-1.3,1.3l0.8-1.6L18.9,23l1.3-1.3L18.4,22l1.6-0.8l-1.8-0.3l1.8-0.3
			l-1.6-0.8l1.8,0.3l-1.3-1.3l1.6,0.8L19.7,18l1.3,1.3l-0.3-1.8l0.8,1.6l0.3-1.8l0.3,1.8l0.8-1.6l-0.3,1.8l1.3-1.3l-0.8,1.6l1.6-0.8
			L23.4,20l1.8-0.3l-1.6,0.8l1.8,0.3l-1.8,0.3L25.2,22z"/>
	</g>
        </symbol>

        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C5">
        <title>C5</title>
    	<g  style="display:inline;">
		<path style="fill:#293FC5;" d="M21.7,23.2c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S23.1,23.2,21.7,23.2z"/>
		<circle style="fill:#293FC5;" cx="17.9" cy="21.5" r="2.5"/>
		<path style="fill:#293FC5;" d="M21.7,22.7c0.5,0,0.9,0.1,1.3,0.3c-0.3-0.5-0.5-1-0.5-1.6c0-0.5,0.1-0.9,0.3-1.3
			c-0.3,0.1-0.7,0.2-1.1,0.2c-0.5,0-0.9-0.1-1.3-0.3c0.3,0.4,0.4,0.9,0.4,1.5c0,0.5-0.1,1-0.4,1.4C20.9,22.8,21.3,22.7,21.7,22.7z"
			/>
		<circle style="fill:#293FC5;" cx="21.8" cy="17.4" r="2.5"/>
		<path style="fill:#293FC5;" d="M26.4,17.3c-0.2,0-0.5,0-0.7,0.1c0-0.2,0.1-0.4,0.1-0.6c0-2.3-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1
			c0,0.2,0,0.4,0.1,0.6c-0.2,0-0.4-0.1-0.5-0.1c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1,4.1,4.1c0.2,0,0.4,0,0.6-0.1
			c-0.1,0.3-0.1,0.6-0.1,0.8c0,2.3,1.8,4.1,4.1,4.1s4.1-1.8,4.1-4.1c0-0.3,0-0.6-0.1-0.9c0.2,0,0.5,0.1,0.7,0.1
			c2.3,0,4.1-1.8,4.1-4.1S28.7,17.3,26.4,17.3z M25.6,24.5c-0.5,0-0.9-0.1-1.3-0.3c0.3,0.5,0.5,1,0.5,1.6c0,1.7-1.3,3-3,3
			s-3-1.3-3-3c0-0.5,0.1-1,0.4-1.4c-0.4,0.2-0.8,0.2-1.2,0.2c-1.7,0-3-1.3-3-3s1.3-3,3-3c0.5,0,0.9,0.1,1.3,0.3
			c-0.3-0.4-0.4-0.9-0.4-1.5c0-1.7,1.3-3,3-3s3,1.3,3,3c0,0.5-0.1,0.9-0.3,1.3c0.3-0.1,0.7-0.2,1.1-0.2c1.7,0,3,1.3,3,3
			C28.6,23.1,27.3,24.5,25.6,24.5z"/>
		<path style="fill:#293FC5;" d="M25.6,19c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S27,19,25.6,19z"/>
	</g>
        </symbol>


        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C4">
        <title>C4</title>
        <g  style="display:inline;">
		<path style="fill:#293FC5;" d="M30,18.3l-4.9-4.9V8.5h-6.4v5.1
			c-1,1-3.2,3.2-4.8,4.7h-5v7.2h4.7l5.2,6.4v3.3h6.4V31l5.6-5.6h4.3v-7.2L30,18.3L30,18.3z M27.3,24.3l-2.9,2.9l-2.5-2.4l-2.4,2.4
			l-2.9-2.9l2.4-2.4l-2.4-2.4l2.9-2.9l2.4,2.4l2.4-2.4l2.9,2.9l-2.4,2.4L27.3,24.3z"/>
		<polygon  style="fill:#293FC5;" points="26,19.4 24.5,17.9 21.9,20.4 
			19.4,17.9 17.9,19.4 20.4,21.9 17.9,24.5 19.4,26 21.9,23.4 24.5,26 26,24.5 23.4,21.9 		"/>
	</g>
	
        </symbol>

        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C3">
        <title>C3</title>
        <g  style="display:inline;">
		<path style="fill:#293FC5;" d="M25.6,18.1l-4.2-9.5l-4.3,9.8l-8.8,3.7l9.2,4.3l3.9,8.9l4.3-9l9.3-4.1L25.6,18.1z M25.3,25.3h-7.2
			v-6.8h7.2V25.3z"/>
		<g>
			<rect x="19.8" y="20" style="fill:#293FC5;" width="3.9" height="4"/>
			<g>
				<g>
					<polygon style="fill:#293FC5;" points="26.7,16.8 28.1,12.9 32.1,11.6 30.7,15.5 					"/>
				</g>
				<polygon style="fill:#293FC5;" points="16.6,16.9 15.2,13 11.1,11.7 12.6,15.6 				"/>
			</g>
			<g>
				<polygon style="fill:#293FC5;" points="16.3,27.2 14.9,31.1 10.8,32.4 12.3,28.5 				"/>
				<polygon style="fill:#293FC5;" points="26.4,27.1 27.8,31 31.8,32.4 30.4,28.5 				"/>
			</g>
		</g>
	</g>
        </symbol>

        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2">
        <title>C2</title>
        <g  style="display:inline;">
		<path style="fill:#293FC5;" d="M21.8,9.7C18.3,15.4,9.2,22,9.2,22c5.1,3.5,12.6,12.8,12.6,12.8C27.7,26.6,35,22,35,22
			C29.1,18.9,21.8,9.7,21.8,9.7z M24.4,23v5.1h-5.1V23h-4.6v-1h4.6v-5.1h5.1V22h4.4v1H24.4z"/>
		<rect x="20.7" y="18.5" style="fill:#293FC5;" width="2.3" height="8"/>
	</g>
        </symbol>
    
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1">
        <title>C1</title>
      
        <g  style="display:inline;">
		<path  style="fill:#293FC5;" d="M28.9,19.4L24.5,15v-2.9h-5.3v3.1c-0.2,0-4.2,4.2-4.2,4.2h-2.5v4.9h2.4l4.6,4.6v2.4h5.1
			v-2.7l4.4-4.4h2.4v-4.9L28.9,19.4L28.9,19.4z M25.6,24l-1.7,1.7l-2.1-2.1l-2.1,2.1L17.9,24l2.1-2.1l-2.2-2.2l1.7-1.7l2.2,2.2
			l2.2-2.2l1.7,1.7l-2.2,2.2L25.6,24z"/>
		<polygon style="fill:#293FC5;" points="24.7,24 22.5,21.8 24.6,19.7 23.9,18.9 21.7,21.1 19.6,18.9 18.8,19.7 21,21.8 
			18.8,24 19.5,24.8 21.7,22.6 23.9,24.8 		"/>
	</g>
        </symbol>



        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12">
        <title>B12</title>
    	<polygon  style="display:inline;fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="
		29.9,31.5 26,33.7 21.6,34.4 17.2,33.6 13.4,31.4 10.5,27.9 9,23.7 9.1,19.3 10.6,15.1 13.5,11.7 17.4,9.5 21.8,8.8 26.2,9.6 
		30,11.8 32.9,15.3 34.4,19.5 34.3,23.9 32.8,28.1 	"/>
        </symbol>

        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11">
        <title>B11</title>
     
		<polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="
		26.6,7.7 17.4,7.7 10.1,13.1 7.2,21.8 10.1,30.4 17.4,35.8 26.6,35.8 33.9,30.4 36.8,21.8 33.9,13.1 	"/>
        </symbol>

        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10">
        <title>B10</title>
		<path style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" d="M37,20.9c0,0-1.5-6.5-10.3-4.9v-0.4
			c0,0,1.5-6.7-4.8-9.9l0,0l0,0l0,0l0,0c-0.1,0-6.5,1.6-4.9,10.3h-0.4c0,0-6.7-1.5-9.9,4.8l0,0l0,0l0,0l0,0c0,0.1,1.6,6.5,10.3,4.9
			v0.4c0,0-1.5,6.7,4.8,9.9l0,0l0,0c0,0,6.5-1.5,4.9-10.3H27C27,25.7,33.7,27.2,37,20.9L37,20.9L37,20.9z"/>
        </symbol>


        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9">
        <title>B9</title>
    
		<polygon  style="display:inline;fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="
		31.5,12.1 31.5,4.9 12.1,4.9 12.1,12.1 5.6,12.1 5.6,31.5 12.1,31.5 12.1,37.6 31.4,37.6 31.4,31.5 38.6,31.5 38.6,12.1 	"/>
        </symbol>


        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8">
        <title>B8</title>
        <path style="display:inline;fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" d="
		M38.6,12.1h-3.7c0,0,0-0.1,0-0.1c0-1.9-1.5-3.5-3.4-3.5V4.9H12.1v3.5c-0.1,0-0.2,0-0.3,0c-2,0-3.5,1.6-3.5,3.5c0,0,0,0.1,0,0.1H5.6
		v19.4h3c0,0,0,0,0,0c0,1.9,1.6,3.5,3.5,3.5v2.6h19.3V35c0.1,0,0.2,0,0.3,0c2,0,3.5-1.6,3.5-3.5c0,0,0,0,0,0h3.4V12.1z"/>
        </symbol>


        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7">
        <title>B7</title>
        <path  style="display:inline;fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" d="
		M36.9,13.8c-4.1,0-7.5-3.3-7.5-7.5c0-0.6,0.1-1.2,0.2-1.8H14.2c0.1,0.6,0.2,1.2,0.2,1.8c0,4.1-3.3,7.5-7.5,7.5
		c-0.5,0-0.9,0-1.4-0.1v15.9c0.5-0.1,0.9-0.1,1.4-0.1c4.1,0,7.5,3.3,7.5,7.5c0,0.2,0,0.4,0,0.6h15.1c0-0.2,0-0.4,0-0.6
		c0-4.1,3.3-7.5,7.5-7.5c0.6,0,1.1,0.1,1.6,0.2v-16C38,13.7,37.4,13.8,36.9,13.8z"/>
        </symbol>


        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6">
        <title>B6</title>
        <polygon  style="display:inline;fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="
		14.8,7.6 29.1,7.6 36.2,14.7 36.2,28.7 29.2,35.7 14.5,35.7 7.8,29 7.8,14.5 	"/>
        </symbol>

        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5">
        <title>B5</title>
        <path style="display:inline;fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" d="
		M30.1,14c-0.2,0-0.5,0-0.7,0c0-0.1,0-0.2,0-0.3c0-4.1-3.3-7.5-7.5-7.5c-4.1,0-7.5,3.3-7.5,7.5c0,0.1,0,0.1,0,0.2
		c-0.2,0-0.5,0-0.7,0c-4.1,0-7.5,3.3-7.5,7.5s3.3,7.5,7.5,7.5c0.2,0,0.4,0,0.6,0c0,0.3-0.1,0.6-0.1,0.9c0,4.1,3.3,7.5,7.5,7.5
		s7.5-3.3,7.5-7.5c0-0.3,0-0.5,0-0.8c0.3,0,0.6,0.1,0.9,0.1c4.1,0,7.5-3.3,7.5-7.5S34.2,14,30.1,14z"/>
        </symbol>


        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4">
        <title>B4</title>
        <circle  style="display:inline;fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" cx="22.1" cy="21.8" r="16.9"/>
        </symbol>

        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3">
        <title>B3</title>
        <g>
        <polygon  style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="
		14.3,14.2 7.6,10.9 7.6,31.6 14.5,29.2 12.1,36.2 32,36.2 29.5,29.3 36.4,31.4 36.4,11.8 29.3,14.6 31.6,7.4 13,7.4 	"/>
    </g>
        </symbol>






        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2">
        <title>B2</title>
  
		<polygon style="display:inline;fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="
		7.6,24.6 7.6,14.2 10.4,11.8 14.3,14.2 12.8,9.7 14.3,7.6 29.4,7.6 31.1,9.2 29.4,14.3 34.3,12.2 36.4,14.3 36.4,24 36.4,24.4 
		36.4,29.5 33.4,32 29.6,29.6 31.1,34.1 29.6,36.2 14.5,36.2 12.8,34.6 14.5,29.5 9.5,31.6 7.6,29.5 7.6,24.9 	"/>
        </symbol>




        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1">
        <title>B1</title>
        <g>
        <path style="fill:#293FC5;" d="M29.5,36.2h-15v-7H7.6v-15h6.7V7.6h15.1v6.7h7v15h-6.9C29.5,29.3,29.5,36.2,29.5,36.2z M15,35.7
            h13.9v-6.9h6.9V14.9h-7V8.1h-14v6.7H8.1v13.9H15V35.7z"/>
    </g>
        </symbol>











        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9">
<title>A9</title>
<g  style="display:inline;">
		<g>
			<rect x="15.2" y="1.1" style="fill:#293FC5;" width="13.2" height="0.5"/>
		</g>
		<g>
			<rect x="41.9" y="16" style="fill:#293FC5;" width="0.5" height="12.1"/>
		</g>
		<g>
			<rect x="1.3" y="16.2" style="fill:#293FC5;" width="0.5" height="11.6"/>
		</g>
		<g>
			<rect x="15" y="41.9" style="fill:#293FC5;" width="13.4" height="0.5"/>
		</g>
		<g>
			<g>
				
					<rect x="32.4" y="4.1" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" width="9.7" height="2.7"/>
				
					<rect x="37.8" y="1.4" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" width="2.6" height="10.7"/>
			</g>
			<g>
				
					<rect x="1.4" y="4" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" width="9.7" height="2.7"/>
				
					<rect x="3" y="1.3" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" width="2.6" height="10.7"/>
			</g>
		</g>
		<g>
			<g>
				
					<rect x="1.3" y="37.2" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" width="9.7" height="2.7"/>
				
					<rect x="3.1" y="32" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" width="2.6" height="10.7"/>
			</g>
			<g>
				
					<rect x="32.4" y="37.3" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" width="9.7" height="2.7"/>
				
					<rect x="37.8" y="31.9" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" width="2.6" height="10.7"/>
			</g>
		</g>
	</g>
</symbol>



        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8">
<title>A8</title>
<g  style="display:inline;">
<g>
    <rect x="15.2" y="1.1" style="fill:#293FC5;" width="13.2" height="0.5"/>
</g>
<g>
    <rect x="41.9" y="16" style="fill:#293FC5;" width="0.5" height="12.1"/>
</g>
<g>
    <rect x="1.3" y="16.2" style="fill:#293FC5;" width="0.5" height="11.6"/>
</g>
<g>
    <g>
        <polyline style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" points="42.9,6 
            40.7,3.8 35.5,9 38.2,11.7 40.6,9.3 34.1,2.8 31.6,5.3 34.3,8 39.6,2.7 37.3,0.4 				"/>
        <polyline style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" points="0.5,6 
            2.8,3.8 8,9 5.3,11.7 2.8,9.3 9.4,2.8 11.9,5.3 9.2,8 3.9,2.7 6.2,0.4 				"/>
    </g>
    <g>
        <polyline style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" points="0.8,37.3 
            3,39.6 8.3,34.3 5.6,31.6 3.1,34.1 9.6,40.6 12.1,38.1 9.4,35.4 4.1,40.7 6.4,43 				"/>
        <polyline style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;" points="43.2,37.3 
            41,39.6 35.7,34.3 38.4,31.6 40.9,34.1 34.4,40.6 31.9,38.1 34.6,35.4 39.9,40.7 37.6,43 				"/>
    </g>
</g>
<g>
    <rect x="15" y="41.9" style="fill:#293FC5;" width="13.4" height="0.5"/>
</g>
</g>
</symbol>

    
<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7">
<title>A7</title>
<g  style="display:inline;">
<g>
    <rect x="15.3" y="1" style="fill:#293FC5;" width="13.2" height="0.5"/>
</g>
<g>
    <rect x="42" y="15.9" style="fill:#293FC5;" width="0.5" height="12.1"/>
</g>
<g>
    <rect x="1.4" y="16.1" style="fill:#293FC5;" width="0.5" height="11.6"/>
</g>
<g>
    <rect x="15.1" y="41.8" style="fill:#293FC5;" width="13.4" height="0.5"/>
</g>
<g>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="1.4,1 1.4,13.5 6.9,7.9 4.1,3.5 
        8.5,6.3 10.6,4.2 13.8,1 			"/>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="42.4,1 42.4,13.5 36.9,7.9 39.7,3.5 
        35.3,6.3 33.2,4.2 30,1 			"/>
</g>
<g>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="1.4,42.4 1.4,29.9 6.9,35.5 4,39.9 
        8.4,37.1 10.5,39.2 13.7,42.4 			"/>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="42.3,42.4 42.3,29.9 36.8,35.5 
        39.7,39.9 35.3,37.1 33.2,39.2 30,42.4 			"/>
</g>
</g>
</symbol>
      
<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6">
<title>A6</title>
<g style="display:inline;">
<g>
    <rect x="15.2" y="1.1" style="fill:#293FC5;" width="13.2" height="0.5"/>
</g>
<g>
    <rect x="41.9" y="16" style="fill:#293FC5;" width="0.5" height="12.1"/>
</g>
<g>
    <rect x="1.3" y="16.2" style="fill:#293FC5;" width="0.5" height="11.6"/>
</g>
<g>
    <rect x="15" y="41.9" style="fill:#293FC5;" width="13.4" height="0.5"/>
</g>
<g>
    <g>
        <g>
            <rect x="32.3" y="1.1" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" width="10.1" height="10.1"/>
            <rect x="35.7" y="4.6" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" width="3.2" height="3.2"/>
        </g>
        <g>
            <rect x="1.3" y="1.1" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" width="10.1" height="10.1"/>
            <rect x="4.8" y="4.6" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" width="3.2" height="3.2"/>
        </g>
    </g>
    <g>
        <g>
            
                <rect x="32.2" y="32.2" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" width="10.1" height="10.1"/>
            <rect x="35.7" y="35.7" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" width="3.2" height="3.2"/>
        </g>
        <g>
            <rect x="1.3" y="32.2" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" width="10.1" height="10.1"/>
            <rect x="4.7" y="35.7" style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" width="3.2" height="3.2"/>
        </g>
    </g>
</g>
</g>
</symbol>
      
  
<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5">
<title>A5</title>
<g  style="display:inline;">
<g>
    <rect x="15.2" y="1.1" style="fill:#293FC5;" width="13.2" height="0.5"/>
</g>
<g>
    <rect x="41.9" y="16" style="fill:#293FC5;" width="0.5" height="12.1"/>
</g>
<g>
    <rect x="1.3" y="16.2" style="fill:#293FC5;" width="0.5" height="11.6"/>
</g>
<g>
    <rect x="15" y="41.9" style="fill:#293FC5;" width="13.4" height="0.5"/>
</g>
<g>
    <g>
        <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="1.3,13.6 1.3,1.1 13.7,1.1 10.1,4.5 
            5.1,3 8.4,5.8 5.6,8.8 3.1,5.1 4.7,10.2 				"/>
        <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="42.4,13.6 42.4,1.1 30,1.1 33.6,4.5 
            38.6,3 35.3,5.8 38.1,8.8 40.6,5.1 39,10.2 				"/>
    </g>
    <g>
        <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="42.6,29.9 42.6,42.4 30.2,42.4 
            33.8,39 38.8,40.5 35.5,37.7 38.3,34.7 40.8,38.4 39.2,33.3 				"/>
        <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="1.5,29.9 1.5,42.4 13.9,42.4 
            10.3,39 5.3,40.5 8.6,37.7 5.8,34.7 3.3,38.4 4.9,33.3 				"/>
    </g>
</g>
</g>
</symbol>
      
    
<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4">
<title>A4</title>
<g style="display:inline;">
<g>
    <rect x="15.2" y="1.1" style="fill:#293FC5;" width="13.2" height="0.5"/>
</g>
<g>
    <rect x="41.9" y="16" style="fill:#293FC5;" width="0.5" height="12.1"/>
</g>
<g>
    <rect x="1.3" y="16.2" style="fill:#293FC5;" width="0.5" height="11.6"/>
</g>
<g>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="13.7,1.1 1.3,1.1 1.3,13.6 6.5,8.3 
        9.4,9 8.6,6.2 10.5,4.3 			"/>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="29.8,1.1 42.2,1.1 42.2,13.6 37,8.3 
        34.1,9 34.9,6.2 33,4.3 			"/>
</g>
<g>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="13.7,42.4 1.3,42.4 1.3,29.9 
        6.6,35.2 9.5,34.5 8.6,37.3 10.5,39.2 			"/>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="29.8,42.4 42.2,42.4 42.2,29.9 
        37,35.2 34.1,34.5 34.9,37.3 33,39.2 			"/>
</g>
<g>
    <rect x="15" y="41.9" style="fill:#293FC5;" width="13.4" height="0.5"/>
</g>
</g>
</symbol>
      
<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3">
<title>A3</title>
<g  style="display:inline;">
<g>
    <rect x="15.2" y="1.1" style="fill:#293FC5;" width="13.2" height="0.5"/>
</g>
<g>
    <rect x="41.9" y="16" style="fill:#293FC5;" width="0.5" height="12.1"/>
</g>
<g>
    <rect x="1.3" y="16.2" style="fill:#293FC5;" width="0.5" height="11.6"/>
</g>
<g>
    <rect x="15" y="41.9" style="fill:#293FC5;" width="13.4" height="0.5"/>
</g>
<g>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="42.3,30 42.3,42.5 29.9,42.5 
        33.1,39.3 			"/>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="1.3,30 1.3,42.5 13.7,42.5 10.5,39.3 
                    "/>
</g>
<g>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="1.3,13.6 1.3,1.1 13.7,1.1 10.5,4.3 
                    "/>
    <polygon style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" points="42.3,13.6 42.3,1.1 29.9,1.1 
        33.1,4.3 			"/>
</g>
</g>

</symbol>
      
  
<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2">
<title>A2</title>
<g style="display:inline;">
<g>
    <rect x="15.2" y="1.1" style="fill:#293FC5;" width="13.2" height="0.5"/>
</g>
<g>
    <rect x="41.9" y="16" style="fill:#293FC5;" width="0.5" height="12.1"/>
</g>
<g>
    <rect x="1.3" y="16.2" style="fill:#293FC5;" width="0.5" height="11.6"/>
</g>
<g>
    <rect x="15" y="41.9" style="fill:#293FC5;" width="13.4" height="0.5"/>
</g>
<g>
    <path style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" d="M10.5,4.3l3.2-3.2H1.3v12.2v0.3l3.4-3.4
        c0.8,0.8,1.8,1.3,3,1.3c2.3,0,4.2-1.9,4.2-4.2C11.9,6.1,11.4,5,10.5,4.3z"/>
    <path style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" d="M33.1,4.3L30,1.1h12.4v12.2v0.3L39,10.2
        c-0.8,0.8-1.8,1.3-3,1.3c-2.3,0-4.2-1.9-4.2-4.2C31.8,6.1,32.3,5,33.1,4.3z"/>
</g>
<g>
    <path style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" d="M33.3,39.2l-3.2,3.2h12.4V30.2v-0.3l-3.4,3.4
        c-0.8-0.8-1.8-1.3-3-1.3c-2.3,0-4.2,1.9-4.2,4.2C31.9,37.4,32.4,38.4,33.3,39.2z"/>
    <path style="fill:none;stroke:#293FC5;stroke-width:0.5;stroke-miterlimit:10;" d="M10.7,39.2l3.2,3.2H1.5V30.2v-0.3l3.4,3.4
        c0.8-0.8,1.8-1.3,3-1.3c2.3,0,4.2,1.9,4.2,4.2C12,37.4,11.5,38.4,10.7,39.2z"/>
</g>
</g>
</symbol>


      
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1">
            <title>A1</title>
       
        	<g  style="display:inline;">
		<path style="fill:#293FC5;" d="M40.1,4.2c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.3-0.1-0.4,0l-4.3,4.4L34.3,7c0.2-0.3,0.3-0.6,0.3-1
			c0-0.9-0.7-1.7-1.7-1.7S31.2,5,31.2,6s0.7,1.7,1.7,1.7c0.4,0,0.7-0.1,1-0.3L35,8.6L33.6,10c-0.3-0.2-0.6-0.3-0.9-0.3
			c-0.9,0-1.7,0.7-1.7,1.7c0,0.9,0.7,1.7,1.7,1.7c0.9,0,1.7-0.7,1.7-1.7c0-0.4-0.1-0.7-0.3-1L35.4,9l1.3,1.4
			c-0.2,0.3-0.2,0.5-0.2,0.9c0,0.9,0.7,1.7,1.7,1.7s1.7-0.7,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7c-0.4,0-0.8,0.1-1.1,0.4l-1.3-1.4
			L40.1,4.2z"/>
		<path style="fill:#293FC5;" d="M4.3,4.2c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0L9,8.3l1.1-1.2c-0.2-0.3-0.3-0.6-0.3-1
			c0-0.9,0.7-1.7,1.7-1.7c0.9,0,1.7,0.7,1.7,1.7s-0.7,1.7-1.7,1.7c-0.4,0-0.7-0.1-1-0.3L9.4,8.6l1.4,1.4c0.3-0.2,0.6-0.3,0.9-0.3
			c0.9,0,1.7,0.7,1.7,1.7c0,0.9-0.7,1.7-1.7,1.7S10,12.3,10,11.4c0-0.4,0.1-0.7,0.3-1L9,9l-1.3,1.4C7.9,10.7,8,11,8,11.3
			C8,12.2,7.3,13,6.3,13s-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7c0.4,0,0.8,0.1,1.1,0.4l1.3-1.4L4.3,4.2z"/>
		<path style="fill:#293FC5;" d="M4.1,40.1c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.3,0.1,0.4,0l4.3-4.4l1.1,1.2c-0.2,0.3-0.3,0.6-0.3,1
			c0,0.9,0.7,1.7,1.7,1.7c0.9,0,1.7-0.7,1.7-1.7s-0.7-1.7-1.7-1.7c-0.4,0-0.7,0.1-1,0.3l-1.1-1.2l1.4-1.4c0.3,0.2,0.6,0.3,0.9,0.3
			c0.9,0,1.7-0.7,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7S9.8,32,9.8,32.9c0,0.4,0.1,0.7,0.3,1l-1.3,1.4l-1.3-1.4c0.2-0.3,0.2-0.5,0.2-0.9
			c0-0.9-0.7-1.7-1.7-1.7S4.4,32.1,4.4,33s0.7,1.7,1.7,1.7c0.4,0,0.8-0.1,1.1-0.4l1.3,1.4L4.1,40.1z"/>
		<path style="fill:#293FC5;" d="M39.9,40.1c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.3,0.1-0.4,0l-4.3-4.4L34,37.3c0.2,0.3,0.3,0.6,0.3,1
			c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7s0.7-1.7,1.7-1.7c0.4,0,0.7,0.1,1,0.3l1.1-1.2l-1.4-1.4c-0.3,0.2-0.6,0.3-0.9,0.3
			c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7s1.7,0.7,1.7,1.7c0,0.4-0.1,0.7-0.3,1l1.3,1.4l1.3-1.4c-0.2-0.3-0.2-0.5-0.2-0.9
			c0-0.9,0.7-1.7,1.7-1.7s1.7,0.7,1.7,1.7s-0.7,1.7-1.7,1.7c-0.4,0-0.8-0.1-1.1-0.4l-1.3,1.4L39.9,40.1z"/>
		<rect x="3.6" y="15.8" style="fill:#293FC5;" width="0.5" height="12.3"/>
		<rect x="39.9" y="15.8" style="fill:#293FC5;" width="0.5" height="12.3"/>
		<rect x="15.8" y="39.9" style="fill:#293FC5;" width="12.3" height="0.5"/>
		<rect x="15.8" y="3.6" style="fill:#293FC5;" width="12.3" height="0.5"/>
	</g>
    
        </symbol>
    </svg>`,

        'symbols': {
            'Z': 3,
            'A': 9,
            'B': 12,
            'C': 12
        },

    },

    {
        'id': 4,
        'svg': `<svg width="0" height="0" class="hidden">
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1"><path fill="#e8f4d7" d="M0 0h44v44H0z"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2"><path fill="#c9ebd8" d="M0 0h44v44H0z"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3"><path fill="#b8e8d9" d="M0 0h44v44H0z"></path></symbol>
          
          <!-- A layer: Distinct base shapes -->
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1"><path d="M6,6 H38 V38 H6z" fill="#2a714d"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2"><path d="M22,6 L38,38 L6,38z" fill="#2a714d"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3"><path d="M6,22 L22,6 L38,22 L22,38z" fill="#2a714d"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4"><path d="M22,6 A16,16 0 1,0 22,38 A16,16 0 1,0 22,6" fill="#2a714d"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5"><path d="M6,6 L38,6 L22,38z" fill="#2a714d"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6"><path d="M6,6 L38,38 M38,6 L6,38" fill="none" stroke="#2a714d" stroke-width="4"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7"><path d="M6,16 H38 V28 H6z" fill="#2a714d"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8"><path d="M16,6 H28 V38 H16z" fill="#2a714d"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9"><path d="M12,6 A16,16 0 0,1 32,22 A16,16 0 0,1 12,38" fill="#2a714d"></path></symbol>
      
          <!-- B layer: Distinct line patterns -->
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1"><path d="M15,15 L29,29 M29,15 L15,29" stroke="#66c48f" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2"><path d="M22,15 v14 M15,22 h14" stroke="#66c48f" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3"><path d="M15,15 Q22,22 29,15 Q22,22 29,29 Q22,22 15,29 Q22,22 15,15" stroke="#66c48f" stroke-width="3" fill="none"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4"><path d="M15,22 h14 M18,18 h8 M18,26 h8" stroke="#66c48f" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5"><path d="M22,15 h-7 v14 h14 v-14 h-7" stroke="#66c48f" stroke-width="3" fill="none"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6"><path d="M15,15 C22,15 22,29 29,29" stroke="#66c48f" stroke-width="3" fill="none"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7"><path d="M15,22 C22,15 22,29 29,22" stroke="#66c48f" stroke-width="3" fill="none"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8"><path d="M15,22 L22,15 M22,15 L29,22 M29,22 L22,29 M22,29 L15,22" stroke="#66c48f" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9"><path d="M15,15 L29,15 M15,22 L29,22 M15,29 L29,29" stroke="#66c48f" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10"><path d="M15,15 L15,29 M22,15 L22,29 M29,15 L29,29" stroke="#66c48f" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11"><path d="M15,22 Q22,15 29,22 Q22,29 15,22" stroke="#66c48f" stroke-width="3" fill="none"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12"><path d="M22,15 L15,29 M22,15 L29,29" stroke="#66c48f" stroke-width="3"></path></symbol>
      
          <!-- C layer: Distinct small elements -->
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1">
      <!-- Main square in center -->
      <path d="M18,18 h8 v8 h-8z" fill="#ff4d94"></path>
      <!-- Corner squares -->
      <path d="M4,4 h4 v4 h-4z M36,4 h4 v4 h-4z M4,36 h4 v4 h-4z M36,36 h4 v4 h-4z" fill="#ff4d94"></path>
    </symbol>

    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2">
      <!-- Main circle in center -->
      <circle cx="22" cy="22" r="4" fill="#ff4d94"></circle>
      <!-- Corner circles -->
      <circle cx="6" cy="6" r="2" fill="#ff4d94"></circle>
      <circle cx="38" cy="6" r="2" fill="#ff4d94"></circle>
      <circle cx="6" cy="38" r="2" fill="#ff4d94"></circle>
      <circle cx="38" cy="38" r="2" fill="#ff4d94"></circle>
    </symbol>
        </svg>`,
        'symbols': {
          'Z': 3,
          'A': 9,
          'B': 12,
          'C': 2
        }
      },

      {
        'id': 5,
        'svg': `<svg width="0" height="0" class="hidden">
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1"><path fill="#ffecd9" d="M0 0h44v44H0z"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2"><path fill="#ffe0bc" d="M0 0h44v44H0z"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3"><path fill="#ffd4a0" d="M0 0h44v44H0z"></path></symbol>
          
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1"><path d="M10,10 A12,12 0 1,0 34,34 A12,12 0 1,0 10,10" fill="#8b4513"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2"><path d="M6,22 Q22,6 38,22 Q22,38 6,22" fill="#8b4513"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3"><path d="M22,6 Q6,22 22,38 Q38,22 22,6" fill="#8b4513"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4"><path d="M6,6 Q22,22 6,38 Q38,22 6,6" fill="#8b4513"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5"><path d="M38,6 Q22,22 38,38 Q6,22 38,6" fill="#8b4513"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6"><path d="M6,6 Q38,6 38,38 Q6,38 6,6" fill="#8b4513"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7"><path d="M6,38 Q38,38 38,6 Q6,6 6,38" fill="#8b4513"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8"><path d="M6,22 Q22,6 38,22 L22,38z" fill="#8b4513"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9"><path d="M22,6 Q38,22 22,38 L6,22z" fill="#8b4513"></path></symbol>
      
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1"><path d="M18,18 Q22,14 26,18 Q30,22 26,26 Q22,30 18,26 Q14,22 18,18" stroke="#4b0082" fill="none" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2"><path d="M18,18 S22,26 26,18 S22,14 18,18" stroke="#4b0082" fill="none" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3"><path d="M18,22 Q22,18 26,22 T18,22" stroke="#4b0082" fill="none" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4"><path d="M18,18 Q22,22 26,18 T18,26 T26,26 T18,18" stroke="#4b0082" fill="none" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5"><path d="M18,18 H26 M18,22 H26 M18,26 H26" stroke="#4b0082" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6"><path d="M18,18 V26 M22,18 V26 M26,18 V26" stroke="#4b0082" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7"><path d="M18,18 L26,26 M26,18 L18,26" stroke="#4b0082" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8"><path d="M22,18 L26,22 L22,26 L18,22 Z" stroke="#4b0082" fill="none" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9"><path d="M18,22 H26 M22,18 V26" stroke="#4b0082" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10"><path d="M20,20 A2,2 0 1,0 24,24 A2,2 0 1,0 20,20" stroke="#4b0082" fill="none" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11"><path d="M18,22 Q22,18 26,22 M18,26 Q22,22 26,26" stroke="#4b0082" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12"><path d="M22,18 L26,22 M22,26 L18,22" stroke="#4b0082" stroke-width="2"></path></symbol>
      
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1"><path d="M19,19 h6 l-3,6 z" fill="#daa520"></path></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2"><path d="M19,19 l6,3 l-6,3 z" fill="#daa520"></path></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C3"><path d="M22,19 l3,6 l-6,-3 z" fill="#daa520"></path></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C4"><circle cx="22" cy="22" r="3" fill="#daa520"></circle></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C5"><path d="M19,22 h6 M22,19 v6" stroke="#daa520" stroke-width="2"></path></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C6"><path d="M19,19 l6,6 M25,19 l-6,6" stroke="#daa520" stroke-width="2"></path></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C7"><path d="M19,20 l3,3 l3,-3" fill="none" stroke="#daa520" stroke-width="2"></path></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C8"><path d="M19,24 l3,-3 l3,3" fill="none" stroke="#daa520" stroke-width="2"></path></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C9"><path d="M20,19 l3,3 l-3,3" fill="none" stroke="#daa520" stroke-width="2"></path></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C10"><path d="M24,19 l-3,3 l3,3" fill="none" stroke="#daa520" stroke-width="2"></path></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C11"><rect x="19" y="19" width="6" height="6" fill="#daa520"></rect></symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C12"><path d="M19,19 h6 v6 h-6z" stroke="#daa520" stroke-width="2" fill="none"></path></symbol>
        </svg>`,
        'symbols': {
          'Z': 3,
          'A': 9,
          'B': 12,
          'C': 12
        }
      },

      {
        'id': 6,
        'svg': `<svg width="0" height="0" class="hidden">
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1"><path fill="#e0f7ff" d="M0 0h44v44H0z"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2"><path fill="#c2f0ff" d="M0 0h44v44H0z"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3"><path fill="#99e6ff" d="M0 0h44v44H0z"></path></symbol>
      
          <!-- Large base hexagonal patterns -->
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1"><path d="M22,6 L38,14 L38,30 L22,38 L6,30 L6,14 Z" fill="#483d8b"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2"><path d="M22,38 L6,22 L22,6 L38,22 Z" fill="#483d8b"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3"><path d="M6,6 L38,6 L38,38 L6,38 Z" fill="#483d8b"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4"><path d="M22,6 L38,22 L22,38 L6,22 Z" fill="#483d8b"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5"><path d="M6,22 A16,16 0 0,1 38,22 A16,16 0 0,1 6,22" fill="#483d8b"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6"><path d="M6,6 L22,22 L6,38 Z" fill="#483d8b"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7"><path d="M38,6 L22,22 L38,38 Z" fill="#483d8b"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8"><path d="M6,6 L38,6 L22,38 Z" fill="#483d8b"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9"><path d="M6,38 L38,38 L22,6 Z" fill="#483d8b"></path></symbol>
      
          <!-- Medium wave patterns -->
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1"><path d="M14,22 Q22,14 30,22 Q22,30 14,22" stroke="#9370db" fill="none" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2"><path d="M14,18 Q22,26 30,18 M14,26 Q22,18 30,26" stroke="#9370db" fill="none" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3"><path d="M14,22 h16 M14,18 h16 M14,26 h16" stroke="#9370db" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4"><path d="M22,14 v16 M18,14 v16 M26,14 v16" stroke="#9370db" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5"><path d="M14,14 Q22,22 30,14 M14,30 Q22,22 30,30" stroke="#9370db" fill="none" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6"><path d="M14,14 L30,30 M30,14 L14,30" stroke="#9370db" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7"><path d="M14,22 h16 M22,14 v16" stroke="#9370db" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8"><path d="M18,18 h8 v8 h-8 z" stroke="#9370db" fill="none" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9"><path d="M22,14 L30,22 L22,30 L14,22 Z" stroke="#9370db" fill="none" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10"><path d="M22,14 L14,22 L22,30" stroke="#9370db" fill="none" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11"><path d="M22,14 L30,22 L22,30" stroke="#9370db" fill="none" stroke-width="3"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12"><path d="M14,18 Q22,14 30,18 Q22,22 14,18" stroke="#9370db" fill="none" stroke-width="3"></path></symbol>
      
          <!-- Small crystal shapes -->
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1"><path d="M18,18 l4,4 l4,-4 l-4,-4 z" fill="#00ced1"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2"><path d="M22,18 l4,4 l-4,4 l-4,-4 z" fill="#00ced1"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C3"><circle cx="22" cy="22" r="4" fill="#00ced1"></circle></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C4"><path d="M18,22 h8 M22,18 v8" stroke="#00ced1" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C5"><path d="M18,18 l8,8 M26,18 l-8,8" stroke="#00ced1" stroke-width="2"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C6"><path d="M18,18 h8 v8 h-8 z" fill="#00ced1"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C7"><path d="M18,22 q4,-4 8,0 q-4,4 -8,0" fill="#00ced1"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C8"><path d="M22,18 l4,4 l-4,4" stroke="#00ced1" stroke-width="2" fill="none"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C9"><path d="M22,18 l-4,4 l4,4" stroke="#00ced1" stroke-width="2" fill="none"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C10"><path d="M20,20 h4 v4 h-4 z" fill="#00ced1"></path></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C11"><circle cx="22" cy="22" r="3" stroke="#00ced1" stroke-width="2" fill="none"></circle></symbol>
          <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C12"><path d="M19,19 l6,6 M25,19 l-6,6" stroke="#00ced1" stroke-width="2"></path></symbol>
        </svg>`,
        'symbols': {
          'Z': 3,
          'A': 9,
          'B': 12,
          'C': 12
        }
      },






      {
        'id': 7,
        'svg': `<svg width="0" height="0" class="hidden">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1">
            <title>Z1</title>
            <path fill="#000033" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2">
            <title>Z2</title>
            <path fill="#0A0A3A" d="M0 0h44v44H0z"></path>
            <circle cx="10" cy="15" r="0.8" fill="#FFFFFF" opacity="0.8" />
            <circle cx="24" cy="8" r="0.6" fill="#FFFFFF" opacity="0.6" />
            <circle cx="36" cy="22" r="0.9" fill="#FFFFFF" opacity="0.7" />
            <circle cx="16" cy="32" r="0.7" fill="#FFFFFF" opacity="0.5" />
            <circle cx="30" cy="38" r="0.5" fill="#FFFFFF" opacity="0.9" />
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3">
            <title>Z3</title>
            <path fill="#14143C" d="M0 0h44v44H0z"></path>
            <circle cx="7" cy="10" r="0.5" fill="#FFFFFF" opacity="0.7" />
            <circle cx="12" cy="22" r="0.6" fill="#FFFFFF" opacity="0.5" />
            <circle cx="30" cy="12" r="0.7" fill="#FFFFFF" opacity="0.6" />
            <circle cx="38" cy="20" r="0.4" fill="#FFFFFF" opacity="0.8" />
            <circle cx="22" cy="34" r="0.8" fill="#FFFFFF" opacity="0.7" />
            <circle cx="4" cy="36" r="0.6" fill="#FFFFFF" opacity="0.9" />
            <circle cx="35" cy="38" r="0.5" fill="#FFFFFF" opacity="0.6" />
        </symbol>
        
        <!-- A series: Planets -->
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1">
            <title>Earth</title>
            <circle cx="22" cy="22" r="18" fill="#1E88E5" />
            <path d="M15,14 C18,12 20,16 26,15 C32,14 34,20 30,24 C26,28 28,30 26,32 C24,34 18,36 14,32 C10,28 12,16 15,14 Z" fill="#4CAF50" />
            <path d="M33,18 C34,22 32,28 29,30 C26,32 28,24 32,22 C36,20 33,18 33,18 Z" fill="#4CAF50" />
            <path d="M12,24 C10,20 12,16 16,18 C20,20 16,26 12,24 Z" fill="#4CAF50" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2">
            <title>Mars</title>
            <circle cx="22" cy="22" r="18" fill="#E57373" />
            <circle cx="16" cy="18" r="4" fill="#FFCA28" opacity="0.6" />
            <circle cx="28" cy="26" r="5" fill="#FFCA28" opacity="0.5" />
            <circle cx="20" cy="30" r="3" fill="#FFCA28" opacity="0.4" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3">
            <title>Saturn</title>
            <circle cx="22" cy="22" r="15" fill="#FFD54F" />
            <ellipse cx="22" cy="22" rx="24" ry="6" fill="transparent" stroke="#E57373" stroke-width="2" transform="rotate(15)" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4">
            <title>Venus</title>
            <circle cx="22" cy="22" r="18" fill="#FF7043" />
            <path d="M12,13 C20,7 28,11 32,20 C36,29 30,36 22,36 C14,36 8,26 12,13 Z" fill="#FFCCBC" opacity="0.4" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5">
            <title>Neptune</title>
            <circle cx="22" cy="22" r="18" fill="#5C6BC0" />
            <path d="M14,16 C18,14 28,16 30,22 C32,28 28,34 20,32 C12,30 10,18 14,16 Z" fill="#7986CB" opacity="0.7" />
            <path d="M22,4 Q32,14 22,24 Q12,14 22,4 Z" fill="#9FA8DA" opacity="0.5" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6">
            <title>Mercury</title>
            <circle cx="22" cy="22" r="18" fill="#9E9E9E" />
            <circle cx="16" cy="16" r="3" fill="#BDBDBD" />
            <circle cx="27" cy="19" r="5" fill="#BDBDBD" />
            <circle cx="20" cy="29" r="4" fill="#BDBDBD" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7">
            <title>Jupiter</title>
            <circle cx="22" cy="22" r="18" fill="#FFB74D" />
            <path d="M4,15 Q22,8 40,15 Q22,20 4,15 Z" fill="#FFECB3" />
            <path d="M4,22 Q22,15 40,22 Q22,27 4,22 Z" fill="#FFE082" />
            <path d="M4,29 Q22,22 40,29 Q22,34 4,29 Z" fill="#FFECB3" />
            <circle cx="28" cy="16" r="4" fill="#EF5350" opacity="0.7" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8">
            <title>Moon</title>
            <circle cx="22" cy="22" r="18" fill="#E0E0E0" />
            <circle cx="15" cy="14" r="3" fill="#9E9E9E" />
            <circle cx="26" cy="18" r="4" fill="#BDBDBD" />
            <circle cx="18" cy="28" r="5" fill="#9E9E9E" />
            <circle cx="30" cy="28" r="2" fill="#BDBDBD" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9">
            <title>Pluto</title>
            <circle cx="22" cy="22" r="18" fill="#90A4AE" />
            <path d="M10,15 C16,10 26,12 30,20 Q32,28 26,32 C20,36 13,30 10,15 Z" fill="#CFD8DC" />
        </symbol>
        
        <!-- B series: Space objects -->
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1">
            <title>Star</title>
            <path d="M22,4 L25.5,15.8 L38,15.8 L28.2,23 L31.8,34.7 L22,27.5 L12.2,34.7 L15.8,23 L6,15.8 L18.5,15.8 Z" fill="#FFEB3B" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2">
            <title>Comet</title>
            <circle cx="30" cy="14" r="8" fill="#E1F5FE" />
            <path d="M30,14 Q20,24 12,32" stroke="#E1F5FE" stroke-width="4" stroke-linecap="round" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3">
            <title>Black Hole</title>
            <circle cx="22" cy="22" r="15" fill="#000000" />
            <circle cx="22" cy="22" r="10" fill="#311B92" />
            <circle cx="22" cy="22" r="5" fill="#6A1B9A" />
            <ellipse cx="22" cy="22" rx="22" ry="6" stroke="#673AB7" stroke-width="1" fill="none" transform="rotate(30)" />
            <ellipse cx="22" cy="22" rx="20" ry="5" stroke="#673AB7" stroke-width="1" fill="none" transform="rotate(60)" />
            <ellipse cx="22" cy="22" rx="18" ry="4" stroke="#673AB7" stroke-width="1" fill="none" transform="rotate(90)" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4">
            <title>Meteor</title>
            <path d="M34,10 Q24,20 14,30 Q10,34 10,34" stroke="#795548" stroke-width="10" stroke-linecap="round" />
            <path d="M34,10 Q24,20 14,30 Q10,34 10,34" stroke="#FF9800" stroke-width="7" stroke-linecap="round" />
            <path d="M34,10 Q24,20 14,30 Q10,34 10,34" stroke="#FFEB3B" stroke-width="4" stroke-linecap="round" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5">
            <title>UFO</title>
            <ellipse cx="22" cy="22" rx="14" ry="5" fill="#90CAF9" />
            <ellipse cx="22" cy="22" rx="8" ry="3" fill="#1976D2" />
            <path d="M8,22 Q22,30 36,22" stroke="#90CAF9" stroke-width="1" fill="none" />
            <circle cx="22" cy="19" r="6" fill="#E1F5FE" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6">
            <title>Nebula</title>
            <circle cx="16" cy="16" r="8" fill="#CE93D8" opacity="0.7" />
            <circle cx="26" cy="18" r="10" fill="#9FA8DA" opacity="0.7" />
            <circle cx="20" cy="26" r="9" fill="#81D4FA" opacity="0.7" />
            <circle cx="30" cy="28" r="7" fill="#80CBC4" opacity="0.7" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7">
            <title>Galaxy</title>
            <circle cx="22" cy="22" r="18" fill="#26A69A" opacity="0.2" />
            <path d="M22,4 Q40,22 22,40 Q4,22 22,4 Z" stroke="#26A69A" stroke-width="2" fill="none" />
            <path d="M22,8 Q36,22 22,36 Q8,22 22,8 Z" stroke="#26A69A" stroke-width="2" fill="none" />
            <path d="M22,12 Q32,22 22,32 Q12,22 22,12 Z" stroke="#26A69A" stroke-width="2" fill="none" />
            <circle cx="22" cy="22" r="4" fill="#004D40" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8">
            <title>Satellite</title>
            <rect x="16" y="16" width="12" height="12" fill="#78909C" />
            <rect x="18" y="10" width="8" height="6" fill="#CFD8DC" />
            <rect x="18" y="28" width="8" height="6" fill="#CFD8DC" />
            <rect x="10" y="18" width="6" height="8" fill="#90A4AE" />
            <rect x="28" y="18" width="6" height="8" fill="#90A4AE" />
            <path d="M10,18 L4,12 M10,26 L4,32 M34,18 L40,12 M34,26 L40,32" stroke="#ECEFF1" stroke-width="1" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9">
            <title>Astronaut</title>
            <circle cx="22" cy="16" r="8" fill="#ECEFF1" />
            <rect x="14" y="16" width="16" height="18" rx="4" ry="4" fill="#CFD8DC" />
            <circle cx="18" cy="14" r="2" fill="#42A5F5" />
            <circle cx="26" cy="14" r="2" fill="#42A5F5" />
            <rect x="10" y="20" width="6" height="4" rx="2" ry="2" fill="#CFD8DC" />
            <rect x="28" y="20" width="6" height="4" rx="2" ry="2" fill="#CFD8DC" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10">
            <title>Pulsar</title>
            <circle cx="22" cy="22" r="8" fill="#FF5722" />
            <path d="M22,2 L22,14 M22,30 L22,42 M2,22 L14,22 M30,22 L42,22" stroke="#FF5722" stroke-width="3" />
            <path d="M8,8 L14,14 M30,30 L36,36 M8,36 L14,30 M36,8 L30,14" stroke="#FF5722" stroke-width="2" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11">
            <title>Supernova</title>
            <circle cx="22" cy="22" r="8" fill="#FFEB3B" />
            <path d="M22,8 L22,2 M22,36 L22,42 M8,22 L2,22 M36,22 L42,22" stroke="#FFEB3B" stroke-width="2" />
            <path d="M12,12 L8,8 M32,32 L36,36 M12,32 L8,36 M32,12 L36,8" stroke="#FFEB3B" stroke-width="2" />
            <path d="M18,8 L16,2 M26,8 L28,2 M18,36 L16,42 M26,36 L28,42" stroke="#FFA000" stroke-width="1" />
            <path d="M8,18 L2,16 M8,26 L2,28 M36,18 L42,16 M36,26 L42,28" stroke="#FFA000" stroke-width="1" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12">
            <title>Rocket</title>
            <path d="M22,4 L28,34 L22,30 L16,34 Z" fill="#F44336" />
            <path d="M18,34 L14,40 L22,36 L30,40 L26,34" fill="#FF9800" />
            <circle cx="22" cy="18" r="4" fill="#FFFFFF" />
        </symbol>
        
        <!-- C series: Constellations -->
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1">
            <title>Ursa Major</title>
            <circle cx="10" cy="10" r="2" fill="#FFFFFF" />
            <circle cx="18" cy="14" r="2" fill="#FFFFFF" />
            <circle cx="24" cy="20" r="2" fill="#FFFFFF" />
            <circle cx="34" cy="24" r="2" fill="#FFFFFF" />
            <circle cx="30" cy="32" r="2" fill="#FFFFFF" />
            <circle cx="20" cy="34" r="2" fill="#FFFFFF" />
            <circle cx="12" cy="28" r="2" fill="#FFFFFF" />
            <path d="M10,10 L18,14 L24,20 L34,24 L30,32 L20,34 L12,28" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2">
            <title>Orion</title>
            <circle cx="14" cy="8" r="2" fill="#FFFFFF" />
            <circle cx="30" cy="8" r="2" fill="#FFFFFF" />
            <circle cx="10" cy="16" r="2" fill="#FFFFFF" />
            <circle cx="22" cy="16" r="2" fill="#FFFFFF" />
            <circle cx="34" cy="16" r="2" fill="#FFFFFF" />
            <circle cx="22" cy="26" r="2" fill="#FFFFFF" />
            <circle cx="16" cy="36" r="2" fill="#FFFFFF" />
            <circle cx="28" cy="36" r="2" fill="#FFFFFF" />
            <path d="M14,8 L22,16 L30,8 M10,16 L22,16 L34,16 M22,16 L22,26 M16,36 L22,26 L28,36" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C3">
            <title>Cassiopeia</title>
            <circle cx="8" cy="12" r="2" fill="#FFFFFF" />
            <circle cx="18" cy="8" r="2" fill="#FFFFFF" />
            <circle cx="26" cy="18" r="2" fill="#FFFFFF" />
            <circle cx="32" cy="10" r="2" fill="#FFFFFF" />
            <circle cx="36" cy="28" r="2" fill="#FFFFFF" />
            <path d="M8,12 L18,8 L26,18 L32,10 L36,28" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C4">
            <title>Cygnus</title>
            <circle cx="14" cy="32" r="2" fill="#FFFFFF" />
            <circle cx="22" cy="22" r="2" fill="#FFFFFF" />
            <circle cx="30" cy="12" r="2" fill="#FFFFFF" />
            <circle cx="12" cy="20" r="2" fill="#FFFFFF" />
            <circle cx="32" cy="24" r="2" fill="#FFFFFF" />
            <path d="M14,32 L22,22 L30,12 M12,20 L22,22 L32,24" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C5">
            <title>Lyra</title>
            <circle cx="22" cy="10" r="2" fill="#FFFFFF" />
            <circle cx="16" cy="18" r="2" fill="#FFFFFF" />
            <circle cx="28" cy="18" r="2" fill="#FFFFFF" />
            <circle cx="22" cy="28" r="2" fill="#FFFFFF" />
            <circle cx="12" cy="34" r="2" fill="#FFFFFF" />
            <circle cx="32" cy="34" r="2" fill="#FFFFFF" />
            <path d="M22,10 L16,18 L22,28 L28,18 L22,10 M12,34 L22,28 L32,34" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C6">
            <title>Gemini</title>
            <circle cx="14" cy="8" r="2" fill="#FFFFFF" />
            <circle cx="30" cy="8" r="2" fill="#FFFFFF" />
            <circle cx="14" cy="18" r="2" fill="#FFFFFF" />
            <circle cx="30" cy="18" r="2" fill="#FFFFFF" />
            <circle cx="14" cy="28" r="2" fill="#FFFFFF" />
            <circle cx="30" cy="28" r="2" fill="#FFFFFF" />
            <circle cx="14" cy="36" r="2" fill="#FFFFFF" />
            <circle cx="30" cy="36" r="2" fill="#FFFFFF" />
            <path d="M14,8 L14,36 M30,8 L30,36 M14,18 L30,18 M14,28 L30,28" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C7">
            <title>Scorpius</title>
            <circle cx="12" cy="8" r="2" fill="#FFFFFF" />
            <circle cx="20" cy="12" r="2" fill="#FFFFFF" />
            <circle cx="22" cy="20" r="2" fill="#FFFFFF" />
            <circle cx="24" cy="28" r="2" fill="#FFFFFF" />
            <circle cx="30" cy="32" r="2" fill="#FFFFFF" />
            <circle cx="36" cy="36" r="2" fill="#FFFFFF" />
            <path d="M12,8 L20,12 L22,20 L24,28 L30,32 C33,34 35,35 36,36" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C8">
            <title>Leo</title>
            <circle cx="14" cy="10" r="2" fill="#FFFFFF" />
            <circle cx="18" cy="18" r="2" fill="#FFFFFF" />
            <circle cx="26" cy="18" r="2" fill="#FFFFFF" />
            <circle cx="34" cy="12" r="2" fill="#FFFFFF" />
            <circle cx="22" cy="28" r="2" fill="#FFFFFF" />
            <circle cx="12" cy="34" r="2" fill="#FFFFFF" />
            <path d="M14,10 L18,18 L26,18 L34,12 M18,18 L22,28 L12,34" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C9">
            <title>Pegasus</title>
            <circle cx="12" cy="12" r="2" fill="#FFFFFF" />
            <circle cx="32" cy="12" r="2" fill="#FFFFFF" />
            <circle cx="12" cy="32" r="2" fill="#FFFFFF" />
            <circle cx="32" cy="32" r="2" fill="#FFFFFF" />
            <path d="M12,12 L32,12 L32,32 L12,32 L12,12" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C10">
            <title>Aquarius</title>
            <circle cx="12" cy="12" r="2" fill="#FFFFFF" />
            <circle cx="22" cy="16" r="2" fill="#FFFFFF" />
            <circle cx="32" cy="12" r="2" fill="#FFFFFF" />
            <circle cx="22" cy="24" r="2" fill="#FFFFFF" />
            <circle cx="12" cy="32" r="2" fill="#FFFFFF" />
            <circle cx="22" cy="36" r="2" fill="#FFFFFF" />
            <circle cx="32" cy="32" r="2" fill="#FFFFFF" />
            <path d="M12,12 Q17,14 22,16 Q27,18 32,12 M22,16 L22,24 M12,32 Q17,34 22,36 Q27,38 32,32" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C11">
            <title>Pisces</title>
            <circle cx="22" cy="12" r="2" fill="#FFFFFF" />
            <circle cx="12" cy="22" r="2" fill="#FFFFFF" />
            <circle cx="32" cy="22" r="2" fill="#FFFFFF" />
            <circle cx="22" cy="32" r="2" fill="#FFFFFF" />
            <path d="M22,12 Q12,17 12,22 Q12,27 22,32 Q32,27 32,22 Q32,17 22,12" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C12">
            <title>Aries</title>
            <circle cx="8" cy="22" r="2" fill="#FFFFFF" />
            <circle cx="20" cy="14" r="2" fill="#FFFFFF" />
            <circle cx="32" cy="10" r="2" fill="#FFFFFF" />
            <circle cx="36" cy="22" r="2" fill="#FFFFFF" />
            <circle cx="32" cy="34" r="2" fill="#FFFFFF" />
            <circle cx="20" cy="30" r="2" fill="#FFFFFF" />
            <path d="M8,22 Q14,14 20,14 Q26,14 32,10 M32,10 Q37,16 36,22 Q35,28 32,34 Q26,30 20,30 Q14,30 8,22" stroke="#B3E5FC" stroke-width="1" fill="none" />
        </symbol>
    </svg>`,

        'symbols': {
            'Z': 3,
            'A': 9,
            'B': 12,
            'C': 12
        },
    },














    {
        'id': 8,
        'svg': `<svg width="0" height="0" class="hidden">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1">
            <title>Z1</title>
            <path fill="#E1F5FE" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2">
            <title>Z2</title>
            <path fill="#B3E5FC" d="M0 0h44v44H0z"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3">
            <title>Z3</title>
            <path fill="#81D4FA" d="M0 0h44v44H0z"></path>
            <path d="M0 30 Q 5 25, 10 30 Q 15 35, 20 30 Q 25 25, 30 30 Q 35 35, 40 30 Q 45 25, 50 30 L 50 44 L 0 44 Z" fill="#4FC3F7" opacity="0.4"></path>
            <path d="M0 35 Q 5 30, 10 35 Q 15 40, 20 35 Q 25 30, 30 35 Q 35 40, 40 35 Q 45 30, 50 35 L 50 44 L 0 44 Z" fill="#29B6F6" opacity="0.4"></path>
        </symbol>
        
        <!-- A series: Coral Reefs -->
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1">
            <title>Branching Coral</title>
            <path d="M22 38 L22 28" stroke="#FF5252" stroke-width="3" stroke-linecap="round" />
            <path d="M22 28 L16 20 M22 28 L28 20 M16 20 L13 12 M16 20 L19 12 M28 20 L25 12 M28 20 L31 12" stroke="#FF5252" stroke-width="2" stroke-linecap="round" />
            <path d="M13 12 L10 6 M13 12 L16 6 M19 12 L16 6 M19 12 L22 6 M25 12 L22 6 M25 12 L28 6 M31 12 L28 6 M31 12 L34 6" stroke="#FF5252" stroke-width="1.5" stroke-linecap="round" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2">
            <title>Brain Coral</title>
            <circle cx="22" cy="25" r="13" fill="#F48FB1" />
            <path d="M13,20 Q16,18 19,20 Q22,22 25,20 Q28,18 31,20" stroke="#EC407A" stroke-width="2" fill="none" />
            <path d="M13,24 Q16,22 19,24 Q22,26 25,24 Q28,22 31,24" stroke="#EC407A" stroke-width="2" fill="none" />
            <path d="M13,28 Q16,26 19,28 Q22,30 25,28 Q28,26 31,28" stroke="#EC407A" stroke-width="2" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3">
            <title>Sea Fan</title>
            <path d="M22 38 L22 28" stroke="#BA68C8" stroke-width="2" stroke-linecap="round" />
            <path d="M22 28 Q 13 15, 8 8 M22 28 Q 31 15, 36 8" stroke="#BA68C8" stroke-width="2" stroke-linecap="round" fill="none" />
            <path d="M10 12 Q 14 16, 16 22 M34 12 Q 30 16, 28 22" stroke="#BA68C8" stroke-width="1.5" stroke-linecap="round" fill="none" />
            <path d="M14 10 Q 17 14, 19 19 M30 10 Q 27 14, 25 19" stroke="#BA68C8" stroke-width="1.5" stroke-linecap="round" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4">
            <title>Tube Coral</title>
            <path d="M12 38 L12 26 Q 12 20, 16 16 Q 22 20, 28 16 Q 32 20, 32 26 L 32 38" stroke="#FF7043" stroke-width="0" fill="#FF7043" />
            <path d="M16 38 L16 28 Q 16 24, 19 22 L19 38" stroke="#FFAB91" stroke-width="0" fill="#FFAB91" />
            <path d="M23 38 L23 28 Q 23 24, 26 22 L26 38" stroke="#FFAB91" stroke-width="0" fill="#FFAB91" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5">
            <title>Staghorn Coral</title>
            <path d="M12 38 L20 26 L16 20 L22 14 L26 18 L32 12" stroke="#FFEB3B" stroke-width="3" stroke-linecap="round" fill="none" />
            <path d="M16 20 L10 16 M26 18 L28 12 M32 12 L36 16" stroke="#FFEB3B" stroke-width="2" stroke-linecap="round" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6">
            <title>Lettuce Coral</title>
            <path d="M18 34 Q 14 30, 12 24 Q 10 18, 14 14 Q 18 10, 22 14 Q 26 10, 30 14 Q 34 18, 32 24 Q 30 30, 26 34 Z" fill="#76FF03" />
            <path d="M22 14 Q 22 18, 22 22 M22 14 Q 18 18, 18 22 M22 14 Q 26 18, 26 22" stroke="#64DD17" stroke-width="1" fill="none" />
            <path d="M14 24 Q 18 24, 22 24 M32 24 Q 28 24, 24 24" stroke="#64DD17" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7">
            <title>Mushroom Coral</title>
            <path d="M19 38 L19 30 L25 30 L25 38" stroke="#9CCC65" stroke-width="2" />
            <path d="M12 30 Q 12 24, 17 20 Q 22 18, 27 20 Q 32 24, 32 30 Z" fill="#9CCC65" />
            <path d="M17 20 Q 19 16, 22 16 Q 25 16, 27 20" stroke="#7CB342" stroke-width="1" fill="none" />
            <circle cx="16" cy="26" r="1.5" fill="#7CB342" />
            <circle cx="22" cy="24" r="1.5" fill="#7CB342" />
            <circle cx="28" cy="26" r="1.5" fill="#7CB342" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8">
            <title>Bubble Coral</title>
            <circle cx="22" cy="26" r="14" fill="#B2EBF2" opacity="0.8" />
            <circle cx="18" cy="22" r="4" fill="#80DEEA" opacity="0.9" />
            <circle cx="24" cy="28" r="5" fill="#4DD0E1" opacity="0.8" />
            <circle cx="18" cy="30" r="3" fill="#26C6DA" opacity="0.7" />
            <circle cx="26" cy="22" r="3.5" fill="#00BCD4" opacity="0.6" />
            <circle cx="22" cy="26" r="2" fill="#00ACC1" opacity="0.5" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9">
            <title>Elkhorn Coral</title>
            <path d="M22 38 L22 30" stroke="#FFD54F" stroke-width="3" stroke-linecap="round" />
            <path d="M22 30 L14 18 M22 30 L30 18" stroke="#FFD54F" stroke-width="2" stroke-linecap="round" />
            <path d="M14 18 L10 12 M14 18 L18 12 M30 18 L26 12 M30 18 L34 12" stroke="#FFD54F" stroke-width="2" stroke-linecap="round" />
            <path d="M10 12 L8 6 M18 12 L16 6 M26 12 L24 6 M34 12 L32 6" stroke="#FFD54F" stroke-width="1.5" stroke-linecap="round" />
        </symbol>
        
        <!-- B series: Fish -->
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1">
            <title>Clownfish</title>
            <path d="M12 22 Q 18 16, 24 16 L 30 16 Q 36 16, 36 22 Q 36 28, 30 28 L 24 28 Q 18 28, 12 22 Z" fill="#FF7043" />
            <path d="M16 18 Q 22 15, 26 16 M16 26 Q 22 29, 26 28" stroke="white" stroke-width="2" />
            <circle cx="32" cy="22" r="2" fill="black" />
            <path d="M12 22 L 8 22" stroke="#FF7043" stroke-width="3" stroke-linecap="round" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2">
            <title>Angelfish</title>
            <path d="M16 22 Q 22 12, 32 16 Q 36 20, 32 28 Q 22 32, 16 22 Z" fill="#9575CD" />
            <path d="M16 22 Q 8 18, 8 22 Q 8 26, 16 22 Z" fill="#9575CD" />
            <path d="M24 16 L 24 28" stroke="white" stroke-width="1" />
            <path d="M28 18 L 28 26" stroke="white" stroke-width="1" />
            <circle cx="30" cy="20" r="1" fill="black" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3">
            <title>Butterflyfish</title>
            <path d="M14 22 Q 20 14, 30 18 Q 35 22, 30 26 Q 20 30, 14 22 Z" fill="#FFF176" />
            <path d="M14 22 Q 8 18, 8 22 Q 8 26, 14 22 Z" fill="#FFF176" />
            <path d="M16 16 L 24 26" stroke="#212121" stroke-width="1" />
            <path d="M20 14 L 28 24" stroke="#212121" stroke-width="1" />
            <circle cx="32" cy="22" r="1" fill="black" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4">
            <title>Pufferfish</title>
            <circle cx="22" cy="22" r="10" fill="#FFECB3" />
            <path d="M15 26 L 11 30 M29 26 L 33 30" stroke="#FFE082" stroke-width="2" stroke-linecap="round" />
            <path d="M14 22 L 8 22 M30 22 L 36 22" stroke="#FFE082" stroke-width="2" stroke-linecap="round" />
            <path d="M15 18 L 11 14 M29 18 L 33 14" stroke="#FFE082" stroke-width="2" stroke-linecap="round" />
            <circle cx="18" cy="20" r="1" fill="black" />
            <circle cx="26" cy="20" r="1" fill="black" />
            <path d="M20 24 Q 22 26, 24 24" stroke="#FFB300" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5">
            <title>Seahorse</title>
            <path d="M24 32 Q 28 30, 28 26 Q 28 24, 26 22 Q 24 20, 24 18 Q 24 16, 26 14 Q 28 12, 28 10 Q 28 8, 26 8 Q 24 8, 24 10 Q 24 14, 22 16 Q 20 18, 20 22 Q 20 26, 22 28 Q 24 30, 24 32 Z" fill="#4FC3F7" />
            <circle cx="26" cy="12" r="1" fill="black" />
            <path d="M24 32 Q 20 34, 18 32" stroke="#4FC3F7" stroke-width="2" stroke-linecap="round" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6">
            <title>Lionfish</title>
            <path d="M22 18 L 22 32" stroke="#EF5350" stroke-width="4" stroke-linecap="round" />
            <path d="M22 24 L 14 20 M22 24 L 14 24 M22 24 L 14 28" stroke="#EF5350" stroke-width="2" stroke-linecap="round" />
            <path d="M22 24 L 30 20 M22 24 L 30 24 M22 24 L 30 28" stroke="#EF5350" stroke-width="2" stroke-linecap="round" />
            <path d="M22 16 Q 18 12, 22 8 Q 26 12, 22 16 Z" fill="#EF5350" />
            <circle cx="20" cy="12" r="1" fill="black" />
            <circle cx="24" cy="12" r="1" fill="black" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7">
            <title>Shark</title>
            <path d="M10 22 Q 16 16, 24 18 L 34 18 Q 38 19, 36 22 Q 38 25, 34 26 L 24 26 Q 16 28, 10 22 Z" fill="#78909C" />
            <path d="M10 22 L 6 18 L 10 22 L 6 26" stroke="#78909C" stroke-width="2" stroke-linecap="round" fill="none" />
            <circle cx="32" cy="20" r="1" fill="black" />
            <path d="M26 18 L 26 26" stroke="#455A64" stroke-width="1" />
            <path d="M21 18 L 21 26" stroke="#455A64" stroke-width="1" />
            <path d="M16 19 L 16 25" stroke="#455A64" stroke-width="1" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8">
            <title>Flying Fish</title>
            <path d="M14 22 Q 20 18, 28 20 Q 32 22, 28 24 Q 20 26, 14 22 Z" fill="#64B5F6" />
            <path d="M14 22 Q 8 20, 8 22 Q 8 24, 14 22 Z" fill="#64B5F6" />
            <path d="M20 20 L 12 14 M20 24 L 12 30" stroke="#2196F3" stroke-width="2" stroke-linecap="round" />
            <circle cx="30" cy="22" r="1" fill="black" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9">
            <title>Stingray</title>
            <path d="M18 22 Q 24 14, 30 14 Q 36 14, 38 22 Q 36 30, 30 30 Q 24 30, 18 22 Z" fill="#90A4AE" />
            <path d="M18 22 L 14 22 L 10 26" stroke="#90A4AE" stroke-width="2" stroke-linecap="round" />
            <circle cx="30" cy="20" r="1" fill="black" />
            <circle cx="34" cy="20" r="1" fill="black" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10">
            <title>Moray Eel</title>
            <path d="M8 28 Q 12 26, 16 28 Q 20 30, 24 28 Q 28 26, 32 28 Q 36 30, 38 26" stroke="#558B2F" stroke-width="4" stroke-linecap="round" fill="none" />
            <circle cx="36" cy="26" r="2" fill="#558B2F" />
            <circle cx="36" cy="25" r="0.5" fill="black" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11">
            <title>Jellyfish</title>
            <path d="M16 18 Q 22 14, 28 18 Q 34 22, 28 26 Q 22 30, 16 26 Q 10 22, 16 18 Z" fill="#CE93D8" opacity="0.8" />
            <path d="M18 26 L 16 34 M22 26 L 22 32 M26 26 L 28 34" stroke="#CE93D8" stroke-width="2" stroke-linecap="round" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12">
            <title>Octopus</title>
            <circle cx="22" cy="20" r="8" fill="#E57373" />
            <path d="M18 26 Q 14 30, 12 34 M16 28 Q 12 30, 10 28 M26 26 Q 30 30, 32 34 M28 28 Q 32 30, 34 28" stroke="#E57373" stroke-width="2" stroke-linecap="round" />
            <path d="M18 20 Q 20 18, 22 20 Q 24 18, 26 20" stroke="#C62828" stroke-width="1" fill="none" />
            <circle cx="18" cy="16" r="2" fill="white" />
            <circle cx="26" cy="16" r="2" fill="white" />
            <circle cx="18" cy="16" r="1" fill="black" />
            <circle cx="26" cy="16" r="1" fill="black" />
        </symbol>
        
        <!-- C series: Shells and Mollusks -->
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1">
            <title>Conch Shell</title>
            <path d="M14 28 Q 8 28, 10 24 Q 12 20, 18 18 Q 24 16, 28 18 Q 32 20, 34 24 Q 36 28, 30 28 Z" fill="#FFAB91" />
            <path d="M16 24 Q 18 22, 22 22 M22 22 Q 26 22, 28 24" stroke="#E64A19" stroke-width="1" fill="none" />
            <path d="M18 26 Q 22 25, 26 26" stroke="#E64A19" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2">
            <title>Nautilus Shell</title>
            <path d="M22 32 Q 14 32, 14 24 Q 14 16, 22 16 Q 30 16, 30 24 Q 30 32, 22 32 Z" fill="#FFCC80" />
            <path d="M22 30 Q 16 30, 16 24 Q 16 18, 22 18 Q 28 18, 28 24 Q 28 30, 22 30 Z" stroke="#EF6C00" stroke-width="1" fill="none" />
            <path d="M22 28 Q 18 28, 18 24 Q 18 20, 22 20 Q 26 20, 26 24 Q 26 28, 22 28 Z" stroke="#EF6C00" stroke-width="1" fill="none" />
            <path d="M22 26 Q 20 26, 20 24 Q 20 22, 22 22 Q 24 22, 24 24 Q 24 26, 22 26 Z" stroke="#EF6C00" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C3">
            <title>Clam Shell</title>
            <path d="M14 26 Q 18 18, 22 18 Q 26 18, 30 26 Q 26 30, 22 32 Q 18 30, 14 26 Z" fill="#BCAAA4" />
            <path d="M16 26 Q 18 22, 22 22 Q 26 22, 28 26" stroke="#8D6E63" stroke-width="1" fill="none" />
            <path d="M18 28 Q 20 26, 22 26 Q 24 26, 26 28" stroke="#8D6E63" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C4">
            <title>Sand Dollar</title>
            <circle cx="22" cy="22" r="12" fill="#EEEEEE" />
            <path d="M22 10 L 22 34 M10 22 L 34 22" stroke="#E0E0E0" stroke-width="1" />
            <path d="M14 14 L 30 30 M14 30 L 30 14" stroke="#E0E0E0" stroke-width="1" />
            <circle cx="22" cy="22" r="3" fill="#E0E0E0" />
            <circle cx="17" cy="22" r="2" fill="#E0E0E0" />
            <circle cx="27" cy="22" r="2" fill="#E0E0E0" />
            <circle cx="22" cy="17" r="2" fill="#E0E0E0" />
            <circle cx="22" cy="27" r="2" fill="#E0E0E0" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C5">
            <title>Sea Urchin</title>
            <circle cx="22" cy="22" r="8" fill="#EC407A" />
            <path d="M22 14 L 22 6 M22 30 L 22 38 M14 22 L 6 22 M30 22 L 38 22" stroke="#EC407A" stroke-width="1" />
            <path d="M16 16 L 10 10 M28 28 L 34 34 M16 28 L 10 34 M28 16 L 34 10" stroke="#EC407A" stroke-width="1" />
            <path d="M19 15 L 15 8 M25 15 L 29 8 M19 29 L 15 36 M25 29 L 29 36" stroke="#EC407A" stroke-width="1" />
            <path d="M15 19 L 8 15 M29 19 L 36 15 M15 25 L 8 29 M29 25 L 36 29" stroke="#EC407A" stroke-width="1" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C6">
            <title>Scallop Shell</title>
            <path d="M12 30 Q 10 24, 12 20 Q 14 16, 22 12 Q 30 16, 32 20 Q 34 24, 32 30 Z" fill="#FFF9C4" />
            <path d="M15 28 L 15 20 Q 17 16, 22 14 Q 27 16, 29 20 L 29 28" stroke="#FBC02D" stroke-width="1" fill="none" />
            <path d="M17 28 L 17 21 Q 19 18, 22 16 Q 25 18, 27 21 L 27 28" stroke="#FBC02D" stroke-width="1" fill="none" />
            <path d="M19 28 L 19 22 Q 20 20, 22 18 Q 24 20, 25 22 L 25 28" stroke="#FBC02D" stroke-width="1" fill="none" />
            <path d="M21 28 L 21 23 Q 21.5 22, 22 21 Q 22.5 22, 23 23 L 23 28" stroke="#FBC02D" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C7">
            <title>Abalone Shell</title>
            <path d="M14 24 Q 12 20, 14 16 Q 16 12, 22 10 Q 28 12, 30 16 Q 32 20, 30 24 Q 28 28, 22 30 Q 16 28, 14 24 Z" fill="#B2DFDB" />
            <path d="M16 24 Q 14 20, 16 17 Q 18 14, 22 12 Q 26 14, 28 17 Q 30 20, 28 24 Q 26 27, 22 28 Q 18 27, 16 24 Z" stroke="#004D40" stroke-width="1" fill="none" />
            <path d="M18 23 Q 17 20, 18 18 Q 19 16, 22 14 Q 25 16, 26 18 Q 27 20, 26 23 Q 25 25, 22 26 Q 19 25, 18 23 Z" stroke="#004D40" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C8">
            <title>Sea Snail</title>
            <path d="M16 28 Q 12 28, 12 24 Q 12 20, 16 16 Q 20 12, 26 14 Q 30 16, 30 22 Q 28 28, 22 28 L 16 28 Z" fill="#A1887F" />
            <path d="M22 28 L 22 32" stroke="#A1887F" stroke-width="3" stroke-linecap="round" />
            <path d="M16 16 Q 20 14, 26 16 Q 28 18, 28 22 Q 26 26, 22 26" stroke="#8D6E63" stroke-width="1" fill="none" />
            <circle cx="24" cy="18" r="1" fill="black" />
            <circle cx="22" cy="18" r="1" fill="black" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C9">
            <title>Cone Shell</title>
            <path d="M16 30 L 18 18 Q 20 14, 22 14 Q 24 14, 26 18 L 28 30 Z" fill="#FFCC80" />
            <path d="M18 28 L 19 20 M22 28 L 22 18 M26 28 L 25 20" stroke="#EF6C00" stroke-width="1" />
            <path d="M18 24 L 26 24 M18 20 L 26 20" stroke="#EF6C00" stroke-width="1" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C10">
            <title>Cockle Shell</title>
            <path d="M14 28 Q 12 24, 14 20 Q 16 16, 22 14 Q 28 16, 30 20 Q 32 24, 30 28 Z" fill="#FFF59D" />
            <path d="M16 26 Q 14 22, 16 19 Q 18 16, 22 15" stroke="#FBC02D" stroke-width="1" fill="none" />
            <path d="M18 27 Q 17 24, 18 21 Q 19 18, 22 17" stroke="#FBC02D" stroke-width="1" fill="none" />
            <path d="M20 28 Q 19 25, 20 22 Q 21 19, 22 18" stroke="#FBC02D" stroke-width="1" fill="none" />
            <path d="M28 26 Q 30 22, 28 19 Q 26 16, 22 15" stroke="#FBC02D" stroke-width="1" fill="none" />
            <path d="M26 27 Q 27 24, 26 21 Q 25 18, 22 17" stroke="#FBC02D" stroke-width="1" fill="none" />
            <path d="M24 28 Q 25 25, 24 22 Q 23 19, 22 18" stroke="#FBC02D" stroke-width="1" fill="none" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C11">
            <title>Starfish</title>
            <path d="M22 19 L 16 10 L 22 13 L 28 10 L 22 19 Z" fill="#FF9800" />
            <path d="M22 19 L 8 22 L 17 25 L 13 34 L 22 19 Z" fill="#FF9800" />
            <path d="M22 19 L 31 34 L 27 25 L 36 22 L 22 19 Z" fill="#FF9800" />
            <circle cx="22" cy="19" r="3" fill="#F57C00" />
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C12">
            <title>Sea Star</title>
            <path d="M22 22 L 12 8 L 22 14 L 32 8 L 22 22 Z" fill="#EF5350" />
            <path d="M22 22 L 4 22 L 16 26 L 10 38 L 22 22 Z" fill="#EF5350" />
            <path d="M22 22 L 34 38 L 28 26 L 40 22 L 22 22 Z" fill="#EF5350" />
            <circle cx="22" cy="22" r="4" fill="#C62828" />
        </symbol>
    </svg>`,

        'symbols': {
            'Z': 3,
            'A': 9,
            'B': 12,
            'C': 12
        },
    },

    {
        'id': 9,
        'svg': `<svg width="0" height="0" class="hidden">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1">
            <title>Z1</title>
            <path fill="#263238" d="M0 0h44v44H0z"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2">
            <title>Z2</title>
            <path fill="#37474F" d="M0 0h44v44H0z"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3">
            <title>Z3</title>
            <path fill="#455A64" d="M0 0h44v44H0z"></path>
        </symbol>
        
        <!-- A series: Corner Shapes (large solid elements) -->
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1">
            <title>Red Circles</title>
            <circle cx="10" cy="10" r="6" fill="#FF5252"></circle>
            <circle cx="34" cy="10" r="6" fill="#FF5252"></circle>
            <circle cx="10" cy="34" r="6" fill="#FF5252"></circle>
            <circle cx="34" cy="34" r="6" fill="#FF5252"></circle>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2">
            <title>Blue Squares</title>
            <rect x="4" y="4" width="12" height="12" fill="#2196F3"></rect>
            <rect x="28" y="4" width="12" height="12" fill="#2196F3"></rect>
            <rect x="4" y="28" width="12" height="12" fill="#2196F3"></rect>
            <rect x="28" y="28" width="12" height="12" fill="#2196F3"></rect>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3">
            <title>Green Triangles</title>
            <path d="M4 16 L 16 4 L 16 16 Z" fill="#4CAF50"></path>
            <path d="M28 16 L 40 4 L 40 16 Z" fill="#4CAF50"></path>
            <path d="M4 40 L 16 28 L 16 40 Z" fill="#4CAF50"></path>
            <path d="M28 40 L 40 28 L 40 40 Z" fill="#4CAF50"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4">
            <title>Yellow Diamonds</title>
            <path d="M10 4 L 16 10 L 10 16 L 4 10 Z" fill="#FFEB3B"></path>
            <path d="M34 4 L 40 10 L 34 16 L 28 10 Z" fill="#FFEB3B"></path>
            <path d="M10 28 L 16 34 L 10 40 L 4 34 Z" fill="#FFEB3B"></path>
            <path d="M34 28 L 40 34 L 34 40 L 28 34 Z" fill="#FFEB3B"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5">
            <title>Purple Stars</title>
            <path d="M10 4 L 12 9 L 16 10 L 12 12 L 10 16 L 8 12 L 4 10 L 8 9 Z" fill="#9C27B0"></path>
            <path d="M34 4 L 36 9 L 40 10 L 36 12 L 34 16 L 32 12 L 28 10 L 32 9 Z" fill="#9C27B0"></path>
            <path d="M10 28 L 12 33 L 16 34 L 12 36 L 10 40 L 8 36 L 4 34 L 8 33 Z" fill="#9C27B0"></path>
            <path d="M34 28 L 36 33 L 40 34 L 36 36 L 34 40 L 32 36 L 28 34 L 32 33 Z" fill="#9C27B0"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6">
            <title>Orange Half-Circles</title>
            <path d="M4 10 A 6 6 0 0 1 16 10" fill="#FF9800"></path>
            <path d="M28 10 A 6 6 0 0 1 40 10" fill="#FF9800"></path>
            <path d="M4 34 A 6 6 0 0 0 16 34" fill="#FF9800"></path>
            <path d="M28 34 A 6 6 0 0 0 40 34" fill="#FF9800"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7">
            <title>Teal Crosses</title>
            <path d="M7 7 L 13 13 M7 13 L 13 7" stroke="#009688" stroke-width="4" stroke-linecap="round"></path>
            <path d="M31 7 L 37 13 M31 13 L 37 7" stroke="#009688" stroke-width="4" stroke-linecap="round"></path>
            <path d="M7 31 L 13 37 M7 37 L 13 31" stroke="#009688" stroke-width="4" stroke-linecap="round"></path>
            <path d="M31 31 L 37 37 M31 37 L 37 31" stroke="#009688" stroke-width="4" stroke-linecap="round"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8">
            <title>Pink Crescents</title>
            <path d="M4 10 A 6 6 0 0 1 16 10 A 3 3 0 0 0 4 10" fill="#E91E63"></path>
            <path d="M28 10 A 6 6 0 0 1 40 10 A 3 3 0 0 0 28 10" fill="#E91E63"></path>
            <path d="M4 34 A 6 6 0 0 0 16 34 A 3 3 0 0 1 4 34" fill="#E91E63"></path>
            <path d="M28 34 A 6 6 0 0 0 40 34 A 3 3 0 0 1 28 34" fill="#E91E63"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9">
            <title>Lime Dots</title>
            <circle cx="10" cy="10" r="4" fill="#CDDC39"></circle>
            <circle cx="34" cy="10" r="4" fill="#CDDC39"></circle>
            <circle cx="10" cy="34" r="4" fill="#CDDC39"></circle>
            <circle cx="34" cy="34" r="4" fill="#CDDC39"></circle>
            <circle cx="10" cy="10" r="1" fill="#263238"></circle>
            <circle cx="34" cy="10" r="1" fill="#263238"></circle>
            <circle cx="10" cy="34" r="1" fill="#263238"></circle>
            <circle cx="34" cy="34" r="1" fill="#263238"></circle>
        </symbol>
        
        <!-- B series: Center Border Elements (medium frames) -->
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1">
            <title>Square Frame</title>
            <rect x="10" y="10" width="24" height="24" fill="none" stroke="#00BCD4" stroke-width="3" rx="2" ry="2"></rect>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2">
            <title>Circle Frame</title>
            <circle cx="22" cy="22" r="13" fill="none" stroke="#FFEB3B" stroke-width="3"></circle>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3">
            <title>Diamond Frame</title>
            <path d="M22 9 L 35 22 L 22 35 L 9 22 Z" fill="none" stroke="#FF5722" stroke-width="3"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4">
            <title>Hexagon Frame</title>
            <path d="M22 9 L 33 15.5 L 33 28.5 L 22 35 L 11 28.5 L 11 15.5 Z" fill="none" stroke="#E91E63" stroke-width="3"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5">
            <title>Triangle Frame</title>
            <path d="M22 9 L 35 35 L 9 35 Z" fill="none" stroke="#4CAF50" stroke-width="3"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6">
            <title>Star Frame</title>
            <path d="M22 9 L 25 18 L 35 19 L 28 25 L 30 35 L 22 30 L 14 35 L 16 25 L 9 19 L 19 18 Z" 
                  fill="none" stroke="#9C27B0" stroke-width="2.5"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7">
            <title>Octagon Frame</title>
            <path d="M15 9 L 29 9 L 35 15 L 35 29 L 29 35 L 15 35 L 9 29 L 9 15 Z" 
                  fill="none" stroke="#FF9800" stroke-width="3"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8">
            <title>Cross Frame</title>
            <path d="M16 9 L 28 9 L 28 16 L 35 16 L 35 28 L 28 28 L 28 35 L 16 35 L 16 28 L 9 28 L 9 16 L 16 16 Z" 
                  fill="none" stroke="#3F51B5" stroke-width="3"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9">
            <title>Grid Frame</title>
            <path d="M9 9 L 35 9 L 35 35 L 9 35 Z" fill="none" stroke="#795548" stroke-width="3"></path>
            <path d="M9 18 L 35 18 M9 26 L 35 26 M18 9 L 18 35 M26 9 L 26 35" stroke="#795548" stroke-width="2"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10">
            <title>Donut Frame</title>
            <circle cx="22" cy="22" r="13" fill="none" stroke="#8BC34A" stroke-width="3"></circle>
            <circle cx="22" cy="22" r="7" fill="none" stroke="#8BC34A" stroke-width="2"></circle>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11">
            <title>Wave Frame</title>
            <path d="M9 22 C 14 12, 22 32, 35 22" fill="none" stroke="#2196F3" stroke-width="3" stroke-linecap="round"></path>
            <path d="M9 22 C 14 32, 22 12, 35 22" fill="none" stroke="#2196F3" stroke-width="3" stroke-linecap="round"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12">
            <title>Dotted Frame</title>
            <rect x="11" y="11" width="22" height="22" fill="none" stroke="#9E9E9E" stroke-width="2" 
                 stroke-dasharray="4,2" rx="2" ry="2"></rect>
            <circle cx="22" cy="22" r="3" fill="#9E9E9E"></circle>
        </symbol>
        
        <!-- C series: Center Shape Elements (small center elements) -->
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1">
            <title>Center Circle</title>
            <circle cx="22" cy="22" r="5" fill="#F44336"></circle>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2">
            <title>Center Square</title>
            <rect x="17" y="17" width="10" height="10" fill="#2196F3"></rect>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C3">
            <title>Center Triangle</title>
            <path d="M22 17 L 27 27 L 17 27 Z" fill="#4CAF50"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C4">
            <title>Center Diamond</title>
            <path d="M22 17 L 27 22 L 22 27 L 17 22 Z" fill="#FFEB3B"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C5">
            <title>Center Star</title>
            <path d="M22 17 L 23.5 21 L 27 21.5 L 24.5 24 L 25 27 L 22 25.5 L 19 27 L 19.5 24 L 17 21.5 L 20.5 21 Z" fill="#9C27B0"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C6">
            <title>Center Cross</title>
            <path d="M19 19 L 25 25 M19 25 L 25 19" stroke="#FF9800" stroke-width="2" stroke-linecap="round"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C7">
            <title>Center Plus</title>
            <path d="M22 17 L 22 27 M17 22 L 27 22" stroke="#009688" stroke-width="2" stroke-linecap="round"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C8">
            <title>Center Ring</title>
            <circle cx="22" cy="22" r="5" fill="none" stroke="#E91E63" stroke-width="2"></circle>
            <circle cx="22" cy="22" r="1.5" fill="#E91E63"></circle>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C9">
            <title>Center Dot</title>
            <circle cx="22" cy="22" r="3" fill="#CDDC39"></circle>
            <circle cx="22" cy="22" r="1" fill="#263238"></circle>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C10">
            <title>Center Hexagon</title>
            <path d="M22 17 L 26 19.5 L 26 24.5 L 22 27 L 18 24.5 L 18 19.5 Z" fill="#3F51B5"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C11">
            <title>Center X</title>
            <path d="M18 18 L 26 26 M18 26 L 26 18" stroke="#8BC34A" stroke-width="2" stroke-linecap="round"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C12">
            <title>Center Heart</title>
            <path d="M22 27 C 20 25, 16 22, 16 20 C 16 18, 17 17, 19 17 C 20 17, 21 18, 22 19 C 23 18, 24 17, 25 17 C 27 17, 28 18, 28 20 C 28 22, 24 25, 22 27 Z" fill="#E91E63"></path>
        </symbol>
    </svg>`,

        'symbols': {
            'Z': 3,
            'A': 9,
            'B': 12,
            'C': 12
        },

    },










    
        {
            'id': 10,
            'svg': `<svg width="0" height="0" class="hidden">
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1">
                <title>Z1</title>
                <path fill="#2E7D32" d="M0 0h44v44H0z"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2">
                <title>Z2</title>
                <path fill="#1B5E20" d="M0 0h44v44H0z"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3">
                <title>Z3</title>
                <path fill="#004D40" d="M0 0h44v44H0z"></path>
            </symbol>
            
            <!-- A series: Corner Fruits (large elements in the corners) -->
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1">
                <title>Apples</title>
                <!-- Top left apple -->
                <circle cx="10" cy="10" r="6" fill="#E53935"></circle>
                <path d="M10 4 C 9 4, 8 5, 9 6" stroke="#33691E" stroke-width="1" fill="none"></path>
                <path d="M13 5 L 12 7" stroke="#33691E" stroke-width="1"></path>
                
                <!-- Top right apple -->
                <circle cx="34" cy="10" r="6" fill="#E53935"></circle>
                <path d="M34 4 C 33 4, 32 5, 33 6" stroke="#33691E" stroke-width="1" fill="none"></path>
                <path d="M37 5 L 36 7" stroke="#33691E" stroke-width="1"></path>
                
                <!-- Bottom left apple -->
                <circle cx="10" cy="34" r="6" fill="#E53935"></circle>
                <path d="M10 28 C 9 28, 8 29, 9 30" stroke="#33691E" stroke-width="1" fill="none"></path>
                <path d="M13 29 L 12 31" stroke="#33691E" stroke-width="1"></path>
                
                <!-- Bottom right apple -->
                <circle cx="34" cy="34" r="6" fill="#E53935"></circle>
                <path d="M34 28 C 33 28, 32 29, 33 30" stroke="#33691E" stroke-width="1" fill="none"></path>
                <path d="M37 29 L 36 31" stroke="#33691E" stroke-width="1"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2">
                <title>Oranges</title>
                <!-- Top left orange -->
                <circle cx="10" cy="10" r="6" fill="#FF9800"></circle>
                <path d="M13 7 C 11 8, 10 10, 10 12 C 10 10, 8 8, 7 7" stroke="#33691E" stroke-width="1" fill="none"></path>
                
                <!-- Top right orange -->
                <circle cx="34" cy="10" r="6" fill="#FF9800"></circle>
                <path d="M37 7 C 35 8, 34 10, 34 12 C 34 10, 32 8, 31 7" stroke="#33691E" stroke-width="1" fill="none"></path>
                
                <!-- Bottom left orange -->
                <circle cx="10" cy="34" r="6" fill="#FF9800"></circle>
                <path d="M13 31 C 11 32, 10 34, 10 36 C 10 34, 8 32, 7 31" stroke="#33691E" stroke-width="1" fill="none"></path>
                
                <!-- Bottom right orange -->
                <circle cx="34" cy="34" r="6" fill="#FF9800"></circle>
                <path d="M37 31 C 35 32, 34 34, 34 36 C 34 34, 32 32, 31 31" stroke="#33691E" stroke-width="1" fill="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3">
                <title>Blueberries</title>
                <!-- Top left blueberry cluster -->
                <circle cx="8" cy="8" r="3" fill="#3F51B5"></circle>
                <circle cx="12" cy="10" r="3" fill="#3F51B5"></circle>
                <circle cx="10" cy="13" r="3" fill="#3F51B5"></circle>
                
                <!-- Top right blueberry cluster -->
                <circle cx="32" cy="8" r="3" fill="#3F51B5"></circle>
                <circle cx="36" cy="10" r="3" fill="#3F51B5"></circle>
                <circle cx="34" cy="13" r="3" fill="#3F51B5"></circle>
                
                <!-- Bottom left blueberry cluster -->
                <circle cx="8" cy="32" r="3" fill="#3F51B5"></circle>
                <circle cx="12" cy="34" r="3" fill="#3F51B5"></circle>
                <circle cx="10" cy="37" r="3" fill="#3F51B5"></circle>
                
                <!-- Bottom right blueberry cluster -->
                <circle cx="32" cy="32" r="3" fill="#3F51B5"></circle>
                <circle cx="36" cy="34" r="3" fill="#3F51B5"></circle>
                <circle cx="34" cy="37" r="3" fill="#3F51B5"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4">
                <title>Strawberries</title>
                <!-- Top left strawberry -->
                <path d="M10 4 L 10 7" stroke="#33691E" stroke-width="1"></path>
                <path d="M10 7 C 6 9, 6 15, 10 17 C 14 15, 14 9, 10 7" fill="#F44336"></path>
                <circle cx="8" cy="10" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="11" cy="9" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="12" cy="12" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="9" cy="14" r="0.5" fill="#FFEB3B"></circle>
                
                <!-- Top right strawberry -->
                <path d="M34 4 L 34 7" stroke="#33691E" stroke-width="1"></path>
                <path d="M34 7 C 30 9, 30 15, 34 17 C 38 15, 38 9, 34 7" fill="#F44336"></path>
                <circle cx="32" cy="10" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="35" cy="9" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="36" cy="12" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="33" cy="14" r="0.5" fill="#FFEB3B"></circle>
                
                <!-- Bottom left strawberry -->
                <path d="M10 28 L 10 31" stroke="#33691E" stroke-width="1"></path>
                <path d="M10 31 C 6 33, 6 39, 10 41 C 14 39, 14 33, 10 31" fill="#F44336"></path>
                <circle cx="8" cy="34" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="11" cy="33" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="12" cy="36" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="9" cy="38" r="0.5" fill="#FFEB3B"></circle>
                
                <!-- Bottom right strawberry -->
                <path d="M34 28 L 34 31" stroke="#33691E" stroke-width="1"></path>
                <path d="M34 31 C 30 33, 30 39, 34 41 C 38 39, 38 33, 34 31" fill="#F44336"></path>
                <circle cx="32" cy="34" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="35" cy="33" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="36" cy="36" r="0.5" fill="#FFEB3B"></circle>
                <circle cx="33" cy="38" r="0.5" fill="#FFEB3B"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5">
                <title>Bananas</title>
                <!-- Top left banana -->
                <path d="M6 6 C 8 8, 13 8, 14 12 C 12 10, 8 10, 6 6" fill="#FFEB3B"></path>
                
                <!-- Top right banana -->
                <path d="M38 6 C 36 8, 31 8, 30 12 C 32 10, 36 10, 38 6" fill="#FFEB3B"></path>
                
                <!-- Bottom left banana -->
                <path d="M6 38 C 8 36, 13 36, 14 32 C 12 34, 8 34, 6 38" fill="#FFEB3B"></path>
                
                <!-- Bottom right banana -->
                <path d="M38 38 C 36 36, 31 36, 30 32 C 32 34, 36 34, 38 38" fill="#FFEB3B"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6">
                <title>Cherries</title>
                <!-- Top left cherries -->
                <path d="M10 4 C 12 6, 12 8, 10 10" stroke="#33691E" stroke-width="1" fill="none"></path>
                <circle cx="10" cy="12" r="4" fill="#D32F2F"></circle>
                
                <!-- Top right cherries -->
                <path d="M34 4 C 36 6, 36 8, 34 10" stroke="#33691E" stroke-width="1" fill="none"></path>
                <circle cx="34" cy="12" r="4" fill="#D32F2F"></circle>
                
                <!-- Bottom left cherries -->
                <path d="M10 28 C 12 30, 12 32, 10 34" stroke="#33691E" stroke-width="1" fill="none"></path>
                <circle cx="10" cy="36" r="4" fill="#D32F2F"></circle>
                
                <!-- Bottom right cherries -->
                <path d="M34 28 C 36 30, 36 32, 34 34" stroke="#33691E" stroke-width="1" fill="none"></path>
                <circle cx="34" cy="36" r="4" fill="#D32F2F"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7">
                <title>Pears</title>
                <!-- Top left pear -->
                <path d="M10 5 L 10 7" stroke="#33691E" stroke-width="1"></path>
                <path d="M10 7 C 8 10, 6 13, 8 16 C 12 16, 14 13, 12 10 C 12 8, 10 7, 10 7" fill="#CDDC39"></path>
                
                <!-- Top right pear -->
                <path d="M34 5 L 34 7" stroke="#33691E" stroke-width="1"></path>
                <path d="M34 7 C 32 10, 30 13, 32 16 C 36 16, 38 13, 36 10 C 36 8, 34 7, 34 7" fill="#CDDC39"></path>
                
                <!-- Bottom left pear -->
                <path d="M10 29 L 10 31" stroke="#33691E" stroke-width="1"></path>
                <path d="M10 31 C 8 34, 6 37, 8 40 C 12 40, 14 37, 12 34 C 12 32, 10 31, 10 31" fill="#CDDC39"></path>
                
                <!-- Bottom right pear -->
                <path d="M34 29 L 34 31" stroke="#33691E" stroke-width="1"></path>
                <path d="M34 31 C 32 34, 30 37, 32 40 C 36 40, 38 37, 36 34 C 36 32, 34 31, 34 31" fill="#CDDC39"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8">
                <title>Grapes</title>
                <!-- Top left grapes -->
                <path d="M12 4 C 14 5, 14 7, 13 9" stroke="#33691E" stroke-width="1" fill="none"></path>
                <circle cx="9" cy="9" r="2" fill="#9C27B0"></circle>
                <circle cx="12" cy="11" r="2" fill="#9C27B0"></circle>
                <circle cx="8" cy="13" r="2" fill="#9C27B0"></circle>
                <circle cx="12" cy="15" r="2" fill="#9C27B0"></circle>
                
                <!-- Top right grapes -->
                <path d="M32 4 C 34 5, 34 7, 33 9" stroke="#33691E" stroke-width="1" fill="none"></path>
                <circle cx="29" cy="9" r="2" fill="#9C27B0"></circle>
                <circle cx="32" cy="11" r="2" fill="#9C27B0"></circle>
                <circle cx="28" cy="13" r="2" fill="#9C27B0"></circle>
                <circle cx="32" cy="15" r="2" fill="#9C27B0"></circle>
                
                <!-- Bottom left grapes -->
                <path d="M12 28 C 14 29, 14 31, 13 33" stroke="#33691E" stroke-width="1" fill="none"></path>
                <circle cx="9" cy="33" r="2" fill="#9C27B0"></circle>
                <circle cx="12" cy="35" r="2" fill="#9C27B0"></circle>
                <circle cx="8" cy="37" r="2" fill="#9C27B0"></circle>
                <circle cx="12" cy="39" r="2" fill="#9C27B0"></circle>
                
                <!-- Bottom right grapes -->
                <path d="M32 28 C 34 29, 34 31, 33 33" stroke="#33691E" stroke-width="1" fill="none"></path>
                <circle cx="29" cy="33" r="2" fill="#9C27B0"></circle>
                <circle cx="32" cy="35" r="2" fill="#9C27B0"></circle>
                <circle cx="28" cy="37" r="2" fill="#9C27B0"></circle>
                <circle cx="32" cy="39" r="2" fill="#9C27B0"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9">
                <title>Watermelons</title>
                <!-- Top left watermelon -->
                <path d="M4 4 C 8 8, 16 8, 16 4" fill="#4CAF50"></path>
                <path d="M5 5 C 8 8, 15 8, 15 5" fill="#F44336"></path>
                <circle cx="7" cy="6" r="0.5" fill="black"></circle>
                <circle cx="9" cy="6" r="0.5" fill="black"></circle>
                <circle cx="11" cy="6" r="0.5" fill="black"></circle>
                <circle cx="13" cy="6" r="0.5" fill="black"></circle>
                
                <!-- Top right watermelon -->
                <path d="M28 4 C 32 8, 40 8, 40 4" fill="#4CAF50"></path>
                <path d="M29 5 C 32 8, 39 8, 39 5" fill="#F44336"></path>
                <circle cx="31" cy="6" r="0.5" fill="black"></circle>
                <circle cx="33" cy="6" r="0.5" fill="black"></circle>
                <circle cx="35" cy="6" r="0.5" fill="black"></circle>
                <circle cx="37" cy="6" r="0.5" fill="black"></circle>
                
                <!-- Bottom left watermelon -->
                <path d="M4 40 C 8 36, 16 36, 16 40" fill="#4CAF50"></path>
                <path d="M5 39 C 8 36, 15 36, 15 39" fill="#F44336"></path>
                <circle cx="7" cy="38" r="0.5" fill="black"></circle>
                <circle cx="9" cy="38" r="0.5" fill="black"></circle>
                <circle cx="11" cy="38" r="0.5" fill="black"></circle>
                <circle cx="13" cy="38" r="0.5" fill="black"></circle>
                
                <!-- Bottom right watermelon -->
                <path d="M28 40 C 32 36, 40 36, 40 40" fill="#4CAF50"></path>
                <path d="M29 39 C 32 36, 39 36, 39 39" fill="#F44336"></path>
                <circle cx="31" cy="38" r="0.5" fill="black"></circle>
                <circle cx="33" cy="38" r="0.5" fill="black"></circle>
                <circle cx="35" cy="38" r="0.5" fill="black"></circle>
                <circle cx="37" cy="38" r="0.5" fill="black"></circle>
            </symbol>
            
            <!-- B series: Border Trees/Plants (frames around the middle) -->
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1">
                <title>Pine Tree Frame</title>
                <path d="M22 9 L 26 15 L 30 21 L 26 21 L 30 27 L 26 27 L 30 33 L 14 33 L 18 27 L 14 27 L 18 21 L 14 21 L 18 15 Z" 
                     fill="#2E7D32" stroke="none"></path>
                <rect x="20" y="33" width="4" height="3" fill="#795548"></rect>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2">
                <title>Oak Tree Frame</title>
                <circle cx="22" cy="18" r="9" fill="#66BB6A"></circle>
                <rect x="20" y="18" width="4" height="17" fill="#795548"></rect>
                <path d="M18 24 L 16 22 M26 24 L 28 22 M20 31 L 18 35 M24 31 L 26 35" stroke="#795548" stroke-width="2"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3">
                <title>Flower Frame</title>
                <circle cx="22" cy="22" r="5" fill="#FFEB3B"></circle>
                <circle cx="22" cy="13" r="4" fill="#F06292"></circle>
                <circle cx="22" cy="31" r="4" fill="#F06292"></circle>
                <circle cx="13" cy="22" r="4" fill="#F06292"></circle>
                <circle cx="31" cy="22" r="4" fill="#F06292"></circle>
                <circle cx="15" cy="15" r="4" fill="#F06292"></circle>
                <circle cx="29" cy="15" r="4" fill="#F06292"></circle>
                <circle cx="15" cy="29" r="4" fill="#F06292"></circle>
                <circle cx="29" cy="29" r="4" fill="#F06292"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4">
                <title>Palm Tree Frame</title>
                <rect x="20" y="16" width="4" height="19" fill="#795548"></rect>
                <path d="M22 16 C 22 12, 18 8, 12 9 M22 16 C 22 12, 26 8, 32 9 M22 16 C 18 14, 14 16, 13 19 M22 16 C 26 14, 30 16, 31 19" 
                     stroke="#4CAF50" stroke-width="3" fill="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5">
                <title>Bush Frame</title>
                <path d="M12 30 C 12 22, 15 17, 22 17 C 29 17, 32 22, 32 30 Z" fill="#388E3C"></path>
                <path d="M13 24 C 18 22, 18 28, 22 28 C 26 28, 26 22, 31 24" stroke="#1B5E20" stroke-width="1" fill="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6">
                <title>Vine Frame</title>
                <path d="M14 11 C 22 11, 22 33, 30 33" stroke="#4CAF50" stroke-width="2" fill="none"></path>
                <path d="M18 14 C 16 16, 18 21, 22 21 C 26 21, 28 16, 26 14" stroke="#4CAF50" stroke-width="2" fill="none"></path>
                <path d="M18 30 C 16 28, 18 23, 22 23 C 26 23, 28 28, 26 30" stroke="#4CAF50" stroke-width="2" fill="none"></path>
                <circle cx="22" cy="21" r="3" fill="#8BC34A"></circle>
                <circle cx="22" cy="23" r="3" fill="#8BC34A"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7">
                <title>Cactus Frame</title>
                <rect x="20" y="14" width="4" height="20" rx="2" fill="#388E3C"></rect>
                <rect x="14" y="20" width="14" height="4" rx="2" fill="#388E3C"></rect>
                <path d="M14 22 C 14 16, 14 14, 20 14" stroke="#388E3C" stroke-width="4" fill="none" stroke-linecap="round"></path>
                <path d="M30 22 C 30 16, 30 14, 24 14" stroke="#388E3C" stroke-width="4" fill="none" stroke-linecap="round"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8">
                <title>Fern Frame</title>
                <path d="M22 10 L 22 34" stroke="#33691E" stroke-width="2"></path>
                <path d="M22 14 C 20 14, 16 16, 14 18 M22 18 C 20 18, 16 20, 14 22 M22 22 C 20 22, 16 24, 14 26 M22 26 C 20 26, 16 28, 14 30" 
                     stroke="#66BB6A" stroke-width="1" fill="none"></path>
                <path d="M22 14 C 24 14, 28 16, 30 18 M22 18 C 24 18, 28 20, 30 22 M22 22 C 24 22, 28 24, 30 26 M22 26 C 24 26, 28 28, 30 30" 
                     stroke="#66BB6A" stroke-width="1" fill="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9">
                <title>Sunflower Frame</title>
                <circle cx="22" cy="22" r="6" fill="#795548"></circle>
                <path d="M22 10 L 22 16 M22 28 L 22 34 M10 22 L 16 22 M28 22 L 34 22" stroke="#FFEB3B" stroke-width="3" stroke-linecap="round"></path>
                <path d="M14 14 L 18 18 M30 14 L 26 18 M14 30 L 18 26 M30 30 L 26 26" stroke="#FFEB3B" stroke-width="3" stroke-linecap="round"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10">
                <title>Bamboo Frame</title>
                <rect x="16" y="10" width="4" height="24" rx="2" fill="#7CB342"></rect>
                <rect x="24" y="10" width="4" height="24" rx="2" fill="#7CB342"></rect>
                <path d="M16 15 L 20 15 M16 21 L 20 21 M16 27 L 20 27 M24 18 L 28 18 M24 24 L 28 24 M24 30 L 28 30" 
                     stroke="#33691E" stroke-width="1"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11">
                <title>Wheat Frame</title>
                <path d="M16 34 L 16 14 M22 34 L 22 14 M28 34 L 28 14" stroke="#FFA000" stroke-width="2"></path>
                <path d="M13 16 L 19 16 M13 20 L 19 20 M13 24 L 19 24 M19 18 L 25 18 M19 22 L 25 22 M19 26 L 25 26 M25 16 L 31 16 M25 20 L 31 20 M25 24 L 31 24" 
                     stroke="#FFC107" stroke-width="1"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12">
                <title>Hedge Frame</title>
                <rect x="9" y="14" width="26" height="16" rx="2" fill="#2E7D32"></rect>
                <path d="M12 14 C 12 10, 14 10, 16 14 M16 14 C 16 10, 18 10, 20 14 M20 14 C 20 10, 22 10, 24 14 M24 14 C 24 10, 26 10, 28 14 M28 14 C 28 10, 30 10, 32 14" 
                     stroke="#388E3C" stroke-width="1" fill="none"></path>
                <path d="M12 30 C 12 34, 14 34, 16 30 M16 30 C 16 34, 18 34, 20 30 M20 30 C 20 34, 22 34, 24 30 M24 30 C 24 34, 26 34, 28 30 M28 30 C 28 34, 30 34, 32 30" 
                     stroke="#388E3C" stroke-width="1" fill="none"></path>
            </symbol>
            
            <!-- C series: Center Leaves/Seeds/Flowers (small central elements) -->
<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1">
    <title>Leaf Shape</title>
    <path d="M22 16 C 19 18, 16 22, 22 28 C 28 22, 25 18, 22 16 Z" fill="#4CAF50"></path>
    <path d="M22 16 L 22 28" stroke="#388E3C" stroke-width="1"></path>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2">
    <title>Four-Leaf Clover</title>
    <path d="M19 16 C 16 16, 16 19, 19 19 C 19 16, 22 16, 22 19 L 22 25 C 22 28, 19 28, 19 25 C 16 25, 16 22, 19 22" fill="#4CAF50"></path>
    <path d="M25 16 C 28 16, 28 19, 25 19 C 25 16, 22 16, 22 19 L 22 25 C 22 28, 25 28, 25 25 C 28 25, 28 22, 25 22" fill="#4CAF50"></path>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C3">
    <title>Flower Blossom</title>
    <circle cx="22" cy="22" r="3" fill="#FFEB3B"></circle>
    <circle cx="22" cy="17" r="2" fill="#F06292"></circle>
    <circle cx="22" cy="27" r="2" fill="#F06292"></circle>
    <circle cx="17" cy="22" r="2" fill="#F06292"></circle>
    <circle cx="27" cy="22" r="2" fill="#F06292"></circle>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C4">
    <title>Acorn</title>
    <path d="M22 16 L 22 19" stroke="#795548" stroke-width="1"></path>
    <path d="M19 19 L 25 19" stroke="#795548" stroke-width="1"></path>
    <path d="M22 19 C 18 19, 17 22, 17 25 C 17 28, 19 29, 22 29 C 25 29, 27 28, 27 25 C 27 22, 26 19, 22 19" fill="#8D6E63"></path>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C5">
    <title>Maple Leaf</title>
    <path d="M22 16 L 23 18 L 25 17 L 24 20 L 26 22 L 23 22 L 22 25 L 21 22 L 18 22 L 20 20 L 19 17 L 21 18 Z" fill="#F44336"></path>
    <path d="M22 25 L 22 28" stroke="#D32F2F" stroke-width="1"></path>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C6">
    <title>Seedling</title>
    <path d="M22 28 L 22 20" stroke="#795548" stroke-width="1"></path>
    <path d="M19 20 C 19 17, 22 14, 25 17" stroke="#4CAF50" stroke-width="1" fill="none"></path>
    <path d="M22 20 C 22 17, 25 15, 27 17" stroke="#4CAF50" stroke-width="1" fill="none"></path>
    <circle cx="19" cy="20" r="1" fill="#8BC34A"></circle>
    <circle cx="25" cy="17" r="1" fill="#8BC34A"></circle>
    <circle cx="27" cy="17" r="1" fill="#8BC34A"></circle>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C7">
    <title>Fruit Seeds</title>
    <circle cx="22" cy="22" r="4" fill="#FFECB3"></circle>
    <circle cx="20" cy="20" r="1" fill="#795548"></circle>
    <circle cx="24" cy="20" r="1" fill="#795548"></circle>
    <circle cx="20" cy="24" r="1" fill="#795548"></circle>
    <circle cx="24" cy="24" r="1" fill="#795548"></circle>
    <circle cx="22" cy="22" r="1" fill="#795548"></circle>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C8">
    <title>Pine Cone</title>
    <path d="M22 16 L 22 28" stroke="#5D4037" stroke-width="1"></path>
    <path d="M20 19 L 24 19 M19 21 L 25 21 M19 23 L 25 23 M20 25 L 24 25" stroke="#795548" stroke-width="2" stroke-linecap="round"></path>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C9">
    <title>Berry</title>
    <circle cx="22" cy="22" r="5" fill="#E53935"></circle>
    <path d="M22 17 L 22 15" stroke="#4CAF50" stroke-width="1"></path>
    <path d="M21 17 C 19 17, 19 18, 20 19" stroke="#4CAF50" stroke-width="1" fill="none"></path>
    <circle cx="21" cy="20" r="0.5" fill="#FFEB3B"></circle>
    <circle cx="23" cy="21" r="0.5" fill="#FFEB3B"></circle>
    <circle cx="20" cy="23" r="0.5" fill="#FFEB3B"></circle>
    <circle cx="23" cy="24" r="0.5" fill="#FFEB3B"></circle>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C10">
    <title>Sunflower Center</title>
    <circle cx="22" cy="22" r="4" fill="#795548"></circle>
    <circle cx="20" cy="20" r="0.5" fill="#3E2723"></circle>
    <circle cx="21" cy="21" r="0.5" fill="#3E2723"></circle>
    <circle cx="22" cy="20" r="0.5" fill="#3E2723"></circle>
    <circle cx="23" cy="21" r="0.5" fill="#3E2723"></circle>
    <circle cx="24" cy="20" r="0.5" fill="#3E2723"></circle>
    <circle cx="20" cy="22" r="0.5" fill="#3E2723"></circle>
    <circle cx="22" cy="22" r="0.5" fill="#3E2723"></circle>
    <circle cx="24" cy="22" r="0.5" fill="#3E2723"></circle>
    <circle cx="20" cy="24" r="0.5" fill="#3E2723"></circle>
    <circle cx="21" cy="23" r="0.5" fill="#3E2723"></circle>
    <circle cx="22" cy="24" r="0.5" fill="#3E2723"></circle>
    <circle cx="23" cy="23" r="0.5" fill="#3E2723"></circle>
    <circle cx="24" cy="24" r="0.5" fill="#3E2723"></circle>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C11">
    <title>Tropical Flower</title>
    <path d="M19 19 C 16 19, 15 22, 19 25 C 15 28, 16 31, 19 31 C 22 31, 25 28, 22 25 C 25 22, 22 19, 19 19" fill="#FF9800"></path>
    <path d="M25 19 C 28 19, 29 22, 25 25 C 29 28, 28 31, 25 31 C 22 31, 19 28, 22 25 C 19 22, 22 19, 25 19" fill="#FF9800"></path>
    <circle cx="22" cy="25" r="2" fill="#FFEB3B"></circle>
</symbol>

<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C12">
    <title>Twirling Vine</title>
    <path d="M22 17 C 19 17, 17 20, 19 23 C 21 26, 25 26, 25 22 C 25 19, 22 19, 22 22 C 22 24, 24 25, 25 23" stroke="#4CAF50" stroke-width="1" fill="none"></path>
    <circle cx="19" cy="23" r="1" fill="#8BC34A"></circle>
    <circle cx="25" cy="22" r="1" fill="#8BC34A"></circle>
    <circle cx="22" cy="22" r="1" fill="#8BC34A"></circle>
    <circle cx="25" cy="23" r="1" fill="#8BC34A"></circle>
</symbol>
</svg>`,

        'symbols': {
            'Z': 3,
            'A': 9,
            'B': 12,
            'C': 12
        },
    },

        // New restructured nature-themed set (id: 9)
        {
            'id': 11,
            'svg': `<svg width="0" height="0" class="hidden">
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z1">
                <title>Z1</title>
                <path fill="#1B5E20" d="M0 0h44v44H0z"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z2">
                <title>Z2</title>
                <path fill="#004D40" d="M0 0h44v44H0z"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="Z3">
                <title>Z3</title>
                <path fill="#33691E" d="M0 0h44v44H0z"></path>
            </symbol>
            
            <!-- A series: Decorative Elements -->
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A1">
                <title>Flower Border</title>
                <circle cx="22" cy="8" r="2" fill="#FF80AB"></circle>
                <circle cx="36" cy="22" r="2" fill="#FF80AB"></circle>
                <circle cx="22" cy="36" r="2" fill="#FF80AB"></circle>
                <circle cx="8" cy="22" r="2" fill="#FF80AB"></circle>
                <path d="M11 11 L 14 14 M33 11 L 30 14 M11 33 L 14 30 M33 33 L 30 30" stroke="#FF80AB" stroke-width="1"></path>
                <circle cx="22" cy="22" r="6" fill="none" stroke="#FF80AB" stroke-width="1" stroke-dasharray="3,2"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A2">
                <title>Swirling Vines</title>
                <path d="M8 8 C 14 4, 18 6, 22 8 C 26 10, 30 4, 36 8 C 40 12, 38 16, 36 22 C 34 26, 40 30, 36 36 C 32 40, 28 38, 22 36 C 18 34, 14 40, 8 36 C 4 32, 6 28, 8 22 C 10 18, 4 14, 8 8" 
                     stroke="#AED581" stroke-width="1" fill="none"></path>
                <circle cx="8" cy="8" r="1" fill="#AED581"></circle>
                <circle cx="36" cy="8" r="1" fill="#AED581"></circle>
                <circle cx="8" cy="36" r="1" fill="#AED581"></circle>
                <circle cx="36" cy="36" r="1" fill="#AED581"></circle>
                <circle cx="22" cy="8" r="1" fill="#AED581"></circle>
                <circle cx="36" cy="22" r="1" fill="#AED581"></circle>
                <circle cx="22" cy="36" r="1" fill="#AED581"></circle>
                <circle cx="8" cy="22" r="1" fill="#AED581"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A3">
                <title>Daisy Chain</title>
                <circle cx="15" cy="15" r="3" fill="none" stroke="#FFF59D" stroke-width="1"></circle>
                <circle cx="29" cy="15" r="3" fill="none" stroke="#FFF59D" stroke-width="1"></circle>
                <circle cx="15" cy="29" r="3" fill="none" stroke="#FFF59D" stroke-width="1"></circle>
                <circle cx="29" cy="29" r="3" fill="none" stroke="#FFF59D" stroke-width="1"></circle>
                <path d="M12 12 L 8 8 M32 12 L 36 8 M12 32 L 8 36 M32 32 L 36 36" stroke="#FFF59D" stroke-width="1"></path>
                <circle cx="15" cy="15" r="1" fill="#FFF59D"></circle>
                <circle cx="29" cy="15" r="1" fill="#FFF59D"></circle>
                <circle cx="15" cy="29" r="1" fill="#FFF59D"></circle>
                <circle cx="29" cy="29" r="1" fill="#FFF59D"></circle>
                <path d="M15 15 C 20 10, 24 10, 29 15 M15 29 C 20 34, 24 34, 29 29 M15 15 C 10 20, 10 24, 15 29 M29 15 C 34 20, 34 24, 29 29" 
                     stroke="#FFF59D" stroke-width="1" fill="none" stroke-dasharray="2,2"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A4">
                <title>Dew Drops</title>
                <circle cx="8" cy="8" r="2" fill="#B3E5FC"></circle>
                <circle cx="36" cy="8" r="2" fill="#B3E5FC"></circle>
                <circle cx="8" cy="36" r="2" fill="#B3E5FC"></circle>
                <circle cx="36" cy="36" r="2" fill="#B3E5FC"></circle>
                <circle cx="22" cy="8" r="1.5" fill="#B3E5FC"></circle>
                <circle cx="36" cy="22" r="1.5" fill="#B3E5FC"></circle>
                <circle cx="22" cy="36" r="1.5" fill="#B3E5FC"></circle>
                <circle cx="8" cy="22" r="1.5" fill="#B3E5FC"></circle>
                <circle cx="15" cy="15" r="1" fill="#B3E5FC"></circle>
                <circle cx="29" cy="15" r="1" fill="#B3E5FC"></circle>
                <circle cx="15" cy="29" r="1" fill="#B3E5FC"></circle>
                <circle cx="29" cy="29" r="1" fill="#B3E5FC"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A5">
                <title>Trellis</title>
                <path d="M8 8 L 36 36 M8 36 L 36 8 M8 22 L 36 22 M22 8 L 22 36" stroke="#FFCC80" stroke-width="1"></path>
                <circle cx="8" cy="8" r="1" fill="#FFCC80"></circle>
                <circle cx="36" cy="8" r="1" fill="#FFCC80"></circle>
                <circle cx="8" cy="36" r="1" fill="#FFCC80"></circle>
                <circle cx="36" cy="36" r="1" fill="#FFCC80"></circle>
                <circle cx="22" cy="8" r="1" fill="#FFCC80"></circle>
                <circle cx="36" cy="22" r="1" fill="#FFCC80"></circle>
                <circle cx="22" cy="36" r="1" fill="#FFCC80"></circle>
                <circle cx="8" cy="22" r="1" fill="#FFCC80"></circle>
                <circle cx="22" cy="22" r="1" fill="#FFCC80"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A6">
                <title>Butterfly Pattern</title>
                <path d="M22 10 C 16 14, 10 12, 8 8 C 10 16, 14 18, 18 17" stroke="#E1BEE7" stroke-width="1" fill="none"></path>
                <path d="M22 10 C 28 14, 34 12, 36 8 C 34 16, 30 18, 26 17" stroke="#E1BEE7" stroke-width="1" fill="none"></path>
                <path d="M22 34 C 16 30, 10 32, 8 36 C 10 28, 14 26, 18 27" stroke="#E1BEE7" stroke-width="1" fill="none"></path>
                <path d="M22 34 C 28 30, 34 32, 36 36 C 34 28, 30 26, 26 27" stroke="#E1BEE7" stroke-width="1" fill="none"></path>
                <path d="M22 10 L 22 34" stroke="#E1BEE7" stroke-width="1"></path>
                <circle cx="22" cy="18" r="1" fill="#E1BEE7"></circle>
                <circle cx="22" cy="26" r="1" fill="#E1BEE7"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A7">
                <title>Windblown Dandelion</title>
                <circle cx="22" cy="22" r="3" fill="#EEEEEE"></circle>
                <path d="M22 22 L 26 18 M22 22 L 28 22 M22 22 L 26 26 M22 22 L 22 28 M22 22 L 18 26 M22 22 L 16 22 M22 22 L 18 18 M22 22 L 22 16" 
                     stroke="#EEEEEE" stroke-width="1"></path>
                <path d="M26 18 C 30 14, 28 10, 25 9 M28 22 C 34 22, 36 18, 35 15 M26 26 C 30 30, 34 28, 35 25 M22 28 C 22 34, 26 36, 29 35 M18 26 C 14 30, 10 28, 9 25 M16 22 C 10 22, 8 18, 9 15 M18 18 C 14 14, 16 10, 19 9 M22 16 C 22 10, 26 8, 29 9" 
                     stroke="#EEEEEE" stroke-width="0.5" fill="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A8">
                <title>Ladybug Trail</title>
                <path d="M8 22 C 14 16, 18 14, 22 12 C 26 14, 30 16, 36 22 C 30 28, 26 30, 22 32 C 18 30, 14 28, 8 22 Z" 
                     stroke="#FFCDD2" stroke-width="1" fill="none" stroke-dasharray="2,2"></path>
                <circle cx="22" cy="12" r="2" fill="#F44336"></circle>
                <circle cx="28" cy="16" r="2" fill="#F44336"></circle>
                <circle cx="34" cy="22" r="2" fill="#F44336"></circle>
                <circle cx="28" cy="28" r="2" fill="#F44336"></circle>
                <circle cx="22" cy="32" r="2" fill="#F44336"></circle>
                <circle cx="16" cy="28" r="2" fill="#F44336"></circle>
                <circle cx="10" cy="22" r="2" fill="#F44336"></circle>
                <circle cx="16" cy="16" r="2" fill="#F44336"></circle>
                <path d="M22 10 L 22 12 M28 14 L 28 16 M36 22 L 34 22 M30 28 L 28 28 M22 34 L 22 32 M14 28 L 16 28 M8 22 L 10 22 M14 14 L 16 16" 
                     stroke="#F44336" stroke-width="1"></path>
                <path d="M22 12 L 28 16 L 34 22 L 28 28 L 22 32 L 16 28 L 10 22 L 16 16 Z" 
                     stroke="#F44336" stroke-width="0.5" fill="none" stroke-dasharray="1,1"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="A9">
                <title>Rain Droplets</title>
                <path d="M11 11 L 8 8 M33 11 L 36 8 M11 33 L 8 36 M33 33 L 36 36" stroke="#81D4FA" stroke-width="1"></path>
                <path d="M16 12 L 14 8 M28 12 L 30 8 M12 16 L 8 14 M12 28 L 8 30 M16 32 L 14 36 M28 32 L 30 36 M32 16 L 36 14 M32 28 L 36 30" 
                     stroke="#81D4FA" stroke-width="1"></path>
                <path d="M22 8 L 22 12 M8 22 L 12 22 M22 36 L 22 32 M36 22 L 32 22" stroke="#81D4FA" stroke-width="1"></path>
                <circle cx="11" cy="11" r="1" fill="#81D4FA"></circle>
                <circle cx="33" cy="11" r="1" fill="#81D4FA"></circle>
                <circle cx="11" cy="33" r="1" fill="#81D4FA"></circle>
                <circle cx="33" cy="33" r="1" fill="#81D4FA"></circle>
                <circle cx="16" cy="12" r="1" fill="#81D4FA"></circle>
                <circle cx="28" cy="12" r="1" fill="#81D4FA"></circle>
                <circle cx="12" cy="16" r="1" fill="#81D4FA"></circle>
                <circle cx="12" cy="28" r="1" fill="#81D4FA"></circle>
                <circle cx="16" cy="32" r="1" fill="#81D4FA"></circle>
                <circle cx="28" cy="32" r="1" fill="#81D4FA"></circle>
                <circle cx="32" cy="16" r="1" fill="#81D4FA"></circle>
                <circle cx="32" cy="28" r="1" fill="#81D4FA"></circle>
                <circle cx="22" cy="12" r="1" fill="#81D4FA"></circle>
                <circle cx="12" cy="22" r="1" fill="#81D4FA"></circle>
                <circle cx="22" cy="32" r="1" fill="#81D4FA"></circle>
                <circle cx="32" cy="22" r="1" fill="#81D4FA"></circle>
            </symbol>
            
            <!-- B series: Large Central Fruits -->
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B1">
                <title>Large Apple</title>
                <circle cx="22" cy="24" r="10" fill="#E53935"></circle>
                <path d="M22 14 L 22 18" stroke="#795548" stroke-width="1.5"></path>
                <path d="M22 18 C 20 16, 18 18, 19 20" stroke="#7CB342" stroke-width="1.5" fill="none"></path>
                <path d="M25 17 L 24 19" stroke="#7CB342" stroke-width="1.5"></path>
                <path d="M22 24 C 18 24, 16 22, 16 18 C 20 16, 28 16, 28 18 C 28 22, 26 24, 22 24" 
                      fill="#D32F2F" stroke="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B2">
                <title>Large Orange</title>
                <circle cx="22" cy="22" r="11" fill="#FF9800"></circle>
                <path d="M22 11 C 20 11, 19 12, 20 13 C 21 12, 23 12, 24 13 C 25 12, 24 11, 22 11" fill="#7CB342"></path>
                <path d="M22 11 L 22 14" stroke="#795548" stroke-width="1.5"></path>
                <path d="M22 22 C 18 22, 16 18, 17 15 C 20 18, 24 18, 27 15 C 28 18, 26 22, 22 22" 
                      fill="#FB8C00" stroke="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B3">
                <title>Large Strawberry</title>
                <path d="M22 12 L 22 16" stroke="#795548" stroke-width="1.5"></path>
                <path d="M22 16 C 14 20, 14 30, 22 34 C 30 30, 30 20, 22 16" fill="#F44336"></path>
                <path d="M22 16 C 19 17, 16 22, 18 28 C 22 30, 26 30, 26 28 C 28 22, 25 17, 22 16" 
                      fill="#E53935" stroke="none"></path>
                <circle cx="17" cy="20" r="0.7" fill="#FFF9C4"></circle>
                <circle cx="19" cy="24" r="0.7" fill="#FFF9C4"></circle>
                <circle cx="22" cy="22" r="0.7" fill="#FFF9C4"></circle>
                <circle cx="25" cy="24" r="0.7" fill="#FFF9C4"></circle>
                <circle cx="27" cy="20" r="0.7" fill="#FFF9C4"></circle>
                <circle cx="19" cy="28" r="0.7" fill="#FFF9C4"></circle>
                <circle cx="23" cy="26" r="0.7" fill="#FFF9C4"></circle>
                <circle cx="25" cy="30" r="0.7" fill="#FFF9C4"></circle>
                <circle cx="21" cy="30" r="0.7" fill="#FFF9C4"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B4">
                <title>Large Watermelon</title>
                <path d="M12 16 C 12 28, 22 36, 32 28 C 32 16, 22 8, 12 16 Z" fill="#4CAF50"></path>
                <path d="M14 18 C 14 26, 22 32, 30 26 C 30 18, 22 12, 14 18 Z" fill="#F44336"></path>
                <path d="M14 18 C 18 20, 26 20, 30 18 C 30 22, 28 26, 22 28 C 16 26, 14 22, 14 18" 
                      fill="#E53935" stroke="none"></path>
                <circle cx="18" cy="20" r="0.8" fill="black"></circle>
                <circle cx="22" cy="22" r="0.8" fill="black"></circle>
                <circle cx="26" cy="20" r="0.8" fill="black"></circle>
                <circle cx="16" cy="24" r="0.8" fill="black"></circle>
                <circle cx="20" cy="26" r="0.8" fill="black"></circle>
                <circle cx="24" cy="26" r="0.8" fill="black"></circle>
                <circle cx="28" cy="24" r="0.8" fill="black"></circle>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B5">
                <title>Large Grapes</title>
                <path d="M22 12 C 24 13, 26 15, 24 18" stroke="#795548" stroke-width="1.5" fill="none"></path>
                <circle cx="20" cy="18" r="3" fill="#9C27B0"></circle>
                <circle cx="26" cy="18" r="3" fill="#9C27B0"></circle>
                <circle cx="17" cy="23" r="3" fill="#9C27B0"></circle>
                <circle cx="23" cy="23" r="3" fill="#9C27B0"></circle>
                <circle cx="29" cy="23" r="3" fill="#9C27B0"></circle>
                <circle cx="14" cy="28" r="3" fill="#9C27B0"></circle>
                <circle cx="20" cy="28" r="3" fill="#9C27B0"></circle>
                <circle cx="26" cy="28" r="3" fill="#9C27B0"></circle>
                <circle cx="17" cy="33" r="3" fill="#9C27B0"></circle>
                <circle cx="23" cy="33" r="3" fill="#9C27B0"></circle>
                <path d="M20 18 C 22 16, 24 16, 26 18 C 28 20, 28 23, 28 26" 
                      fill="#8E24AA" stroke="none" fill-opacity="0.3"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B6">
                <title>Large Pineapple</title>
                <path d="M19 12 L 25 12 L 25 16 L 19 16 Z" fill="#7CB342"></path>
                <path d="M22 16 L 22 18" stroke="#7CB342" stroke-width="2"></path>
                <path d="M18 18 C 18 30, 18 34, 22 34 C 26 34, 26 30, 26 18 Z" fill="#FFC107"></path>
                <path d="M18 18 C 22 20, 22 28, 18 30 C 18 26, 18 22, 18 18" 
                      fill="#FFA000" stroke="none"></path>
                <path d="M26 18 C 22 20, 22 28, 26 30 C 26 26, 26 22, 26 18" 
                      fill="#FFA000" stroke="none"></path>
                <path d="M19 20 L 25 20 M19 24 L 25 24 M19 28 L 25 28 M19 32 L 25 32" 
                      stroke="#FF6F00" stroke-width="0.5" stroke-dasharray="1,1"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B7">
                <title>Large Cherries</title>
                <path d="M22 12 C 16 14, 12 16, 14 22" stroke="#795548" stroke-width="1.5" fill="none"></path>
                <path d="M22 12 C 28 14, 32 16, 30 22" stroke="#795548" stroke-width="1.5" fill="none"></path>
                <circle cx="14" cy="26" r="7" fill="#D32F2F"></circle>
                <circle cx="30" cy="26" r="7" fill="#D32F2F"></circle>
                <path d="M14 26 C 12 24, 10 24, 10 26 C 10 28, 12 28, 14 26" 
                      fill="#B71C1C" stroke="none"></path>
                <path d="M30 26 C 28 24, 26 24, 26 26 C 26 28, 28 28, 30 26" 
                      fill="#B71C1C" stroke="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B8">
                <title>Large Pear</title>
                <path d="M22 12 L 22 16" stroke="#795548" stroke-width="1.5"></path>
                <path d="M22 16 C 18 18, 16 22, 16 26 C 16 32, 28 32, 28 26 C 28 22, 26 18, 22 16" fill="#CDDC39"></path>
                <path d="M22 16 C 19 18, 16 22, 16 26 C 16 28, 18 30, 22 30 C 26 30, 28 28, 28 26 C 28 22, 25 18, 22 16" 
                      fill="#C0CA33" stroke="none"></path>
                <path d="M16 26 C 16 20, 28 20, 28 26" stroke="#AFB42B" stroke-width="0.5" fill="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B9">
                <title>Large Lemon</title>
                <ellipse cx="22" cy="22" rx="11" ry="9" fill="#FFEB3B"></ellipse>
                <path d="M22 13 C 18 13, 14 17, 14 22 C 14 27, 18 31, 22 31 C 26 31, 30 27, 30 22 C 30 17, 26 13, 22 13" 
                      fill="#FDD835" stroke="none"></path>
                <path d="M14 22 C 18 20, 26 20, 30 22 M14 22 C 18 24, 26 24, 30 22" 
                      stroke="#F9A825" stroke-width="0.5" fill="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B10">
                <title>Large Banana</title>
                <path d="M30 14 C 24 18, 14 20, 12 30 C 20 26, 30 24, 32 14 Z" fill="#FFEB3B"></path>
                <path d="M30 14 C 26 16, 20 18, 16 22 C 12 26, 12 28, 12 30 C 16 26, 24 24, 28 20 C 32 16, 32 14, 30 14" 
                      fill="#FDD835" stroke="none"></path>
                <path d="M16 22 L 28 20 M18 26 L 26 24" stroke="#F9A825" stroke-width="0.5"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B11">
                <title>Large Avocado</title>
                <path d="M22 13 C 14 13, 12 22, 12 28 C 12 34, 32 34, 32 28 C 32 22, 30 13, 22 13" fill="#689F38"></path>
                <path d="M18 22 C 18 24, 20 29, 22 32 C 24 29, 26 24, 26 22 C 26 20, 24 18, 22 18 C 20 18, 18 20, 18 22" 
                      fill="#FFF176" stroke="#F9A825" stroke-width="0.5"></path>
                <circle cx="22" cy="22" r="2" fill="#795548"></circle>
                <path d="M22 13 C 26 15, 28 18, 28 24 C 28 30, 26 33, 22 33 C 18 33, 16 30, 16 24 C 16 18, 18 15, 22 13" 
                      fill="#558B2F" stroke="none"></path>
            </symbol>
            
            <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="B12">
                <title>Large Coconut</title>
                <circle cx="22" cy="22" r="10" fill="#795548"></circle>
                <path d="M22 12 C 16 12, 12 16, 12 22 C 12 28, 16 32, 22 32" 
                    fill="#8D6E63" stroke="none"></path>
            <path d="M15 18 L 13 16 M29 18 L 31 16 M15 26 L 13 28 M29 26 L 31 28" 
                  stroke="#5D4037" stroke-width="1"></path>
            <circle cx="18" cy="18" r="1" fill="#5D4037"></circle>
            <circle cx="26" cy="18" r="1" fill="#5D4037"></circle>
            <circle cx="22" cy="22" r="1" fill="#5D4037"></circle>
        </symbol>
        
        <!-- C series: Corner Elements -->
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C1">
            <title>Maple Leaves</title>
            <!-- Top left maple leaf -->
            <path d="M6 6 L 8 9 L 5 11 L 9 12 L 11 16 L 13 12 L 17 11 L 14 9 L 16 6 L 11 7 Z" fill="#FF5722"></path>
            <!-- Top right maple leaf -->
            <path d="M38 6 L 36 9 L 39 11 L 35 12 L 33 16 L 31 12 L 27 11 L 30 9 L 28 6 L 33 7 Z" fill="#FF5722"></path>
            <!-- Bottom left maple leaf -->
            <path d="M6 38 L 8 35 L 5 33 L 9 32 L 11 28 L 13 32 L 17 33 L 14 35 L 16 38 L 11 37 Z" fill="#FF5722"></path>
            <!-- Bottom right maple leaf -->
            <path d="M38 38 L 36 35 L 39 33 L 35 32 L 33 28 L 31 32 L 27 33 L 30 35 L 28 38 L 33 37 Z" fill="#FF5722"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C2">
            <title>Oak Leaves</title>
            <!-- Top left oak leaf -->
            <path d="M6 6 C 12 6, 14 12, 12 16 C 16 14, 18 6, 12 6 Z" fill="#66BB6A"></path>
            <path d="M6 6 C 10 8, 12 10, 12 16 M12 16 C 16 12, 16 8, 12 6" stroke="#43A047" stroke-width="0.5" fill="none"></path>
            <!-- Top right oak leaf -->
            <path d="M38 6 C 32 6, 30 12, 32 16 C 28 14, 26 6, 32 6 Z" fill="#66BB6A"></path>
            <path d="M38 6 C 34 8, 32 10, 32 16 M32 16 C 28 12, 28 8, 32 6" stroke="#43A047" stroke-width="0.5" fill="none"></path>
            <!-- Bottom left oak leaf -->
            <path d="M6 38 C 12 38, 14 32, 12 28 C 16 30, 18 38, 12 38 Z" fill="#66BB6A"></path>
            <path d="M6 38 C 10 36, 12 34, 12 28 M12 28 C 16 32, 16 36, 12 38" stroke="#43A047" stroke-width="0.5" fill="none"></path>
            <!-- Bottom right oak leaf -->
            <path d="M38 38 C 32 38, 30 32, 32 28 C 28 30, 26 38, 32 38 Z" fill="#66BB6A"></path>
            <path d="M38 38 C 34 36, 32 34, 32 28 M32 28 C 28 32, 28 36, 32 38" stroke="#43A047" stroke-width="0.5" fill="none"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C3">
            <title>Palm Leaves</title>
            <!-- Top left palm leaf -->
            <path d="M4 8 C 8 8, 10 4, 14 4 C 10 10, 10 14, 8 16 C 6 14, 6 10, 4 8 Z" fill="#8BC34A"></path>
            <!-- Top right palm leaf -->
            <path d="M40 8 C 36 8, 34 4, 30 4 C 34 10, 34 14, 36 16 C 38 14, 38 10, 40 8 Z" fill="#8BC34A"></path>
            <!-- Bottom left palm leaf -->
            <path d="M4 36 C 8 36, 10 40, 14 40 C 10 34, 10 30, 8 28 C 6 30, 6 34, 4 36 Z" fill="#8BC34A"></path>
            <!-- Bottom right palm leaf -->
            <path d="M40 36 C 36 36, 34 40, 30 40 C 34 34, 34 30, 36 28 C 38 30, 38 34, 40 36 Z" fill="#8BC34A"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C4">
            <title>Fern Leaves</title>
            <!-- Top left fern -->
            <path d="M6 6 C 8 8, 10 10, 12 8 C 14 6, 12 4, 10 4 C 8 4, 6 6, 6 6 Z" fill="#4CAF50"></path>
            <path d="M6 6 C 8 8, 10 8, 12 8" stroke="#388E3C" stroke-width="0.5" fill="none"></path>
            <!-- Top right fern -->
            <path d="M38 6 C 36 8, 34 10, 32 8 C 30 6, 32 4, 34 4 C 36 4, 38 6, 38 6 Z" fill="#4CAF50"></path>
            <path d="M38 6 C 36 8, 34 8, 32 8" stroke="#388E3C" stroke-width="0.5" fill="none"></path>
            <!-- Bottom left fern -->
            <path d="M6 38 C 8 36, 10 34, 12 36 C 14 38, 12 40, 10 40 C 8 40, 6 38, 6 38 Z" fill="#4CAF50"></path>
            <path d="M6 38 C 8 36, 10 36, 12 36" stroke="#388E3C" stroke-width="0.5" fill="none"></path>
            <!-- Bottom right fern -->
            <path d="M38 38 C 36 36, 34 34, 32 36 C 30 38, 32 40, 34 40 C 36 40, 38 38, 38 38 Z" fill="#4CAF50"></path>
            <path d="M38 38 C 36 36, 34 36, 32 36" stroke="#388E3C" stroke-width="0.5" fill="none"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C5">
            <title>Flower Blooms</title>
            <!-- Top left flower -->
            <circle cx="8" cy="8" r="2" fill="#F06292"></circle>
            <path d="M6 6 L 4 4 M10 6 L 12 4 M6 10 L 4 12 M10 10 L 12 12" stroke="#F06292" stroke-width="1" stroke-linecap="round"></path>
            <!-- Top right flower -->
            <circle cx="36" cy="8" r="2" fill="#F06292"></circle>
            <path d="M34 6 L 32 4 M38 6 L 40 4 M34 10 L 32 12 M38 10 L 40 12" stroke="#F06292" stroke-width="1" stroke-linecap="round"></path>
            <!-- Bottom left flower -->
            <circle cx="8" cy="36" r="2" fill="#F06292"></circle>
            <path d="M6 34 L 4 32 M10 34 L 12 32 M6 38 L 4 40 M10 38 L 12 40" stroke="#F06292" stroke-width="1" stroke-linecap="round"></path>
            <!-- Bottom right flower -->
            <circle cx="36" cy="36" r="2" fill="#F06292"></circle>
            <path d="M34 34 L 32 32 M38 34 L 40 32 M34 38 L 32 40 M38 38 L 40 40" stroke="#F06292" stroke-width="1" stroke-linecap="round"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C6">
            <title>Clover Leaves</title>
            <!-- Top left clover -->
            <path d="M8 4 C 4 4, 4 8, 8 8 C 8 4, 12 4, 12 8 C 12 12, 8 12, 8 8 C 4 8, 4 12, 8 12 C 12 12, 12 8, 8 8" fill="#4CAF50"></path>
            <!-- Top right clover -->
            <path d="M36 4 C 32 4, 32 8, 36 8 C 36 4, 40 4, 40 8 C 40 12, 36 12, 36 8 C 32 8, 32 12, 36 12 C 40 12, 40 8, 36 8" fill="#4CAF50"></path>
            <!-- Bottom left clover -->
            <path d="M8 36 C 4 36, 4 40, 8 40 C 8 36, 12 36, 12 40 C 12 44, 8 44, 8 40 C 4 40, 4 44, 8 44 C 12 44, 12 40, 8 40" fill="#4CAF50"></path>
            <!-- Bottom right clover -->
            <path d="M36 36 C 32 36, 32 40, 36 40 C 36 36, 40 36, 40 40 C 40 44, 36 44, 36 40 C 32 40, 32 44, 36 44 C 40 44, 40 40, 36 40" fill="#4CAF50"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C7">
            <title>Pine Needles</title>
            <!-- Top left pine needles -->
            <path d="M4 4 L 8 8 M6 4 L 10 8 M4 6 L 8 10" stroke="#2E7D32" stroke-width="1.5" stroke-linecap="round"></path>
            <!-- Top right pine needles -->
            <path d="M40 4 L 36 8 M38 4 L 34 8 M40 6 L 36 10" stroke="#2E7D32" stroke-width="1.5" stroke-linecap="round"></path>
            <!-- Bottom left pine needles -->
            <path d="M4 40 L 8 36 M6 40 L 10 36 M4 38 L 8 34" stroke="#2E7D32" stroke-width="1.5" stroke-linecap="round"></path>
            <!-- Bottom right pine needles -->
            <path d="M40 40 L 36 36 M38 40 L 34 36 M40 38 L 36 34" stroke="#2E7D32" stroke-width="1.5" stroke-linecap="round"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C8">
            <title>Berry Clusters</title>
            <!-- Top left berries -->
            <circle cx="6" cy="6" r="2" fill="#E53935"></circle>
            <circle cx="10" cy="8" r="2" fill="#E53935"></circle>
            <circle cx="8" cy="12" r="2" fill="#E53935"></circle>
            <path d="M6 6 C 5 5, 4 6, 5 7" stroke="#4CAF50" stroke-width="0.5" fill="none"></path>
            <!-- Top right berries -->
            <circle cx="38" cy="6" r="2" fill="#E53935"></circle>
            <circle cx="34" cy="8" r="2" fill="#E53935"></circle>
            <circle cx="36" cy="12" r="2" fill="#E53935"></circle>
            <path d="M38 6 C 39 5, 40 6, 39 7" stroke="#4CAF50" stroke-width="0.5" fill="none"></path>
            <!-- Bottom left berries -->
            <circle cx="6" cy="38" r="2" fill="#E53935"></circle>
            <circle cx="10" cy="36" r="2" fill="#E53935"></circle>
            <circle cx="8" cy="32" r="2" fill="#E53935"></circle>
            <path d="M6 38 C 5 39, 4 38, 5 37" stroke="#4CAF50" stroke-width="0.5" fill="none"></path>
            <!-- Bottom right berries -->
            <circle cx="38" cy="38" r="2" fill="#E53935"></circle>
            <circle cx="34" cy="36" r="2" fill="#E53935"></circle>
            <circle cx="36" cy="32" r="2" fill="#E53935"></circle>
            <path d="M38 38 C 39 39, 40 38, 39 37" stroke="#4CAF50" stroke-width="0.5" fill="none"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C9">
            <title>Herb Sprigs</title>
            <!-- Top left herb -->
            <path d="M8 4 C 6 6, 4 10, 6 12 C 8 10, 10 6, 8 4 Z" fill="#BDBDBD"></path>
            <path d="M8 4 C 6 6, 5 9, 6 12" stroke="#9E9E9E" stroke-width="0.5" fill="none"></path>
            <!-- Top right herb -->
            <path d="M36 4 C 38 6, 40 10, 38 12 C 36 10, 34 6, 36 4 Z" fill="#BDBDBD"></path>
            <path d="M36 4 C 38 6, 39 9, 38 12" stroke="#9E9E9E" stroke-width="0.5" fill="none"></path>
            <!-- Bottom left herb -->
            <path d="M8 40 C 6 38, 4 34, 6 32 C 8 34, 10 38, 8 40 Z" fill="#BDBDBD"></path>
            <path d="M8 40 C 6 38, 5 35, 6 32" stroke="#9E9E9E" stroke-width="0.5" fill="none"></path>
            <!-- Bottom right herb -->
            <path d="M36 40 C 38 38, 40 34, 38 32 C 36 34, 34 38, 36 40 Z" fill="#BDBDBD"></path>
            <path d="M36 40 C 38 38, 39 35, 38 32" stroke="#9E9E9E" stroke-width="0.5" fill="none"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C10">
            <title>Lotus Petals</title>
            <!-- Top left lotus -->
            <path d="M4 8 C 8 4, 12 8, 12 12 C 8 12, 4 8, 4 8 Z" fill="#E1BEE7"></path>
            <!-- Top right lotus -->
            <path d="M40 8 C 36 4, 32 8, 32 12 C 36 12, 40 8, 40 8 Z" fill="#E1BEE7"></path>
            <!-- Bottom left lotus -->
            <path d="M4 36 C 8 40, 12 36, 12 32 C 8 32, 4 36, 4 36 Z" fill="#E1BEE7"></path>
            <!-- Bottom right lotus -->
            <path d="M40 36 C 36 40, 32 36, 32 32 C 36 32, 40 36, 40 36 Z" fill="#E1BEE7"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C11">
            <title>Jungle Leaves</title>
            <!-- Top left jungle leaf -->
            <path d="M4 12 C 8 4, 12 4, 16 8 C 12 12, 8 16, 4 12 Z" fill="#00C853"></path>
            <!-- Top right jungle leaf -->
            <path d="M40 12 C 36 4, 32 4, 28 8 C 32 12, 36 16, 40 12 Z" fill="#00C853"></path>
            <!-- Bottom left jungle leaf -->
            <path d="M4 32 C 8 40, 12 40, 16 36 C 12 32, 8 28, 4 32 Z" fill="#00C853"></path>
            <!-- Bottom right jungle leaf -->
            <path d="M40 32 C 36 40, 32 40, 28 36 C 32 32, 36 28, 40 32 Z" fill="#00C853"></path>
        </symbol>
        
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="C12">
            <title>Wheat Stems</title>
            <!-- Top left wheat -->
            <path d="M6 6 L 10 10" stroke="#FFC107" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M6 10 L 10 6" stroke="#FFC107" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M6 6 C 4 4, 2 6, 4 8" stroke="#FFC107" stroke-width="0.5" fill="none"></path>
            <!-- Top right wheat -->
            <path d="M38 6 L 34 10" stroke="#FFC107" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M38 10 L 34 6" stroke="#FFC107" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M38 6 C 40 4, 42 6, 40 8" stroke="#FFC107" stroke-width="0.5" fill="none"></path>
            <!-- Bottom left wheat -->
            <path d="M6 38 L 10 34" stroke="#FFC107" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M6 34 L 10 38" stroke="#FFC107" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M6 38 C 4 40, 2 38, 4 36" stroke="#FFC107" stroke-width="0.5" fill="none"></path>
            <!-- Bottom right wheat -->
            <path d="M38 38 L 34 34" stroke="#FFC107" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M38 34 L 34 38" stroke="#FFC107" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M38 38 C 40 40, 42 38, 40 36" stroke="#FFC107" stroke-width="0.5" fill="none"></path>
        </symbol>
    </svg>`,

        'symbols': {
            'Z': 3,
            'A': 9,
            'B': 12,
            'C': 12
        },
    },
]

export default data_svgs